import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import DOMPurify from "dompurify";
import {
  FormControlLabel,
  Checkbox,
  Button,
  Box,
  Grid,
  CircularProgress,
  Typography,
  Snackbar,
  Alert,
  RadioGroup,
  Switch,
  InputAdornment,
  useTheme,
  useMediaQuery,
  Tooltip,
  IconButton as IconButtonMui,
} from "@mui/material";
import { Skeleton } from "@mui/material";
import OfferCheckLoader from "../../ui/OfferCheckLoader";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, RootState } from "../../../services/redux/store";
import { RadioButton } from "../../ui/RadioButton";
import { IconButton } from "../../ui/Button";
import EntranceExamDetailsSection from "./EntranceExamDetailsSection";
import {
  nextVerticalStep,
  prevVerticalStep,
  updateFormData,
  setSelectedProduct,
  setIsMobileVerified,
  setIsEmailVerified,
  setTrackingId,
  setApplicationId,
  setApplicantId,
  setAadhaarApplicationNo,
  setHasPan,
  setIsPanVerified,
  setPanNumber,
  setAadhaarMandatory,
  setShowAadhaar,
  setLastPanNumber,
  setLastVerifiedPhoneNumber,
  setLastVerifiedEmail,
  setIsDocumentVerified,
  setAadhaarVerifiedDetails,
  setCoApplicantVerification,
  setCurrentCoApplicantIdx,
  setCgpaMode,
  setActiveHorizontalIndex,
  setBreData,
  setBreStatus,
  setIsEligible,
  setIsDocumentVerifiedCoApplicant,
  setAadhaarApplicationNoCoApplicant,
  setAadhaarVerifiedDetailsCoApplicant,
  setActiveVerticalIndex,
  setCoApplicantZipCodeData,
  setCheckIsLeadApiInvoked,
  setLeadSequenceId,
  setAssignedSMIdValue,
  setAadhaarSeedingStatus,
  setVerificationMessage,
  setApplicationSource,
  setEncryptionKey,
  setFetchUserApplicationData,
  setDisplayHorizontalSteps,
  bumpFormJsonRefreshNonce,
  bumpCompletionSummaryRefreshNonce,
  setSummaryApplicationEditActive,
  setSummaryFormSaveInProgress,
} from "../../../services/redux/slices/stepperDynamicFormSlice";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import eligibilityCheckServices from "../../../services/api/service/eligibilityCheckService";
import applicantDetailsServices from "../../../services/api/service/applicantDetailsService";
import losServices from "../../../services/api/service/losService";
import { SectionHeader } from "../../ui/SectionHeader";
import idIcon from "./../../../assets/svgIcons/id.svg";
import booksIcon from "./../../../assets/svgIcons/book line.svg";
import loanIcon from "./../../../assets/svgIcons/Loan.svg";
import locationIcon from "./../../../assets/svgIcons/live-view.svg";
import academicIcon from "./../../../assets/svgIcons/academic-cap-green.svg";
import VerifiedIcon from "./../../../assets/svgIcons/check-circle.svg";
import newVerifiedIcon from "./../../../assets/svgIcons/verified-btn.svg";
import newVerifyIcon from "./../../../assets/svgIcons/verify-btn.svg";
import greenCheckVerified from "./../../../assets/svgIcons/green-check-verified.svg";
import arrowRightVerify from "./../../../assets/svgIcons/arrow-right-verify.svg";
//import workExperienceIcon from "./../../../assets/svgIcons/work-experience.svg";
import RightBlackArrow from "./../../../assets/svgIcons/right-black-arrow.svg";
import ArrowNarrowRight from "./../../../assets/images/icons/arrow-narrow-right.png";
import { CustomRadioGroup } from "../../ui/CustomRadioGroup";
import { InputField } from "../../ui/Inputs";
import AutoCompleteOptions from "../../ui/AutoComplete";
import ModalPopup from "../../ui/ModalPopup";
import OtpInputForm from "../../../pages/common-features/OtpInputForm";
import SelectOptions from "../../ui/SelectOptions";
import { PrimaryButton } from "../../ui/Button";
import postsServices from "../../../services/api/service/postsService";
import dropdownService from "../../../services/api/service/dropdownService";
import { getValidationSchema } from "../../../utils/validationSchemas";
import { isValidJourneyEmail } from "../../../utils/emailValidation";
import EligibilityConfirmation from "../../../pages/eligibility-check/EligibilityConfirmation";
import { FormGrid } from "../../ui/FormGrid";
import { authStatusSelector } from "../../../services/redux/slices/authSlice";
import type { FormikProps } from "formik";
import { decrypt, encryptData } from "../../../utils/crypto";
import CourseDetailsSection from "./CourseDetailsSection";
import CoApplicantDetailsSection from "./CoApplicantDetailsSection";
import ApplicationAdditionalDetails from "./ApplicationAdditionalDetails";
import FundExpenseDetails from "./FundExpenseDetails";
import ReferenceCollateralDetails from "./ReferenceCollateralDetails";
import LoaderBackdrop from "../../ui/LoaderBackdrop";
import { AnyCnameRecord } from "node:dns";
import { fetchUserApplicationsFormData } from "../../../services/api/service/userApplicationService";
import { setSalesUserId } from "../../../services/redux/slices/chatSlice";
import { letterSpacing } from "@mui/system";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { formatDateToDDMMYYYY, removeSalutation, debounce, handleUnwanted, splitAddressByWords, mapCollateral, matchCoOwnerNameToApplicant, extractFetchedApplicationVals, isCoApplicantFieldLockedByCoOwner } from "../../../utils/helpers";
import { getSanitizedPublicKeyFromResponse } from "../../../utils/piiKey";
import { useLocation, useNavigate } from "react-router-dom";
import { topCountry } from "../../../data/stepsData";
import { persistor } from "../../../services/redux/store";
import BasicDatePicker from "../../ui/BasicDatePicker";
import dayjs from "dayjs";
import {
  autoCompleteOffFields,
  getCombinedApplicationSteps,
  getGAEligibilityStatements,
  getGAProvisionalOfferStatements,
} from "./helper";
import {
  buildApplicantIdDtosBySection,
  APPLICANT_SECTION_BY_VERTICAL_INDEX,
  getMasterOptionName,
} from "./helperDto";
import { OutlinedPrimaryButton } from "../../../components/ui/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { trackCustomerJourneyEvent } from "../../../utils/ga";
import SummarySectionHeader from "../../applicantDetailsTabs/SummarySectionHeader";
import { useApplicantMasterData } from "../../../hooks/useApplicantMasterData";
import { numberToWord } from '../../../utils/helpers'

/** Normalizes API/Redux boolean-ish flags (true, "true", 1, "1"). */
const isTruthyFormFlag = (value: unknown): boolean =>
  value === true ||
  value === "true" ||
  value === 1 ||
  value === "1";

const hasNonEmptyFormValue = (value: unknown): boolean =>
  value !== undefined &&
  value !== null &&
  !(typeof value === "string" && value.trim() === "");

/**
 * Aadhaar / KYC payloads sometimes return locality fields as plain strings and
 * sometimes as nested objects (e.g. parsed XML). City autocomplete expects a
 * string or { value, label }; storing a raw object surfaces as "[object Object]".
 */
const normalizeAadhaarAddressPart = (raw: unknown): string => {
  if (raw === undefined || raw === null) return "";
  if (typeof raw === "string" || typeof raw === "number") {
    return String(raw).trim();
  }
  if (typeof raw === "object") {
    const o = raw as Record<string, unknown>;
    const nested =
      o.label ??
      o.value ??
      o.name ??
      o.districtName ??
      o.cityName ??
      o._ ??
      o.$ ??
      (o as { "#text"?: unknown })["#text"];
    if (nested !== undefined && nested !== null) {
      return normalizeAadhaarAddressPart(nested);
    }
  }
  return "";
};

const getFirstNonEmptyValue = (...values: unknown[]) => {
  for (const value of values) {
    if (value === undefined || value === null) continue;
    if (typeof value === "string" && value.trim() === "") continue;
    return value;
  }
  return "";
};

const getReferenceCityId = (codeData: any, selectedCity: unknown) =>
  getFirstNonEmptyValue(
    codeData?.cityId,
    codeData?.city,
    codeData?.cityCode,
    codeData?.id,
    codeData?.value,
    typeof selectedCity === "object"
      ? (selectedCity as any)?.value
      : selectedCity
  );

const getReferencePincodeId = (codeData: any, pincode: unknown) => {
  const value = getFirstNonEmptyValue(
    codeData?.pinCodeId,
    codeData?.pincodeId,
    codeData?.pinCodeID,
    codeData?.pinCode,
    codeData?.id,
    codeData?.value,
    pincode
  );
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? value : numericValue;
};

const getReferencePayloadCityId = (codeData: any, selectedCity: unknown) =>
  getFirstNonEmptyValue(
    codeData?.cityId,
    codeData?.city,
    codeData?.cityCode,
    codeData?.id,
    codeData?.value,
    typeof selectedCity === "object" ? (selectedCity as any)?.value : ""
  );

const getReferencePayloadPincodeId = (codeData: any) => {
  const value = getFirstNonEmptyValue(
    codeData?.pinCodeId,
    codeData?.pincodeId,
    codeData?.pinCodeID,
    codeData?.id,
    codeData?.value
  );
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? value : numericValue;
};

const getNormalizedFieldToken = (value: unknown) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const toOptionValue = (value: unknown) => {
  const stripWrappedQuotes = (raw: unknown) =>
    typeof raw === "string" ? raw.replace(/^"+|"+$/g, "") : raw;
  if (value && typeof value === "object") {
    const option = value as Record<string, unknown>;
    return stripWrappedQuotes(option.value ?? option.label ?? option.name ?? "");
  }
  return stripWrappedQuotes(value ?? "");
};

const getCollateralFieldNumber = (fieldName: string): number => {
  const collateralMatch = String(fieldName || "").match(/^collateral(\d+)/i);
  if (collateralMatch) return Number(collateralMatch[1]);

  const coOwnerMatch = String(fieldName || "").match(/^coOwnerCollateral(\d+)/i);
  if (coOwnerMatch) return Number(coOwnerMatch[1]);

  return 1;
};

const getCollateralTotalValueFieldName = (fieldName: string) => {
  const match = String(fieldName || "").match(/^collateral(\d+)(unitPrice|noOfUnits)$/i);
  return match ? `collateral${match[1]}totalValue` : "";
};

const toNumberValue = (value: unknown) =>
  Number(String(value ?? "").replace(/,/g, "")) || 0;

const hasNumericInputValue = (value: unknown) =>
  String(value ?? "").replace(/,/g, "").trim() !== "";

const getStepValidationSnackbarMessage = (
  fieldNames: string[],
  errors: Record<string, any>,
  values: Record<string, any> = {}
) => {
  const stepErrors = fieldNames
    .map((fieldName) => ({
      fieldName,
      message: String(errors?.[fieldName] || ""),
      value: values?.[fieldName],
    }))
    .filter((item) => item.message);
    
  const hasInvalidValueError = stepErrors.some((item) => {
    const hasValue = String(item.value ?? "").trim() !== "";
    return hasValue || !/required/i.test(item.message);
  });
  console.log(stepErrors, "stepErrors")
    console.log(hasInvalidValueError, "stepErrors")

  return hasInvalidValueError
    ? "Some field values are invalid."
    : "Please fill all required fields.";
};

const isCoOwnerCollateralNameField = (fieldName: string) =>
  /^coOwnerCollateral(?:\d+(?:_?\d+)?)?Name$/i.test(String(fieldName || ""));

const getCoOwnerCollateralPhoneFieldName = (fieldName: string) =>
  String(fieldName || "").replace(/Name$/i, "PhoneNumber");

const normalizeSelectionValue = (value: unknown) =>
  String(toOptionValue(value) || "").trim();

interface DynamicFormProps {
  fields: any[];
  pageType: string;
  module?: string;
  currentVerticalStep?: any;
}
const DynamicForm = ({ fields, pageType, currentVerticalStep }: DynamicFormProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();
  const formikRef = useRef<FormikProps<any>>(null);
  const lastHandledSummarySaveRequestRef = useRef<number | null>(null);
  const referenceCollateralSaveInFlightRef = useRef(false);
  const summaryEligibilityLeadSyncInitializedRef = useRef(false);
  const lastSummaryEligibilityLeadPayloadRef = useRef("");
  const isAuthenticated = useSelector(authStatusSelector);
  const location = useLocation();
  const navigate = useNavigate();
  // console.log(isAuthenticated, "isAuthenticated")
  // Load testing flag - if true, auto-verify PAN and Aadhaar
  const isLoadTesting = process.env.REACT_APP_LOAD_TESTING == "true";

  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [isSubmittingToAPI, setIsSubmittingToAPI] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  // Loader for BRE checkOffer API
  const [isCheckingOffer, setIsCheckingOffer] = useState(false);
  const [openEmailOtp, setOpenEmailOtp] = useState(false);
  const [openCoApplicantModal, setOpenCoApplicantModal] = useState(false);
  const [openAnchorModal, setOpenAnchorModal] = useState(false);
  const [anchorModalContent, setAnchorModalContent] = useState("");
  const purposeItems = useMemo(() => {
    return anchorModalContent
      .split(/\n\s*\n/) // split on blank lines
      .map((item) => item.replace(/;+$/, "").trim()) // remove trailing semicolons
      .filter(Boolean);
  }, [anchorModalContent]);
  // State for dropdown data
  const [dropdownData, setDropdownData] = useState<{
    countries: Array<{ value: string; label: string; countryId?: string }>;
    institutes: Array<{ value: string; label: string; code: string }>;
    universities: Array<{ value: string; label: string; code: string }>;
    courses: Array<{ value: string; label: string; code: string }>;
    courseCategory?: Array<{ value: string; label: string }>;
    admissionStatus?: Array<{ value: string; label: string }>;
    courseType?: Array<{ value: string; label: string }>;
    salutations?: Array<{ value: string; label: string }>;
    languageExamTypes?: Array<{ value: string; label: string; id: string }>;
    entranceExamTypes?: Array<{ value: string; label: string; id: string }>;
    loanTenureOptions?: Array<{ value: string; label: string; id: string }>;
    designations?: Array<{ value: string; label: string }>;
  }>({
    countries: [],
    institutes: [],
    universities: [],
    courses: [],
    courseCategory: [],
    admissionStatus: [],
    courseType: [],
    languageExamTypes: [],
    entranceExamTypes: [],
    loanTenureOptions: [],
    designations: [],
  });
  const [loadingDropdowns, setLoadingDropdowns] = useState({
    countries: false,
    institutes: false,
    universities: false,
    courses: false,
  });
  // State to track form values for dependent dropdowns
  const [formValues, setFormValues] = useState<{
    countryId?: string;
    universityId?: string;
    instituteId?: string;
    instituteName?: string;
    universityName?: string;
    courseName?: string;
  }>({});
  const [productOptions, setProductOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [zipCodeLoading, setZipCodeLoading] = useState(false);
  const {
    countryOptions: birthCountryMasterOptions,
    nationalityOptions: nationalityMasterOptions,
    maritalStatusOptions: maritalStatusMasterOptions,
    fetchCitiesByCountryState,
    getCityOptionsForCountry,
  } = useApplicantMasterData();
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity?: "error" | "success";
  }>({
    open: false,
    message: "",
    severity: "error",
  });

  const [tabIndex, setTabIndex] = React.useState<Record<string, number>>(
    {}
  );
  const [otpEmailFieldName, setOtpEmailFieldName] = useState("email");
  const [otpMobileFieldName, setOtpMobileFieldName] = useState("phone_number");
  const [errorMsg, setErrorMsg] = useState("");
  // For Mobile Verification Step 1
  const [otpMobileNumber, setOtpMobileNumber] = useState("");
  const [otpKey, setOtpKey] = useState("");
  const [otpTime, setOtpTime] = useState("");
  // For Email Verification Step 1
  const [otpEmail, setOtpEmail] = useState("");
  const [otpEmailKey, setOtpEmailKey] = useState("");
  const [otpEmailTime, setOtpEmailTime] = useState("");
  const [cityList, setCityList] = useState<any[]>([]);
  // Flag to prevent API calls during form initialization
  const [isFormInitialized, setIsFormInitialized] = useState(false);
  // For Co-applicant Pan Verification API Loading State
  const [coApplicantPanLoading, setCoApplicantPanLoading] = useState<{
    [key: string]: boolean;
  }>({});
  // Store entrance exam master data
  const [entranceExamMaster, setEntranceExamMaster] = useState([]);
  // Loading state for API calls in useEffect
  const [isApiLoading, setIsApiLoading] = useState(false);
  // Track pushed documents to prevent duplicates
  const pushedDocumentsRef = useRef<Set<string>>(new Set());
  // Track ongoing Aadhaar verification calls to prevent concurrent processing
  const processingAadhaarVerificationRef = useRef<Set<string>>(new Set());
  const [enableContinue, setenableContinue] = useState(false);

  // Function to check for specific purposes anchor tag
  const hasSpecificPurposesAnchor = (htmlString: string): boolean => {
    return htmlString.includes("<a>purposes</a>");
  };

  // const fetchSanitizedPiiPublicKey = useCallback(async () => {
  //   const piiKeyResponse: any = await losServices.getPiiKey();
  //   if (piiKeyResponse?.status !== 200) return "";

  //   return getSanitizedPublicKeyFromResponse(piiKeyResponse?.data?.p_k);
  // }, []);

  const isPreviousButton = process.env.REACT_APP_ENABLE_PREVIOUS_BUTTON == "true";
  // Function to handle purposes anchor clicks
  const handlePurposesClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    if (target.tagName === "A" && target.textContent?.trim() === "purposes") {
      event.preventDefault();
      setAnchorModalContent(`For relying upon KYC documents supplied to us, whether by you or through our representative/service provider, for meeting our legal, regulatory and compliance obligations such as customer due diligence, know your customer/re-KYC/anti-money laundering checks, processing your loan application details and other value-added services;

For providing your application details to Central KYC Registry, UIDAI, credit information companies/credit bureaus for verification purposes;

For verifying the applied (i) course or admission details with the institute/university, (ii) credentials with the relevant third parties required in respect of the loan application, (iii) enrollment verifications from organizations/entity in possession of such data;

For enabling repayment and ensuring recovery of amounts due from you including through our appointed recovery agents, etc.

For our general administration and granting services in relation to the above;

For contacting you over, Emails, WhatsApp, call and SMS, overriding NDNC registration.`);
      setOpenAnchorModal(true);
    }
  };

  // Get all form data from Redux
  const formData = useSelector((state: RootState) => state.stepper.formData);

  const {
    horizontalSteps,
    activeHorizontalIndex,
    templateId,
    trackingId,
    isMobileVerified,
    isEmailVerified,
    lastVerifiedPhoneNumber,
    lastVerifiedEmail,
    hasPan,
    panNumber,
    isPanVerified,
    adharMandatory,
    showAadhaar,
    isDocumentVerified,
    aadhaarApplicationNo,
    aadhaarVerifiedDetails,
    aadhaarVerifiedDetailsCoApplicant,
    coApplicantVerification,
    breData,
    aadhaarApplicationNoCoApplicant,
    isDocumentVerifiedCoApplicant,
    loanDetailCoApplicantCollapseValue,
    checkIsLeadApiInvoked,
    leadSequenceId,
    assignedSMIdValue,
    coApplicantZipCodeData,
    aadhaarSeedingStatus,
    verificationMessage,
    applicationSource,
    encryptionKey,
    customerConsentTime,
    summarySaveRequestId,
    summaryReferenceCollateralEditTab,
    completionSummaryRefreshNonce,
    referenceOneId,
    referenceTwoId,
    collateralId,
    fetchUserApplicationData,
  } = useSelector((state: RootState) => state.stepper);
  // Saved values used to lock co-applicant First/Last Name & Mobile (Applicant &
  // Loan Details and Additional Details) once that co-applicant is a collateral
  // co-owner. Like DIY, the co-owners come from the fetch-application-data
  // API's Collateral Details vertical step. It's fetched here directly (the
  // assisted dashboard doesn't keep fetchUserApplicationData in redux), on
  // step change and after every save-collateral ("collateral:saved").
  const [fetchedApplicationLockVals, setFetchedApplicationLockVals] = useState<Record<string, any>>({});
  useEffect(() => {
    if (!isAuthenticated || !trackingId) return;
    const token: any = process.env.REACT_APP_FETCH_TOKEN;
    if (!token) return;
    let isMounted = true;
    const loadFetchedApplicationLockVals = async () => {
      try {
        const res: any = await fetchUserApplicationsFormData(token, trackingId);
        const application = res?.data?.applications?.[0];
        if (isMounted && application) {
          setFetchedApplicationLockVals(extractFetchedApplicationVals(application));
        }
      } catch {
        // keep the last known values; formData below still applies
      }
    };
    loadFetchedApplicationLockVals();
    window.addEventListener("collateral:saved", loadFetchedApplicationLockVals);
    return () => {
      isMounted = false;
      window.removeEventListener("collateral:saved", loadFetchedApplicationLockVals);
    };
  }, [isAuthenticated, trackingId, activeHorizontalIndex]);
  const coOwnerLockSavedValues = useMemo(
    () => ({
      ...(formData || {}),
      ...extractFetchedApplicationVals(fetchUserApplicationData),
      ...fetchedApplicationLockVals,
    }),
    [fetchUserApplicationData, fetchedApplicationLockVals, formData],
  );

  const fetchSanitizedPiiPublicKey = useCallback(async () => {
    if (encryptionKey) {
      return getSanitizedPublicKeyFromResponse(encryptionKey);
    }
    const piiKeyResponse: any = await losServices.getPiiKey();
    if (piiKeyResponse?.status !== 200) return "";

    const rawKey = piiKeyResponse?.data?.p_k;
    const rawKeyStr = typeof rawKey === "string" ? rawKey : "";
    dispatch(setEncryptionKey(rawKeyStr));

    return getSanitizedPublicKeyFromResponse(rawKey);
  }, [encryptionKey, dispatch]);

  /** After createApplicant save: refetch application from API and mirror into Redux (same pattern as Summary.tsx). */
  const refreshReduxFromUserApplicationFetch = useCallback(
    async (submissionIdOverride?: string) => {
      const submissionId = submissionIdOverride || trackingId;
      if (!isAuthenticated || !submissionId) return;
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      if (!token) return;
      try {
        const res: any = await fetchUserApplicationsFormData(
          token,
          submissionId
        );
        const applicationData = res.data?.applications?.[0];
        if (!applicationData) return;

        dispatch(setFetchUserApplicationData(applicationData));

        const finalSteps = getCombinedApplicationSteps(applicationData);
        dispatch(setDisplayHorizontalSteps(finalSteps));

        const lengthOfHorizontalSteps =
          applicationData?.horizontalSteps?.length ?? 0;
        let apiFormData: any = {};
        for (let i = 0; i < lengthOfHorizontalSteps; i++) {
          const verticalSteps =
            applicationData?.horizontalSteps?.[i]?.verticalSteps;
          for (let j = 0; j < verticalSteps?.length; j++) {
            const stepFields = verticalSteps?.[j]?.fields;
            for (let k = 0; k < stepFields?.length; k++) {
              const field = stepFields?.[k];
              apiFormData = { ...apiFormData, ...field };
            }
          }
        }
        dispatch(updateFormData(apiFormData));

        if (applicationData?.applicationId != null) {
          dispatch(setApplicationId(String(applicationData.applicationId)));
        }
        if (applicationData?.applicantId != null) {
          dispatch(setApplicantId(String(applicationData.applicantId)));
        }

        dispatch(bumpFormJsonRefreshNonce());
      } catch (err) {
        console.error("refreshReduxFromUserApplicationFetch failed:", err);
      }
    },
    [dispatch, isAuthenticated, trackingId]
  );

  const activeVerticalIndex = useSelector(
    (state: RootState) =>
      state.stepper.activeVerticalIndex[activeHorizontalIndex] || 0
  );
  const currentHorizontalStep = horizontalSteps?.[activeHorizontalIndex];
  const currentHorizontalStepIdentity = String(
    currentHorizontalStep?.stepKey ||
      currentHorizontalStep?.stepLabel ||
      currentHorizontalStep?.horizontalStepName ||
      ""
  ).trim();
  const currentHorizontalStepId = Number(
    currentHorizontalStep?.horizontalStepId ?? currentHorizontalStep?.id
  );
  const currentVerticalStepName = String(
    currentVerticalStep?.verticalStepName ||
      currentVerticalStep?.stepLabel ||
      currentHorizontalStep?.verticalSteps?.[activeVerticalIndex]?.verticalStepName ||
      currentHorizontalStep?.verticalSteps?.[activeVerticalIndex]?.stepLabel ||
      ""
  ).trim();
  const isAdditionalDetailsStepIdentity =
    currentHorizontalStepId === 4 ||
    currentHorizontalStepIdentity === "additional_details_and_documents" ||
    currentHorizontalStepIdentity === "Additional Details & Documents";
  const isSummaryAdditionalDetailsIndex =
    pageType === "SUMMARY" && isAdditionalDetailsStepIdentity;
  const isSummaryAdditionalDetailsVerticalStep =
    pageType === "SUMMARY" &&
    [
      "Applicant Additional Details",
      "Funds & Expenses",
      "Funds and Expenses",
      "Reference & Collateral Details",
      "Reference Details",
      "Collateral Details",
    ].includes(currentVerticalStepName);
  const isAdditionalDetailsStep =
    isSummaryAdditionalDetailsIndex ||
    isSummaryAdditionalDetailsVerticalStep ||
    isAdditionalDetailsStepIdentity;
  const isApplicantAdditionalDetailsStep =
    (isAdditionalDetailsStep &&
      currentVerticalStepName === "Applicant Additional Details");
  const isFundsAndExpensesStep =
    (isAdditionalDetailsStep &&
      (currentVerticalStepName === "Funds & Expenses" ||
        currentVerticalStepName === "Funds and Expenses"));
  const isReferenceCollateralStep =
    (isAdditionalDetailsStep &&
      (currentVerticalStepName === "Reference & Collateral Details" ||
        currentVerticalStepName === "Reference Details" ||
        currentVerticalStepName === "Collateral Details"));
  const [permanentCodeData, setPermanentCodeData] = useState<any>(null);
  const [currentCodeData, setCurrentCodeData] = useState<any>(null);
  const [companyCodeData, setCompanyCodeData] = useState<any>(null);
  const [reference1CodeData, setReference1CodeData] = useState<any>(null);
  const [reference2CodeData, setReference2CodeData] = useState<any>(null);
  const [collateralCodeData, setCollateralCodeData] = useState<Record<number, any>>({});
  const [collateralMasterOptions, setCollateralMasterOptions] = useState({
    addressTypes: [] as any[],
    propertyTypes: [] as any[],
    propertySubTypes: [] as any[],
  });
  const [referenceCollateralActiveTab, setReferenceCollateralActiveTab] =
    useState(0);
  const [activeReferenceSection, setActiveReferenceSection] = useState(1);
  const [activeCollateralSection, setActiveCollateralSection] = useState(1);
  const referenceCollateralFields = useMemo(() => {
    if (!isReferenceCollateralStep) return fields || [];
    const relatedFields = (currentHorizontalStep?.verticalSteps || [])
      .filter((step: any) =>
        [
          "Reference & Collateral Details",
          "Reference Details",
          "Collateral Details",
        ].includes(String(step?.verticalStepName || step?.stepLabel || "").trim())
      )
      .flatMap((step: any) => step?.fields || []);
    const seen = new Set<string>();
    return (relatedFields.length > 0 ? relatedFields : fields || []).filter(
      (field: any) => {
        const key = getNormalizedFieldToken(field?.name);
        if (!key || seen.has(key)) return !key;
        seen.add(key);
        return true;
      },
    );
  }, [currentHorizontalStep?.verticalSteps, fields, isReferenceCollateralStep]);

  const getReferenceSectionFields = useCallback(
    (referenceNumber: number) =>
      (referenceCollateralFields || []).filter((field: any) => {
        const name = String(field?.name || "");
        return (
          new RegExp(`^basicReference${referenceNumber}`, "i").test(name) ||
          new RegExp(`^addressReference${referenceNumber}`, "i").test(name)
        );
      }),
    [referenceCollateralFields]
  );

  const getCollateralSectionFields = useCallback(
    (collateralNumber: number) => {
      const basePrefix = new RegExp(`^collateral${collateralNumber}`, "i");
      const coOwnerPrefix = new RegExp(`^coOwnerCollateral${collateralNumber}`, "i");

      const base = (referenceCollateralFields || []).filter((field: any) => {
        const normalized = getNormalizedFieldToken(field?.name);
        if (normalized.startsWith("coownercollateral")) return false;
        return (
          basePrefix.test(String(field?.name || "")) ||
          (collateralNumber === 1 &&
            normalized.startsWith("collateral") &&
            !/^collateral\d+/.test(normalized))
        );
      });

      const coOwner = (referenceCollateralFields || []).filter((field: any) => {
        const normalized = getNormalizedFieldToken(field?.name);
        return (
          coOwnerPrefix.test(String(field?.name || "")) ||
          (collateralNumber === 1 &&
            normalized.startsWith("coownercollateral") &&
            !/^coownercollateral\d+/.test(normalized))
        );
      });

      return { base, coOwner };
    },
    [referenceCollateralFields]
  );

  const getHasCollateralField = useCallback(
    () =>
      (referenceCollateralFields || []).find(
        (field: any) => getNormalizedFieldToken(field?.name) === "hascollateral"
      ),
    [referenceCollateralFields]
  );

  const getHasCollateralPayloadValue = useCallback(
    (sourceValues: Record<string, any>) => {
      const field = getHasCollateralField();
      const rawValue = field?.name
        ? sourceValues?.[field.name]
        : sourceValues?.hasCollateral;
      const normalized = getNormalizedFieldToken(toOptionValue(rawValue));
      if (normalized === "no") return "No";
      if (normalized === "yes") return "Yes";
      return "";
    },
    [getHasCollateralField]
  );

  const isHasCollateralNoValue = useCallback(
    (sourceValues: Record<string, any>) =>
      getHasCollateralPayloadValue(sourceValues) === "No",
    [getHasCollateralPayloadValue]
  );

  const getHasCollateralNoFormData = useCallback(
    (sourceValues: Record<string, any>) => {
      const field = getHasCollateralField();
      if (!field?.id || !field?.name) return [];
      return [
        {
          formFieldId: field.id,
          fieldKey: field.name,
          fieldValue: getHasCollateralPayloadValue(sourceValues) || "No",
        },
      ];
    },
    [getHasCollateralField, getHasCollateralPayloadValue]
  );

  const getCollateralModeForFields = useCallback(
    (sectionFields: any[], sourceValues: Record<string, any>) => {
      const typeField = sectionFields.find((field: any) => {
        const normalized = getNormalizedFieldToken(field?.name);
        return (
          /^collateral\d*type$/.test(normalized) ||
          getNormalizedFieldToken(field?.label).includes("collateraltype")
        );
      });

      if (!typeField) return null;

      const raw = sourceValues?.[typeField?.name];
      const rawValue = toOptionValue(raw);
      const normalized = getNormalizedFieldToken(rawValue);
      const normalizedValue = String(rawValue ?? "").trim();

      if (
        normalizedValue === "307" ||
        normalized.includes("fixed") ||
        normalized.includes("fd")
      ) {
        return "fixed";
      }
      if (normalizedValue === "309" || normalized.includes("saving")) {
        return "savings";
      }
      if (normalizedValue === "308" || normalized.includes("property")) {
        return "property";
      }
      return null;
    },
    []
  );

  const getVisibleCollateralBaseFields = useCallback(
    (baseFields: any[], sourceValues: Record<string, any>) => {
      const mode = getCollateralModeForFields(baseFields, sourceValues);
      if (!mode) return baseFields;

      const commonTokens = ["collateraltype", "collateralvalue"];
      const fixedTokens = ["fdholdername", "fdnumber"];
      const savingsTokens = ["accountnumber"];
      const propertyTokens = [
        "unitprice",
        "noofunits",
        "totalvalue",
        "propertypename",
        "propertysubtypename",
        "addresstype",
        "addressline1",
        "addressline2",
        "pincode",
        "city",
        "state",
        "country",
      ];

      const hasToken = (field: any, tokens: string[]) => {
        const normalizedName = getNormalizedFieldToken(field?.name);
        const normalizedLabel = getNormalizedFieldToken(field?.label);
        return tokens.some(
          (token) =>
            normalizedName.includes(token) || normalizedLabel.includes(token)
        );
      };

      const isTypeOrValueField = (field: any) => {
        const normalized = getNormalizedFieldToken(field?.name);
        return (
          /^collateral\d*type$/.test(normalized) ||
          /^collateral\d*value$/.test(normalized) ||
          hasToken(field, commonTokens)
        );
      };

      const tokenMap = {
        fixed: fixedTokens,
        savings: savingsTokens,
        property: propertyTokens,
      } as const;

      return baseFields.filter(
        (field: any) =>
          isTypeOrValueField(field) ||
          (mode === "savings" && /^collateral\d+holderName$/i.test(String(field?.name || ""))) ||
          hasToken(field, tokenMap[mode as keyof typeof tokenMap])
      );
    },
    [getCollateralModeForFields]
  );

  const getReferenceCollateralActiveFields = useCallback(
    (sourceValues: Record<string, any>) => {
      if (!isReferenceCollateralStep) {
        return fields || [];
      }

      if (referenceCollateralActiveTab === 0) {
        return getReferenceSectionFields(activeReferenceSection);
      }

      const hasCollateralField = getHasCollateralField();
      if (isHasCollateralNoValue(sourceValues)) {
        return hasCollateralField ? [hasCollateralField] : [];
      }

      const { base, coOwner } = getCollateralSectionFields(activeCollateralSection);
      return [
        ...(hasCollateralField ? [hasCollateralField] : []),
        ...getVisibleCollateralBaseFields(base, sourceValues),
        ...coOwner,
      ];
    },
    [
      activeCollateralSection,
      activeReferenceSection,
      fields,
      getCollateralSectionFields,
      getHasCollateralField,
      getReferenceSectionFields,
      getVisibleCollateralBaseFields,
      isHasCollateralNoValue,
      isReferenceCollateralStep,
      referenceCollateralActiveTab,
    ]
  );

  const hasReferenceCollateralValue = (value: any) =>
    value !== null && value !== undefined && String(value).trim() !== "";

  const getReferenceSectionNumbersForSave = useCallback(
    (sourceValues: Record<string, any>) => {
      const numbers = Array.from<number>(
        new Set(
          (referenceCollateralFields || [])
            .map((field: any) =>
              Number(
                String(field?.name || "").match(
                  /^(?:basic|address)Reference(\d+)/i
                )?.[1]
              )
            )
            .filter(Boolean)
        )
      ).sort((a, b) => a - b);

      return numbers.filter(
        (number) =>
          number === activeReferenceSection ||
          getReferenceSectionFields(number).some((field: any) =>
            hasReferenceCollateralValue(sourceValues?.[field.name])
          )
      );
    },
    [activeReferenceSection, getReferenceSectionFields, referenceCollateralFields]
  );

  const getCollateralSectionNumbersForSave = useCallback(
    (sourceValues: Record<string, any>) => {
      if (isHasCollateralNoValue(sourceValues)) return [];

      const numbers = Array.from<number>(
        new Set(
          (referenceCollateralFields || [])
            .map((field: any) => {
              const name = String(field?.name || "");
              const match =
                name.match(/^collateral(\d+)/i) ||
                name.match(/^coOwnerCollateral(\d+)/i);
              return Number(match?.[1] || (name.match(/^collateral/i) ? 1 : 0));
            })
            .filter(Boolean)
        )
      ).sort((a, b) => a - b);

      return numbers.filter((number) => {
        const { base, coOwner } = getCollateralSectionFields(number);
        return (
          number === activeCollateralSection ||
          [...base, ...coOwner].some((field: any) =>
            hasReferenceCollateralValue(sourceValues?.[field.name])
          )
        );
      });
    },
    [activeCollateralSection, getCollateralSectionFields, isHasCollateralNoValue, referenceCollateralFields]
  );

  const getReferenceCollateralSaveFields = useCallback(
    (sourceValues: Record<string, any>) => {
      if (!isReferenceCollateralStep) return fields || [];

      if (referenceCollateralActiveTab === 0) {
        return getReferenceSectionNumbersForSave(sourceValues).flatMap(
          getReferenceSectionFields
        );
      }

      const hasCollateralField = getHasCollateralField();
      if (isHasCollateralNoValue(sourceValues)) {
        return hasCollateralField ? [hasCollateralField] : [];
      }

      return getCollateralSectionNumbersForSave(sourceValues).flatMap(
        (number) => {
          const { base, coOwner } = getCollateralSectionFields(number);
          return [
            ...(number === 1 && hasCollateralField ? [hasCollateralField] : []),
            ...getVisibleCollateralBaseFields(base, sourceValues),
            ...coOwner,
          ];
        }
      );
    },
    [
      fields,
      getCollateralSectionFields,
      getCollateralSectionNumbersForSave,
      getHasCollateralField,
      getReferenceSectionFields,
      getReferenceSectionNumbersForSave,
      getVisibleCollateralBaseFields,
      isHasCollateralNoValue,
      isReferenceCollateralStep,
      referenceCollateralActiveTab,
      activeCollateralSection,
    ]
  );

  const canAdvanceStepper = pageType !== "SUMMARY";
  const moveToNextStep = useCallback(() => {
    if (!canAdvanceStepper) return;
    dispatch(nextVerticalStep());
  }, [canAdvanceStepper, dispatch]);
  const moveToStep = useCallback(
    (horizontalIndex: number, verticalIndex: number) => {
      if (!canAdvanceStepper) return;
      dispatch(setActiveHorizontalIndex(horizontalIndex));
      dispatch(setActiveVerticalIndex(verticalIndex));
    },
    [canAdvanceStepper, dispatch]
  );
  const updateLeadWithLatestLeadData = useCallback(async (payload: any) => {
    const resolvedTrackingId = String(payload?.trackingId || "");
    let leadDataPayload = {};

    if (resolvedTrackingId) {
      try {
        const leadDataResp: any = await losServices.getDataByLeadId({
          trackingId: resolvedTrackingId,
        });
        const leadConfigData = leadDataResp?.data?.data?.configs || leadDataResp?.data?.configs || {};
        leadDataPayload = {
          leadType: leadConfigData?.leadType ?? null,
          leadSource: leadConfigData?.leadSource ?? null,
          leadSystem: leadConfigData?.leadSystem ?? null,
          partnerLead: leadConfigData?.partnerLead ?? null,
          qualifiedPartner: leadConfigData?.qualifiedPartner ?? null,
          marketingLead: leadConfigData?.marketingLead ?? null,
          leadSubSource: leadConfigData?.leadSubSource ?? null,
          undergraduateFlag: leadConfigData?.undergraduateFlag ?? null,
          partnerFirmId:leadConfigData?.partnerFirmId ?? null,
        };
      } catch (error) {
        console.error("getdata-byleadId failed:", error);
      }
    }

    return losServices.updateLead({
      ...payload,
      ...leadDataPayload,
    });
  }, []);
  const previousStepRef = useRef({
    horizontal: activeHorizontalIndex,
    vertical: activeVerticalIndex,
  });
  useEffect(() => {
    const isSummaryEligibilitySection =
      pageType === "SUMMARY" &&
      activeHorizontalIndex === 0 &&
      [0, 1, 2].includes(activeVerticalIndex);

    if (!isSummaryEligibilitySection || !trackingId) {
      summaryEligibilityLeadSyncInitializedRef.current = false;
      lastSummaryEligibilityLeadPayloadRef.current = "";
      return;
    }

    // Don't send full `formData` to update-lead API; only use it to detect changes.
    const updateLeadPayload = {
      trackingId: String(trackingId),
    };
    const payloadSignature = JSON.stringify({
      trackingId: String(trackingId),
      formData,
    });

    // Skip first run when summary section opens; only send on user changes.
    if (!summaryEligibilityLeadSyncInitializedRef.current) { 
      summaryEligibilityLeadSyncInitializedRef.current = true;
      lastSummaryEligibilityLeadPayloadRef.current = payloadSignature;
      return;
    }

    if (payloadSignature === lastSummaryEligibilityLeadPayloadRef.current) return;

    const timer = setTimeout(async () => {
      try {
        await updateLeadWithLatestLeadData(updateLeadPayload);
        lastSummaryEligibilityLeadPayloadRef.current = payloadSignature;
      } catch (error: any) {
        console.error("Summary eligibility update lead sync failed:", error);
      }
    }, 450);

    return () => clearTimeout(timer);
  }, [
    pageType,
    activeHorizontalIndex,
    activeVerticalIndex,
    trackingId,
    formData,
    updateLeadWithLatestLeadData,
  ]);
  const reduxLastPanNumber = useSelector(
    (state: RootState) => state.stepper.lastPanNumber
  );
  const isEligibilityCheckSubmitted = useSelector(
    (state: RootState) => state.stepper.isEligibilityCheckSubmitted
  );
  const userProfile = useSelector(
    (state: RootState) => state?.auth?.userProfile
  );
  const notInList = useSelector(
    (state: RootState) => state?.stepper?.notInList
  );
  const applicationIdApp = useSelector(
    (state: RootState) => state?.stepper?.applicationId
  );
  const applicantIdApp = useSelector(
    (state: RootState) => state?.stepper?.applicantId
  );

  const validationSchema = getValidationSchema(
    fields,
    activeHorizontalIndex,
    activeVerticalIndex,
    notInList,
    pageType
  );

  useEffect(() => {
    if (
      pageType !== "SUMMARY" ||
      activeHorizontalIndex !== 0 ||
      activeVerticalIndex !== 0 ||
      !formikRef.current
    ) {
      return;
    }
    formikRef.current.setFieldValue("terms_conditions", true, false);
    formikRef.current.setFieldValue("privacy_policy", true, false);
    dispatch(
      updateFormData({
        terms_conditions: true,
        privacy_policy: true,
      })
    );
  }, [pageType, activeHorizontalIndex, activeVerticalIndex, dispatch]);
  // For Step 2
  const isPanStep = activeHorizontalIndex === 1 && activeVerticalIndex === 0;
  const [isAadharLoading, setIsAadharLoading] = useState(false);
  const [isAadharCoApplicantLoading, setIsAadharCoApplicantLoading] = useState<
    Record<string, boolean>
  >({});
  const [isCurrentSameAsPermanent, setIsCurrentSameAsPermanent] =
    useState(false);
  // To prevent eaadhaar API call on verify now button click
  const [isEaadhaarOnVerifyNow, setIsEaadhaarOnVerifyNow] = useState(false);

  const MobileNumberTooltipContent = (
    <Typography variant="caption">
      Mobile number should be the one which is linked with Aadhaar.
    </Typography>
  );

  // Configure DOMPurify once (can be at top of your component file)
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank"); // opens in new tab
      node.setAttribute("rel", "noopener noreferrer"); // security best practice
    }
  });

  useEffect(() => {
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      setIsCurrentSameAsPermanent(
        isSameAsPermanentChecked(formikRef?.current?.values?.currentsameAsPermanent)
      );
    }
  }, [formikRef?.current?.values?.currentsameAsPermanent, activeHorizontalIndex, activeVerticalIndex])

  useEffect(() => {
    const previousStep = previousStepRef.current;
    const isHorizontalStepChanged =
      activeHorizontalIndex !== previousStep.horizontal;
    const isVerticalStepIncreased =
      activeVerticalIndex > previousStep.vertical;

    if (isHorizontalStepChanged || isVerticalStepIncreased) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    previousStepRef.current = {
      horizontal: activeHorizontalIndex,
      vertical: activeVerticalIndex,
    };
  }, [activeHorizontalIndex, activeVerticalIndex]);

  // useEffect(() => {
  //   // Set default value for main applicant if not present
  //   if (!formData?.employmentisEmployed) {
  //     dispatch(updateFormData({ ...formData, employmentisEmployed: "Yes" }));
  //   }
  // }, [formData]);

  useEffect(() => {
    if (formikRef.current) {
      const isEligibilityConsentStep =
        activeHorizontalIndex === 0 && activeVerticalIndex === 0;
      // For Applicant Step 0 Form 0 - Personal Details
      formikRef.current.setFieldValue(
        "isMobileVerified",
        isEligibilityConsentStep && hasNonEmptyFormValue(formData?.isMobileVerified)
          ? isTruthyFormFlag(formData?.isMobileVerified)
          : isTruthyFormFlag(isMobileVerified)
      );
      if (isEligibilityConsentStep) {
        if (hasNonEmptyFormValue(formData?.isEmailVerified)) {
          formikRef.current.setFieldValue(
            "isEmailVerified",
            isTruthyFormFlag(formData?.isEmailVerified)
          );
        }
      } else {
        formikRef.current.setFieldValue(
          "isEmailVerified",
          isTruthyFormFlag(isEmailVerified)
        );
      }
      // For Student Loan - Applicant
      formikRef.current.setFieldValue(
        "isPanVerified",
        isPanVerified ? true : false
      );
      formikRef.current.setFieldValue(
        "isAadhaarVerified",
        isDocumentVerified ? true : false
      );

      // Dynamic for all co-applicants
      Object.keys(coApplicantVerification).forEach((idx) => {
        const num = Number(idx) + 1;
        // Only set if Redux value is not undefined, else preserve Formik value
        if (typeof coApplicantVerification[idx]?.panVerified !== "undefined") {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsPanVerified`,
            coApplicantVerification[idx]?.panVerified
          );
        }
        if (
          typeof coApplicantVerification[idx]?.emailVerified !== "undefined"
        ) {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsEmailVerified`,
            coApplicantVerification[idx]?.emailVerified
          );
        }
        if (
          typeof coApplicantVerification[idx]?.mobileVerified !== "undefined"
        ) {
          formikRef?.current?.setFieldValue(
            `basicCoApplicant${num}IsMobileVerified`,
            coApplicantVerification[idx]?.mobileVerified
          );
        }
      });

      // Set AadhaarVerified field for all co-applicants from isDocumentVerifiedCoApplicant
      if (
        typeof isDocumentVerifiedCoApplicant === "object" &&
        isDocumentVerifiedCoApplicant !== null
      ) {
        Object.keys(isDocumentVerifiedCoApplicant).forEach((coAppKey) => {
          // coAppKey is like 'CoApplicant1', extract number
          const match = coAppKey.match(/CoApplicant(\d+)/);
          if (match) {
            const num = match[1];
            if (formikRef.current) {
              formikRef.current.setFieldValue(
                `basicCoApplicant${num}AadhaarVerified`,
                isDocumentVerifiedCoApplicant[coAppKey] ? true : ""
              );
            }
          }
        });
      }
    }
  }, [
    isMobileVerified,
    isEmailVerified,
    isPanVerified,
    isDocumentVerified,
    coApplicantVerification,
    isDocumentVerifiedCoApplicant,
  ]);

  // Safely hydrate Formik from Redux formData (especially after refresh fetch flow)
  // without overriding actively entered values.
  useEffect(() => {
    if (!formikRef.current || !formData) return;

    const currentValues = formikRef.current.values || {};
    let hasChanges = false;
    const nextValues: Record<string, any> = { ...currentValues };

    Object.entries(formData).forEach(([key, reduxValue]) => {
      const currentValue = currentValues[key];
      const isCurrentBlank =
        currentValue === undefined || currentValue === null || currentValue === "";

      const hasReduxValue =
        reduxValue !== undefined && reduxValue !== null && reduxValue !== "";

      const shouldSyncEligibilityVerificationFlag =
        activeHorizontalIndex === 0 &&
        activeVerticalIndex === 0 &&
        (key === "isEmailVerified" || key === "isMobileVerified") &&
        hasReduxValue &&
        currentValue !== reduxValue;

      const isCoApplicantEmailField =
        /^(?:basic)?CoApplicant\d+Email$/i.test(key);
      const shouldSyncCoApplicantEmail =
        isCoApplicantEmailField &&
        hasReduxValue &&
        String(currentValue ?? "").trim().toLowerCase() !==
          String(reduxValue ?? "").trim().toLowerCase();

      if (
        (isCurrentBlank && hasReduxValue) ||
        shouldSyncEligibilityVerificationFlag ||
        shouldSyncCoApplicantEmail
      ) {
        nextValues[key] = reduxValue;
        hasChanges = true;
      }
    });

    if (hasChanges) {
      formikRef.current.setValues(nextValues, false);
    }
  }, [formData, completionSummaryRefreshNonce]);
  const [relationshipOptions, setRelationshipOptions] = useState<any>([]);

  const handleRelationMasterApi = async () => {
    setIsApiLoading(true);
    try {
      const data = await losServices.relationMaster();
      if (data.status == 200) {
        const optionsData = data?.data?.data?.map((item: any) => ({
          label: item.descInPennant,
          value: item.codeInPennant,
        }));
        setRelationshipOptions(optionsData);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsApiLoading(false);
    }
  };

  /**
   * Auto-populate email and phone number fields with user profile data
   * on the first step of the form (horizontal index 0, vertical index 0).
   *
   * This effect automatically fills in the user's verified email and phone number
   * from their profile when they reach the initial form step, and marks these
   * fields as verified in the Redux store. The email and phone data is decrypted
   * before being set in the form.
   *
   * @effect
   * @dependencies {number} activeHorizontalIndex - Current horizontal step index
   * @dependencies {number} activeVerticalIndex - Current vertical step index
   * @dependencies {object} userProfile - User profile data containing encrypted email and phone
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  useEffect(() => {
    const profileEmail = (decrypt(userProfile?.email) || "").toLowerCase();
    const existingEmail =
      formikRef?.current?.values?.studentDetailEmail ||
      formikRef?.current?.values?.email ||
      formData?.studentDetailEmail ||
      formData?.email ||
      "";
    const resolvedEmail = existingEmail || profileEmail;
    const hasExplicitEmailVerificationFlag = hasNonEmptyFormValue(
      formData?.isEmailVerified
    );
    const shouldAutoVerifyPrefilledEmail =
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0 &&
      !hasExplicitEmailVerificationFlag &&
      !!profileEmail &&
      String(resolvedEmail || "").trim().toLowerCase() ===
        String(profileEmail || "").trim().toLowerCase();

    // Applicant loan — Student Details (same trust as step 0): logged-in profile email is verified.
    const shouldAutoVerifyApplicantLoanPrefilledEmail =
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      !hasExplicitEmailVerificationFlag &&
      !!profileEmail &&
      String(resolvedEmail || "").trim().toLowerCase() ===
        String(profileEmail || "").trim().toLowerCase();

    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      (userProfile?.email || userProfile?.phoneNumber)
    ) {
      let fullname = userProfile?.fullName?.split(" ");
      formikRef?.current?.setFieldValue("email", resolvedEmail);
      formikRef?.current?.setFieldValue("studentDetailEmail", resolvedEmail);
      if (shouldAutoVerifyApplicantLoanPrefilledEmail) {
        dispatch(setIsEmailVerified(true));
        formikRef?.current?.setFieldValue("isEmailVerified", true, false);
      }
      if (!lastVerifiedEmail && resolvedEmail) {
        dispatch(setLastVerifiedEmail(resolvedEmail));
      }
      formikRef?.current?.setFieldValue(
        "phone_number",
        decrypt(userProfile?.phoneNumber)
      );
      
        const finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
        const finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];
      
        formikRef?.current?.setFieldValue("firstName", finalFirstName);
        formikRef?.current?.setFieldValue("lastName", finalLastName); 
      //dispatch(setIsMobileVerified(true));
      dispatch(setLastVerifiedPhoneNumber(decrypt(userProfile?.phoneNumber)));
      dispatch(updateFormData({
          email: resolvedEmail,
          studentDetailEmail: resolvedEmail,
          firstName: formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0],
          lastName: formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1],
          phone_number:  decrypt(userProfile?.phoneNumber),
          ...(shouldAutoVerifyApplicantLoanPrefilledEmail
            ? { isEmailVerified: true }
            : {}),
        }));
    }else{
      if (!(userProfile?.email || userProfile?.phoneNumber)) return;
      if (!formikRef?.current) return;

      const fullname = userProfile?.fullName?.split(" ") ?? [];
      const decryptedPhone = decrypt(userProfile?.phoneNumber);
      const firstName = fullname[0] || "";
      const lastName = fullname[1] || "";
        formikRef.current.setFieldValue("email", resolvedEmail);
        formikRef.current.setFieldValue("studentDetailEmail", resolvedEmail);
        if (shouldAutoVerifyPrefilledEmail) {
            dispatch(setIsEmailVerified(true));
            dispatch(setIsMobileVerified(true));
        }
        if (!lastVerifiedEmail && resolvedEmail) {
          dispatch(setLastVerifiedEmail(resolvedEmail));
        }

        formikRef.current.setFieldValue("phone_number", decryptedPhone);
        dispatch(setLastVerifiedPhoneNumber(decryptedPhone));

        // Also prefill studentDetails fields (used on student details page)
        // Only set if not already populated — preserves any user edits
        if (!formikRef.current.values?.studentDetailsFirstName) {
          formikRef.current.setFieldValue("studentDetailsFirstName", firstName);
        }
        if (!formikRef.current.values?.studentDetailsLastName) {
          formikRef.current.setFieldValue("studentDetailsLastName", lastName);
        }
        if (!formikRef.current.values?.studentDetailsPhone_number) {
          formikRef.current.setFieldValue("studentDetailsPhone_number", decryptedPhone);
        }
        if (!formikRef.current.values?.studentDetailEmail) {
          formikRef.current.setFieldValue("studentDetailEmail", resolvedEmail);
        }
        let finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
        let finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];
      
        formikRef?.current?.setFieldValue("firstName", finalFirstName);
        formikRef?.current?.setFieldValue("lastName", finalLastName);  
      // Persist to Redux formData so initialValues mapping also picks them up on re-render
        dispatch(updateFormData({
          email: resolvedEmail,
          studentDetailEmail: resolvedEmail,
          firstName: formikRef.current?.values?.studentDetailsFirstName || formikRef.current?.values?.firstName || fullname[0],
          lastName: formikRef.current?.values?.studentDetailsLastName || formikRef.current?.values?.lastName || fullname[1],
          phone_number: decryptedPhone,
        }));
      }
      const fullname = userProfile?.fullName?.split(" ") ?? [];
      const finalFirstName = formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || fullname[0];
      const finalLastName = formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || fullname[1];

      // formikRef?.current?.setValues({
      //   firstName: finalFirstName,
      //   lastName: finalLastName,
      // });

      // dispatch(updateFormData({
      //   firstName: finalFirstName,
      //   lastName: finalLastName,
      // }));
  }, [activeHorizontalIndex, activeVerticalIndex, userProfile, formData?.email, formData?.studentDetailEmail, lastVerifiedEmail]);
  /**
   * Fetch initial data required for the dynamic form on component mount.
   *
   * This effect runs once when the component mounts and fetches three types of data:
   * 1. Product options - Available loan products with their codes and names
   * 2. Master data - Course categories, admission statuses, and course types for dropdowns
   * 3. Countries - List of available countries for address and other location fields
   *
   * All fetched data is stored in component state to populate dropdown fields throughout
   * the form. Loading states are managed to provide user feedback during data fetching.
   * Error handling ensures the form remains functional even if some data fails to load.
   *
   * @effect
   * @dependencies [] - Empty dependency array means this runs only on mount
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  useEffect(() => {
    // Fetch Products on component mount

    if (
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 || activeVerticalIndex === 5)
    ) {
      handleRelationMasterApi();
    }

    // Fetch relation master for Additional Details sections in SUMMARY mode
    const isSummaryAdditionalDetails =
      pageType === "SUMMARY" && isAdditionalDetailsStep;
    if (isSummaryAdditionalDetails && activeVerticalIndex === 2) {
      handleRelationMasterApi();
    }

    const fetchProducts = async () => {
      setLoadingProducts(true);
      try {
        const res = await dropdownService.getProducts();
        setProductOptions(
          res.data.map((prod) => ({
            value: prod.code,
            label: prod.name,
          }))
        );
      } catch (error) {
        setProductOptions([]);
      } finally {
        setLoadingProducts(false);
      }
    };
    // Fetch master data for dropdowns like courseCategory, admissionStatus, courseType
    const fetchMasterData = async () => {
      try {
        const res = await eligibilityCheckServices.getMasters();
        if (res.data?.status === "success") {
          setDropdownData((prev) => ({
            ...prev,
            courseCategory: (res.data.data.categories || []).map(
              (cat: any) => ({
                value: cat.categoryCode,
                label: cat.categoryName,
              })
            ),
            admissionStatus: (res.data.data.statusesOfAdmission || []).map(
              (stat: any) => ({
                value: stat.statusName,
                label: stat.statusName,
              })
            ),
            courseType: (res.data.data.courseTypes || []).map((type: any) => ({
              value: type.typeCode,
              label: type.typeName,
            })),
          }));
        }
      } catch (error) {
        // Optionally handle error or fallback to static data
        console.error("Failed to fetch master data", error);
      }
    };

    // Fetch Countries on component mount
    const fetchCountries = async () => {
      setLoadingDropdowns((prev) => ({ ...prev, countries: true }));
      try {
        const countriesResponse = await dropdownService.getCountries();
        const allCountries = countriesResponse.data
          // .filter((country) => country.active)
          .map((country) => ({
            value: country.countryId,
            label: country.countryDesc,
            countryId: String(country.countryId ?? ""),
          }));
        // Separate top countries and rest
        const topCountries: any[] = [];
        const restCountries: any[] = [];

        allCountries.forEach((country) => {
          const countryLabel = country.label.toUpperCase();
          const isTopCountry = topCountry.some((topName: any) =>
            countryLabel.includes(topName)
          );

          if (isTopCountry) {
            topCountries.push(country);
          } else {
            restCountries.push(country);
          }
        });

        // Sort top countries by the order in topCountryNames array
        topCountries.sort((a, b) => {
          const aIndex = topCountry.findIndex((name: any) =>
            a.label.toUpperCase().includes(name)
          );
          const bIndex = topCountry.findIndex((name: any) =>
            b.label.toUpperCase().includes(name)
          );
          return aIndex - bIndex;
        });

        // Sort rest of countries alphabetically
        restCountries.sort((a, b) => a.label.localeCompare(b.label));

        // Combine: top countries first, then rest
        const countriesOptions = [...topCountries, ...restCountries];
        setDropdownData((prev) => ({
          ...prev,
          countries: countriesOptions,
        }));
        setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
      }
    };
    // Fetch Salutations on component mount
    const fetchSalutations = async () => {
      setLoadingDropdowns((prev) => ({ ...prev, salutations: true }));
      try {
        const salutationResponse = await dropdownService.getSalutations();
        const salutationsOptions = salutationResponse.data
          // .filter((sal) => sal.active)
          .map((sal) => ({
            value: sal.salutationCode,
            label: sal.salutationDesc,
          }));

        setDropdownData((prev) => ({
          ...prev,
          salutations: salutationsOptions,
        }));
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        //setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
      }
    };

    // Fetch System Values after Salutations
    const fetchSystemValues = async () => {
      try {
        const systemValuesResponse =
          await eligibilityCheckServices.getSystemValues();

        if (systemValuesResponse.data?.status === "success") {
          const systemValues = systemValuesResponse.data.data;

          // Filter and process Language Exam Types
          const languageExamTypes = systemValues
            .filter(
              (item: any) => item.name === "LANGUAGE_EXAM_TYPE" && item.active
            )
            .map((item: any) => ({
              value: item.code,
              label: item.value,
              id: item.serialId,
            }));

          // Filter and process Entrance Exam Types
          const entranceExamTypes = systemValues
            .filter(
              (item: any) => item.name === "ENTRANCE_EXAM_TYPE" && item.active
            )
            .map((item: any) => ({
              value: item.code,
              label: item.value,
              id: item.serialId,
            }));

          const loanTenureOptions = systemValues
            .filter(
              (item: any) => item.name === "LOAN_TENURE_INMONTH" && item.active
            )
            .map((item: any) => ({
              value: item.id,
              label: item.value,
              id: item.serialId,
            }));

          // Update dropdown data with system values
          setDropdownData((prev) => ({
            ...prev,
            languageExamTypes,
            entranceExamTypes,
            loanTenureOptions,
          }));
        }
      } catch (error) {
        console.error("Error fetching system values:", error);
      }
    };

    // Get Entrance Exam Master
    const getEntranceExamMaster = async () => {
      try {
        const response = await eligibilityCheckServices.getEntranceExamMaster();
        if (response?.data?.data) {
          setEntranceExamMaster(response.data.data);
        }
      } catch (error: any) {
        console.log(error, "error");
        setEntranceExamMaster([]);
      }
    };

    // Fetch Designations
    const fetchDesignations = async () => {
      try {
        const designationResponse =
          await eligibilityCheckServices.getDesignations();
        if (designationResponse?.data?.status === "success") {
          const designationsOptions = designationResponse.data.data.map(
            (designation: any) => ({
              value: designation.genDesignation,
              label: designation.genDesgDesc,
            })
          );
          setTimeout(() => {
            setDropdownData((prev) => ({
            ...prev,
            designations: designationsOptions,
          }));
         console.log(dropdownData, 'designationsOptions')
          }, 1000);

        }
      } catch (error) {
        console.error("Error fetching designations:", error);
      }
    };

    // Execute API calls based on step conditions
    const executeApiCalls = async () => {
      const promises: Promise<void>[] = [];

      if (activeHorizontalIndex === 0 && activeVerticalIndex === 0) {
        promises.push(fetchProducts());
      }

      if (
        activeHorizontalIndex === 0 &&
        (activeVerticalIndex === 1 || activeVerticalIndex === 5)
      ) {
        promises.push(fetchMasterData());
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
        debouncedZipCodeCall(formData.permanentPincode, undefined, "permanent");
        debouncedZipCodeCall(formData.currentPincode, undefined, "current");
      }

      if (
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 5 &&
        /^CoApplicant\d+$/.test(loanDetailCoApplicantCollapseValue) &&
        tabIndex[loanDetailCoApplicantCollapseValue] === 1
      ) {
        const coNum = loanDetailCoApplicantCollapseValue.replace(
          "CoApplicant",
          ""
        );
        debouncedZipCodeCall(
          formData[`addressCoApplicant${coNum}permanentPincode`],
          loanDetailCoApplicantCollapseValue,
          "permanent"
        );
        debouncedZipCodeCall(
          formData[`addressCoApplicant${coNum}currentPincode`],
          loanDetailCoApplicantCollapseValue,
          "current"
        );
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 2) {
        debouncedCompanyZipCodeCall(formData.employmentCompanyPincode);
      }

      if (
        (activeHorizontalIndex === 0 && activeVerticalIndex === 1) ||
        (activeHorizontalIndex === 1 &&
          (activeVerticalIndex === 1 ||
            activeVerticalIndex === 2 ||
            activeVerticalIndex === 5)) ||
            isSummaryAdditionalDetails
      ) {
        promises.push(fetchCountries());
      }

      if (
        activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 0 || activeVerticalIndex === 5)
      ) {
        promises.push(fetchSalutations());
      }
      // Fetch salutations for Additional Details sections in SUMMARY mode
      if (isSummaryAdditionalDetails && activeVerticalIndex === 0) {
        promises.push(fetchSalutations());
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 2) {
        promises.push(fetchDesignations());
        handleInvokCompanyZipCode(String(formData.employmentCompanyPincode));
      }
      if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
        promises.push(fetchDesignations());
      }
      // Fetch designations for Additional Details sections
      if (isSummaryAdditionalDetails) {
        promises.push(fetchDesignations());
      }

      if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
        promises.push(getEntranceExamMaster());
        promises.push(fetchSystemValues());
      }

      if (isApplicantAdditionalDetailsStep) {
        promises.push(fetchSystemValues());
      }

      // Set loading state at the start
      if (promises.length > 0) {
        setIsApiLoading(true);
        try {
          // Wait for all API calls to complete
          await Promise.all(promises);
        } finally {
          setIsApiLoading(false);
        }
      }
    };

    executeApiCalls();
  }, [activeHorizontalIndex, activeVerticalIndex, tabIndex, loanDetailCoApplicantCollapseValue]);

  // Initialize courseXTypeId fields and default courseXType values on academic details page load
  useEffect(() => {
    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 3 &&
      formikRef.current
    ) {
      const currentFormData = { ...formData };
      let hasChanges = false;

      // Define default course type values
      const defaultCourseTypes: { [key: string]: string } = {
        course1Type: "10th",
        course2Type: "12th",
        course3Type: "Graduation",
      };

      // Set default values for course types if not already set
      Object.entries(defaultCourseTypes).forEach(
        ([fieldName, defaultValue]) => {
          if (
            !formData?.[fieldName] &&
            !formikRef.current?.values?.[fieldName]
          ) {
            formikRef.current?.setFieldValue(fieldName, defaultValue, false);
            currentFormData[fieldName] = defaultValue;
            hasChanges = true;
          }
        }
      );

      // Iterate through formData to find courseXType fields and calculate TypeId
      Object.keys(currentFormData).forEach((key) => {
        const courseTypeMatch = key.match(/^course(\d+)Type$/);
        if (courseTypeMatch && currentFormData[key]) {
          const courseNumber = courseTypeMatch[1];
          const courseTypeIdField = `course${courseNumber}TypeID`;
          const courseTypeValue = currentFormData[key];

          // Calculate examTypeIdValue based on course type
          let examTypeIdValue: number = 0;
          if (courseTypeValue === "10th") {
            examTypeIdValue = 283;
          } else if (courseTypeValue === "12th") {
            examTypeIdValue = 284;
          } else if (courseTypeValue === "Diploma") {
            examTypeIdValue = 285;
          } else if (courseTypeValue === "Graduation") {
            examTypeIdValue = 286;
          }

          // Set the TypeId field in form values and Redux if not already set
          if (examTypeIdValue !== 0 && !currentFormData[courseTypeIdField]) {
            formikRef.current?.setFieldValue(
              courseTypeIdField,
              examTypeIdValue,
              false
            );
            currentFormData[courseTypeIdField] = examTypeIdValue;
            hasChanges = true;
          }
        }
      });

      // Update Redux only if there are changes
      if (hasChanges) {
        dispatch(updateFormData(currentFormData));
      }
    }
  }, [activeHorizontalIndex, activeVerticalIndex, dispatch]);

  const handleExamDropdownChange = (
    field: string,
    value: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    // Support dynamic field names with suffixes, e.g., languageExamName_6;
    let examType = field.startsWith("coreExamName")
      ? "CORE_EXAM"
      : "LANGUAGE_EXAM";
    const found: any = entranceExamMaster.find(
      (exam: any) => exam.examTypeName === examType && exam.examName === value
    );
    // Determine suffix (e.g., _6)
    const suffixMatch = field.match(/_(\d+)$/);
    const suffix = suffixMatch ? `_${suffixMatch[1]}` : "";
    const marksField = field.startsWith("coreExamName")
      ? `coreTotalMarks${suffix}`
      : `languageTotalMarks${suffix}`;
    // Set exam name WITHOUT triggering cascade validation on other fields
    setFieldValue(field, value, false);
    if (found && found.totalMarks) {
      setFieldValue(marksField, found.totalMarks, false);
    } else {
      setFieldValue(marksField, "", false);
    }

    // Store exam ID in Redux and form values
    const isCoreExam = field.startsWith("coreExamName");
    const examIdField = isCoreExam
      ? `coreExamID${suffix}`
      : `languageExamID${suffix}`;
    const examIdFieldLowercase = isCoreExam
      ? `coreExamId${suffix}`
      : `languageExamId${suffix}`;

    // Find the exam ID from dropdownData
    const examTypes = isCoreExam
      ? dropdownData?.entranceExamTypes
      : dropdownData?.languageExamTypes;

    const selectedExam = examTypes?.find((exam: any) => exam.label === value);
    const examId = selectedExam?.id || "";

    // Set exam ID WITHOUT triggering cascade validation on other fields
    setFieldValue(examIdField, examId, false);
    setFieldValue(examIdFieldLowercase, examId, false);

    // Store exam name and ID in Redux
    const currentFormData = { ...formData };
    currentFormData[field] = value; // Store exam name (e.g., coreExamName, coreExamName_7)
    currentFormData[examIdField] = examId; // Store exam ID uppercase (e.g., coreExamID, coreExamID_7)
    currentFormData[examIdFieldLowercase] = examId; // Store exam ID lowercase (e.g., coreExamId, coreExamId_7)

    dispatch(updateFormData(currentFormData));
  };

  // Retry wrapper function for API calls
  const retryApiCall = async (
    apiCall: () => Promise<any>,
    maxRetries: number = 3,
    delay: number = 1000
  ): Promise<any> => {
    let lastError: any;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await apiCall();
        return response;
      } catch (error) {
        lastError = error;

        // If this is not the last attempt, wait before retrying
        if (attempt < maxRetries) {
          await new Promise((resolve) => setTimeout(resolve, delay));
          // Optional: Increase delay for next retry (exponential backoff)
          delay *= 1.5;
        }
      }
    }

    // If all retries failed, throw the last error
    throw lastError;
  };

  useEffect(() => {
    if (isLoadTesting) {
      dispatch(setIsDocumentVerified(true));
      const formikInstance = formikRef?.current;
      if (!formikInstance) {
        return;
      }
      // Only set the primary applicant's Aadhaar flag. Co-applicant Aadhaar
      // flags must be updated only by their own verification flow.
      formikInstance.setFieldValue("isAadhaarVerified", true, false);
    }
  }, [isLoadTesting, formikRef?.current?.values]);

  const handleInvokAadharApi = (
    applicationNo: string,
    payload: any,
    coAppKey?: string
  ): Promise<any> => {
    // Create unique verification key to track this specific verification call
    const verificationKey = `${payload?.typeOfApplicant}-${applicationNo}-${trackingId}`;

    // Check if this verification is already being processed
    if (processingAadhaarVerificationRef.current.has(verificationKey)) {
      return Promise.resolve(); // Skip duplicate call
    }

    // Mark this verification as being processed
    processingAadhaarVerificationRef.current.add(verificationKey);

    if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
      setIsAadharLoading(true);
    }

    if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
      setIsAadharCoApplicantLoading((prev) => ({
        ...prev,
        [String(coAppKey)]: true,
      }));
    }
    // Use retry wrapper for the API call
    return retryApiCall(
      () => applicantDetailsServices.verifyAadhaarApplication(payload),
      3,
      1000
    )
      .then((res) => {
        const detailsObject = {
          ...res.data.data.proofOfAddress,
          ...res.data.data.proofOfIdentity,
        };

        if (detailsObject?.dob) {
          if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
            if (
              formatDateToDDMMYYYY(
                formikRef?.current?.values?.[
                `basicCoApplicant${coAppKey?.replace("CoApplicant", "")}dob`
                ]
              ) !== detailsObject?.dob
            ) {
              //  setIsAadharCoApplicantLoading((prev) => ({
              //       ...prev,
              //       [String(coAppKey)]: false,
              //   }));
              // dispatch(
              //   setStatusPopup({
              //     status: "error",
              //     message:
              //       "DOB mismatch. Please ensure the Date of Birth matches the one linked to the Aadhaar.",
              //   })
              // );

              // return;
            }
          }

          if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
            if (
              formatDateToDDMMYYYY(formikRef?.current?.values?.dob) !==
              detailsObject?.dob
            ) {
              //setIsAadharLoading(false);
              // dispatch(
              //   setStatusPopup({
              //     status: "error",
              //     message:
              //       "DOB mismatch. Please ensure the Date of Birth matches the one linked to the Aadhaar.",
              //   })
              // );

              // return;
            }
          }
        }
        if (Number(applicationIdApp) != 0 && activeVerticalIndex !== 1) {
          const uploadedDocuments = res?.data?.data?.uploadedDocuments || [];
          // Loop through each uploaded document and call push document API sequentially
          let coApp = `1`;
          if (coAppKey) {
            coApp = coAppKey.replace("CoApplicant", "");
          }

          // Sequential processing of documents using async/await
          (async () => {
            for (const document of uploadedDocuments) {
              const docNamed = document?.docName?.replace(/\s+/g, "").toUpperCase();
              if (document?.docName) {
                // Create unique key for this document to prevent duplicate pushes
                const documentKey = `${payload?.typeOfApplicant}-${document?.docType}-${document?.key}-${trackingId}`;

                // Check if this document has already been pushed
                if (pushedDocumentsRef.current.has(documentKey)) {
                  continue; // Skip this document
                }

                let pushPayload: any = {
                  eventName:
                    payload?.typeOfApplicant === "Applicant"
                      ? `APPLICANT_${docNamed}_PUSH_DOCUMENT`
                      : `COAPPLICANT${coApp}_${docNamed}_PUSH_DOCUMENT`,
                  trackingId: trackingId,
                  docType: document?.docNameDms || "",
                  applicantId:
                    payload?.typeOfApplicant === "Applicant"
                      ? Number(applicantIdApp)
                      : 0,
                  applicationId: applicationIdApp ? Number(applicationIdApp) : 0,
                  documentFilePath: document?.key || "",
                  userApplicantType: payload?.typeOfApplicant,
                };

                if (document?.docType === "PANCR") {
                  pushPayload.applicantHasPanCardFlag = true;
                }

                // Call push document API for each document sequentially
                if (pushPayload.docType && ((payload?.typeOfApplicant === "Applicant" && pushPayload.applicantId > 0 && pushPayload.applicationId > 0) || (payload?.typeOfApplicant !== "Applicant" && pushPayload.applicationId > 0))) {
                  // Mark this document as pushed before making the API call
                  pushedDocumentsRef.current.add(documentKey);

                  try {
                    await eligibilityCheckServices.pushDocument(pushPayload);
                  } catch (pushError: any) {
                    console.error(
                      "Push document failed for document:",
                      document,
                      pushError
                    );
                    // Remove from set if push failed so it can be retried
                    pushedDocumentsRef.current.delete(documentKey);
                  }
                }
              }
            }
          })();


        }
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          setIsAadharLoading(false);
        }
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
          setIsAadharCoApplicantLoading((prev) => ({
            ...prev,
            [String(coAppKey)]: false,
          }));
        }

        // Remove from processing set after successful completion
        processingAadhaarVerificationRef.current.delete(verificationKey);

        if (!res?.data?.data?.isAadhaarConsent) {
          dispatch(
            setVerificationMessage({
              index:
                activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 5 &&
                  coAppKey
                  ? coAppKey
                  : `CoApplicant1`,
              applicantType:
                activeHorizontalIndex === 1 && activeVerticalIndex === 0
                  ? "applicant"
                  : "coapplicant",
              field: "aadhar",
              status: "error",
              message:
                "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
            })
          );
          return;
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          dispatch(
            setVerificationMessage({
              // index: "",
              applicantType: "applicant",
              field: "aadhar",
              status: "success",
              message: "Yay! Your Aadhaar has been verified successfully.",
            })
          );
        } else if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
          dispatch(
            setVerificationMessage({
              index: coAppKey ? coAppKey : `CoApplicant1`,
              applicantType: "coapplicant",
              field: "aadhar",
              status: "success",
              message:
                "Yay! The co-applicant’s Aadhaar has been successfully verified.",
            })
          );
        }

        // Clear document_verified param from URL
        if (activeHorizontalIndex === 1 && activeVerticalIndex !== 0) {
          const url = new URL(window.location.href);
          if (url.searchParams.has("document_verified")) {
            url.searchParams.delete("document_verified");
            window.history.replaceState({}, document.title, url.toString());
          }
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(setAadhaarVerifiedDetails(detailsObject));
          dispatch(setIsDocumentVerified(true));
          dispatch(setAadhaarApplicationNo(applicationNo));
          formikRef?.current?.setFieldValue("aadhaar", applicationNo);
          localStorage.removeItem("aadhaarApplicationNo");
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(setAadhaarVerifiedDetails(detailsObject));

          // Check if user has manually entered any permanent address data
          const hasManualPermanentAddress = (
            (formikRef?.current?.values?.permanentAddressLine1 && formikRef?.current?.values?.permanentAddressLine1.trim() !== "") ||
            (formikRef?.current?.values?.permanentAddressLine2 && formikRef?.current?.values?.permanentAddressLine2.trim() !== "") ||
            (formikRef?.current?.values?.permanentAddressLine3 && formikRef?.current?.values?.permanentAddressLine3.trim() !== "")
          );

          // Only prefill if user hasn't manually entered data
          if (!hasManualPermanentAddress) {
            // Prefill address fields from Aadhaar data on address page
            const conCatPermanentAddress: string = [
              handleUnwanted(detailsObject.house),
              handleUnwanted(detailsObject.street),
              handleUnwanted(detailsObject.landmark),
              handleUnwanted(detailsObject.locality),
              //detailsObject.vtc,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            let chunkSize: boolean = conCatPermanentAddress.length > 50;

            if (chunkSize) {
              // const permanentAddr1: string = conCatPermanentAddress.slice(0, 50);
              // const permanentAddr2: string = conCatPermanentAddress.slice(50, 100);
              // const permanentAddr3: string = conCatPermanentAddress.slice(100, 150);
              const addressLines = splitAddressByWords(conCatPermanentAddress);
              const permanentAddr1: string = addressLines[0] || "";
              const permanentAddr2: string = addressLines[1] || "";
              const permanentAddr3: string = addressLines[2] || "";
              formikRef?.current?.setFieldValue(
                "permanentAddressLine1",
                permanentAddr1 || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine2",
                permanentAddr2 || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine3",
                permanentAddr3 || ""
              );
            } else {
              formikRef?.current?.setFieldValue(
                "permanentAddressLine1",
                detailsObject.house || ""
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine2",
                `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim()
              );
              formikRef?.current?.setFieldValue(
                "permanentAddressLine3",
                `${detailsObject.locality || ""}`.trim()
              );
            }
          }

          // Set pincode, city, state, country (only if not manually entered)
          if (detailsObject.pincode && !formikRef?.current?.values?.permanentPincode) {
            formikRef?.current?.setFieldValue(
              "permanentPincode",
              detailsObject.pincode || ""
            );
            // Trigger pincode API to fetch city, state data
            handleInvokZipCode(detailsObject.pincode, undefined, "permanent");
          }

          if (!formikRef?.current?.values?.permanentCity) {
            formikRef?.current?.setFieldValue(
              "permanentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
          }

          if (!formikRef?.current?.values?.permanentState) {
            formikRef?.current?.setFieldValue(
              "permanentState",
              detailsObject.state || ""
            );
          }

          if (!formikRef?.current?.values?.permanentCountry) {
            formikRef?.current?.setFieldValue(
              "permanentCountry",
              detailsObject.country || "India"
            );
          }

          // Update filled fields count for all address fields (only if they were prefilled)
          if (!hasManualPermanentAddress) {
            handleFilledFieldsCount("permanentAddressLine1", detailsObject.house || "");
            handleFilledFieldsCount("permanentAddressLine2", `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim());
            handleFilledFieldsCount("permanentAddressLine3", `${detailsObject.locality || ""}`.trim());
            handleFilledFieldsCount("permanentPincode", detailsObject.pincode || "");
            handleFilledFieldsCount(
              "permanentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
            handleFilledFieldsCount("permanentState", detailsObject.state || "");
            handleFilledFieldsCount("permanentCountry", detailsObject.country || "India");
          }

          // Handle current address - check if manually entered
          const hasManualCurrentAddress = (
            (formikRef?.current?.values?.currentAddressLine1 && formikRef?.current?.values?.currentAddressLine1.trim() !== "") ||
            (formikRef?.current?.values?.currentAddressLine2 && formikRef?.current?.values?.currentAddressLine2.trim() !== "") ||
            (formikRef?.current?.values?.currentAddressLine3 && formikRef?.current?.values?.currentAddressLine3.trim() !== "")
          );

          // Only prefill current address if user hasn't manually entered data
          if (!hasManualCurrentAddress) {
            const conCatCurrentAddress: string = [
              handleUnwanted(detailsObject.house),
              handleUnwanted(detailsObject.street),
              handleUnwanted(detailsObject.landmark),
              handleUnwanted(detailsObject.locality),
              //detailsObject.vtc,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            let currentChunkSize: boolean = conCatCurrentAddress.length > 50;

            if (currentChunkSize) {
              const currentAddr1: string = conCatCurrentAddress.slice(0, 50);
              const currentAddr2: string = conCatCurrentAddress.slice(50, 100);
              const currentAddr3: string = conCatCurrentAddress.slice(100, 150);

              formikRef?.current?.setFieldValue(
                "currentAddressLine1",
                currentAddr1 || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine2",
                currentAddr2 || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine3",
                currentAddr3 || ""
              );
            } else {
              formikRef?.current?.setFieldValue(
                "currentAddressLine1",
                detailsObject.house || ""
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine2",
                `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim()
              );
              formikRef?.current?.setFieldValue(
                "currentAddressLine3",
                `${detailsObject.locality || ""}`.trim()
              );
            }
          }

          // Set current address pincode, city, state, country (only if not manually entered)
          if (detailsObject.pincode && !formikRef?.current?.values?.currentPincode) {
            formikRef?.current?.setFieldValue(
              "currentPincode",
              detailsObject.pincode || ""
            );
            handleInvokZipCode(detailsObject.pincode, undefined, "current");
          }

          if (!formikRef?.current?.values?.currentCity) {
            formikRef?.current?.setFieldValue(
              "currentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
          }

          if (!formikRef?.current?.values?.currentState) {
            formikRef?.current?.setFieldValue(
              "currentState",
              detailsObject.state || ""
            );
          }

          if (!formikRef?.current?.values?.currentCountry) {
            formikRef?.current?.setFieldValue(
              "currentCountry",
              detailsObject.country || "India"
            );
          }

          // Update filled fields count for current address fields (only if they were prefilled)
          if (!hasManualCurrentAddress) {
            handleFilledFieldsCount("currentAddressLine1", detailsObject.house || "");
            handleFilledFieldsCount("currentAddressLine2", `${detailsObject.street || ""} ${detailsObject.landmark || ""}`.trim());
            handleFilledFieldsCount("currentAddressLine3", `${detailsObject.locality || ""}`.trim());
            handleFilledFieldsCount("currentPincode", detailsObject.pincode || "");
            handleFilledFieldsCount(
              "currentCity",
              normalizeAadhaarAddressPart(detailsObject.vtc) ||
                normalizeAadhaarAddressPart(detailsObject.district)
            );
            handleFilledFieldsCount("currentState", detailsObject.state || "");
            handleFilledFieldsCount("currentCountry", detailsObject.country || "India");
          }
        }

        if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
          detailsObject.careOf = removeSalutation(detailsObject.careOf)
          dispatch(
            setAadhaarVerifiedDetailsCoApplicant({
              coAppKey,
              details: detailsObject,
            })
          );
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: true,
            })
          );
          dispatch(
            setAadhaarApplicationNoCoApplicant({
              coAppKey,
              applicationNo,
            })
          );
          // Set Aadhaar number in the correct co-applicant field
          formikRef?.current?.setFieldValue(
            `basic${coAppKey}AadhaarNumber`,
            applicationNo
          );
          const coAppNum = coAppKey ? coAppKey.replace("CoApplicant", "") : "";

          const conCatPermanentAddress: string = [
            handleUnwanted(detailsObject.house),
            handleUnwanted(detailsObject.street),
            handleUnwanted(detailsObject.landmark),
            handleUnwanted(detailsObject.locality),
            //detailsObject.vtc,
          ]
            .filter(Boolean)
            .join(" ")
            .trim();

          let chunkSize: boolean = conCatPermanentAddress.length > 50; // Condition applied here

          if (chunkSize) {
            // const permanentAddr1: string = conCatPermanentAddress.slice(0, 50);
            // const permanentAddr2: string = conCatPermanentAddress.slice(
            //   50,
            //   100
            // );
            // const permanentAddr3: string = conCatPermanentAddress.slice(
            //   100,
            //   150
            // );
            const addressLines = splitAddressByWords(conCatPermanentAddress);
            const permanentAddr1: string = addressLines[0] || "";
            const permanentAddr2: string = addressLines[1] || "";
            const permanentAddr3: string = addressLines[2] || "";
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine1`,
              permanentAddr1 || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine2`,
              permanentAddr2 || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine3`,
              permanentAddr3 || ""
            );
          } else {
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine1`,
              detailsObject.house || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine2`,
              `${detailsObject.street} ${detailsObject.landmark}` || ""
            );
            formikRef?.current?.setFieldValue(
              `addressCoApplicant${coAppNum}permanentAddressLine3`,
              `${detailsObject.locality}` || ""
            );
          }

          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentPincode`,
            detailsObject.pincode || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentCity`,
            normalizeAadhaarAddressPart(detailsObject.vtc) ||
              normalizeAadhaarAddressPart(detailsObject.district)
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentState`,
            detailsObject.state || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${coAppNum}permanentCountry`,
            detailsObject.country || ""
          );
          // Optionally trigger zip code lookup for co-applicant
          // if (detailsObject.pincode) {
          //   debouncedZipCodeCall(detailsObject.pincode, coAppNum);
          // }
          localStorage.removeItem("aadhaarApplicationNoCoApplicant");
        }
      })
      .catch((err) => {
        // Remove from processing set on error to allow retry
        processingAadhaarVerificationRef.current.delete(verificationKey);
        dispatch(
          setStatusPopup({
            status: "error",
            message: "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
            // message: err?.response?.data?.message || "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
          })
        );
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 0) {
          setIsAadharLoading(false);
          dispatch(setIsDocumentVerified(isLoadTesting ? true : false));
        }
        if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
          setIsAadharCoApplicantLoading((prev) => ({
            ...prev,
            [String(coAppKey)]: false,
          }));
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: isLoadTesting ? true : false,
            })
          );
        }
      });
  };

  // check if productName is present in the url and set it in the redux store
  useEffect(() => {
    if (location.pathname === "/apply-now") {
      const urlParams = new URLSearchParams(window.location.search);
      const productName = urlParams.get("productName");
      formikRef?.current?.setFieldValue(
        "product",
        productName?.toUpperCase() || ""
      );
    }
  }, [location, formikRef]);

  /**
   * Verify Aadhaar application status and update form data if needed.
   *
   * This effect checks if the Aadhaar application has been verified through URL parameters
   * or local storage. If verified, it fetches the application details and updates the form
   * data accordingly. The application number is used to fetch the details and is removed
   * from local storage after processing.
   *
   * @effect
   * @dependencies {string} aadhaarApplicationNo - Aadhaar application number
   * @dependencies {string} documentVerified - URL parameter indicating if document is verified
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const documentVerified = urlParams.get("document_verified");
    // Retrieve co-applicant key from localStorage or another source
    const coAppKey = localStorage.getItem("aadhaarCoAppKey"); // e.g., "CoApplicant1"
    // Get per-coapplicant applicationNo if coAppKey exists, else use applicant's
    const applicationNo =
      coAppKey &&
        aadhaarApplicationNoCoApplicant &&
        aadhaarApplicationNoCoApplicant[coAppKey]
        ? aadhaarApplicationNoCoApplicant[coAppKey]
        : aadhaarApplicationNo;

    // Determine typeOfApplicant value
    let typeOfApplicant = "Applicant";
    let coAppNum = "";
    if (
      documentVerified === "true" &&
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 5 &&
      coAppKey
    ) {
      // Extract co-applicant number from coAppKey, e.g., "CoApplicant1" -> "1"
      coAppNum = coAppKey.replace("CoApplicant", "");
      typeOfApplicant = `Co-Applicant ${coAppNum}`;
    }

    const payload = {
      documentId: applicationNo,
      employmentCategory: formData?.applicantType ?? formikRef?.current?.values?.applicantType ?? "student",
      typeOfApplicant,
      formSubmissionTrackingId: trackingId,
    };

    if (
      documentVerified === "true" &&
      applicationNo &&
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 0 &&
      isEaadhaarOnVerifyNow !== true
    ) {
      setIsApiLoading(true);
      handleInvokAadharApi(aadhaarApplicationNo, payload).finally(() => {
        setIsApiLoading(false);
      });
    }

    if (
      activeVerticalIndex === 1 &&
      activeHorizontalIndex === 1 &&
      formData?.aadhaar
    ) {
      const payloadAddress = {
        documentId: formData?.aadhaar,
        employmentCategory: formData?.applicantType ?? formikRef?.current?.values?.applicantType ?? "student",
        typeOfApplicant,
        formSubmissionTrackingId: trackingId,
      };

      setIsApiLoading(true);
      handleInvokAadharApi(aadhaarApplicationNo, payloadAddress).finally(() => {
        setIsApiLoading(false);
      });
    }

    if (
      documentVerified === "true" &&
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 5 &&
      applicationNo &&
      coAppKey // Make sure you have the key
    ) {
      // coAppNum already set above
      // Set the Aadhaar number for the correct co-applicant field
      if (formikRef.current) {
        formikRef.current.setFieldValue(
          `basicCoApplicant${coAppNum}AadhaarNumber`,
          applicationNo
        );
      }

      setIsApiLoading(true);
      handleInvokAadharApi(applicationNo, payload, coAppKey).finally(() => {
        setIsApiLoading(false);
      });
    }
  }, [
    aadhaarApplicationNo,
    aadhaarApplicationNoCoApplicant,
    trackingId,
    activeHorizontalIndex,
    activeVerticalIndex,
  ]);

  /**
   * Determine if certain fields should be disabled based on eligibility check status.
   *
   * This function checks if the eligibility check has been submitted and the current
   * horizontal index is 0. If both conditions are met, it returns true, indicating
   * that certain fields should be disabled.
   *
   * @function
   * @returns {boolean} - True if fields should be disabled, false otherwise
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const shouldDisableFields = useMemo(() => {
    return isEligibilityCheckSubmitted && activeHorizontalIndex === 0;
  }, [isEligibilityCheckSubmitted, activeHorizontalIndex]);

  useEffect(() => {
    if (activeHorizontalIndex == 1 && activeVerticalIndex == 1) {
      // Use formData value if present, otherwise default to true
      let value = formData?.currentsameAsPermanent;
      if (value === undefined || value === null || value === "") {
        value = true;
      }
      // Convert string "true"/"false" to boolean
      if (typeof value === "string") {
        value = value === "true";
      }
      formikRef?.current?.setFieldValue("currentsameAsPermanent", value);
    }
  }, [activeHorizontalIndex, activeVerticalIndex, formikRef, formData]);
  const isAddressYearField = (fieldName: string) =>
    /^(permanent|current)YearsInCurrent(Address|City)$/.test(fieldName) ||
    /^addressCoApplicant\d+(permanent|current)YearsInCurrent(Address|City)$/.test(
      fieldName
    );

  const isSameAsPermanentChecked = (value: any) => value === true || value === "true";

  const syncAddressYearFieldErrors = (
    fieldName: string,
    currentField: string,
    value: any
  ) => {
    if (!isAddressYearField(fieldName) || !isAddressYearField(currentField)) {
      return;
    }
    setTimeout(() => {
      const normalizedValue = String(value ?? "").trim();
      if (normalizedValue && Number(normalizedValue) <= 150) {
        formikRef?.current?.setFieldError(fieldName, undefined);
        formikRef?.current?.setFieldError(currentField, undefined);
        return;
      }
      if (
        showFieldErrorsAfterSaveAttempt &&
        normalizedValue &&
        Number(normalizedValue) > 150
      ) {
        formikRef?.current?.setFieldTouched(fieldName, true, false);
        formikRef?.current?.setFieldTouched(currentField, true, false);
        formikRef?.current?.setFieldError(fieldName, "Years cannot exceed 150");
        formikRef?.current?.setFieldError(
          currentField,
          "Years cannot exceed 150"
        );
        return;
      }
      if (showFieldErrorsAfterSaveAttempt) {
        formikRef?.current?.validateForm();
      }
    }, 0);
  };

  const handleCurrentAddressFilledInPermanent = (
    value: any,
    fieldName: any
  ): void => {
    // Only main applicant: copy single permanent field to current field
    if (/^permanent/.test(fieldName)) {
      const currentField = fieldName?.replace(/^[a-z]+/, "current");
      formikRef?.current?.setFieldValue(currentField, value, false);
      syncAddressYearFieldErrors(fieldName, currentField, value);
    }

    // Co-applicant
    const coAppMatch = fieldName.match(
      /^addressCoApplicant(\d+)permanent(.+)$/
    );
    if (coAppMatch) {
      const coAppNum = coAppMatch[1];
      const fieldSuffix = coAppMatch[2];
      const currentField = `addressCoApplicant${coAppNum}current${fieldSuffix}`;
      formikRef?.current?.setFieldValue(currentField, value, false);
      syncAddressYearFieldErrors(fieldName, currentField, value);
    }
  };

  /**
   * Update form completion state based on field values.
   *
   * This function tracks the completion status of form fields by checking if they
   * have been filled. It also handles special cases for certain fields, such as
   * current address fields that are dependent on permanent address fields.
   *
   * @function
   * @param {string} fieldName - The name of the field being checked
   * @param {any} value - The value of the field being checked
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const handleFilledFieldsCount = (fieldName: string, value: any) => {
    // Main applicant only: copy single permanent field to current field if sameAsPermanent is true (strict boolean)
    if (
      /^permanent/.test(fieldName) &&
      isSameAsPermanentChecked(formikRef?.current?.values?.currentsameAsPermanent)
    ) {
      handleCurrentAddressFilledInPermanent(value, fieldName);
    }
    // Co-applicant
    const coAppMatch = fieldName.match(
      /^addressCoApplicant(\d+)permanent(.+)$/
    );
    if (coAppMatch) {
      const coAppNum = coAppMatch[1];
      const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
      if (isSameAsPermanentChecked(formikRef?.current?.values?.[sameAsKey])) {
        handleCurrentAddressFilledInPermanent(value, fieldName);
      }
    }
  };

  // Function to copy all permanent address fields to current address fields for a given co-applicant
  const copyCoApplicantPermanentToCurrent = (coAppNum: string) => {
    if (!formikRef?.current) return;
    const values = formikRef?.current?.values;
    // Dynamically copy all permanent address fields for this co-applicant
    Object.keys(values)
      .filter(
        (key) =>
          key.startsWith(`addressCoApplicant${coAppNum}permanent`) &&
          !key.includes("currentsameAsPermanent")
      )
      .forEach((permKey) => {
        const fieldSuffix = permKey.replace(
          `addressCoApplicant${coAppNum}permanent`,
          ""
        );
        const currKey = `addressCoApplicant${coAppNum}current${fieldSuffix}`;
        formikRef?.current?.setFieldValue(currKey, values[permKey] ?? "");
        syncAddressYearFieldErrors(permKey, currKey, values[permKey] ?? "");
      });
  };

  // Effect: Only copy permanent to current address when checkbox transitions from unchecked to checked
  const prevSameAsPermanentRef = useRef<{ [key: string]: boolean }>({});
  useEffect(() => {
    if (!formikRef.current) return;
    const values = formikRef.current.values;
    Object.keys(values)
      .filter(
        (key) =>
          key.startsWith("addressCoApplicant") &&
          key.match(/^addressCoApplicant\d+currentsameAsPermanent$/)
      )
      .forEach((key) => {
        const coAppNum = key.match(
          /^addressCoApplicant(\d+)currentsameAsPermanent$/
        )?.[1];
        const prev = prevSameAsPermanentRef.current[key];
        const curr = isSameAsPermanentChecked(values[key]);
        if (coAppNum && curr && !prev) {
          copyCoApplicantPermanentToCurrent(coAppNum);
        }
        prevSameAsPermanentRef.current[key] = curr;
      });
  }, [formikRef.current?.values]);

  /**
   * Fetch universities when country changes
   *
   * This function fetches universities based on the selected country and updates
   * the dropdown data accordingly. It also handles the case where no country is
   * selected by clearing the universities dropdown.
   *
   * @function
   * @param {any} value - The value of the country being selected
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const resolveFieldId = (
    primary?: any,
    formikFieldName?: string,
    reduxFieldName?: string
  ) => {
    const options =
      formikFieldName === "university"
        ? dropdownData?.universities || []
        : formikFieldName === "institute"
          ? dropdownData?.institutes || []
          : [];
    const getId = (raw: any) => {
      if (raw === undefined || raw === null || raw === "") return "";
      if (typeof raw === "object") {
        return String(
          raw.value ??
            raw.universityId ??
            raw.instituteId ??
            raw.courseId ??
            raw.countryId ??
            raw.id ??
            ""
        );
      }
      const rawText = String(raw).trim();
      const matchedOption = options.find((opt: any) => {
        const optionValues = [
          opt?.value,
          opt?.universityId,
          opt?.instituteId,
          opt?.courseId,
          opt?.id,
          opt?.code,
          opt?.label,
        ].map((item) => String(item ?? "").toLowerCase());
        return optionValues.includes(rawText.toLowerCase());
      });
      const matchedOptionData = matchedOption as any;
      const matchedId =
        matchedOptionData?.value ??
        matchedOptionData?.universityId ??
        matchedOptionData?.instituteId ??
        matchedOptionData?.courseId ??
        matchedOptionData?.id;
      if (matchedId !== undefined && matchedId !== null && matchedId !== "") {
        return String(matchedId);
      }
      return /^\d+$/.test(rawText) ? rawText : "";
    };
    const primaryId = getId(primary);
    if (primaryId) return primaryId;
    const formikValue = formikRef?.current?.values?.[formikFieldName || ""];
    const formikId = getId(formikValue);
    if (formikId) return formikId;
    const reduxValue = formData?.[reduxFieldName || ""];
    const reduxId = getId(reduxValue);
    if (reduxId) return reduxId;
    return "";
  };

  // Normalize any country selection (object/string/number) to its country ID.
  // Form fields can hold either an autocomplete option object, the raw ID, or a
  // display label, so this guards every payload from leaking the label as ID.
  const resolveCountryId = (rawValue: any): string => {
    if (rawValue === undefined || rawValue === null || rawValue === "") {
      return "";
    }

    const countries = dropdownData?.countries || [];

    if (typeof rawValue === "object") {
      if (rawValue.value !== undefined && rawValue.value !== null && rawValue.value !== "") {
        return String(rawValue.value);
      }
      if (
        rawValue.countryId !== undefined &&
        rawValue.countryId !== null &&
        rawValue.countryId !== ""
      ) {
        return String(rawValue.countryId);
      }
      if (rawValue.label) {
        const matched = countries.find(
          (c: any) =>
            String(c.label).toLowerCase() === String(rawValue.label).toLowerCase()
        );
        if (matched?.value) return String(matched.value);
      }
      return "";
    }

    const stringValue = String(rawValue).trim();
    if (!stringValue) return "";

    const byId = countries.find(
      (c: any) =>
        String(c.value).toLowerCase() === stringValue.toLowerCase() ||
        String(c.countryId).toLowerCase() === stringValue.toLowerCase()
    );
    if (byId?.value) return String(byId.value);

    const byLabel = countries.find(
      (c: any) => String(c.label).toLowerCase() === stringValue.toLowerCase()
    );
    if (byLabel?.value) return String(byLabel.value);

    return "";
  };

  const resolveCourseCountryId = (rawValue: any): string => {
    const resolvedCountryId = resolveCountryId(rawValue);
    if (resolvedCountryId) return resolvedCountryId;

    if (typeof rawValue === "object") return "";

    const rawText = String(rawValue || "").trim();
    return /^[a-zA-Z0-9_-]{1,10}$/.test(rawText) ? rawText : "";
  };

  const normalizeAutocompleteScalarValue = (
    fieldName: string,
    value: any
  ) => {
    const lowered = String(fieldName || "").toLowerCase();
    if (value == null) return value;

    if (lowered.includes("designation")) {
      return value?.value || value;
    }

    if (lowered.includes("salutation")) {
      return value?.value || value;
    }

    if (fieldName === "loanLoanTenure") {
      return value?.value || value;
    }

    if (
      /(city|state|country)$/i.test(fieldName) ||
      /countryofbirth$/i.test(fieldName) ||
      fieldName === "applicantCityCountry"
    ) {
      return value?.label || value?.value || value;
    }

    return value;
  };

  const isScalarAutocompleteField = (fieldName: string) => {
    const lowered = String(fieldName || "").toLowerCase();
    return (
      lowered.includes("designation") ||
      lowered.includes("salutation") ||
      fieldName === "loanLoanTenure" ||
      /(city|state|country)$/i.test(fieldName) ||
      /countryofbirth$/i.test(fieldName) ||
      fieldName === "applicantCityCountry"
    );
  };

  const isCollateralScalarDropdownField = (fieldName: string) => {
    const normalized = getNormalizedFieldToken(fieldName);
    const isCollateralField = normalized.startsWith("collateral");
    const isPropertyTypeField =
      isCollateralField &&
      normalized.includes("property") &&
      normalized.includes("type") &&
      !normalized.includes("subtype");
    const isPropertySubTypeField =
      isCollateralField &&
      normalized.includes("property") &&
      normalized.includes("subtype");
    const isAddressTypeField = isCollateralField && normalized.includes("addresstype");

    return (
      isPropertyTypeField ||
      isPropertySubTypeField ||
      isAddressTypeField ||
      /^collateral\d*propertypename$/.test(normalized) ||
      /^collateral\d*propertysubtypename$/.test(normalized) ||
      /^collateral\d*addresstype$/.test(normalized)
    );
  };

  const normalizeDropdownScalarValue = (value: any) => {
    const raw =
      value && typeof value === "object"
        ? value.value ?? value.label ?? ""
        : value ?? "";
    return typeof raw === "string" ? raw.replace(/^"+|"+$/g, "") : raw;
  };

  const getCollateralAddressFieldName = useCallback(
    (collateralNumber: number, suffix: "Pincode" | "City" | "State" | "Country") => {
      const expectedWithNumber = `collateral${collateralNumber}${suffix}`.toLowerCase();
      const expectedWithoutNumber = `collateral${suffix}`.toLowerCase();
      const matchedField = (fields || []).find((candidate: any) => {
        const candidateName = String(candidate?.name || "").toLowerCase();
        return (
          candidateName === expectedWithNumber ||
          (collateralNumber === 1 && candidateName === expectedWithoutNumber)
        );
      });
      return matchedField?.name || `collateral${collateralNumber}${suffix}`;
    },
    [fields]
  );

  const setCollateralAddressValues = useCallback(
    (
      collateralNumber: number,
      values: { city?: string; state?: string; country?: string }
    ) => {
      const cityField = getCollateralAddressFieldName(collateralNumber, "City");
      const stateField = getCollateralAddressFieldName(collateralNumber, "State");
      const countryField = getCollateralAddressFieldName(collateralNumber, "Country");
      const updates = {
        [cityField]: values.city || "",
        [stateField]: values.state || "",
        [countryField]: values.country || "",
      };

      if (formikRef?.current) {
        formikRef.current.setFieldValue(cityField, values.city || "", false);
        formikRef.current.setFieldValue(stateField, values.state || "", false);
        formikRef.current.setFieldValue(countryField, values.country || "", false);
        formikRef.current.setFieldTouched(cityField, true, false);
        formikRef.current.setFieldTouched(stateField, true, false);
        formikRef.current.setFieldError(cityField, undefined);
        formikRef.current.setFieldError(stateField, undefined);
      }

      dispatch(updateFormData(updates));
    },
    [dispatch, getCollateralAddressFieldName]
  );

  const fetchUniversities = async (value: any, countryIdOverride?: any) => {
    const selectedCountryId = resolveCourseCountryId(
      countryIdOverride ||
      formValues.countryId ||
      formikRef?.current?.values?.country ||
      formData?.country
    );

    console.log(dropdownData?.countries, "dropdownData?.countries")

    if (selectedCountryId) {
      setLoadingDropdowns((prev) => ({ ...prev, universities: true }));
      try {
        const universitiesResponse = await dropdownService.getUniversities({
          universityName: value,
          countryId: selectedCountryId,
        });

        const universitiesOptions = universitiesResponse.data
          .filter((university) => university.active)
          .map((university) => ({
            value: university.universityId.toString(),
            label: university.universityName,
            code: university.universityCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          universities: universitiesOptions,
        }));
        return universitiesOptions;
      } catch (error) {
        console.error("Error fetching universities:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, universities: false }));
      }
    } else {
      // Clear universities if country not selected
      setDropdownData((prev) => ({
        ...prev,
        universities: [],
      }));
    }
    return [];
  };
  // Fetch institutes when university changes
  const fetchInstitutes = async (
    value: any,
    universityIdOverride?: any,
    countryIdOverride?: any
  ) => {
    const selectedCountryId = resolveCourseCountryId(
      countryIdOverride ||
      formValues.countryId ||
      formikRef?.current?.values?.country ||
      formData?.country
    );
    const selectedUniversityId = resolveFieldId(
      universityIdOverride || formValues.universityId,
      "university",
      "university"
    );
    if (selectedCountryId && selectedUniversityId) {
      setLoadingDropdowns((prev) => ({ ...prev, institutes: true }));
      try {
        const institutesResponse = await dropdownService.getInstitutes({
          instituteName: value, // Default search term
          universityId: selectedUniversityId,
          countryId: selectedCountryId,
        });

        const institutesOptions = institutesResponse.data
          .filter((institute) => institute.active)
          .map((institute) => ({
            value: institute.instituteId.toString(),
            label: institute.instituteName,
            code: institute.instituteCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          institutes: institutesOptions,
        }));
        return institutesOptions;
      } catch (error) {
        console.error("Error fetching institutes:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, institutes: false }));
      }
    } else {
      // Clear institutes if dependencies are not met
      setDropdownData((prev) => ({
        ...prev,
        institutes: [],
      }));
    }
    return [];
  };
  // Fetch courses when institute changes
  const fetchCourses = async (value: any, instituteIdOverride?: any) => {
    const selectedInstituteId = resolveFieldId(
      instituteIdOverride || formValues?.instituteId,
      "institute",
      "institute"
    );
    if (selectedInstituteId) {
      setLoadingDropdowns((prev) => ({ ...prev, courses: true }));
      try {
        const coursesResponse = await dropdownService.getCourses({
          courseName: value,
          instituteId: selectedInstituteId,
        });

        const coursesOptions = coursesResponse.data
          .filter((course) => course.recordStatus === "Approved")
          .map((course) => ({
            value: course.courseId.toString(),
            label: course.courseName,
            code: course.courseCode.toString(),
          }));

        setDropdownData((prev) => ({
          ...prev,
          courses: coursesOptions,
        }));
        return coursesOptions;
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoadingDropdowns((prev) => ({ ...prev, courses: false }));
      }
    } else {
      // Clear courses if institute not selected
      setDropdownData((prev) => ({
        ...prev,
        courses: [],
      }));
    }
    return [];
  };

  const getOptionTextValue = (value: any) =>
    String(value?.label ?? value?.value ?? value ?? "").trim();

  const getSelectedApplicantBirthCountryName = () => {
    const selected = formikRef?.current?.values?.applicantBirthCountry;
    const selectedText = getOptionTextValue(selected);
    if (!selectedText) return "";
    const matchedCountry = birthCountryMasterOptions.find((option: any) => {
      return (
        getOptionTextValue(option?.value) === selectedText ||
        getOptionTextValue(option?.label) === selectedText ||
        getOptionTextValue(option?.countryId) === selectedText
      );
    });
    return getOptionTextValue(matchedCountry?.label || selectedText);
  };

  const getBirthCountryNameForCityFetch = useCallback(
    (rawCountry: any) => {
      const selectedText = getOptionTextValue(rawCountry);
      if (!selectedText) return "";

      const fieldCountryOptions = (fields || [])
        .filter((field: any) => {
          const name = String(field?.name || "");
          return (
            name === "applicantBirthCountry" ||
            name === "applicantCountryOfBirth" ||
            /CountryOfBirth$/i.test(name)
          );
        })
        .flatMap((field: any) =>
          Array.isArray(field?.options?.options)
            ? field.options.options
            : Array.isArray(field?.options)
              ? field.options
              : []
        );
      const countryOptions = [
        ...fieldCountryOptions,
        ...(birthCountryMasterOptions || []),
      ];
      const matchedCountry = countryOptions.find((option: any) => {
        const optionValue = getOptionTextValue(option?.value);
        const optionLabel = getOptionTextValue(option?.label);
        const optionCountryId = getOptionTextValue(option?.countryId);
        return [optionValue, optionLabel, optionCountryId].some(
          (optionText) =>
            optionText.toLowerCase() === selectedText.toLowerCase()
        );
      });

      return getOptionTextValue(matchedCountry?.label || selectedText);
    },
    [birthCountryMasterOptions, fields]
  );

  const prefetchedBirthCityCountriesRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const currentValues = {
      ...(formData || {}),
      ...(formikRef?.current?.values || {}),
    };
    const birthCountryValues: any[] = [
      currentValues?.applicantCountryOfBirth,
      currentValues?.applicantBirthCountry,
    ];

    Object.keys(currentValues || {}).forEach((key) => {
      if (/^basicCoApplicant\d+CountryOfBirth$/i.test(key)) {
        birthCountryValues.push(currentValues[key]);
      }
    });

    (fields || []).forEach((field: any) => {
      const fieldName = String(field?.name || "");
      if (
        fieldName === "applicantBirthCountry" ||
        fieldName === "applicantCountryOfBirth" ||
        /^basicCoApplicant\d+CountryOfBirth$/i.test(fieldName)
      ) {
        birthCountryValues.push(currentValues[fieldName] ?? field?.value);
      }
    });

    birthCountryValues.forEach((rawCountry) => {
      const countryName = getBirthCountryNameForCityFetch(rawCountry);
      if (!countryName || prefetchedBirthCityCountriesRef.current.has(countryName)) {
        return;
      }
      prefetchedBirthCityCountriesRef.current.add(countryName);
      void fetchCitiesByCountryState(countryName);
    });
  }, [
    activeHorizontalIndex,
    activeVerticalIndex,
    fields,
    formData,
    fetchCitiesByCountryState,
    getBirthCountryNameForCityFetch,
  ]);

  const getApplicantBirthCountryOptions = () => {
    const countryField = fields?.find((field: any) =>
      ["applicantBirthCountry", "applicantCountryOfBirth"].includes(
        field?.name
      )
    );
    const fieldOptions = Array.isArray(countryField?.options?.options)
      ? countryField.options.options
      : Array.isArray(countryField?.options)
        ? countryField.options
        : [];

    return [...fieldOptions, ...(birthCountryMasterOptions || [])];
  };

  const getApplicantBirthCountryProcessioValue = (rawCountry: any) => {
    const selectedCountry = getOptionTextValue(rawCountry);
    if (!selectedCountry) return "";

    const matchedCountry = getApplicantBirthCountryOptions().find(
      (country: any) => {
        const optionValue = String(country?.value ?? "").trim();
        const optionLabel = String(country?.label ?? "").trim();
        const optionCountryId = String(country?.countryId ?? "").trim();
        return [optionValue, optionLabel, optionCountryId].some(
          (optionText) =>
            optionText.toLowerCase() === selectedCountry.toLowerCase()
        );
      }
    );

    return String(
      matchedCountry?.countryId ?? matchedCountry?.value ?? selectedCountry
    ).trim();
  };

  // Handle dropdown changes to update form values for dependent dropdowns
  const handleDropdownChange = (fieldName: string, value: any, form: any, shouldValidate?: boolean) => {
    if (isCollateralScalarDropdownField(fieldName)) {
      const scalarValue = normalizeDropdownScalarValue(value);
      form.setFieldValue(fieldName, scalarValue, shouldValidate);
      dispatch(updateFormData({ [fieldName]: scalarValue }));
      return;
    }

    const normalizedScalarValue = normalizeAutocompleteScalarValue(
      fieldName,
      value
    );
    form.setFieldValue(
      fieldName,
      isScalarAutocompleteField(fieldName) ? normalizedScalarValue : value,
      shouldValidate
    );
    if (/CountryOfBirth$/i.test(fieldName) || fieldName === "applicantBirthCountry") {
      const selectedCountry = String(normalizedScalarValue ?? "").trim();
      const cityFieldName =
        fieldName === "applicantBirthCountry"
          ? "applicantCityCountry"
          : fieldName.replace(/CountryOfBirth$/i, "CityOfBirth");
      dispatch(updateFormData({ [fieldName]: value, [cityFieldName]: "" }));
      form.setFieldValue(cityFieldName, "", false);
      if (selectedCountry) {
        void fetchCitiesByCountryState(selectedCountry);
      }
      return;
    }

    // Re-populate total marks when coreScoreReceived changes to "Yes"
    const coreScoreReceivedMatch = fieldName.match(/^coreScoreReceived(_\d+)?$/);
    if (coreScoreReceivedMatch) {
      const suffix = coreScoreReceivedMatch[1] || "";
      const examNameField = `coreExamName${suffix}`;
      const marksField = `coreTotalMarks${suffix}`;
      const examScoreField = `coreExamScore${suffix}`;
      const expectedOnField = `coreScoreExpectedOn${suffix}`;

      if (value === "Yes") {
        // Re-populate total marks from master
        const examNameValue = formikRef?.current?.values?.[examNameField];
        if (examNameValue) {
          const found: any = entranceExamMaster.find(
            (exam: any) => exam.examTypeName === "CORE_EXAM" && exam.examName === examNameValue
          );
          if (found && found.totalMarks) {
            form.setFieldValue(marksField, found.totalMarks, false);
            form.setFieldError(marksField, undefined);
            form.setFieldError(examScoreField, undefined);
            dispatch(updateFormData({ [marksField]: found.totalMarks }));
          }
        }
        // Clear expected date and its stale error (no longer required when score is received)
        form.setFieldValue(expectedOnField, "", false);
        form.setFieldError(expectedOnField, undefined);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }

      if (value === "No") {
        // Clear marks obtained and total marks, and their stale errors
        form.setFieldValue(examScoreField, "", false);
        form.setFieldValue(marksField, "", false);
        form.setFieldError(examScoreField, undefined);
        form.setFieldError(marksField, undefined);
        dispatch(updateFormData({ [examScoreField]: "", [marksField]: "" }));
        // Clear expected date in case switching back keeps stale value
        form.setFieldValue(expectedOnField, "", false);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }
    }

    // Re-populate total marks when languageScoreReceived changes to "Yes"
    const langScoreReceivedMatch = fieldName.match(/^languageScoreReceived(_\d+)?$/);
    if (langScoreReceivedMatch) {
      const suffix = langScoreReceivedMatch[1] || "";
      const examNameField = `languageExamName${suffix}`;
      const marksField = `languageTotalMarks${suffix}`;
      const examScoreField = `languageExamScore${suffix}`;
      const expectedOnField = `languageScoreExpectedOn${suffix}`;

      if (value === "Yes") {
        // Re-populate total marks from master
        const examNameValue = formikRef?.current?.values?.[examNameField];
        if (examNameValue) {
          const found: any = entranceExamMaster.find(
            (exam: any) => exam.examTypeName === "LANGUAGE_EXAM" && exam.examName === examNameValue
          );
          if (found && found.totalMarks) {
            form.setFieldValue(marksField, found.totalMarks, false);
            form.setFieldError(marksField, undefined);
            form.setFieldError(examScoreField, undefined);
            dispatch(updateFormData({ [marksField]: found.totalMarks }));
          }
        }
        // Clear expected date and its stale error (no longer required when score is received)
        form.setFieldValue(expectedOnField, "", false);
        form.setFieldError(expectedOnField, undefined);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }

      if (value === "No") {
        // Clear marks obtained and total marks, and their stale errors
        form.setFieldValue(examScoreField, "", false);
        form.setFieldValue(marksField, "", false);
        form.setFieldError(examScoreField, undefined);
        form.setFieldError(marksField, undefined);
        dispatch(updateFormData({ [examScoreField]: "", [marksField]: "" }));
        // Clear expected date in case switching back keeps stale value
        form.setFieldValue(expectedOnField, "", false);
        dispatch(updateFormData({ [expectedOnField]: "" }));
      }
    }

    // Handle course type fields - set corresponding TypeId field
    const courseTypeMatch = fieldName.match(/^course(\d+)Type$/);
    if (courseTypeMatch) {
      const courseNumber = courseTypeMatch[1];
      const courseTypeIdField = `course${courseNumber}TypeID`;

      let examTypeIdValue: number = 0;
      if (value === "10th") {
        examTypeIdValue = 283;
      } else if (value === "12th") {
        examTypeIdValue = 284;
      } else if (value === "Diploma") {
        examTypeIdValue = 285;
      } else if (value === "Graduation") {
        examTypeIdValue = 286;
      }
      // Set the TypeId field in form values
      form.setFieldValue(courseTypeIdField, examTypeIdValue, false);

      // Store both course type and TypeId in Redux immediately
      const currentFormData = { ...formData };
      currentFormData[fieldName] = value; // Store course type (e.g., course1Type: "10th")
      currentFormData[courseTypeIdField] = examTypeIdValue; // Store TypeId (e.g., course1TypeId: 283)
      dispatch(updateFormData(currentFormData));
    }

    // Don't set field value here as it's already set in the onChange handler
    if (fieldName === "permanentCity" && value) {
      // Only update current city if "same as permanent" is checked
      const isSameAs = formikRef?.current?.values?.currentsameAsPermanent;
      if (isSameAsPermanentChecked(isSameAs)) {
        form.setFieldValue("currentCity", value?.value || value);
      }
    }

    if (fieldName?.toLowerCase()?.includes("coursename")) {
      const courseValue = value?.value || value;
      const courseCode = value?.code || value;
      setFormValues((prev) => ({ ...prev, courseCode: courseCode }));
      formikRef?.current?.setFieldValue("courseCode", courseCode);
      // Force form validation/update after courseName is set (skip when shouldValidate=false to avoid re-setting cleared errors)
      if (shouldValidate !== false) {
        setTimeout(() => {
          if (formikRef?.current) {
            formikRef?.current.validateForm();
          }
        }, 10);
      }
    }

    // Update form values state for dependent dropdowns
    if (fieldName?.toLowerCase()?.includes("study")) {
      // Only clear if the value is being cleared/emptied
      const actualValue = value?.value || value;
      if (!actualValue || actualValue === "" || actualValue === null) {
        // Clear all course-related dependent dropdowns when course category/study/admission status is cleared
        form.setFieldValue("country", "");
        form.setFieldValue("university", "");
        form.setFieldValue("institute", "");
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          countries: [],
          universities: [],
          institutes: [],
          courses: [],
        }));
      }
    } else if (fieldName?.toLowerCase()?.includes("country")) {
      const rawCountryValue = normalizeAutocompleteScalarValue(fieldName, value);
      const normalizedCountryId = resolveCountryId(value) || resolveCountryId(rawCountryValue);

      setFormValues((prev) => ({
        ...prev,
        countryId: normalizedCountryId,
        universityCountryId: normalizedCountryId,
      }));
      formikRef.current?.setFieldValue("universityCountryId", normalizedCountryId);

      // Only clear if the value is being cleared/emptied
      if (!rawCountryValue || rawCountryValue === "" || rawCountryValue === null) {
        // Clear dependent dropdowns
        form.setFieldValue("university", "");
        form.setFieldValue("institute", "");
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          institutes: [],
          universities: [],
          courses: [],
        }));
      }
    } else if (fieldName?.toLowerCase()?.includes("university")) {
      const universityValue = resolveFieldId(value, "university", "university");
      const universityCode = value?.code || value;
      setFormValues((prev) => ({
        ...prev,
        universityId: universityValue,
        universityCampusId: universityCode,
      }));
      formikRef.current?.setFieldValue("universityCampusId", universityCode);

      // Only clear if the value is being cleared/emptied
      if (
        !universityValue ||
        universityValue === "" ||
        universityValue === null
      ) {
        // Clear dependent dropdowns
        form.setFieldValue("institute", "");
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          institutes: [],
          courses: [],
        }));
      }
    } else if (fieldName?.toLowerCase()?.includes("institute")) {
      const instituteValue = resolveFieldId(value, "institute", "institute");
      const instituteCode = value?.code || value;
      setFormValues((prev) => ({
        ...prev,
        instituteId: instituteValue,
        institute_code: instituteCode,
      }));
      formikRef.current?.setFieldValue("institute_code", instituteCode);

      // Only clear if the value is being cleared/emptied
      if (!instituteValue || instituteValue === "" || instituteValue === null) {
        // Clear dependent dropdown
        form.setFieldValue("course", "");
        form.setFieldValue("courseName", "");
        setDropdownData((prev) => ({
          ...prev,
          courses: [],
        }));
      }
    } else if (
      fieldName?.toLowerCase()?.includes("course") &&
      !fieldName?.toLowerCase()?.includes("coursename")
    ) {
      // You can add search functionality here if needed for generic "course" fields
      const searchTerm = value?.value || value; // or extract from input
      setFormValues((prev) => ({ ...prev, courseName: searchTerm }));
    } else if (fieldName?.toLowerCase() == "salutation") {
      const salutationValue = value?.value || value;
      const salutationLabel = value?.label || value;

      setFormValues((prev) => ({
        ...prev,
        salutation: salutationValue,
        salutationName: salutationLabel,
      }));
      // Set both the main salutation field and salutationName field
      formikRef.current?.setFieldValue(fieldName, salutationValue);
      formikRef.current?.setFieldValue("salutationName", salutationLabel);
    } else if (/coapplicant.*salutation/i.test(fieldName)) {
      const salutationValue = value?.value || value;
      const salutationLabel = value?.label || value;

      setFormValues((prev) => ({
        ...prev,
        [fieldName]: salutationValue,
        [`${fieldName}Name`]: salutationLabel,
      }));
      // Set both the main salutation field and salutationName field
      formikRef.current?.setFieldValue(fieldName, salutationValue);
      formikRef.current?.setFieldValue(`${fieldName}Name`, salutationLabel);
    } else if (fieldName?.toLowerCase()?.includes("pincode")) {
      // setFormValues((prev) => ({
      //   ...prev,
      //   salutation: value?.value,
      //   salutationName: value?.label,
      // }));
      // formikRef.current?.setFieldValue("salutationName", value?.label);
    }
    // Handle Language Exam ID and Name storage in Redux
    else if (
      fieldName?.toLowerCase()?.includes("languageexamname") ||
      fieldName?.toLowerCase()?.includes("languageexam")
    ) {
      if (value && typeof value === "object" && value.value && value.label) {
        // Store exam ID in formData instead of separate Redux state
        const currentFormData = { ...formData };
        currentFormData.languageExamId = value.value; // Store the ID
        dispatch(updateFormData(currentFormData));
      }
    }
    // Handle Core Exam ID and Name storage in Redux
    else if (
      fieldName?.toLowerCase()?.includes("coreexamname") ||
      fieldName?.toLowerCase()?.includes("coreexam") ||
      /core.*exam.*name/i.test(fieldName) ||
      /entrance.*exam/i.test(fieldName)
    ) {
      if (value && typeof value === "object" && value.value && value.label) {
        // Store exam ID in formData instead of separate Redux state
        const currentFormData = { ...formData };
        currentFormData.coreExamId = value.value; // Store the ID
        dispatch(updateFormData(currentFormData));
      }
    }
    // Handle direct coreExamID/languageExamID field storage in Redux
    else if (
      /^coreExamID(_\d+)?$/i.test(fieldName) ||
      /^languageExamID(_\d+)?$/i.test(fieldName)
    ) {
      const currentFormData = { ...formData };
      currentFormData[fieldName] = value;
      dispatch(updateFormData(currentFormData));
    }
    // Handle RelationWithStudent field - similar to salutation handling
    else if (/basicCoApplicant\d+RelationWithStudent/i.test(fieldName)) {
      const relationValue = value?.value || value;
      const relationLabel = value?.label || value;

      setFormValues((prev) => ({
        ...prev,
        [fieldName]: relationValue,
        [`${fieldName}Name`]: relationLabel,
      }));
      // Set both the main relation field and relationName field
      formikRef.current?.setFieldValue(fieldName, relationValue);
      formikRef.current?.setFieldValue(`${fieldName}Name`, relationLabel);

      // Update Redux with RelationWithStudent value
      const currentFormData = { ...formData };
      currentFormData[fieldName] = relationValue;
      currentFormData[`${fieldName}Name`] = relationLabel;
      dispatch(updateFormData(currentFormData));
    }
  };

  // Helper function to get dropdown options based on field
  const getDropdownOptions = (field: any) => {
    if (/Nationality$/i.test(field?.name || "")) {
      return nationalityMasterOptions;
    }
    if (/MaritalStatus$/i.test(field?.name || "")) {
      return maritalStatusMasterOptions;
    }
    if (field?.name === "loanLoanTenure") {
      return dropdownData?.loanTenureOptions || [];
    }
    if (/CountryOfBirth$/i.test(field?.name || "") || field?.name === "applicantBirthCountry") {
      const fieldOptions = Array.isArray(field?.options?.options)
        ? field.options.options
        : [];
      return birthCountryMasterOptions?.length
        ? birthCountryMasterOptions
        : fieldOptions;
    }
    if (/CityOfBirth$/i.test(field?.name || "") || field?.name === "applicantCityCountry") {
      const countryFieldName =
        field?.name === "applicantCityCountry"
          ? "applicantBirthCountry"
          : String(field?.name || "").replace(/CityOfBirth$/i, "CountryOfBirth");
      const selectedCountry =
        field?.name === "applicantCityCountry"
          ? getSelectedApplicantBirthCountryName()
          : String(
              formikRef?.current?.values?.[countryFieldName]?.label ??
                formikRef?.current?.values?.[countryFieldName]?.value ??
                formikRef?.current?.values?.[countryFieldName] ??
                ""
            ).trim();
      if (selectedCountry) {
        return getCityOptionsForCountry(selectedCountry);
      }
      return [];
    }
    // Handle designation dropdown for co-applicant employment sections
    if (field.name.toLowerCase().includes("designation")) {
      return dropdownData?.designations ?? [];
    }
    // Show years from 2000 to current year for "cour" fields in activeHorizontalIndex 1, form 3
    if (
      activeHorizontalIndex === 1 &&
      activeVerticalIndex === 3 && // form 3 (0-based index)
      field.name.toLowerCase().includes("year")
    ) {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = currentYear - 30; year <= currentYear; year++) {
        years.push({ value: year.toString(), label: year.toString() });
      }

      // Filter based on chronological order of courses
      const formValues = formikRef?.current?.values || {};

      // Extract course number from field name (e.g., "course1Year", "course1PassingYear" -> 1)
      const currentCourseMatch = field.name.match(/course(\d+)(Year|PassingYear|YearOfPassing|PassYear)/i);
      if (!currentCourseMatch) {
        return [
          { value: "", label: `Select ${field.label || "Year"}` },
          ...years,
        ];
      }

      const currentCourseNum = parseInt(currentCourseMatch[1]);

      // Get current course type (e.g., "10th", "Diploma", etc.)
      const currentCourseType = formValues[`course${currentCourseNum}Type`] || "";

      // Special handling for Diploma: show same options as 10th, but exclude 10th's selected year
      if (currentCourseType === "Diploma") {
        // Find the course that is "10th" and get its selected year
        let tenthSelectedYear: number | null = null;
        Object.keys(formValues).forEach((key) => {
          const typeMatch = key.match(/course(\d+)Type/);
          if (typeMatch && formValues[key] === "10th") {
            const tenthCourseNum = parseInt(typeMatch[1]);
            // Check multiple possible year field name patterns
            const yearFieldPatterns = [
              `course${tenthCourseNum}Year`,
              `course${tenthCourseNum}PassingYear`,
              `course${tenthCourseNum}YearOfPassing`,
              `course${tenthCourseNum}PassYear`,
            ];

            for (const yearKey of yearFieldPatterns) {
              const tenthYear = formValues[yearKey];
              if (tenthYear) {
                const tenthYearValue = parseInt(tenthYear);
                if (!isNaN(tenthYearValue)) {
                  tenthSelectedYear = tenthYearValue;
                  break; // Found the year, no need to check other patterns
                }
              }
            }
          }
        });

        // Filter years: show only years AFTER the year selected in 10th
        const filteredYears = years.filter((yearOption) => {
          const yearValue = parseInt(yearOption.value);
          // If no 10th year selected, show all years. Otherwise, show only years after the selected 10th year
          if (tenthSelectedYear === null) {
            return true;
          }
          return yearValue > tenthSelectedYear;
        });

        return [
          { value: "", label: `Select ${field.label || "Year"}` },
          ...filteredYears,
        ];
      }

      // Get all course year fields and their values
      const courseYearData: { courseNum: number; year: number }[] = [];
      Object.keys(formValues).forEach((key) => {
        const match = key.match(/course(\d+)(Year|PassingYear|YearOfPassing|PassYear)/i);
        if (match && formValues[key]) {
          const courseNum = parseInt(match[1]);
          const year = parseInt(formValues[key]);
          if (!isNaN(year)) {
            courseYearData.push({ courseNum, year });
          }
        }
      });

      // Find the maximum year from all previous courses
      let minAllowedYear = 1965; // Default minimum
      courseYearData.forEach(({ courseNum, year }) => {
        if (courseNum < currentCourseNum && year >= minAllowedYear) {
          minAllowedYear = year;
        }
      });

      // Collect all already selected years (to exclude duplicates)
      const selectedYears = courseYearData
        .filter(({ courseNum }) => courseNum !== currentCourseNum)
        .map(({ year }) => year);

      // Filter years: show only years after the previous course and exclude duplicates
      const filteredYears = years.filter((yearOption) => {
        const yearValue = parseInt(yearOption.value);
        return yearValue > minAllowedYear && !selectedYears.includes(yearValue);
      });

      return [
        { value: "", label: `Select ${field.label || "Year"}` },
        ...filteredYears,
      ];
    }

    // 1. If options are provided directly in the field JSON, use them
    // Exclude fields that should use system values instead
    const isSystemValueField =
      field.name.toLowerCase().includes("salutation") ||
      field.name.toLowerCase().includes("coreexamname") ||
      field.name.toLowerCase().includes("coreexam") ||
      field.name.toLowerCase().includes("languageexamname") ||
      field.name.toLowerCase().includes("languageexam") ||
      /core.*exam/i.test(field.name) ||
      /language.*exam/i.test(field.name);

    if (
      field.options &&
      Array.isArray(field.options.options) &&
      !isSystemValueField
    ) {
      return [
        ...field.options.options
          .filter((opt: any) => opt != null && opt !== undefined)
          .map((opt: any) => ({
            value:
              typeof opt === "object"
                ? opt?.value ?? opt?.label ?? ""
                : opt || "",
            label:
              typeof opt === "object"
                ? opt?.label ?? opt?.value ?? ""
                : opt || "",
          })),
      ];
    }

    // 2. Existing logic for other dropdowns
    if (
      field.name.toLowerCase().includes("coursecategory") ||
      field.label.toLowerCase().includes("coursecategory")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Course Category"}` },
        ...(dropdownData?.courseCategory ?? []),
      ];
    }
    if (
      field.name.toLowerCase().includes("coursetype") ||
      field.label.toLowerCase().includes("coursetype")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Course Type"}` },
        ...(dropdownData?.courseType ?? []),
      ];
    }
    if (
      field.name.toLowerCase().includes("country") ||
      field.label.toLowerCase().includes("country")
    ) {
      const countryOptions = [...(dropdownData?.countries || [])];
      const isStudyDestinationStep =
        activeHorizontalIndex === 0 &&
        activeVerticalIndex === 1 &&
        (
          field.name.toLowerCase().includes("study") ||
          field.name.toLowerCase().includes("destination") ||
          field.label.toLowerCase().includes("study") ||
          field.label.toLowerCase().includes("destination")
        );

      if (isStudyDestinationStep) {
        return countryOptions.filter(
          (country: any) =>
            String(country?.label || "").trim().toLowerCase() !== "india"
        );
      }

      return [
        // { value: "", label: `Select ${field.label || "Country"}` },
        ...countryOptions,
      ];
    }
    const referenceCityMatch = String(field?.name || "").match(
      /^addressReference(\d+)City$/i
    );
    if (referenceCityMatch) {
      const referenceNumber = referenceCityMatch[1];
      const codeData =
        referenceNumber === "2" ? reference2CodeData : reference1CodeData;
      const currentCity =
        formikRef?.current?.values?.[`addressReference${referenceNumber}City`] ||
        codeData?.cityName ||
        "";
      const options = [...(cityList || [])];
      if (
        currentCity &&
        !options.some(
          (option: any) =>
            String(option?.value || option?.label || "") === String(currentCity)
        )
      ) {
        options.unshift({ value: currentCity, label: currentCity });
      }
      return options;
    }
    const referenceStateMatch = String(field?.name || "").match(
      /^addressReference(\d+)State$/i
    );
    if (referenceStateMatch) {
      const referenceNumber = referenceStateMatch[1];
      const codeData =
        referenceNumber === "2" ? reference2CodeData : reference1CodeData;
      const currentState =
        formikRef?.current?.values?.[`addressReference${referenceNumber}State`] ||
        codeData?.stateName ||
        "";
      return currentState ? [{ value: currentState, label: currentState }] : [];
    }
    const collateralCityMatch = String(field?.name || "").match(
      /^collateral(\d*)City$/i
    );
    if (collateralCityMatch) {
      const collateralNumber = Number(collateralCityMatch[1] || 1);
      const codeData = collateralCodeData[collateralNumber];
      const fieldValue = formikRef?.current?.values?.[field.name];
      const currentCity =
        toOptionValue(fieldValue) ||
        toOptionValue(formikRef?.current?.values?.[`collateral${collateralNumber}City`]) ||
        toOptionValue(formikRef?.current?.values?.collateralCity) ||
        codeData?.cityName ||
        "";
      const options = [...(cityList || [])];
      if (
        currentCity &&
        !options.some(
          (option: any) =>
            String(option?.value || option?.label || "") === String(currentCity)
        )
      ) {
        options.unshift({ value: currentCity, label: currentCity });
      }
      return options;
    }
    const collateralStateMatch = String(field?.name || "").match(
      /^collateral(\d*)State$/i
    );
    if (collateralStateMatch) {
      const collateralNumber = Number(collateralStateMatch[1] || 1);
      const codeData = collateralCodeData[collateralNumber];
      const fieldValue = formikRef?.current?.values?.[field.name];
      const currentState =
        toOptionValue(fieldValue) ||
        toOptionValue(formikRef?.current?.values?.[`collateral${collateralNumber}State`]) ||
        toOptionValue(formikRef?.current?.values?.collateralState) ||
        codeData?.stateName ||
        "";
      return currentState ? [{ value: currentState, label: currentState }] : [];
    }
    if (
      field.name.toLowerCase().includes("university") ||
      field.label.toLowerCase().includes("university")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "University"}` },
        ...(dropdownData?.universities || []),
      ];
    }
    if (
      field.name.toLowerCase().includes("institute") ||
      field.label.toLowerCase().includes("institute")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Institute"}` },
        ...(dropdownData?.institutes || []),
      ];
    }
    if (
      field.name.toLowerCase().includes("course") ||
      field.label.toLowerCase().includes("course")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Course"}` },
        ...(dropdownData?.courses || []),
      ];
    }
    if (field.name.toLowerCase().includes("salutation")) {
      return [
        // { value: "", label: `Select ${field.name || "Salutation"}` },
        ...(dropdownData?.salutations || []),
      ];
    }
    console.log(field, 'fieldssssssssssssss')
    if (field.name.toLowerCase().includes("designation")) {
      return [
        // { value: "", label: `Select ${field.label || "Designation"}` },
        ...(dropdownData?.designations || []),
      ];
    }
    if (
      field.name.toLowerCase().includes("admissionstatus") ||
      field.label.toLowerCase().includes("admissionstatus")
    ) {
      return [
        // { value: "", label: `Select ${field.label || "Admission Status"}` },
        ...(dropdownData?.admissionStatus || []),
      ];
    }

    if (
      field.name.toLowerCase().includes("permanentcity") ||
      field.name.toLowerCase().includes("currentcity")
    ) {
      return [
        { value: "", label: `Select ${field.label || "City"}` },
        ...(cityList || []),
      ];
    }
    // Handle Language Exam Type fields
    if (
      field.name.toLowerCase().includes("languageexamname") ||
      field.name.toLowerCase().includes("languageexam") ||
      /language.*exam/i.test(field.name)
    ) {
      const options = [
        // { value: "", label: `Select ${field.label || "Language Exam"}` },
        ...(dropdownData?.languageExamTypes || []),
      ];
      return options;
    }

    // Handle Entrance/Core Exam Type fields
    if (
      field.name.toLowerCase().includes("coreexamname") ||
      field.name.toLowerCase().includes("coreexam") ||
      /core.*exam.*name/i.test(field.name) ||
      /entrance.*exam/i.test(field.name)
    ) {
      const options = [
        // { value: "", label: `Select ${field.label || "Core Exam"}` },
        ...(dropdownData?.entranceExamTypes || []),
      ];
      return options;
    }

    return [];
  };

  // Check if dropdown is loading
  const isDropdownLoading = (field: any) => {
    if (field.name.toLowerCase().includes("country")) {
      return loadingDropdowns.countries;
    }
    if (field.name.toLowerCase().includes("university")) {
      return loadingDropdowns.universities;
    }
    if (field.name.toLowerCase().includes("institute")) {
      return loadingDropdowns.institutes;
    }
    if (field.name.toLowerCase().includes("course")) {
      return loadingDropdowns.courses;
    }
    return false;
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isRedirectVerified = urlParams.get("document_verified") === "true";

  // Fix initial values - set proper defaults for different field types
  const initialValues = (() => {
    // Use mergedFields for vertical step 3, fields for others
    const fieldsToUse = fields;
    const values: Record<string, any> = {};

    // Define enableReinitialize based on your logic or set to false by default
    const enableReinitialize =
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 ||
        activeVerticalIndex === 1 ||
        activeVerticalIndex === 5);

    fieldsToUse.forEach((field: any) => {
      // Special case for employmentType dropdown to default to 'Student'
      if (field.type === "dropdown" && field.name === "employmentType") {
        if (
          formData &&
          formData[field.name] !== undefined &&
          formData[field.name] !== "" &&
          String(formData[field.name]).toLowerCase() !== "student"
        ) {
          values[field.name] = formData[field.name];
        } else {
          values[field.name] = "";
        }
        return;
      }
      // Skip initial value for co-applicant fields and dob if reinitializing
      if (
        enableReinitialize &&
        (/^(basicCoApplicant\d+|addressCoApplicant\d+|employmentCoApplicant\d+)/.test(
          field.name
        ) ||
          field.name === "dob")
      ) {
        return;
      }

      // Special case for employmentisEmployed radio button to default to "null"
      if (field.type === "radio" && field.name === "employmentisEmployed") {
        if (
          formData &&
          formData[field.name] !== undefined &&
          formData[field.name] !== ""
        ) {
          values[field.name] = formData[field.name];
        } else {
          // values[field.name] = "Yes";
          values[field.name] = "";
        }
        return;
      }
      // For CGPA fields, set the corresponding score type to "CGPA" by default
      // if (
      //   field.name.match(/^course\d+ScoreType$/) &&
      //   (formData?.[field.name] === undefined || formData?.[field.name] === "")
      // ) {
      //   values[field.name] = "CGPA";
      //   return;
      // }
      // Prefill from existing formData in Redux if available
      if (formData && formData[field.name] !== undefined) {
        values[field.name] = formData[field.name];
        return;
      }
      // Prefill co-applicant fields from coApplicantVerification
      // Co-applicant strict mapping (new field names)
      const coApplicantMatch = field.name.match(
        /^basicCoApplicant(\d+)(Email|PhoneNumber|PanNumber)$/
      );
      if (coApplicantMatch) {
        const idx = coApplicantMatch[1]; // '1' for basicCoApplicant1, '2' for basicCoApplicant2
        const reduxIdx = String(Number(idx) - 1); // '0' for basicCoApplicant1, '1' for basicCoApplicant2
        const type = coApplicantMatch[2];

        // Prefer formData if present
        if (formData[field.name] !== undefined && formData[field.name] !== "") {
          values[field.name] = formData[field.name];
          return;
        }

        // Strictly match field name and reduxIdx
        if (
          type === "PhoneNumber" &&
          coApplicantVerification[reduxIdx]?.lastVerifiedMobileNumber &&
          field.name === `basicCoApplicant${idx}PhoneNumber`
        ) {
          values[field.name] =
            coApplicantVerification[reduxIdx].lastVerifiedMobileNumber;
          return;
        }
        if (
          type === "Email" &&
          coApplicantVerification[reduxIdx]?.lastVerifiedEmail &&
          field.name === `basicCoApplicant${idx}Email`
        ) {
          values[field.name] =
            coApplicantVerification[reduxIdx].lastVerifiedEmail;
          return;
        }
        if (
          type === "PanNumber" &&
          coApplicantVerification[reduxIdx]?.lastPanNumber &&
          field.name === `basicCoApplicant${idx}PanNumber`
        ) {
          values[field.name] = coApplicantVerification[reduxIdx].lastPanNumber;
          return;
        }
      }
      // For indexed exam fields (core/language), prefill all matching keys from formData
      if (
        (field.name.startsWith("core") || field.name.startsWith("language")) &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 4 &&
        formData
      ) {
        Object.keys(formData).forEach((key) => {
          if (key.startsWith(field.name)) {
            values[key] = formData[key];
          }
        });
        if (values[field.name] === undefined) {
          switch (field.type) {
            case "checkbox":
              values[field.name] = false;
              break;
            case "number":
              values[field.name] = "";
              break;
            default:
              values[field.name] = "";
              break;
          }
        }
        return;
      }
      // For indexed course fields (course13Type, etc.), prefill all matching keys from formData
      if (
        field.name.startsWith("course") &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 3 &&
        formData
      ) {
        Object.keys(formData).forEach((key) => {
          if (key.startsWith(field.name)) {
            values[key] = formData[key];
          }
        });
        if (values[field.name] === undefined) {
          switch (field.type) {
            case "checkbox":
              values[field.name] = false;
              break;
            case "number":
              values[field.name] = "";
              break;
            default:
              values[field.name] = "";
              break;
          }
        }
        return;
      }
      // Special redirect prefill for phone/email
      if (
        isRedirectVerified &&
        field.name === "phone_number" &&
        lastVerifiedPhoneNumber
      ) {
        values[field.name] = lastVerifiedPhoneNumber;
        return;
      }
      if (isRedirectVerified && field.name === "email" && lastVerifiedEmail) {
        values[field.name] = lastVerifiedEmail;
        return;
      }

      // Default values for all other fields
      switch (field.type) {
        case "checkbox":
          values[field.name] = false;
          break;
        case "number":
          values[field.name] = "";
          break;
        default:
          values[field.name] = "";
          break;
      }
    });

    // Also prefill any indexed keys in formData not present in fieldsToUse
    if (formData) {
      Object.keys(formData).forEach((key) => {
        if (values[key] === undefined) {
          values[key] = formData[key];
        }
      });
      // Map studentDetails fields from main applicant fields if not already set
      if (
        (values["studentDetailEmail"] === undefined ||
          values["studentDetailEmail"] === "") &&
        formData["email"] !== undefined
      ) {
        values["studentDetailEmail"] = formData["email"];
      }
      if (
        (values["studentDetailsFirstName"] === undefined ||
          values["studentDetailsFirstName"] === "") &&
        formData["firstName"] !== undefined
      ) {
        values["studentDetailsFirstName"] = formData["firstName"];
      }
      if (
        (values["studentDetailsLastName"] === undefined ||
          values["studentDetailsLastName"] === "") &&
        formData["lastName"] !== undefined
      ) {
        values["studentDetailsLastName"] = formData["lastName"];
      }
      if (
        (values["studentDetailsPhone_number"] === undefined ||
          values["studentDetailsPhone_number"] === "") &&
        formData["phone_number"] !== undefined
      ) {
        values["studentDetailsPhone_number"] = formData["phone_number"];
      }
      if (
        (values["LoanDetailsLoanAmount"] === undefined ||
          values["LoanDetailsLoanAmount"] === "") &&
        formData["loanAmount"] !== undefined
      ) {
        values["LoanDetailsLoanAmount"] = formData["loanAmount"];
      }
    }
    if (
      pageType === "SUMMARY" &&
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0
    ) {
      if (fieldsToUse.some((f: any) => f.name === "terms_conditions")) {
        values.terms_conditions = true;
      }
      if (fieldsToUse.some((f: any) => f.name === "privacy_policy")) {
        values.privacy_policy = true;
      }
    }
    // console.log(values, "<--- initial form values");
    return values;
  })();

  const handleRadioChange = (fieldName: string, value: string, form: any) => {
    // Check if this is an applicant type field and value is co-applicant
    if (
      fieldName === "applicantType" &&
      value.toLowerCase().includes("co-applicant")
    ) {
      setOpenCoApplicantModal(true);
    }
    // Employment: clear other fields if "No" is selected
    if (fieldName === "employmentisEmployed" && /^(yes|no)$/i.test(value)) {
      fields
        .filter((f) => f.name !== "employmentisEmployed")
        .forEach((field) => {
          form.setFieldValue(field.name, "");
        });
      // Ensure employment type state is reset even if field is hidden/not in current field list.
      form.setFieldValue("employmentType", "");
      form.setFieldValue("employmentTypeId", "");
      form.setFieldValue("employmentTypeDesc", "");
    }
    // Co-applicant Employment: if "No" is selected, clear that co-applicant's employment type
    const coAppEmploymentMatch = fieldName.match(/^employmentCoApplicant(\d+)isEmployed$/);
    if (coAppEmploymentMatch && value === "No") {
      const idx = coAppEmploymentMatch[1];
      const employmentTypeField = `employmentCoApplicant${idx}employmentType`;
      form.setFieldValue(employmentTypeField, "");
    }
    // Exam: clear other fields if "No" is selected
    if (fieldName === "coreExamApplied" && value === "No") {
      coreFields
        .filter((f: any) => f.name !== "coreExamApplied")
        .forEach((field: any) => {
          // For dynamic exam fields, clear all matching keys
          Object.keys(form.values).forEach((key) => {
            if (key.startsWith(field.name)) {
              form.setFieldValue(key, "");
            }
          });
        });
    }
    if (fieldName === "languageExamApplied" && value === "No") {
      languageFields
        .filter((f: any) => f.name !== "languageExamApplied")
        .forEach((field: any) => {
          Object.keys(form.values).forEach((key) => {
            if (key.startsWith(field.name)) {
              form.setFieldValue(key, "");
            }
          });
        });
    }

    form.setFieldValue(fieldName, value);
  };


  const handleGAEligibilityStatments = useMemo(
    () => getGAEligibilityStatements(applicationSource),
    [applicationSource]
  );

  const handleGAProvisionalOfferStatments = useMemo(
    () => getGAProvisionalOfferStatements(applicationSource),
    [applicationSource]
  );

  const handleInvokCreateApi = async (payload: any, values: any) => {
    try {
      let resp = null;
      if (isAuthenticated) {
        resp = await postsServices.addPost(
          "api/v1/user-lead/create-verified",
          payload
        );
      } else {
        resp = await postsServices.addPost("api/v1/user-lead/create", payload);
      }

      if (resp.status == 201) {
        trackCustomerJourneyEvent(
          `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
          decrypt(userProfile?.id) ?? "",
          resp.data.data.trackingId,
          {
            label: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            category: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            action: `${handleGAEligibilityStatments}_VERIFYYOURSELF_SAVE_PAGE1`,
            page: "EligibiityCheck_Verify Yourself and Provide Consent_Verify",
          }
        );

        // window.scrollTo({ top: 0, behavior: "smooth" });
        dispatch(setTrackingId(resp.data.data.trackingId));
        setIsSubmittingToAPI(false);
        dispatch(
          updateFormData({
            ...values,
            isAadhaarVerified: values?.isAadhaarVerified ?? false,
          })
        );
        moveToNextStep();
      }
    } catch (error: any) {
      setIsSubmittingToAPI(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "API call failed",
        })
      );
    }
  };

  // Map form values to API format
  const hasPayloadValue = (value: any) =>
    value !== undefined &&
    value !== null &&
    !(typeof value === "string" && value.trim() === "");

  const resolveApplicantVerificationFieldValue = (
    key: string,
    value: any,
    fieldDef?: any
  ) => {
    const isApplicantVerificationStep =
      (activeHorizontalIndex === 0 && activeVerticalIndex === 0) ||
      (activeHorizontalIndex === 1 && activeVerticalIndex === 0);
    if (
      !isApplicantVerificationStep ||
      (key !== "isEmailVerified" && key !== "isMobileVerified")
    ) {
      return value;
    }

    const fetchedValue = [
      formData?.[key],
      fieldDef?.[key],
      fieldDef?.formFieldValue,
      fieldDef?.fieldValue,
      fieldDef?.value,
    ].find(hasPayloadValue);

    return hasPayloadValue(fetchedValue) ? fetchedValue : value;
  };

  const mapFormDataToAPI = (values: any, fields: any[]) =>
    fields.map((field) => {
      let fieldValue = values[field.name];
      if (
        (field.name === "loanAmount" || field.name === "totalCost") &&
        !hasPayloadValue(fieldValue)
      ) {
        const liveFormikValue = formikRef?.current?.values?.[field.name];
        fieldValue = hasPayloadValue(liveFormikValue)
          ? liveFormikValue
          : formData?.[field.name];
      }
      // If the value is an object with a 'value' property, use that
      if (
        fieldValue &&
        typeof fieldValue === "object" &&
        "value" in fieldValue
      ) {
        // Special handling for RelationWithStudent fields - use only value
        if (/basicCoApplicant\d+RelationWithStudent/i.test(field.name)) {
          fieldValue = fieldValue.value;
        }
        // Special handling for university field
        else if (field.name == "university") {
          fieldValue = `${fieldValue.label}-${fieldValue.value}`;
        }
        // Default behavior for other autocomplete fields
        else {
          fieldValue = fieldValue.label;
        }
      }

      return {
        field_id: field.id,
        field_key: field.name,
        field_value: fieldValue ?? "",
      };
    });

  const normalizePayloadFieldValue = (key: string, rawValue: any): string => {
    const zeroWhenEmptyFields = new Set([
      "expenseTuitionFees",
      "expenseLivingExpenses",
      "expenseTravelExpenses",
      "expenseOtherExpenses",
      "fundRequestedLoanAmount",
      "fundOwnSources",
      "fundScholarshipAmount",
      "fundOtherIncome",
    ]);
    if (
      zeroWhenEmptyFields.has(key) &&
      (rawValue === undefined || rawValue === null || String(rawValue).trim() === "")
    ) {
      return "0";
    }
    if (rawValue === undefined || rawValue === null) return "";

    if (typeof rawValue === "string" || typeof rawValue === "number" || typeof rawValue === "boolean") {
      return String(rawValue);
    }

    if (Array.isArray(rawValue)) {
      return rawValue
        .map((item) => normalizePayloadFieldValue(key, item))
        .filter(Boolean)
        .join(",");
    }

    if (typeof rawValue === "object") {
      const optionLikeValue = rawValue?.value ?? rawValue?.id ?? rawValue?.code;
      const optionLikeLabel = rawValue?.label ?? rawValue?.name ?? rawValue?.desc;

      // IDs/codes should persist as value-like tokens.
      if (/id$/i.test(key) || /code$/i.test(key)) {
        if (optionLikeValue !== undefined && optionLikeValue !== null) {
          return String(optionLikeValue);
        }
      }

      // Display fields should persist readable labels.
      if (optionLikeLabel !== undefined && optionLikeLabel !== null) {
        return String(optionLikeLabel);
      }
      if (optionLikeValue !== undefined && optionLikeValue !== null) {
        return String(optionLikeValue);
      }

      try {
        return JSON.stringify(rawValue);
      } catch {
        return "";
      }
    }

    return String(rawValue);
  };

  // Add debug logging to form submission
  const handleSubmitForm1 = (values: any, { setSubmitting }: any) => {
    // Build the data array as per required payload
    const data: any[] = [];
    const formDataEntries = Object.entries(values);

    formDataEntries.forEach(([key, value]: any) => {
      const fieldDef = fields.find((f) => f.name === key);
      if (fieldDef?.id) {
        let formFieldValue: any = value;
        // Force applicantType to always be "student"
        if (key === "applicantType") {
          formFieldValue = "student";
        }
        // Always send Aadhaar verified as false in payload for now
        if (key === "isAadhaarVerified") {
          formFieldValue = false;
        }
        formFieldValue = resolveApplicantVerificationFieldValue(
          key,
          formFieldValue,
          fieldDef
        );

        data.push({
          formFieldId: fieldDef.id, // Use field.id from API response
          formFieldKey: key,
          formFieldValue: normalizePayloadFieldValue(key, formFieldValue),
        });
      }
    });

    // Build the payload object as per required structure
    const payloadObject: any = {
      templateId: templateId,
      formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
      mobileNumber: values?.phone_number,
      data,
    };

    // Extract source values from URL query parameters only when not authenticated
    if (!isAuthenticated) {
      const urlParams = new URLSearchParams(window.location.search);
      const leadOriginSource = urlParams.get("leadoriginsource") || "";
      const subSource = urlParams.get("source") || "";
      const subSubSource = urlParams.get("subsubsource") || "";

      payloadObject.leadOriginSource = leadOriginSource;
      payloadObject.subSource = subSource;
      payloadObject.subSubSource = subSubSource;
    }
    // If trackingId is available, add it to the payload
    if (trackingId) {
      payloadObject.trackingId = trackingId;
    }

    handleInvokCreateApi(payloadObject, values);
  };

  const handleCourseCategoryValue = (value: any) => {
    switch (value) {
      case "UG":
        return "Under Graduation";
      case "PG":
        return "Post Graduation";
      default:
        return "Post Graduation";
    }
  };

  useEffect(() => {
    if (
      fields
        ?.find((f) => f.name === "university")
        ?.name?.toLowerCase()
        .includes("university")
    ) {
      setFormValues((prev) => ({
        ...prev,
        universityNotInList: notInList?.includes(
          fields?.find((f) => f.name === "university")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "universityNotInList",
        notInList?.includes(fields?.find((f) => f.name === "university")?.label)
          ? true
          : false
      );
    }
    if (
      fields
        ?.find((f) => f.name === "institute")
        ?.name?.toLowerCase()
        .includes("institute")
    ) {
      setFormValues((prev) => ({
        ...prev,
        instituteNotInList: notInList?.includes(
          fields?.find((f) => f.name === "institute")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "instituteNotInList",
        notInList?.includes(fields?.find((f) => f.name === "institute")?.label)
          ? true
          : false
      );
    }
    if (
      fields
        ?.find((f) => f.name === "courseName")
        ?.name?.toLowerCase()
        .includes("coursename")
    ) {
      setFormValues((prev) => ({
        ...prev,
        courseNameNotInList: notInList?.includes(
          fields?.find((f) => f.name === "courseName")?.label
        )
          ? true
          : false,
      }));
      formikRef.current?.setFieldValue(
        "courseNameNotInList",
        notInList?.includes(fields?.find((f) => f.name === "courseName")?.label)
          ? true
          : false
      );
    }
  }, [notInList, setFormValues, formikRef, fields]);

  const shouldAutoInvokeLeadFlow: boolean =
    checkIsLeadApiInvoked.ASSIGN_SM == false ||
    checkIsLeadApiInvoked.CREATE_LEAD == false ||
    checkIsLeadApiInvoked.LEAD_TO_APPLICATION == false;
  const getLeadPayload: any = useMemo(() => {
    if (activeHorizontalIndex == 1) {
      const extractId = (field: any) => {
        const match = field?.match(/^\s*([^-\s]+)\s*(?:-|$)/);
        return match ? match[1] : field?.trim();
      };
      const extractValue = (field: any) =>
        field && typeof field === "object" && "value" in field
          ? field?.value
          : field;
      const extractValueCode = (field: any) =>
        field && typeof field === "object" && "code" in field
          ? field?.code
          : extractId(field)
      // console.log(formData, "formData")
      const partnerLeadPayload: {
        applicationId: any;
        leadFirstName: any;
        leadLastName: any;
        leadMobileNo: any;
        leadEmailAddr: any;
        amountRequested: any;
        admissionStatus: any;
        countryOfStudyId: any;
        universityId: string;
        universityNotInList: any;
        otherUniversityName: any;
        instituteId: string;
        instituteNotInList: any;
        otherInstituteName: any;
        courseId: string;
        courseNotInList: any;
        leadCourseTypeName: any;
        stemFlag: boolean;
        otherCourseName: string;
        assignedSMId?: string;
        pincode?: string;
      } = {
        pincode: formData?.pincode || "",
        applicationId: trackingId || "",
        leadFirstName: formData?.firstName || "",
        leadLastName: formData?.lastName || "",
        leadMobileNo: formData?.phone_number,
        leadEmailAddr: formData?.email || "",
        amountRequested: formData?.loanAmount || "",
        admissionStatus: formData?.admissionStatus || "",
        countryOfStudyId: extractValue(formData?.universityCountryId) || "US",
        universityId: notInList?.includes("University Name")
          ? ""
          : formData.university != null && formData.university != "" ? String(extractValueCode(formData.university)) : "",
        universityNotInList: notInList?.includes("University Name") || false,
        otherUniversityName: notInList?.includes("University Name")
          ? formData.university
          : "",
        instituteId: notInList?.includes("Institute Name")
          ? ""
          : formData.institute != null && formData.institute != "" ? String(extractValueCode(formData.institute)) : "",
        instituteNotInList: notInList?.includes("Institute Name") || false,
        otherInstituteName: notInList?.includes("Institute Name")
          ? formData.institute
          : "",
        courseId: notInList?.includes("Course Name")
          ? ""
          : formData.courseName != null && formData.courseName != "" ? String(extractValueCode(formData.courseName)) : "",
        courseNotInList: notInList?.includes("Course Name") || false,
        leadCourseTypeName: formData.leadCourseTypeName || "Post Graduate",
        stemFlag: formData.courseType == "STEM" ? true : false,
        otherCourseName: notInList?.includes("Course Name")
          ? String(extractValue(formData.courseName))
          : "",
      };

      return partnerLeadPayload;

      // if (shouldAutoInvokeLeadFlow == false) {
      //   handleLeadCreationFlow(partnerLeadPayload);
      // }
    }
  }, [checkIsLeadApiInvoked, formData, activeHorizontalIndex]);

  const handleLeadCreationFlow = async (partnerLeadPayload: any, leadSequenceId: string) => {
    //source
    if (checkIsLeadApiInvoked?.ASSIGN_SM == false && applicationSource == "") {
      const payload = {
        pinCode: formData?.pincode, //this static pincode need to be change later for now we are passing it static
        applicationId: trackingId,
      };
      try {
        await eligibilityCheckServices
          .leadAllocation(payload)
          .then((res: any) => {
            partnerLeadPayload.assignedSMId =
              String(res?.data?.data?.assignedSMId) || "";
            dispatch(
              setAssignedSMIdValue(String(res?.data?.data?.assignedSMId))
            );
            // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
            dispatch(setSalesUserId(String(res?.data?.data?.assignedSMId)));
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "ASSIGN_SM",
                value: true,
              })
            );
          })
          .catch((err: any) => {
            setIsSubmittingToAPI(false);
            console.error("Lead allocation failed:", err);
            return;
          });
      } catch (error) {
        setIsSubmittingToAPI(false);
        console.error("Lead creation flow failed:", error);
        return;
      }
    }

    let leadIdData = "";
    // source
    if (checkIsLeadApiInvoked?.CREATE_LEAD == false && applicationSource == "") {
      const hasLeadSequenceId =
        !!leadSequenceId && String(leadSequenceId).trim().toLowerCase() !== "null";

      if (!hasLeadSequenceId) {
        try {
          partnerLeadPayload.leadPincode = formData?.pincode;
          partnerLeadPayload.assignedSMId =
            partnerLeadPayload.assignedSMId || String(assignedSMIdValue);
          console.log(partnerLeadPayload, "partnerLeadPayload", formData);
          await eligibilityCheckServices
            .createPartnerLead(partnerLeadPayload)
            .then(async (resp: any) => {
              leadIdData = resp?.data?.data?.leadSequence.toString();
              dispatch(
                setLeadSequenceId(resp?.data?.data?.leadSequence.toString())
              );
              if (resp?.status == 200) {
                dispatch(
                  setCheckIsLeadApiInvoked({
                    key: "CREATE_LEAD",
                    value: true,
                  })
                );
              }
            })
            .catch(() => {
              setIsSubmittingToAPI(false);
              return;
            });
        } catch (error: any) {
          console.error("Lead to Application Error:", error);
          return;
        }
      } else {
        try {
          const updateLeadPayload = {
            trackingId: trackingId ?? "",
          };
          const updateLeadResp: any = await updateLeadWithLatestLeadData(updateLeadPayload);
          if (updateLeadResp?.status === 200) {
            leadIdData = String(leadSequenceId);
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "CREATE_LEAD",
                value: true,
              })
            );
          }
        } catch (error: any) {
          console.error("Update Lead Error:", error);
          return;
        }
      }
    }
    // lead id
    if (checkIsLeadApiInvoked?.LEAD_TO_APPLICATION == false) {
      try {
        if (leadSequenceId || leadIdData) {
          const leadToAppPayload = {
            leadId: leadSequenceId || leadIdData,
            trackingId: trackingId ?? "",
            // Add any other required fields for lead-to-application
          };

          const leadToAppResp: any = await losServices.leadToApplication(
            leadToAppPayload
          );
          if (leadToAppResp.status == 200) {
            dispatch(
              setCheckIsLeadApiInvoked({
                key: "LEAD_TO_APPLICATION",
                value: true,
              })
            );
            dispatch(
              setApplicationId(leadToAppResp?.data?.data?.applicationId)
            );
            dispatch(setApplicantId(leadToAppResp?.data?.data?.applicantId));

            if (
              activeHorizontalIndex === 1 &&
              (activeVerticalIndex === 0 || activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)
            ) {
              handleRelationMasterApi();
            }

            const fetchProducts = async () => {
              setLoadingProducts(true);
              try {
                const res = await dropdownService.getProducts();
                setProductOptions(
                  res.data.map((prod) => ({
                    value: prod.code,
                    label: prod.name,
                  }))
                );
              } catch (error) {
                setProductOptions([]);
              } finally {
                setLoadingProducts(false);
              }
            };
            // Fetch master data for dropdowns like courseCategory, admissionStatus, courseType
            const fetchMasterData = async () => {
              try {
                const res = await eligibilityCheckServices.getMasters();
                if (res.data?.status === "success") {
                  setDropdownData((prev) => ({
                    ...prev,
                    courseCategory: (res.data.data.categories || []).map(
                      (cat: any) => ({
                        value: cat.categoryCode,
                        label: cat.categoryName,
                      })
                    ),
                    admissionStatus: (res.data.data.statusesOfAdmission || []).map(
                      (stat: any) => ({
                        value: stat.statusName,
                        label: stat.statusName,
                      })
                    ),
                    courseType: (res.data.data.courseTypes || []).map((type: any) => ({
                      value: type.typeCode,
                      label: type.typeName,
                    })),
                  }));
                }
              } catch (error) {
                // Optionally handle error or fallback to static data
                console.error("Failed to fetch master data", error);
              }
            };

            // Fetch Countries on component mount
            const fetchCountries = async () => {
              setLoadingDropdowns((prev) => ({ ...prev, countries: true }));
              try {
                const countriesResponse = await dropdownService.getCountries();
                const allCountries = countriesResponse.data
                  // .filter((country) => country.active)
                  .map((country) => ({
                    value: country.countryId,
                    label: country.countryDesc,
                    countryId: String(country.countryId ?? ""),
                  }));
                // Separate top countries and rest
                const topCountries: any[] = [];
                const restCountries: any[] = [];

                allCountries.forEach((country) => {
                  const countryLabel = country.label.toUpperCase();
                  const isTopCountry = topCountry.some((topName: any) =>
                    countryLabel.includes(topName)
                  );

                  if (isTopCountry) {
                    topCountries.push(country);
                  } else {
                    restCountries.push(country);
                  }
                });

                // Sort top countries by the order in topCountryNames array
                topCountries.sort((a, b) => {
                  const aIndex = topCountry.findIndex((name: any) =>
                    a.label.toUpperCase().includes(name)
                  );
                  const bIndex = topCountry.findIndex((name: any) =>
                    b.label.toUpperCase().includes(name)
                  );
                  return aIndex - bIndex;
                });

                // Sort rest of countries alphabetically
                restCountries.sort((a, b) => a.label.localeCompare(b.label));

                // Combine: top countries first, then rest
                const countriesOptions = [...topCountries, ...restCountries];
                setDropdownData((prev) => ({
                  ...prev,
                  countries: countriesOptions,
                }));
              } catch (error) {
                console.error("Error fetching dropdown data:", error);
              } finally {
                setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
              }
            };
            // Fetch Salutations on component mount
            const fetchSalutations = async () => {
              setLoadingDropdowns((prev) => ({ ...prev, salutations: true }));
              try {
                const salutationResponse = await dropdownService.getSalutations();
                const salutationsOptions = salutationResponse.data
                  // .filter((sal) => sal.active)
                  .map((sal) => ({
                    value: sal.salutationCode,
                    label: sal.salutationDesc,
                  }));

                setDropdownData((prev) => ({
                  ...prev,
                  salutations: salutationsOptions,
                }));
              } catch (error) {
                console.error("Error fetching dropdown data:", error);
              } finally {
                //setLoadingDropdowns((prev) => ({ ...prev, countries: false }));
              }
            };

            // Fetch System Values after Salutations
            const fetchSystemValues = async () => {
              try {
                const systemValuesResponse =
                  await eligibilityCheckServices.getSystemValues();

                if (systemValuesResponse.data?.status === "success") {
                  const systemValues = systemValuesResponse.data.data;

                  // Filter and process Language Exam Types
                  const languageExamTypes = systemValues
                    .filter(
                      (item: any) => item.name === "LANGUAGE_EXAM_TYPE" && item.active
                    )
                    .map((item: any) => ({
                      value: item.code,
                      label: item.value,
                      id: item.serialId,
                    }));

                  // Filter and process Entrance Exam Types
                  const entranceExamTypes = systemValues
                    .filter(
                      (item: any) => item.name === "ENTRANCE_EXAM_TYPE" && item.active
                    )
                    .map((item: any) => ({
                      value: item.code,
                      label: item.value,
                      id: item.serialId,
                    }));

                  const loanTenureOptions = systemValues
                    .filter(
                      (item: any) => item.name === "LOAN_TENURE_INMONTH" && item.active
                    )
                    .map((item: any) => ({
                      value: item.code,
                      label: item.value,
                      id: item.serialId,
                    }));

                  // Update dropdown data with system values
                  setDropdownData((prev) => ({
                    ...prev,
                    languageExamTypes,
                    entranceExamTypes,
                    loanTenureOptions,
                  }));
                }
              } catch (error) {
                console.error("Error fetching system values:", error);
              }
            };

            // Get Entrance Exam Master
            const getEntranceExamMaster = async () => {
              try {
                const response = await eligibilityCheckServices.getEntranceExamMaster();
                if (response?.data?.data) {
                  setEntranceExamMaster(response.data.data);
                }
              } catch (error: any) {
                console.log(error, "error");
                setEntranceExamMaster([]);
              }
            };

            // Fetch Designations
            const fetchDesignations = async () => {
              try {
                const designationResponse =
                  await eligibilityCheckServices.getDesignations();
                if (designationResponse?.data?.status === "success") {
                  const designationsOptions = designationResponse.data.data.map(
                    (designation: any) => ({
                      value: designation.genDesignation,
                      label: designation.genDesgDesc,
                    })
                  );
                    alert('hello')
                  setDropdownData((prev) => ({
                    ...prev,
                    designations: designationsOptions,
                  }));
                }
              } catch (error) {
                console.error("Error fetching designations:", error);
              }
            };

            // Execute API calls based on step conditions
            const executeApiCalls = async () => {
              const promises: Promise<void>[] = [];

              if (activeHorizontalIndex === 0 && (activeVerticalIndex === 0 || activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(fetchProducts());
              }

              if (
                activeHorizontalIndex === 0 &&
                (activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)
              ) {
                promises.push(fetchMasterData());
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 1 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                debouncedZipCodeCall(formData.permanentPincode, undefined, "permanent");
                debouncedZipCodeCall(formData.currentPincode, undefined, "current");
              }
              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                debouncedCompanyZipCodeCall(formData.employmentCompanyPincode);
              }

              if (
                (activeHorizontalIndex === 0 && activeVerticalIndex === 1) ||
                (activeHorizontalIndex === 1 &&
                  (activeVerticalIndex === 1 ||
                    activeVerticalIndex === 2 ||
                    activeVerticalIndex === 3 ||
                    activeVerticalIndex === 4 ||
                    activeVerticalIndex === 5))
              ) {
                promises.push(fetchCountries());
              }

              if (
                activeHorizontalIndex === 1 &&
                (activeVerticalIndex === 0 || activeVerticalIndex === 5 || activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4)
              ) {
                promises.push(fetchSalutations());
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 2 || activeVerticalIndex === 3 || activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(fetchDesignations());
                handleInvokCompanyZipCode(String(formData.employmentCompanyPincode));
              }

              if (activeHorizontalIndex === 1 && (activeVerticalIndex === 4 || activeVerticalIndex === 5)) {
                promises.push(getEntranceExamMaster());
                promises.push(fetchSystemValues());
              }

              // Set loading state at the start
              if (promises.length > 0) {
                setIsApiLoading(true);
                try {
                  // Wait for all API calls to complete
                  await Promise.all(promises);
                } finally {
                  setIsApiLoading(false);
                }
              }
            };

            await executeApiCalls();
          }
        }
      } catch (error: any) {
        console.error("Lead to Application Error:", error);
        dispatch(
          setStatusPopup({
            status: "error",
            message:
              error?.response?.data?.message ||
              error?.message ||
              "Processio API call failed. Please try again.",
          })
        );
      }
    }
  };


  // handleSubmit
  const saveReferenceSectionDetails = useCallback(
    async (
      currentValues: Record<string, any>,
      applicantResp: any,
      referenceNumberOverride?: number
    ) => {
      const referenceNumber = referenceNumberOverride || activeReferenceSection;
      const resolvedTrackingId =
        applicantResp?.data?.data?.trackingId || trackingId || "";
      const resolvedApplicationId =
        applicantResp?.data?.data?.applicationId || applicationIdApp || "";
      let latestReferenceIds: any = {};
      try {
        const referenceIdsResp: any =
          await losServices.getReferenceIds(resolvedTrackingId);
        latestReferenceIds = referenceIdsResp?.data?.data || {};
      } catch (error) {
        console.error("getReferenceIds failed:", error);
      }
      const resolvedReferenceId =
        referenceNumber === 2
          ? latestReferenceIds?.referenceTwoId || null
          : latestReferenceIds?.referenceOneId || null;
      let selectedReferenceCode =
        referenceNumber === 2 ? reference2CodeData : reference1CodeData;
      const selectedReferenceCity =
        currentValues?.[`addressReference${referenceNumber}City`];
      const selectedReferenceCountry =
        currentValues?.[`addressReference${referenceNumber}Country`];
      const selectedReferencePincode =
        currentValues?.[`addressReference${referenceNumber}Pincode`];
      const shouldResolveReferenceCode =
        String(selectedReferencePincode || "").length === 6 &&
        (!getReferencePayloadCityId(selectedReferenceCode, selectedReferenceCity) ||
          !getReferencePayloadPincodeId(selectedReferenceCode));

      if (shouldResolveReferenceCode) {
        try {
          const [zipResp, pinCodeResp] = await Promise.all([
            eligibilityCheckServices.getZipCode(selectedReferencePincode),
            eligibilityCheckServices.getPinCode(selectedReferencePincode),
          ]);
          const zipCodeData = zipResp?.data?.data?.[0] || {};
          const pinCodeData = pinCodeResp?.data?.data?.[0] || {};
          selectedReferenceCode = {
            ...zipCodeData,
            ...pinCodeData,
            cityId:
              pinCodeData?.city ??
              pinCodeData?.cityId ??
              zipCodeData?.cityId ??
              zipCodeData?.cityCode,
          };
          if (referenceNumber === 2) {
            setReference2CodeData(selectedReferenceCode);
          } else {
            setReference1CodeData(selectedReferenceCode);
          }
        } catch (error) {
          console.error("Reference pincode code lookup failed:", error);
        }
      }

      const payload: any = {
        trackingId: resolvedTrackingId,
        eventName: `APPLICANT_APPLICATION_REFERENCE_${referenceNumber === 1 ? "ONE" : "TWO"}_DETAILS`,
        applicantType: "Applicant",
        applicationId: Number(resolvedApplicationId) || resolvedApplicationId,
        emailAddress: currentValues?.[`basicReference${referenceNumber}Email`],
        firstName: currentValues?.[`basicReference${referenceNumber}FirstName`],
        lastName: currentValues?.[`basicReference${referenceNumber}LastName`],
        fullName: `${currentValues?.[`basicReference${referenceNumber}FirstName`] || ""} ${currentValues?.[`basicReference${referenceNumber}LastName`] || ""}`.trim(),
        active: true,
        referenceType: referenceNumber === 1 ? "one" : "two",
        mobileNo: Number(currentValues?.[`basicReference${referenceNumber}PhoneNumber`]) || "",
        referenceAddress: {
          addressTypeDescription: "RESI ALTERNATE ADDRESS",
          addressTypeId: "ALTRESI",
          landmark: currentValues?.[`addressReference${referenceNumber}Landmark`] || "",
          area: currentValues?.[`addressReference${referenceNumber}Area`] || "",
          locality: currentValues?.[`addressReference${referenceNumber}Locality`] || "",
          addressLine1:
            currentValues?.[`addressReference${referenceNumber}AddressLine1`] || "",
            addressLine2:
            currentValues?.[`addressReference${referenceNumber}AddressLine2`] || "",
          cityId: String(
            getReferencePayloadCityId(selectedReferenceCode, selectedReferenceCity) || ""
          ),
          cityName: String(toOptionValue(selectedReferenceCity) || ""),
          countryId: resolveCountryId(selectedReferenceCountry) || "IN",
          countryName: String(toOptionValue(selectedReferenceCountry) || ""),
          pincodeId: getReferencePayloadPincodeId(selectedReferenceCode),
          pincode: String(selectedReferencePincode || ""),
        },
      };

      if (resolvedReferenceId) {
        payload.referenceId = Number(resolvedReferenceId) || resolvedReferenceId;
        await losServices.updateReference(payload);
      } else {
        await losServices.saveReference(payload);
      }
    },
    [
      activeReferenceSection,
      applicationIdApp,
      reference1CodeData,
      reference2CodeData,
      referenceOneId,
      referenceTwoId,
      trackingId,
    ]
  );

  const saveCollateralSectionDetails = useCallback(
    async (
      currentValues: Record<string, any>,
      applicantResp: any,
      collateralNumberOverride?: number
    ) => {
      const collateralNumber = collateralNumberOverride || activeCollateralSection;
      const collateralSequenceType = `COLLATERAL_${numberToWord[collateralNumber] || numberToWord[1]}`
      const { base, coOwner } = getCollateralSectionFields(collateralNumber);
      const visibleBaseFields = getVisibleCollateralBaseFields(base, currentValues);
      const findSectionField = (tokens: string[]) =>
        visibleBaseFields.find((field: any) => {
          const normalizedName = getNormalizedFieldToken(field?.name);
          const normalizedLabel = getNormalizedFieldToken(field?.label);
          return tokens.some(
            (token) =>
              normalizedName.includes(token) || normalizedLabel.includes(token)
          );
        });
      const getSectionValue = (tokens: string[]) => {
        const field = findSectionField(tokens);
        return field ? currentValues?.[field.name] : "";
      };
      const collateralTypeField = visibleBaseFields.find((field: any) =>
        /^collateral\d*type$/i.test(String(field?.name || ""))
      );
      const collateralValueField = visibleBaseFields.find((field: any) =>
        /^collateral\d*value$/i.test(String(field?.name || ""))
      );
      const collateralTypeRaw = collateralTypeField
        ? currentValues?.[collateralTypeField.name]
        : "";
      const collateralTypeRawValue = String(toOptionValue(collateralTypeRaw) ?? "");
      const collateralTypeRawLabel = String(
        (collateralTypeRaw && typeof collateralTypeRaw === "object"
          ? (collateralTypeRaw as any)?.label
          : collateralTypeRaw) ?? "",
      );
      // The Collateral Type field can hold either the backend id/code
      // (307/308/309) or the display label ("Property"/"Fixed Deposit"/"Saving")
      // depending on how it was populated — check both against the master list
      // so collateralTypeId always resolves to the numeric id the processio
      // save-collateral API expects, instead of sending the label text through.
      const collateralTypeOptions = Array.isArray(
        collateralTypeField?.options?.options
      )
        ? collateralTypeField.options.options
        : [];
      const collateralTypeMaster = [...mapCollateral(), ...collateralTypeOptions];
      const matchedCollateralType = collateralTypeMaster.find(
        (opt: any) =>
          String(opt?.value ?? opt?.id ?? "") === collateralTypeRawValue ||
          String(opt?.label ?? opt?.name ?? "").toLowerCase() === collateralTypeRawValue.toLowerCase() ||
          String(opt?.label ?? opt?.name ?? "").toLowerCase() === collateralTypeRawLabel.toLowerCase(),
      );
      const collateralTypeId =
        matchedCollateralType?.value ??
        matchedCollateralType?.id ??
        (/^\d+$/.test(collateralTypeRawValue) ? collateralTypeRawValue : "");
      const collateralTypeLabel =
        matchedCollateralType?.label ||
        matchedCollateralType?.name ||
        (collateralTypeRaw && typeof collateralTypeRaw === "object"
          ? (collateralTypeRaw as any)?.label || collateralTypeId
          : collateralTypeOptions.find(
              (option: any) =>
                String(option?.value ?? "") === String(collateralTypeId) ||
                String(option?.id ?? "") === String(collateralTypeId)
            )?.label || collateralTypeId);
      const collateralMode = getCollateralModeForFields(base, currentValues);
      const collateralCountry = getSectionValue(["country"]);
      const collateralPincode = getSectionValue(["pincode"]);
      const collateralCode = collateralCodeData[collateralNumber];
      const collateralCity = getSectionValue(["city"]);
      const collateralState = getSectionValue(["state"]);
      const ownershipSections = new Map<number, Record<string, any>>();
      const collateralAddressType = getSectionValue(["addresstype"]);
      const addressTypes = collateralMasterOptions.addressTypes || [];
      const propertyTypes = collateralMasterOptions.propertyTypes || [];
      const propertySubTypes = collateralMasterOptions.propertySubTypes || [];
      const collateralAddressTypeDescription =
        addressTypes.find(
          (item: any) =>
            String(item?.value) === String(toOptionValue(collateralAddressType))
        )?.label || getOptionTextValue(collateralAddressType);

      coOwner.forEach((field: any) => {
        const match = String(field?.name || "").match(
          new RegExp(`^coOwnerCollateral${collateralNumber}(?:_(\\d+)|(\\d+))?(.*)$`, "i")
        );
        if (!match) return;
        const ownerIndex = Number(match[1] || match[2] || 1);
        const suffix = String(match[3] || "")
          .replace(/^_/, "")
          .toLowerCase();
        const currentSection = ownershipSections.get(ownerIndex) || {};
        currentSection[suffix] = currentValues?.[field.name];
        ownershipSections.set(ownerIndex, currentSection);
      });

      const ownershipPayload = Array.from(ownershipSections.entries())
        .sort((a, b) => a[0] - b[0])
        .map(([ownerIndex, sectionValues]) => ({
          ownerIndex,
          collateralId: null,
          applicationId:
            Number(applicantResp?.data?.data?.applicationId) || applicationIdApp || 0,
          phoneNumber: String(sectionValues.phonenumber || ""),
          ownershipPercentage:
            sectionValues.ownershippercentage !== undefined &&
            sectionValues.ownershippercentage !== ""
              ? Number(sectionValues.ownershippercentage)
              : null,
          coOwnerName: String(sectionValues.name || ""),
          active: true,
        }));

      const mainApplicantId =
        Number(applicantResp?.data?.data?.applicantId) ||
        Number(applicantIdApp) ||
        0;
      // Each co-owner section can be a different real person (the main
      // applicant, a specific co-applicant, or an unrelated third party) —
      // reusing mainApplicantId for every entry (as before) tagged every
      // co-owner as the main applicant. Match the co-owner's selected name
      // the same way the "ui" DynamicForm/FormEdit collateral save flow does,
      // and fetch that specific co-applicant's own applicantId when matched.
      const coApplicantApplicantIdCache: Record<number, any> = {};
      const resolveOwnerApplicantId = async (coOwnerName: string): Promise<number> => {
        const match = matchCoOwnerNameToApplicant(currentValues, coOwnerName);
        if (!match) return 0;
        if (match.type === "main") return mainApplicantId;
        if (coApplicantApplicantIdCache[match.coApplicantNumber] === undefined) {
          try {
            const coApplicantResp: any = await losServices.getCoApplicantDetails({
              trackingId: applicantResp?.data?.data?.trackingId || trackingId || "",
              coApplicantType: `Co-Applicant ${match.coApplicantNumber}`,
            });
            coApplicantApplicantIdCache[match.coApplicantNumber] =
              Number(coApplicantResp?.data?.data?.applicantId) || 0;
          } catch {
            coApplicantApplicantIdCache[match.coApplicantNumber] = 0;
          }
        }
        return Number(coApplicantApplicantIdCache[match.coApplicantNumber]) || 0;
      };

      // Every co-owner section (not just the first) needs these shared
      // enrichment fields attached before being sent — previously only
      // ownershipPayload[0] was enriched and sent, so collateralOwnershipDetailsDTOList
      // always dropped co-owner 2+ regardless of how many sections were filled in.
      const ownershipDetailsList = await Promise.all(
        ownershipPayload
          .filter((item) => item.coOwnerName || item.phoneNumber)
          .map(async ({ ownerIndex, ...item }) => ({
            ...item,
            __coOwnerIndex: ownerIndex,
            collateralOwnerDetailsId: null,
            applicationDisplayCode: null,
            bankCustomer: null,
            ownerAddressId: 0,
            ownerAddress: null,
            coOwnerApplicantCIF: null,
            createdBy: 0,
            createdOn: null,
            modifiedBy: null,
            modifiedOn: null,
            applicationId:
              Number(applicantResp?.data?.data?.applicationId) ||
              Number(applicationIdApp) ||
              0,
            applicantId: await resolveOwnerApplicantId(item.coOwnerName),
          })),
      );

      const payload: any = {
        trackingId: applicantResp?.data?.data?.trackingId || trackingId || "",
        eventName: `APPLICANT_APPLICATION_COLLATERAL_${
          numberToWord[collateralNumber] || numberToWord[1]
        }_OWNERSHIP_DETAILS`,
        applicantType: "Applicant",
        collateralSequenceType: collateralSequenceType,
        applicationId:
          Number(applicantResp?.data?.data?.applicationId) || Number(applicationIdApp) || 0,
        collateralId: null,
        collateralType: String(collateralTypeLabel || ""),
        collateralTypeId:
          collateralTypeId !== undefined && collateralTypeId !== ""
            ? Number(collateralTypeId)
            : null,
        collateralValue: collateralValueField
          ? Number(
              String(currentValues?.[collateralValueField.name] || 0).replace(
                /,/g,
                ""
              )
            )
          : null,
        collateralAddress: {
          addressTypeDescription: collateralAddressTypeDescription,
          landmark: '',
          cityId: String(
            getReferenceCityId(collateralCode, collateralCity) || ""
          ),
          cityName: String(toOptionValue(collateralCity) || ""),
          countryId: resolveCountryId(collateralCountry) || "IN",
          countryName: String(toOptionValue(collateralCountry) || ""),
          pincode: String(collateralPincode || ""),
          pincodeId: String(
            getFirstNonEmptyValue(
              collateralCode?.pinCodeId,
              collateralCode?.pincodeId,
              collateralCode?.pinCodeID,
              collateralCode?.id
            ) || ""
          ),
          stateId: String(
            getFirstNonEmptyValue(collateralCode?.stateCode, collateralCode?.stateId) || ""
          ),
          stateName: String(toOptionValue(collateralState) || ""),
          addressTypeId: String(
            toOptionValue(collateralAddressType) || ""
          ),
          addressLine1: String(getSectionValue(["addressline1"]) || ""),
          addressLine2: String(getSectionValue(["addressline2"]) || ""),
        },
        collateralOwnershipDetailsDTOList: ownershipDetailsList,
      };
      if (collateralMode === "fixed") {
        payload.nameFdHolder = String(getSectionValue(["fdholdername"]) || "");
        payload.fdrNumber = Number(getSectionValue(["fdnumber"]))|| null;
      } else if (collateralMode === "savings") {
        const savingsHolderField = visibleBaseFields.find((field: any) =>
          /^collateral\d+holderName$/i.test(String(field?.name || ""))
        );
        payload.holderName = String(
          (savingsHolderField && currentValues?.[savingsHolderField.name]) || ""
        );
        payload.accountNumber = Number(getSectionValue(["accountnumber"])) || null;
      } else if (collateralMode === "property") {
        const propertySubTypeValue = getSectionValue(["propertysubtypename"]);
        const propertyTypeValue = getSectionValue([
          "propertypename",
          "propertytypename",
        ]);
        payload.propertySubTypeId =
          Number(
            propertySubTypes.find(
              (item: any) =>
                String(item?.value) === String(toOptionValue(propertySubTypeValue)) ||
                String(item?.label).toLowerCase() ===
                  String(getOptionTextValue(propertySubTypeValue)).toLowerCase()
            )?.id
          ) || null;
        payload.propertyTypeId =
          Number(
            propertyTypes.find(
              (item: any) =>
                String(item?.value) === String(toOptionValue(propertyTypeValue)) ||
                String(item?.label).toLowerCase() ===
                  String(getOptionTextValue(propertyTypeValue)).toLowerCase()
            )?.id
          ) || null;
        payload.propertyValue =
          Number(getSectionValue(["totalvalue"]) || 0) ||
          Number(
            String(
              currentValues?.[`collateral${collateralNumber}Value`] || 0
            ).replace(/,/g, "")
          ) ||
          null;
           payload.noOfUnits =
          Number(getSectionValue(["noofunits"]) || 0)
          payload.unitPrice =
          Number(getSectionValue(["unitprice"]) || 0)
      }
      const existingCollateral: any = await losServices
        .fetchCollateral(payload.trackingId)
        .then((resp: any) =>
          resp?.data?.data?.find(
            (item: any) =>
              item?.collateralSequenceType === payload.collateralSequenceType
          )
        )
        .catch(() => null);
       
      if (existingCollateral) {
         const keys = ["savingSequence", "fdSequence", "propertySequence"];
          keys.forEach(key => {
            payload[key] = existingCollateral[key] || null;
          });
        
        payload.collateralId =
          existingCollateral?.collateralId != null
            ? Number(existingCollateral.collateralId)
            : null;
        payload.collateralOwnershipDetailsDTOList?.forEach((item: any) => {
          item.collateralId =
            existingCollateral?.collateralId != null
              ? Number(existingCollateral.collateralId)
              : null;
          const ownerDetail = Array.isArray(existingCollateral?.collateralOwnerDetails)
            ? existingCollateral.collateralOwnerDetails.find(
                (detail: any) =>
                  Number(detail?.coOwnerIndex) === Number(item.__coOwnerIndex)
              )
            : null;

          if (ownerDetail) {
            item.collateralOwnerDetailsId =
              ownerDetail?.collateralOwnerDetailsId != null
                ? Number(ownerDetail.collateralOwnerDetailsId)
                : 0;
            item.applicantId =
              ownerDetail?.applicantId != null
                ? Number(ownerDetail.applicantId)
                : 0;
            item.ownerAddressId =
              ownerDetail?.ownerAddressId != null
                ? Number(ownerDetail.ownerAddressId)
                : 0;
          } else {
            item.collateralOwnerDetailsId =
              existingCollateral?.collateralOwnerDetailsId != null
                ? Number(existingCollateral.collateralOwnerDetailsId)
                : 0;
          }
          delete item.__coOwnerIndex;
        });
      } else {
        payload.collateralOwnershipDetailsDTOList?.forEach((item: any) => {
          delete item.__coOwnerIndex;
        });
      }

      await losServices.saveCollateral(payload);
      // Mirror the just-saved co-owner Name / Phone into redux formData so the
      // co-applicant First/Last Name & Mobile lock applies without a reload.
      const savedCoOwnerValues: Record<string, any> = {};
      Object.keys(currentValues || {}).forEach((key) => {
        const coOwnerMatch = key.match(
          /^coOwnerCollateral(\d+)(?:_\d+)?(Name|PhoneNumber|OwnershipPercentage)$/,
        );
        if (coOwnerMatch && Number(coOwnerMatch[1]) === Number(collateralNumber)) {
          savedCoOwnerValues[key] = currentValues[key];
        }
      });
      if (Object.keys(savedCoOwnerValues).length > 0) {
        dispatch(updateFormData(savedCoOwnerValues));
      }
      window.dispatchEvent(new CustomEvent("collateral:saved"));
    },
    [
      activeCollateralSection,
      applicationIdApp,
      collateralCodeData,
      collateralMasterOptions,
      collateralId,
      getCollateralModeForFields,
      getCollateralSectionFields,
      getVisibleCollateralBaseFields,
      applicantIdApp,
      trackingId,
    ]
  );

  const saveReferenceCollateralSummaryDetails = useCallback(async () => {
    const formikInstance = formikRef.current;
    if (!formikInstance || referenceCollateralSaveInFlightRef.current) {
      dispatch(setSummaryFormSaveInProgress(false));
      return;
    }

    const currentValues = formikInstance.values || {};
    const activeFields = getReferenceCollateralSaveFields(currentValues);
    const activeFieldNames = activeFields
      .map((field: any) => field?.name)
      .filter((name: string | undefined): name is string => Boolean(name));

    if (activeFieldNames.length === 0) {
      setSnackbar({
        open: true,
        message: "No Reference or Collateral fields found to save.",
        severity: "error",
      });
      dispatch(setSummaryFormSaveInProgress(false));
      return;
    }

    const normalizedCollateralValues = activeFields.reduce(
      (acc: Record<string, any>, field: any) => {
        if (field?.name && isCollateralScalarDropdownField(field.name)) {
          const normalizedValue = normalizeDropdownScalarValue(
            formikInstance.values?.[field.name]
          );
          acc[field.name] = normalizedValue;
          if (formikInstance.values?.[field.name] !== normalizedValue) {
            formikInstance.setFieldValue(field.name, normalizedValue, false);
          }
        }
        return acc;
      },
      {}
    );
    const submitValues = {
      ...(formikInstance.values || {}),
      ...normalizedCollateralValues,
    };

    const touchedFields = activeFieldNames.reduce(
      (acc: Record<string, boolean>, fieldName: string) => {
        acc[fieldName] = true;
        return acc;
      },
      {}
    );

    formikInstance.setTouched(
      {
        ...(formikInstance.touched || {}),
        ...touchedFields,
      },
      false
    );

    const errors = await formikInstance.validateForm(submitValues);
    const hasActiveFieldErrors = activeFieldNames.some((fieldName) =>
      Boolean((errors as Record<string, any>)?.[fieldName])
    );

    if (hasActiveFieldErrors) {
      setShowFieldErrorsAfterSaveAttempt(true);
      setSnackbar({
        open: true,
        message: getStepValidationSnackbarMessage(
          activeFieldNames,
          errors as Record<string, any>,
          submitValues
        ),
        severity: "error",
      });
      dispatch(setSummaryFormSaveInProgress(false));
      return;
    }

    referenceCollateralSaveInFlightRef.current = true;
    setIsSubmittingToAPI(true);

    const getReferenceCollateralPayloadValue = (field: any) => {
      const rawValue = submitValues?.[field.name];
      const normalizedName = getNormalizedFieldToken(field?.name);
      if (/^collateral\d*type$/.test(normalizedName)) {
        if (rawValue && typeof rawValue === "object") {
          return String(rawValue?.label ?? rawValue?.name ?? rawValue?.value ?? "");
        }
        const options = Array.isArray(field?.options?.options)
          ? field.options.options
          : [];
        const matchedOption = options.find(
          (option: any) =>
            String(option?.value ?? option?.id ?? option?.code ?? "") ===
            String(rawValue ?? "")
        );
        return String(
          matchedOption?.label ?? matchedOption?.name ?? rawValue ?? ""
        );
      }

      return normalizePayloadFieldValue(field.name, rawValue);
    };

    const data = activeFields
      .filter((field: any) => field?.id && field?.name)
      .map((field: any) => ({
        formFieldId: field.id,
        formFieldKey: field.name,
        formFieldValue: getReferenceCollateralPayloadValue(field),
      }));

    const isAadhaarSeededPayload =
      aadhaarSeedingStatus === undefined ||
      aadhaarSeedingStatus === null ||
      aadhaarSeedingStatus === ""
        ? false
        : aadhaarSeedingStatus;

    const currentVerticalStepLabel =
      horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
        activeVerticalIndex
      ]?.stepLabel ||
      horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
        activeVerticalIndex
      ]?.verticalStepName ||
      "Reference & Collateral Details";

    const payloadObject = {
      data,
      trackingId,
      templateId,
      formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
      mobileNumber: submitValues?.phone_number || formData?.phone_number,
      isAadhaarSeeded: isAadhaarSeededPayload,
    };

	    try {
      if (referenceCollateralActiveTab === 1 && isHasCollateralNoValue(submitValues)) {
        const hasCollateralFormData = getHasCollateralNoFormData(submitValues);
        if (hasCollateralFormData.length === 0) {
          throw new Error("No Collateral fields found to save.");
        }

        const resp = await losServices.createCollateral({
          formData: hasCollateralFormData,
          trackingId,
          collateralSequenceType: "COLLATERAL_ONE",
        });
        const responseStatus = String(resp?.data?.status || "").toLowerCase();
        const isCreateSuccessful =
          responseStatus === "success" ||
          (resp?.status >= 200 && resp?.status < 300 && responseStatus !== "fail");

        if (!isCreateSuccessful) {
          throw new Error(
            resp?.data?.message || `Failed to save ${currentVerticalStepLabel}.`
          );
        }

        await refreshReduxFromUserApplicationFetch(
          resp?.data?.data?.trackingId || trackingId
        );
        dispatch(bumpCompletionSummaryRefreshNonce());
        dispatch(
          updateFormData({
            ...submitValues,
            isAadhaarVerified: submitValues?.isAadhaarVerified ?? false,
          })
        );
        setSnackbar({
          open: true,
          message: `${currentVerticalStepLabel} saved successfully.`,
          severity: "success",
        });
        dispatch(setSummaryApplicationEditActive(false));
        return;
      }

	      const saveNumbers =
	        referenceCollateralActiveTab === 0
	          ? getReferenceSectionNumbersForSave(submitValues)
          : getCollateralSectionNumbersForSave(submitValues);
      let latestResp: any = null;
      const getSectionData = (sectionFields: any[]) => {
        const sectionFieldNames = new Set(
          sectionFields.map((field: any) => field?.name).filter(Boolean)
        );
        return data.filter((item: any) =>
          sectionFieldNames.has(item?.formFieldKey)
        );
      };

      for (const sectionNumber of saveNumbers) {
        const sectionFields =
          referenceCollateralActiveTab === 0
            ? getReferenceSectionFields(sectionNumber)
            : (() => {
                const { base, coOwner } =
                  getCollateralSectionFields(sectionNumber);
                const hasCollateralField = getHasCollateralField();
                return [
                  ...(sectionNumber === 1 && hasCollateralField ? [hasCollateralField] : []),
                  ...getVisibleCollateralBaseFields(base, submitValues),
                  ...coOwner,
                ];
              })();
        const sectionData = getSectionData(sectionFields);
        if (sectionData.length === 0) continue;

        const collateralSequenceType = `COLLATERAL_${
          numberToWord[sectionNumber] || numberToWord[1]
        }`;
        const resp =
          referenceCollateralActiveTab === 1
            ? await losServices.createCollateral({
                formData: sectionData.map((field: any) => ({
                  formFieldId: field.formFieldId,
                  fieldKey: field.formFieldKey,
                  fieldValue: field.formFieldValue,
                })),
                trackingId,
                collateralSequenceType,
              })
            : await applicantDetailsServices.createApplicant({
                ...payloadObject,
                data: sectionData,
              });
        const responseStatus = String(resp?.data?.status || "").toLowerCase();
        const isCreateSuccessful =
          responseStatus === "success" ||
          (resp?.status >= 200 && resp?.status < 300 && responseStatus !== "fail");

        if (!isCreateSuccessful) {
          throw new Error(
            resp?.data?.message || `Failed to save ${currentVerticalStepLabel}.`
          );
        }

        if (resp?.data?.data?.applicationId) {
          dispatch(setApplicationId(resp.data.data.applicationId.toString()));
        }

        if (referenceCollateralActiveTab === 0) {
          await saveReferenceSectionDetails(submitValues, resp, sectionNumber);
        } else {
          await saveCollateralSectionDetails(submitValues, resp, sectionNumber);
        }
        latestResp = resp;
      }

      await refreshReduxFromUserApplicationFetch(
        latestResp?.data?.data?.trackingId || trackingId
      );
      dispatch(bumpCompletionSummaryRefreshNonce());

      if (latestResp?.data?.data?.trackingId) {
        dispatch(setTrackingId(latestResp.data.data.trackingId));
      }
      dispatch(
        updateFormData({
          ...submitValues,
          isAadhaarVerified: submitValues?.isAadhaarVerified ?? false,
        })
      );
      setSnackbar({
        open: true,
        message: `${currentVerticalStepLabel} saved successfully.`,
        severity: "success",
      });
      dispatch(setSummaryApplicationEditActive(false));
    } catch (error: any) {
      setSnackbar({
        open: true,
        message:
          error?.response?.data?.message ||
          error?.message ||
          `Failed to save ${currentVerticalStepLabel}.`,
        severity: "error",
      });
    } finally {
      referenceCollateralSaveInFlightRef.current = false;
      setIsSubmittingToAPI(false);
      dispatch(setSummaryFormSaveInProgress(false));
      formikInstance.setSubmitting(false);
    }
  }, [
    activeCollateralSection,
    activeHorizontalIndex,
    activeVerticalIndex,
    aadhaarSeedingStatus,
    dispatch,
    formData?.phone_number,
	    getCollateralSectionFields,
	    getCollateralSectionNumbersForSave,
    getHasCollateralNoFormData,
	    getReferenceCollateralSaveFields,
	    getReferenceSectionFields,
	    getReferenceSectionNumbersForSave,
	    getVisibleCollateralBaseFields,
	    horizontalSteps,
    isHasCollateralNoValue,
	    referenceCollateralActiveTab,
    refreshReduxFromUserApplicationFetch,
    saveCollateralSectionDetails,
    saveReferenceSectionDetails,
    templateId,
    trackingId,
  ]);

  useEffect(() => {
    if (pageType !== "SUMMARY") return;
    if (lastHandledSummarySaveRequestRef.current === null) {
      // Baseline on first summary render; do not auto-submit on Edit/open.
      lastHandledSummarySaveRequestRef.current = summarySaveRequestId;
      return;
    }
    if (summarySaveRequestId === lastHandledSummarySaveRequestRef.current) return;
    lastHandledSummarySaveRequestRef.current = summarySaveRequestId;

    if (isReferenceCollateralStep) {
      saveReferenceCollateralSummaryDetails();
      return;
    }

    (async () => {
      const formikInstance = formikRef.current;
      if (!formikInstance) {
        dispatch(setSummaryFormSaveInProgress(false));
        return;
      }

      const currentStepFieldNames = (fields || [])
        .map((f: any) => f?.name)
        .filter((name: string | undefined): name is string => Boolean(name));

      const touchedFields = currentStepFieldNames.reduce(
        (acc: Record<string, boolean>, fieldName: string) => {
          acc[fieldName] = true;
          return acc;
        },
        {}
      );

      formikInstance.setTouched(
        {
          ...(formikInstance.touched || {}),
          ...touchedFields,
        },
        false
      );

      const errors = await formikInstance.validateForm();
      const hasCurrentStepErrors = currentStepFieldNames.some(
        (fieldName: string) => Boolean((errors as Record<string, any>)?.[fieldName])
      );

      if (hasCurrentStepErrors) {
        setShowFieldErrorsAfterSaveAttempt(true);
        setSnackbar({
          open: true,
          message: getStepValidationSnackbarMessage(
            currentStepFieldNames,
            errors as Record<string, any>,
            formikInstance.values || {}
          ),
          severity: "error",
        });
        dispatch(setSummaryFormSaveInProgress(false));
        return;
      }
      formikInstance.submitForm();
    })();
  }, [
    fields,
    dispatch,
    isReferenceCollateralStep,
    pageType,
    saveReferenceCollateralSummaryDetails,
    summarySaveRequestId,
  ]);

  const validateFundsAndExpensesTotals = useCallback(
    (currentValues: Record<string, any>) => {
      const toAmount = (raw: any) => {
        const candidate =
          raw && typeof raw === "object" && "value" in raw ? raw.value : raw;
        const normalized = String(candidate ?? "")
          .replace(/,/g, "")
          .replace(/[^0-9.-]/g, "")
          .trim();
        if (!normalized) return 0;
        const parsed = Number(normalized);
        return Number.isNaN(parsed) ? 0 : parsed;
      };
      const expenseKeys = [
        "expenseTuitionFees",
        "expenseLivingExpenses",
        "expenseTravelExpenses",
        "expenseOtherExpenses",
        "expenseVasExpense",
      ];
      const fundKeys = [
        "fundRequestedLoanAmount",
        "fundOwnSources",
        "fundScholarshipAmount",
        "fundOtherIncome",
      ];
      const totalExpenses = expenseKeys.reduce(
        (sum, key) => sum + toAmount(currentValues?.[key]),
        0
      );
      const totalFunds = fundKeys.reduce(
        (sum, key) => sum + toAmount(currentValues?.[key]),
        0
      );
      return {
        isValid: totalExpenses === totalFunds,
        totalExpenses,
        totalFunds,
      };
    },
    []
  );

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    setIsSubmittingToAPI(true);
    // window.scrollTo({ top: 0, behavior: "smooth" });
    const currentHorizontalStepLabel =
      horizontalSteps?.[activeHorizontalIndex]?.stepLabel ||
      horizontalSteps?.[activeHorizontalIndex]?.horizontalStepName ||
      "Details";
    const currentVerticalStepLabel =
      horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
        activeVerticalIndex
      ]?.stepLabel ||
      horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
        activeVerticalIndex
      ]?.verticalStepName ||
      currentHorizontalStepLabel;
    const currentReferenceCollateralFieldNameSet = new Set(
      getReferenceCollateralSaveFields(values || {}).map((field: any) =>
        String(field?.name || "")
      )
    );
    if (isFundsAndExpensesStep) {
      const fundsExpenseValidation = validateFundsAndExpensesTotals(values || {});
      if (!fundsExpenseValidation.isValid) {
        setIsSubmittingToAPI(false);
        setSubmitting(false);
        if (pageType === "SUMMARY") {
          dispatch(setSummaryFormSaveInProgress(false));
        }
        setSnackbar({
          open: true,
          message: "Total Funds must be equal to Total Expenses.",
          severity: "error",
        });
        return;
      }
    }
    if (isReferenceCollateralStep) {
      if (referenceCollateralSaveInFlightRef.current) {
        setIsSubmittingToAPI(false);
        setSubmitting(false);
        if (pageType === "SUMMARY") {
          dispatch(setSummaryFormSaveInProgress(false));
        }
        return;
      }
      referenceCollateralSaveInFlightRef.current = true;
    }
    try {
      dispatch(
        updateFormData({
          ...values,
          isAadhaarVerified: values?.isAadhaarVerified ?? false,
        })
      );
      // On Form 1 (vertical step 1)
      if (
        pageType !== "SUMMARY" &&
        activeHorizontalIndex === 0 &&
        activeVerticalIndex === 0
      ) {
        handleSubmitForm1(values, setSubmitting);
      } else if (
        pageType !== "SUMMARY" &&
        activeHorizontalIndex === 0 &&
        activeVerticalIndex == 1
      ) {
        // Call dedupe-check API (mobileNumber encrypted with PII public key, same pattern as PAN verification)
        const courseName =
          values.courseName?.label || values.courseName;
        const mobileNumber =
          values.phone_number ?? formData.phone_number;

        if (!courseName) {
          setIsSubmittingToAPI(false);
          moveToNextStep();
        } else {
          try {
            const piiPublicKey = await fetchSanitizedPiiPublicKey();
            if (!piiPublicKey) {
              setIsSubmittingToAPI(false);
              dispatch(
                setStatusPopup({
                  status: "error",
                  message:
                    "Unable to secure your details. Please try again.",
                })
              );
              return;
            }

            const payload = await encryptData(
              {
                mobileNumber,
                courseName,
              },
              ["mobileNumber"],
              piiPublicKey
            );

            await eligibilityCheckServices.dedupeCheck(payload);

            trackCustomerJourneyEvent(
              `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
              decrypt(userProfile?.id) ?? "",
              trackingId,
              {
                label: `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
                category: `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
                action: `${handleGAEligibilityStatments}_COURSEDETAILS_PAGE2`,
                page: "EligibiityCheck_Provide Course Details",
              }
            );

            setIsSubmittingToAPI(false);
            moveToNextStep();
          } catch (err: any) {
            setIsSubmittingToAPI(false);
            dispatch(
              setStatusPopup({
                status: "error",
                message:
                  err?.response?.data?.message || "Dedupe check failed",
              })
            );
          }
        }
      } else if (
        pageType !== "SUMMARY" &&
        activeHorizontalIndex === 0 &&
        activeVerticalIndex === 2
      ) {
        const verticalSteps =
          horizontalSteps[activeHorizontalIndex]?.verticalSteps || [];
        const allFields = [
          ...(verticalSteps[1]?.fields || []),
          ...(verticalSteps[2]?.fields || []),
        ];
        const allFormValues = { ...formData, ...values };
        ["loanAmount", "totalCost"].forEach((key) => {
          if (!hasPayloadValue(allFormValues[key])) {
            const liveFormikValue = formikRef?.current?.values?.[key];
            allFormValues[key] = hasPayloadValue(liveFormikValue)
              ? liveFormikValue
              : formData?.[key] ?? "";
          }
        });
        const payload: any = {
          formData: mapFormDataToAPI(allFormValues, allFields),
          submissionTrackingId: trackingId,
        };

        // 1. Capture API
        const captureResp = await eligibilityCheckServices.captureFormData(
          payload
        );
        if (captureResp?.data?.status !== "success") {
          setIsSubmittingToAPI(false);
          dispatch(
            setStatusPopup({
              status: "error",
              message: captureResp?.data?.message || "Capture failed",
            })
          );
          return;
        }

        // 2. BRE API
        const brePayload = {
          applicationId: trackingId,
          provisionalOfferBody: {
            values: {
              input: {
                Unique_Lead_ID: trackingId,
                oApplicant: {
                  oApplName: {
                    sFirstName: allFormValues.firstName || "",
                    sLastName: allFormValues.lastName || "",
                  },
                  aCourseDetails: [
                    {
                      ...(!notInList?.includes("Institute Name") && {
                        institute_code: allFormValues.institute?.value
                          ? dropdownData.institutes.find(
                            (item: any) =>
                              item.value === allFormValues.institute?.value,
                          )?.code
                          : allFormValues.institute_code,
                      }),

                      ...(!notInList?.includes("Course Name") && {
                        course_code: allFormValues.courseName?.value
                          ? dropdownData.courses.find(
                            (item: any) =>
                              item.value === allFormValues.courseName?.value,
                          )?.code
                          : allFormValues.courseCode,
                      }),

                      ...(!notInList?.includes("University Name") && {
                        university_campus_id: allFormValues.university?.code
                          ? allFormValues.university.code
                          : allFormValues.university?.value
                            ? dropdownData.universities.find(
                              (item: any) =>
                                item.value == allFormValues.university?.value
                            )?.code
                            : typeof allFormValues.university === "string"
                              ? allFormValues.universityCampusId
                              : "",
                      }),
                      university_country_id: allFormValues.country?.value || "",
                      category: allFormValues.courseType || "",
                      admission_status: allFormValues.admissionStatus || "",
                      course_category:
                        handleCourseCategoryValue(
                          allFormValues.courseCategory
                        ) || "",
                    },
                  ],
                },
              },
            },
          },
        };

        let breResp: any;
        let fetchUserApplicationRes: any = null;
        if (isAuthenticated) {
          // fetching userapplication data to get isQualified
          const token: any = process.env.REACT_APP_FETCH_TOKEN;
          const res: any = await fetchUserApplicationsFormData(
            token,
            trackingId
          );
          const apps = res.data?.applications || [];
          fetchUserApplicationRes = apps[0];
          let finalSteps = getCombinedApplicationSteps(apps[0]);
          dispatch(setDisplayHorizontalSteps(finalSteps));
          // Store source from API response in Redux
          if (fetchUserApplicationRes?.source) {
            dispatch(setApplicationSource(fetchUserApplicationRes.source));
          }
        }

        // if isQualified is true then bypass EligibilityConfirmation screen because user is already eligible & navigate to student details
        if (fetchUserApplicationRes && fetchUserApplicationRes?.isQualified) {
          setIsSubmittingToAPI(false);
            moveToStep(1, 0);
        } else {
          setIsCheckingOffer(true);
          try {
            breResp = await eligibilityCheckServices.checkOffer(brePayload);

            trackCustomerJourneyEvent(
              `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
              decrypt(userProfile?.id) ?? "",
              trackingId,
              {
                label: `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
                category: `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
                action: `${handleGAEligibilityStatments}_PROVIDELOANDET_PAGE3`,
                page: "EligibiityCheck_Provide Loan Details",
              }
            );

            if (isAuthenticated) {
              const token: any = process.env.REACT_APP_FETCH_TOKEN;
              const res: any = await fetchUserApplicationsFormData(
                token,
                trackingId
              );
              const apps = res.data?.applications || [];
              fetchUserApplicationRes = apps[0];
              let finalSteps = getCombinedApplicationSteps(apps[0]);
              dispatch(setDisplayHorizontalSteps(finalSteps));
              dispatch(setLeadSequenceId(fetchUserApplicationRes?.leadId));
            }
          } catch (e: any) {
            dispatch(setIsEligible(false));
            // Show server error message in modal popup when API fails
            const apiMessage =
              e?.response?.data?.message ||
              e?.response?.data?.error ||
              e?.message ||
              "Unable to check eligibility. Please try again.";
            setIsSubmittingToAPI(false);
            dispatch(
              setStatusPopup({
                status: "error",
                message: apiMessage,
              })
            );
          } finally {
            setIsCheckingOffer(false);
          }

          dispatch(setBreStatus("FROM_FORM"));
          dispatch(setBreData(breResp?.data?.data));
          dispatch(
            setIsEligible(breResp?.data?.data?.Scheme_Available == "Yes")
          );

          if (breResp?.data?.status !== "success" && (breResp?.data?.message || breResp?.data?.response?.message)) {
            setIsSubmittingToAPI(false);
            dispatch(
              setStatusPopup({
                status: "info",
                message: breResp?.data?.message || breResp?.data?.response?.message,
              })
            );
            return;
          }

          moveToNextStep();
        }

        // 3. Partner Lead API
        // Merge formData and values to ensure all latest keys are included
        const mergedFormData = { ...formData, ...values };
        // Helper to extract value if object, else return as is
        const extractId = (field: any) => {
          const match = field?.match(/^\s*([^-\s]+)\s*(?:-|$)/);
          return match ? match[1] : field?.trim();
        };
        const extractValue = (field: any) =>
          field && typeof field === "object" && "value" in field
            ? field.value
            : field;
        const extractValueCode = (field: any) =>
          field && typeof field === "object" && "code" in field
            ? field.code
            : extractId(field);
        const partnerLeadPayload: {
          applicationId: any;
          leadFirstName: any;
          leadLastName: any;
          leadMobileNo: any;
          leadEmailAddr: any;
          amountRequested: any;
          admissionStatus: any;
          countryOfStudyId: any;
          universityId: string;
          universityNotInList: any;
          otherUniversityName: any;
          instituteId: string;
          instituteNotInList: any;
          otherInstituteName: any;
          courseId: string;
          courseNotInList: any;
          leadCourseTypeName: any;
          stemFlag: boolean;
          otherCourseName: string;
          assignedSMId?: string;
          pincode?: string;
        } = {
          pincode: mergedFormData.pincode || "",
          applicationId: trackingId || "",
          leadFirstName: mergedFormData.firstName || "",
          leadLastName: mergedFormData.lastName || "",
          leadMobileNo: mergedFormData.phone_number,
          leadEmailAddr: mergedFormData.email || "",
          amountRequested: mergedFormData.loanAmount || "",
          admissionStatus: mergedFormData.admissionStatus || "",
          countryOfStudyId: extractValue(mergedFormData.country) || "US",
          universityId: notInList?.includes("University Name")
            ? ""
            : mergedFormData.university != null && mergedFormData.university != "" ? String(extractValueCode(mergedFormData.university)) : "",
          universityNotInList: notInList?.includes("University Name") || false,
          otherUniversityName: notInList?.includes("University Name")
            ? mergedFormData.university
            : "",
          instituteId: notInList?.includes("Institute Name")
            ? ""
            : mergedFormData.institute != null && mergedFormData.institute != "" ? String(extractValueCode(mergedFormData.institute)) : "",
          instituteNotInList: notInList?.includes("Institute Name") || false,
          otherInstituteName: notInList?.includes("Institute Name")
            ? mergedFormData.institute
            : "",
          courseId: notInList?.includes("Course Name")
            ? ""
            : mergedFormData.courseName != null && mergedFormData.courseName != "" ? String(extractValueCode(mergedFormData.courseName)) : "",
          courseNotInList: notInList?.includes("Course Name") || false,
          leadCourseTypeName:
            mergedFormData.leadCourseTypeName || "Post Graduate",
          stemFlag: mergedFormData.courseType == "STEM" ? true : false,
          otherCourseName: notInList?.includes("Course Name")
            ? String(extractValue(mergedFormData.courseName))
            : "",
        };



        // if externalId or leadId is present it means lead is already created so skipping createPartnerLead par
        if (
          isAuthenticated &&
          (fetchUserApplicationRes?.externalId ||
            fetchUserApplicationRes?.leadId)
        ) {
          // navigation already happened after check-eligibility, so no need of nextVerticalStep
          // dispatch(nextVerticalStep())
        }

        if (
          breResp?.data?.data?.Scheme_Available.toLowerCase() === "yes"
        ) {
          // console.log(leadSequenceId, "leadSequenceId")
          handleLeadCreationFlow(partnerLeadPayload, fetchUserApplicationRes?.leadId || leadSequenceId);
        }

        setIsSubmittingToAPI(false);
        dispatch(setBreStatus("FROM_FORM"));
      }

      // For all vertical steps under horizontal step 2.
      // In SUMMARY mode, horizontal step 0 (vertical 0/1/2) also saves via createApplicant,
      // and Additional Details & Documents sections (Applicant Additional Details, Funds & Expenses,
      // Reference & Collateral Details) also save via createApplicant.
      if (
        activeHorizontalIndex === 1 ||
        (pageType === "SUMMARY" &&
          activeHorizontalIndex === 0 &&
          [0, 1, 2].includes(activeVerticalIndex)) ||
        (pageType === "SUMMARY" && isAdditionalDetailsStep)
      ) {
        if (shouldAutoInvokeLeadFlow && pageType !== "SUMMARY") {
          handleLeadCreationFlow(getLeadPayload, leadSequenceId);
        }

        // Build the data array as per required payload
        const data: any[] = [];
        console.log(activeHorizontalIndex)
        if (activeHorizontalIndex !== 0 && activeVerticalIndex === 2) {
          const isEmployed = values.employmentisEmployed;

          // Always include the radio field
          const radioField = fields.find(
            (f) => f.name === "employmentisEmployed"
          );
          if (radioField) {
            data.push({
              formFieldId: radioField.id,
              formFieldKey: radioField.name,
              formFieldValue: isEmployed,
            });
          }

          // Include all other employment fields
          fields
            .filter((f) => f.name !== "employmentisEmployed")
            .forEach((field) => {
              let fieldValue = "";
              if (isEmployed === "Yes" || isAdditionalDetailsStep) {
                fieldValue = values[field.name] ?? "";
                // Designation is stored as its code; formData carries the full name.
                if (field.name === "employmentDesignation") {
                  fieldValue = getMasterOptionName(fieldValue, dropdownData?.designations);
                }
              } else {
                // If not employed, set employmentType to 'Student', others blank
                if (field.name === "employmentType") {
                  fieldValue = "Student";
                } else {
                  fieldValue = "";
                }
              }
              data.push({
                formFieldId: field.id,
                formFieldKey: field.name,
                formFieldValue: normalizePayloadFieldValue(field.name, fieldValue),
              });
            });
        } else if (activeVerticalIndex === 3) {
          // Merge fields and extraCourses for lookup
          const allCourseFields = fields;

          // Build a map of courseXType values to calculate courseXTypeId
          const courseTypeValues: { [key: string]: string } = {};
          Object.keys(values).forEach((key) => {
            if (/^course\d+Type$/.test(key)) {
              courseTypeValues[key] = values[key];
            }
          });

          // Academic Details: skip core/language fields
          Object.entries(values).forEach(([key, value]: any) => {
            // Skip core/language fields (including indexed)
            if (
              key.startsWith("core") ||
              key.startsWith("language") ||
              key.match(/^core.*_\d+$/) ||
              key.match(/^language.*_\d+$/)
            ) {
              return;
            }

            // Only process fields that match course patterns (course1, course2, etc.) or educationGap
            // if (!key.match(/^course\d+/) && key !== "educationGap") {
            //   return;
            // }

            const fieldDef = allCourseFields.find((f) => f.name === key);
            // Handle courseXType fields - also add corresponding courseXTypeId
            const courseTypeMatch = key.match(/^course(\d+)Type$/);
            // Below code is commented to stop adding courseXTypeId fields as per duplication issue reported
            // if (courseTypeMatch && value) {
            //   const courseNumber = courseTypeMatch[1];
            //   const courseTypeIdField = `course${courseNumber}TypeID`;
            //   // Calculate the TypeId value based on course type
            //   let examTypeIdValue: number = 0;
            //   if (value === "10th") {
            //     examTypeIdValue = 283;
            //   } else if (value === "12th") {
            //     examTypeIdValue = 284;
            //   } else if (value === "Diploma") {
            //     examTypeIdValue = 285;
            //   } else if (value === "Graduation") {
            //     examTypeIdValue = 286;
            //   }

            //   // Add the courseXType field first
            //   if (fieldDef?.id) {
            //     data.push({
            //       formFieldId: fieldDef.id,
            //       formFieldKey: key,
            //       formFieldValue: String(value),
            //     });
            //   }

            //   // Add the courseXTypeId field with calculated value
            //   if (examTypeIdValue > 0 && fieldDef?.id != undefined) {
            //     data.push({
            //       formFieldId: fieldDef?.id,
            //       formFieldKey: courseTypeIdField,
            //       formFieldValue: String(examTypeIdValue),
            //     });
            //   }
            //   //return; // Skip adding courseXType again below
            // }

            // Skip courseXTypeId fields since they're added with courseXType above
            const courseTypeIdMatch = key.match(/^course(\d+)TypeID$/);
            if (courseTypeIdMatch) {
              //return; // Skip - already handled above
            }
            if (fieldDef?.id) {
              let fieldValue = value;
              // Special handling for educationGap - pass "0" if blank
              // Fix: Ensure educationGap never becomes "undefined"
              if (key === "educationGap") {
                fieldValue =
                  value !== undefined &&
                    value !== null &&
                    value.toString().trim() !== ""
                    ? value
                    : "0";
              }
              data.push({
                formFieldId: fieldDef.id,
                formFieldKey: key,
                formFieldValue: normalizePayloadFieldValue(key, fieldValue),
              });
            } else {
              console.warn(`Field definition not found for key: ${key}, fieldDef:`, fieldDef);
            }
          });

          const eduGapDef = allCourseFields.find(
            (f) => f.name === "educationGap",
          );

          // If educationGap exists in field definitions but was NOT included in the Formik values → push it (to handle untouched field)
          if (
            eduGapDef &&
            !data.some((item) => item.formFieldKey === "educationGap")
          ) {
            data.push({
              formFieldId: eduGapDef.id,
              formFieldKey: "educationGap",
              formFieldValue: "0", // default value
            });
          }
        } else if (activeVerticalIndex === 4) {
          // Core Exam
          const coreRadioField = coreFields.find(
            (f: any) => f.name === "coreExamApplied"
          );
          if (coreRadioField) {
            data.push({
              formFieldId: coreRadioField.id,
              formFieldKey: coreRadioField.name,
              formFieldValue: values[coreRadioField.name] ?? "",
            });

            // Separate base fields and dynamic fields
            const baseCoreFields = coreFields.filter(
              (f: any) => f.name !== "coreExamApplied" && !f.isRemoved
            );
            const dynamicCoreFields = coreFields.filter(
              (f: any) => f.isRemoved
            );

            // Add base fields (exact match only)
            baseCoreFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include coreExamID/coreExamId fields regardless of "Yes" or "No" status
                const isCoreExamID =
                  /^coreExamID(_\d+)?$/.test(field.name) ||
                  /^coreExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isCoreExamID || values[coreRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });

            // Add dynamic fields with their own IDs
            dynamicCoreFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include coreExamID/coreExamId fields regardless of "Yes" or "No" status
                const isCoreExamID =
                  /^coreExamID(_\d+)?$/.test(field.name) ||
                  /^coreExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isCoreExamID || values[coreRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });
          }

          // Language Exam
          const languageRadioField = languageFields.find(
            (f: any) => f.name === "languageExamApplied"
          );
          if (languageRadioField) {
            data.push({
              formFieldId: languageRadioField.id,
              formFieldKey: languageRadioField.name,
              formFieldValue: values[languageRadioField.name] ?? "",
            });

            // Separate base fields and dynamic fields
            const baseLanguageFields = languageFields.filter(
              (f: any) => f.name !== "languageExamApplied" && !f.isRemoved
            );
            const dynamicLanguageFields = languageFields.filter(
              (f: any) => f.isRemoved
            );

            // Add base fields (exact match only)
            baseLanguageFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include languageExamID/languageExamId fields regardless of "Yes" or "No" status
                const isLanguageExamID =
                  /^languageExamID(_\d+)?$/.test(field.name) ||
                  /^languageExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isLanguageExamID ||
                      values[languageRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });

            // Add dynamic fields with their own IDs
            dynamicLanguageFields.forEach((field: any) => {
              if (values.hasOwnProperty(field.name)) {
                // Always include languageExamID/languageExamId fields regardless of "Yes" or "No" status
                const isLanguageExamID =
                  /^languageExamID(_\d+)?$/.test(field.name) ||
                  /^languageExamId(_\d+)?$/.test(field.name);
                data.push({
                  formFieldId: field.id,
                  formFieldKey: field.name,
                  formFieldValue:
                    isLanguageExamID ||
                      values[languageRadioField.name] === "Yes"
                      ? normalizePayloadFieldValue(field.name, values[field.name] || "")
                      : "",
                });
              }
            });
          }

          // Add any other non-core/language fields if needed
          Object.entries(values).forEach(([key, value]: any) => {
            if (
              !coreFields.some((f: any) => f.name === key) &&
              !languageFields.some((f: any) => f.name === key)
            ) {
              const fieldDef = fields.find((f) => f.name === key);
              if (fieldDef?.id) {
                data.push({
                  formFieldId: fieldDef.id,
                  formFieldKey: key,
                  formFieldValue: normalizePayloadFieldValue(key, value),
                });
              }
            }
          });
        } else {
          // Default mapping for other steps
          Object.entries(values).forEach(([key, value]: any) => {
            // if (key === "aadhaar") return; // Do not include aadhaar field
            const fieldDef = fields.find((f) => f.name === key);
            if (fieldDef?.id) {
              let fieldValue = value;
              if (
                (key === "loanAmount" || key === "totalCost") &&
                !hasPayloadValue(fieldValue)
              ) {
                const liveFormikValue = formikRef?.current?.values?.[key];
                fieldValue = hasPayloadValue(liveFormikValue)
                  ? liveFormikValue
                  : formData?.[key] ?? "";
              }
              // Special handling for PAN
              if (key === "pan") {
                fieldValue = hasPan === "no" ? "no" : panNumber;
              }
              // Always send Aadhaar verified as false in payload for now
              if (key === "isAadhaarVerified") {
                fieldValue = false;
              }
              fieldValue = resolveApplicantVerificationFieldValue(
                key,
                fieldValue,
                fieldDef
              );

              data.push({
                formFieldId: fieldDef.id,
                formFieldKey: key,
                formFieldValue: normalizePayloadFieldValue(key, fieldValue),
              });
            }
          });
        }

        const scopedData = isReferenceCollateralStep
          ? data.filter((item: any) =>
              currentReferenceCollateralFieldNameSet.has(item?.formFieldKey)
            )
          : data;

        // Safety: enforce isAadhaarVerified=false even if pushed elsewhere above.
        scopedData.forEach((item: any) => {
          if (item?.formFieldKey === "isAadhaarVerified") {
            item.formFieldValue = "false";
          }
          if (item?.formFieldKey === "loanLoanTenure") {
            const tenureValue = String(item?.formFieldValue ?? "");
            item.formFieldValue =
              dropdownData?.loanTenureOptions?.find(
                (option: any) =>
                  String(option?.value ?? "") === tenureValue ||
                  String(option?.id ?? "") === tenureValue ||
                  String(option?.label ?? "") === tenureValue
              )?.label || item.formFieldValue;
          }
        });

        const isAadhaarSeededPayload =
          aadhaarSeedingStatus === undefined ||
            aadhaarSeedingStatus === null ||
            aadhaarSeedingStatus === ""
            ? false
            : aadhaarSeedingStatus;

	        const payloadObject: any = {
	          data: scopedData,
	          trackingId: trackingId,
	          templateId: templateId,
          formName: horizontalSteps?.[activeHorizontalIndex]?.stepLabel,
          mobileNumber: values?.phone_number || formData?.phone_number,
          isAadhaarSeeded: isAadhaarSeededPayload,

	        };

        // Applicant sections before Co-Applicant (vertical 0-4) also send the
        // master-data ids for the backend, tagged with the section saved.
        const applicantSection =
          horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
            "Applicant & Loan Details"
            ? APPLICANT_SECTION_BY_VERTICAL_INDEX[activeVerticalIndex]
            : undefined;
        if (applicantSection) {
          // The stored code data can be missing (saved right after opening) or belong to a
          // previous pincode (saved before the changed pincode's lookup landed) — either way
          // cityId/stateId/pincodeId would be wrong, so resolve it for the form's pincode now.
          let permanentCodeDataForSave = permanentCodeData;
          let currentCodeDataForSave = currentCodeData;
          const isCodeDataForPincode = (codeData: any, pincode: any) =>
            !!codeData?.city &&
            String(codeData?.lookupPincode ?? "").trim() === String(pincode ?? "").trim();
          if (applicantSection === "applicantAddress") {
            // zipcodes → stateCode (stateId); pincodes master → city (cityId) + pinCodeId.
            const fetchAddressCodeData = async (pincode: any) => {
              const pin = String(pincode ?? "").trim();
              if (pin.length !== 6) return null;
              try {
                const zipData = (await eligibilityCheckServices.getZipCode(pin))?.data?.data?.[0];
                const pinData = (await eligibilityCheckServices.getPinCode(pin))?.data?.data?.[0];
                if (!pinData && !zipData) return null;
                return {
                  ...pinData,
                  city: pinData?.city ?? zipData?.city,
                  stateCode: zipData?.stateCode,
                  lookupPincode: pin,
                };
              } catch {
                return null;
              }
            };
            if (
              values?.permanentPincode &&
              !isCodeDataForPincode(permanentCodeDataForSave, values.permanentPincode)
            ) {
              permanentCodeDataForSave = await fetchAddressCodeData(values.permanentPincode);
            }
            if (
              values?.currentPincode &&
              !isCodeDataForPincode(currentCodeDataForSave, values.currentPincode)
            ) {
              currentCodeDataForSave =
                String(values.currentPincode).trim() === String(values?.permanentPincode ?? "").trim()
                  ? permanentCodeDataForSave
                  : await fetchAddressCodeData(values.currentPincode);
            }
          }
          const idDtosBySection = buildApplicantIdDtosBySection({
            values,
            countryOptions: dropdownData?.countries,
            currentCodeData: currentCodeDataForSave,
            permanentCodeData: permanentCodeDataForSave,
            companyCodeData,
            entranceExamTypes: dropdownData?.entranceExamTypes,
            languageExamTypes: dropdownData?.languageExamTypes,
            designations: dropdownData?.designations,
          });
          // Only the dto of the screen being saved.
          payloadObject.idDtos = idDtosBySection[applicantSection];
          payloadObject.section = applicantSection;
        }
	        try {
          if (isReferenceCollateralStep && referenceCollateralActiveTab === 1 && isHasCollateralNoValue(values)) {
            const hasCollateralFormData = getHasCollateralNoFormData(values);
            const resp = await losServices.createCollateral({
              formData: hasCollateralFormData,
              trackingId,
              collateralSequenceType: "COLLATERAL_ONE",
            });
            const responseStatus = String(resp?.data?.status || "").toLowerCase();
            const isCreateSuccessful =
              responseStatus === "success" ||
              (resp?.status >= 200 && resp?.status < 300 && responseStatus !== "fail");

            if (!isCreateSuccessful) {
              throw new Error(
                resp?.data?.message || `Failed to save ${currentVerticalStepLabel}.`
              );
            }

            await refreshReduxFromUserApplicationFetch(
              resp?.data?.data?.trackingId || trackingId
            );
            if (pageType === "SUMMARY") {
              dispatch(bumpCompletionSummaryRefreshNonce());
              setSnackbar({
                open: true,
                message: `${currentVerticalStepLabel} saved successfully.`,
                severity: "success",
              });
              dispatch(setSummaryApplicationEditActive(false));
            }
            dispatch(
              updateFormData({
                ...values,
                isAadhaarVerified: values?.isAadhaarVerified ?? false,
              })
            );
            moveToNextStep();
            return;
          }

	          const resp = await applicantDetailsServices.createApplicant(
	            payloadObject
	          );

          if (
            resp.data?.status === "success"
          ) {
            // Call create-update-applicant-basic-details after successful applicant creation

            try {
              // Set applicationId if available
              if (resp?.data?.data?.applicationId) {
                dispatch(
                  setApplicationId(resp?.data?.data?.applicationId.toString())
                );
              }
              if (isReferenceCollateralStep) {
                if (referenceCollateralActiveTab === 0) {
                  for (const referenceNumber of getReferenceSectionNumbersForSave(values)) {
                    await saveReferenceSectionDetails(values, resp, referenceNumber);
                  }
                } else {
                  for (const collateralNumber of getCollateralSectionNumbersForSave(values)) {
                    await saveCollateralSectionDetails(values, resp, collateralNumber);
                  }
                }
              }
              if (isApplicantAdditionalDetailsStep) {
                const currentValues = { ...(formData || {}), ...(values || {}) };
                const resolvedApplicantId = Number(
                  resp?.data?.data?.applicantId || applicantIdApp
                );
                const resolvedApplicationId = Number(
                  resp?.data?.data?.applicationId || applicationIdApp
                );
                const resolvedTrackingId =
                  resp?.data?.data?.trackingId || trackingId || "";

                if (resolvedApplicantId > 0 && resolvedApplicationId > 0) {
                  const firstName =
                    currentValues?.studentDetailsFirstName ||
                    currentValues?.firstName ||
                    "";
                  const lastName =
                    currentValues?.studentDetailsLastName ||
                    currentValues?.lastName ||
                    "";
                  const salutationId = toOptionValue(
                    currentValues?.salutation
                  );
                  const salutation =
                    (dropdownData?.salutations || []).find(
                      (option: any) => option?.value === salutationId
                    )?.label ||
                    currentValues?.salutationName ||
                    salutationId;
                  const applicantBirthCountryForProcessio =
                    currentValues?.applicantCountryOfBirth ||
                    currentValues?.applicantBirthCountry;
	                  const applicantBirthCityForProcessio =
	                    currentValues?.applicantCityOfBirth ||
	                    currentValues?.applicantCityCountry;
	                  const applicantNationalityValue = toOptionValue(
	                    currentValues?.applicantNationality ||
	                      currentValues?.applicantNaionality
	                  );
	                  const applicantNationalityCode =
	                    nationalityMasterOptions.find(
	                      (option: any) =>
	                        String(option?.value || "") ===
	                          String(applicantNationalityValue) ||
	                        String(option?.label || "") ===
	                          String(applicantNationalityValue) ||
	                        String(option?.nationalityId || "") ===
	                          String(applicantNationalityValue)
	                    )?.value || applicantNationalityValue;

	                  await losServices.createUpdateApplicantBasicDetails({
                    applicantId: resolvedApplicantId,
                    applicationId: resolvedApplicationId,
                    trackingId: resolvedTrackingId,
                    applicantType: "MAIN_APPLICANT",
                    emailAddress:
                      currentValues?.studentDetailEmail ||
                      currentValues?.email ||
                      "",
                    firstName,
                    fullname: `${firstName} ${lastName}`.trim(),
                    lastName,
                    motherFirstName:
                      currentValues?.motherFirstName,
                    motherLastName:
                      currentValues?.motherLastName,
                    fatherFirstName:
                      currentValues?.fatherFirstName,
                    fatherLastName:
                      currentValues?.fatherLastName,
                    dateOfBirth: currentValues?.dob
                      ? new Date(currentValues.dob).getTime()
                      : "",
                    mobileNo:
                      currentValues?.studentDetailsPhone_number ||
                      currentValues?.phone_number ||
                      "",
                    salutation,
                    salutationId,
                    queryId: "",
                    relationship: currentValues?.relationship || "STUDENT",
                    relationshipId: "CHILDREN",
                    eventName: "APPLICANT_ADDITIONAL_BASIC_DETAILS_SAVED",
                    noOfDependants: Number(
                      currentValues?.applicantDependents || 0
                    ),
                    maritalStatusId: toOptionValue(
                      currentValues?.applicantMaritalStatus
                    ),
	                    nationalityId: applicantNationalityCode,
                    birthCountryId: getApplicantBirthCountryProcessioValue(applicantBirthCountryForProcessio),
                    birthCityId: getCityOptionsForCountry(applicantBirthCountryForProcessio).find(city => applicantBirthCityForProcessio === city?.label)?.value,
                    otherRelationship: null,
                  });

                  await losServices.saveLoanRequirement({
                    applicationId: resolvedApplicationId,
                    trackingId: resolvedTrackingId,
                    eventName: "APPLICANT_SAVE_LOAN_REQUIREMENT_ADDED",
                    applicantType: "Applicant",
                    amountRequested: Number(
                      currentValues?.loanLoanAmount || 0
                    ),
                    psiAmount: Number(currentValues?.psiAmount || 0),
                    loantenure: Number(
                      toOptionValue(currentValues?.loanLoanTenure) || 0
                    ),
                    requiredRoi: Number(
                      currentValues?.loanRequestedRoi || 0
                    ),
                    queryId: "",
                    caseType: currentValues?.caseType || "ELLOAN",
                    expectedDateOfDisbursement:
                      currentValues?.loanDateOfDisbursement || "",
                    promoCode: currentValues?.promoCode || "",
                    isSiblingTag: currentValues?.isSiblingTag || "",
                  });
                }
              }
              if (isFundsAndExpensesStep) {
                const currentValues = { ...(formData || {}), ...(values || {}) };
                const resolvedApplicationId = Number(
                  resp?.data?.data?.applicationId || applicationIdApp
                );
                const resolvedTrackingId =
                  resp?.data?.data?.trackingId || trackingId || "";
                const amount = (key: string) =>
                  Number(
                    String(currentValues?.[key] ?? "").replace(/,/g, "")
                  ) || 0;

                if (resolvedApplicationId > 0) {
                  const livingExpenses = amount("expenseLivingExpenses");
                  const livingCardExpenses = amount("expenseVasExpense");
                  const travelExpenses = amount("expenseTravelExpenses");
                  const otherExpenses = amount("expenseOtherExpenses");
                  const tuitionFees = amount("expenseTuitionFees");
                  const loanRequestedAmt = amount("fundRequestedLoanAmount");
                  const ownSourceAmt = amount("fundOwnSources");
                  const scholarshipAmt = amount("fundScholarshipAmount");
                  const otherIncomeAmt = amount("fundOtherIncome");

                  await losServices.saveExpense({
                    trackingId: resolvedTrackingId,
                    eventName:
                      "APPLICANT_APPLICATION_EXPENSE_FUNDS_DETAILS",
                    applicantType: "Applicant",
                    applicationId: resolvedApplicationId.toString(),
                    queryId: "",
                    livingExpenses,
                    livingCardExpenses,
                    travelExpenses,
                    otherExpenses,
                    tuitionFees,
                    totalExpenses:
                      livingExpenses +
                      livingCardExpenses +
                      travelExpenses +
                      otherExpenses +
                      tuitionFees,
                    loanRequestedAmt,
                    ownSourceAmt,
                    scholarshipAmt,
                    otherIncomeAmt,
                    totalFundsRequiredAmt:
                      loanRequestedAmt +
                      ownSourceAmt +
                      scholarshipAmt +
                      otherIncomeAmt,
                  });
                }
              }
              // GA events for the applicant step just saved. The per-step LOS
              // calls were dropped (same as DIY); createApplicant carries idDtos.
              if (resp?.data?.data?.applicantId && resp?.data?.data?.applicationId) {
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 0 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {

                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      category: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      action: `${handleGAProvisionalOfferStatments}_STDUENTDET_PAGE5`,
                      page: "ProvisionalOff_Student Details",
                    }
                  );

                  // window.scrollTo({ top: 0, behavior: "smooth" });  

                  // ==================== APPLICANT DEMOGRAPHIC DETAILS ====================
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 1 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {

                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      category: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      action: `${handleGAProvisionalOfferStatments}_ADDRESSDET_PAGE6`,
                      page: "ProvisionalOff_Address Details",
                    }
                  );

                  // window.scrollTo({ top: 0, behavior: "smooth" });
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      category: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      action: `${handleGAProvisionalOfferStatments}_EMPLOYDET_PAGE7`,
                      page: "ProvisionalOff_Employment Details",
                    }
                  );
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 3 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {

                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      category: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      action: `${handleGAProvisionalOfferStatments}_ACADEMICDET_PAGE8`,
                      page: "ProvisionalOff_Academic Details",
                    }
                  );

                  // window.scrollTo({ top: 0, behavior: "smooth" });
                } else if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 4 &&
                  horizontalSteps?.[activeHorizontalIndex]?.stepLabel ===
                  "Applicant & Loan Details"
                ) {

                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      category: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      action: `${handleGAProvisionalOfferStatments}_ENTRANEXAMDET_PAGE9`,
                      page: "ProvisionalOff_Entrance Exam Details",
                    }
                  );

                  // window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }
            } catch (basicDetailsError: any) {
              console.error(
                "Create/Update Applicant Basic Details Error:",
                basicDetailsError
              );
              // You can choose to show an error or continue silently
              // For now, we'll continue with the normal flow
            }

            // Post-save: refetch application so Redux matches server. Note: some LOS calls in the try above are
            // fire-and-forget (not awaited); this fetch may still reflect partial downstream persistence.
            await refreshReduxFromUserApplicationFetch(
              resp?.data?.data?.trackingId
            );
            if (pageType === "SUMMARY") {
              dispatch(bumpCompletionSummaryRefreshNonce());
            }

            // These dispatches are inside the success if block
            dispatch(setTrackingId(resp.data.data.trackingId));
            setIsSubmittingToAPI(false);
            dispatch(
              updateFormData({
                ...values,
                isAadhaarVerified: values?.isAadhaarVerified ?? false,
              })
            );
             if (pageType === "SUMMARY") {
              setSnackbar({
                open: true,
                message: `${currentVerticalStepLabel} saved successfully.`,
                severity: "success",
              });
              dispatch(setSummaryApplicationEditActive(false));
            }
            moveToNextStep();

            if (canAdvanceStepper && activeVerticalIndex === 5) {
              dispatch(setActiveHorizontalIndex(2));
            }
            dispatch(setBreStatus("FROM_FORM"));
          } else {
            setIsSubmittingToAPI(false);
            if (pageType === "SUMMARY") {
              setSnackbar({
                open: true,
                message:
                  resp?.data?.message ||
                  `Failed to save ${currentVerticalStepLabel}.`,
                severity: "error",
              });
            } else {
              dispatch(
                setStatusPopup({
                  status: "error",  
                  message: resp?.data?.message || "Applicant creation failed",
                })
              );
            }
            return;
          }

          // else {
          //   // Error case - resp.data?.status is not "success"
          //   setIsSubmittingToAPI(false);
          //   dispatch(
          //     setStatusPopup({
          //       status: "error",
          //       message: resp.data?.message || "Applicant creation failed",
          //     })
          //   );
          // }
        }
        catch (error: any) {
          // Catch for outer try block (createApplicant API call)
          setIsSubmittingToAPI(false);
           if (pageType === "SUMMARY") {
            setSnackbar({
              open: true,
              message:
                error?.response?.data?.message ||
                `Failed to save ${currentVerticalStepLabel}.`,
              severity: "error",
            });
            } else {
              dispatch(
                setStatusPopup({
                  status: "error",
                  message:
                    error?.response?.data?.message || "Applicant creation failed",
                }),
              );
            }
          // }
        }
        //return;
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      setIsSubmittingToAPI(false);
    } finally {
      if (isReferenceCollateralStep) {
        referenceCollateralSaveInFlightRef.current = false;
      }
      if (pageType === "SUMMARY") {
        dispatch(setSummaryFormSaveInProgress(false));
      }
      setSubmitting(false);
    }
  };

  /**
   * Handles filling current address fields based on a boolean value.
   *
   * When the value is "false", this function copies values from permanent address fields
   * to the corresponding current address fields. When the value is "true" or any other value,
   * it clears all current address fields by setting them to empty strings.
   *
   * This function is typically used in address forms where users can choose to use
   * their permanent address as their current address, or enter a different current address.
   *
   * @param {any} value - A string value that determines the behavior:
   *                      - "false": Copy permanent address values to current address fields
   *                      - Any other value: Clear all current address fields
   *
   * @example
   * // Copy permanent address to current address
   * handleFilledCurrentAddressFields("false");
   *
   * // Clear current address fields
   * handleFilledCurrentAddressFields("true");
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */
  const handleFilledCurrentAddressFields = (value: any) => {
    const currentAddressValues = value === true
      ? {
          currentAddressLine1: formikRef?.current?.values?.permanentAddressLine1 || "",
          currentAddressLine2: formikRef?.current?.values?.permanentAddressLine2 || "",
          currentAddressLine3: formikRef?.current?.values?.permanentAddressLine3 || "",
          currentAddressType: formikRef?.current?.values?.permanentAddressType || "",
          currentCity:
            formikRef?.current?.values?.permanentCity?.value ||
            formikRef?.current?.values?.permanentCity ||
            "",
          currentCountry: formikRef?.current?.values?.permanentCountry || "",
          currentOwnershipStatus: formikRef?.current?.values?.permanentOwnershipStatus || "",
          currentPincode: formikRef?.current?.values?.permanentPincode || "",
          currentState: formikRef?.current?.values?.permanentState || "",
          currentYearsInCurrentAddress:
            formikRef?.current?.values?.permanentYearsInCurrentAddress || "",
          currentYearsInCurrentCity:
            formikRef?.current?.values?.permanentYearsInCurrentCity || "",
        }
      : {
          currentAddressLine1: "",
          currentAddressLine2: "",
          currentAddressLine3: "",
          currentAddressType: "",
          currentCity: "",
          currentCountry: "",
          currentOwnershipStatus: "",
          currentPincode: "",
          currentState: "",
          currentYearsInCurrentAddress: "",
          currentYearsInCurrentCity: "",
        };
    if (value === true) {
      // Copy permanent address fields to current address fields
      formikRef?.current?.setFieldValue(
        "currentAddressLine1",
        formikRef?.current?.values?.permanentAddressLine1 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressLine2",
        formikRef?.current?.values?.permanentAddressLine2 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressLine3",
        formikRef?.current?.values?.permanentAddressLine3 || ""
      );
      formikRef?.current?.setFieldValue(
        "currentAddressType",
        formikRef?.current?.values?.permanentAddressType || ""
      );
      formikRef?.current?.setFieldValue(
        "currentCity",
        formikRef?.current?.values?.permanentCity?.value ||
        formikRef?.current?.values?.permanentCity ||
        ""
      );
      formikRef?.current?.setFieldValue(
        "currentCountry",
        formikRef?.current?.values?.permanentCountry || ""
      );
      formikRef?.current?.setFieldValue(
        "currentOwnershipStatus",
        formikRef?.current?.values?.permanentOwnershipStatus || ""
      );
      formikRef?.current?.setFieldValue(
        "currentPincode",
        formikRef?.current?.values?.permanentPincode || ""
      );
      formikRef?.current?.setFieldValue(
        "currentState",
        formikRef?.current?.values?.permanentState || ""
      );
      formikRef?.current?.setFieldValue(
        "currentYearsInCurrentAddress",
        formikRef?.current?.values?.permanentYearsInCurrentAddress || ""
      );
      syncAddressYearFieldErrors(
        "permanentYearsInCurrentAddress",
        "currentYearsInCurrentAddress",
        formikRef?.current?.values?.permanentYearsInCurrentAddress || ""
      );
      formikRef?.current?.setFieldValue(
        "currentYearsInCurrentCity",
        formikRef?.current?.values?.permanentYearsInCurrentCity || ""
      );
      syncAddressYearFieldErrors(
        "permanentYearsInCurrentCity",
        "currentYearsInCurrentCity",
        formikRef?.current?.values?.permanentYearsInCurrentCity || ""
      );
    } else {

      // Clear current address fields so user can enter new values
      formikRef?.current?.setFieldValue("currentAddressLine1", "");
      formikRef?.current?.setFieldValue("currentAddressLine2", "");
      formikRef?.current?.setFieldValue("currentAddressLine3", "");
      formikRef?.current?.setFieldValue("currentAddressType", "");
      formikRef?.current?.setFieldValue("currentCity", "");
      formikRef?.current?.setFieldValue("currentCountry", "");
      formikRef?.current?.setFieldValue("currentOwnershipStatus", "");
      formikRef?.current?.setFieldValue("currentPincode", "");
      formikRef?.current?.setFieldValue("currentState", "");
      formikRef?.current?.setFieldValue("currentYearsInCurrentAddress", "");
      formikRef?.current?.setFieldValue("currentYearsInCurrentCity", "");
    }
    dispatch(updateFormData({ ...currentAddressValues, currentsameAsPermanent: !!value }));
    setTimeout(() => {
      if (showFieldErrorsAfterSaveAttempt) {
        formikRef?.current?.validateForm();
      }
    }, 0);
  };

  // Generic handler for co-applicant address copy/clear
  const handleFilledCurrentAddressFieldsCoApplicant = (
    coAppNum: string,
    value: any
  ) => {
    const prefix = `addressCoApplicant${coAppNum}`;
    const currentAddressValues = value === true
      ? {
          [`${prefix}currentAddressLine1`]:
            formikRef?.current?.values?.[`${prefix}permanentAddressLine1`] || "",
          [`${prefix}currentAddressLine2`]:
            formikRef?.current?.values?.[`${prefix}permanentAddressLine2`] || "",
          [`${prefix}currentAddressLine3`]:
            formikRef?.current?.values?.[`${prefix}permanentAddressLine3`] || "",
          [`${prefix}currentCity`]:
            formikRef?.current?.values?.[`${prefix}permanentCity`]?.value ||
            formikRef?.current?.values?.[`${prefix}permanentCity`] ||
            "",
          [`${prefix}currentCountry`]:
            formikRef?.current?.values?.[`${prefix}permanentCountry`] || "",
          [`${prefix}currentOwnershipStatus`]:
            formikRef?.current?.values?.[`${prefix}permanentOwnershipStatus`] || "",
          [`${prefix}currentPincode`]:
            formikRef?.current?.values?.[`${prefix}permanentPincode`] || "",
          [`${prefix}currentState`]:
            formikRef?.current?.values?.[`${prefix}permanentState`] || "",
          [`${prefix}currentYearsInCurrentAddress`]:
            formikRef?.current?.values?.[
              `${prefix}permanentYearsInCurrentAddress`
            ] || "",
          [`${prefix}currentYearsInCurrentCity`]:
            formikRef?.current?.values?.[`${prefix}permanentYearsInCurrentCity`] ||
            "",
        }
      : {
          [`${prefix}currentAddressLine1`]: "",
          [`${prefix}currentAddressLine2`]: "",
          [`${prefix}currentAddressLine3`]: "",
          [`${prefix}currentCity`]: "",
          [`${prefix}currentCountry`]: "",
          [`${prefix}currentOwnershipStatus`]: "",
          [`${prefix}currentPincode`]: "",
          [`${prefix}currentState`]: "",
          [`${prefix}currentYearsInCurrentAddress`]: "",
          [`${prefix}currentYearsInCurrentCity`]: "",
        };
    if (value === true) {
      // Copy permanent address fields to current address fields

      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine1`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine1`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine2`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine2`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentAddressLine3`,
        formikRef?.current?.values?.[`${prefix}permanentAddressLine3`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentCity`,
        formikRef?.current?.values?.[`${prefix}permanentCity`]?.value ||
        formikRef?.current?.values?.[`${prefix}permanentCity`] ||
        ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentCountry`,
        formikRef?.current?.values?.[`${prefix}permanentCountry`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentOwnershipStatus`,
        formikRef?.current?.values?.[`${prefix}permanentOwnershipStatus`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentPincode`,
        formikRef?.current?.values?.[`${prefix}permanentPincode`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentState`,
        formikRef?.current?.values?.[`${prefix}permanentState`] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentAddress`,
        formikRef?.current?.values?.[
        `${prefix}permanentYearsInCurrentAddress`
        ] || ""
      );
      syncAddressYearFieldErrors(
        `${prefix}permanentYearsInCurrentAddress`,
        `${prefix}currentYearsInCurrentAddress`,
        formikRef?.current?.values?.[
          `${prefix}permanentYearsInCurrentAddress`
        ] || ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentCity`,
        formikRef?.current?.values?.[`${prefix}permanentYearsInCurrentCity`] ||
        ""
      );
      syncAddressYearFieldErrors(
        `${prefix}permanentYearsInCurrentCity`,
        `${prefix}currentYearsInCurrentCity`,
        formikRef?.current?.values?.[`${prefix}permanentYearsInCurrentCity`] ||
          ""
      );
    } else {
      // Clear current address fields so user can enter new values
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine1`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine2`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentAddressLine3`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentCity`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentCountry`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentOwnershipStatus`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentPincode`, "");
      formikRef?.current?.setFieldValue(`${prefix}currentState`, "");
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentAddress`,
        ""
      );
      formikRef?.current?.setFieldValue(
        `${prefix}currentYearsInCurrentCity`,
        ""
      );
    }
    // Always set the checkbox value as a boolean in Formik
    formikRef?.current?.setFieldValue(
      `${prefix}currentsameAsPermanent`,
      !!value
    );
    dispatch(
      updateFormData({
        ...currentAddressValues,
        [`${prefix}currentsameAsPermanent`]: !!value,
      })
    );
    setTimeout(() => {
      if (showFieldErrorsAfterSaveAttempt) {
        formikRef?.current?.validateForm();
      }
    }, 0);
  };

  // const handleInvokStateApi = async (stateCode: string) => {
  //   try {
  //     const resp = await eligibilityCheckServices.getState(stateCode);
  //     if (resp.status === 200) {
  //       // handleInvokCityApi(cityCode);
  //     }
  //   } catch (error: any) {
  //     console.log("error", error)
  //   }
  // };

  const handleInvokCityApi = async (cityCode: string) => {
    if (!cityCode) return;

    try {
      const resp = await eligibilityCheckServices.getCity(cityCode);
      if (resp.status === 200 && resp.data?.data) {
        const cityLists: any = resp.data.data
          .filter((item: any) => item?.cityName) // Filter out items without cityName
          .map((item: any) => ({
            value: item.cityName || "",
            label: item.cityName || "",
          }));
        setCityList(cityLists);
      }
    } catch (error: any) {
      console.log("error", error);
      setCityList([]); // Reset city list on error
    }
  };

  const handleDisablePermanentPincodeBasedFields = (field: any) => {
    const name = field?.name || "";
    const isPincodeField = /pincode/i.test(name);

    // Pincode: lock only on first horizontal + first vertical (Eligibility landing, or merged flows
    // where Address is the first cell). SUMMARY stays editable via form rules elsewhere.
    if (isPincodeField) {
      const stepLabelRaw =
        horizontalSteps?.[activeHorizontalIndex]?.verticalSteps?.[
          activeVerticalIndex
        ]?.stepLabel ?? "";
      const stepLabel = String(stepLabelRaw).trim();
      const verifyConsentStep =
        /verify\s+yourself/i.test(stepLabel) && /consent/i.test(stepLabel);
      const onFirstEligibilityVertical =
        activeHorizontalIndex === 0 && activeVerticalIndex === 0;

      if (verifyConsentStep || onFirstEligibilityVertical) {
        return true;
      }
      return false;
    }

    const staticFields = [
      "permanentCity",
      "permanentState",
      "permanentCountry",
      "currentCity",
      "currentState",
      "currentCountry",
      "employmentCompanyCity",
      "employmentCompanyState",
      "employmentCompanyCountry",
    ];

    // 1. Static field names
    if (staticFields.includes(field.name)) return true;

    // 2. Dynamic co-applicant fields (1, 2, 3, ...)
    const dynamicPattern =
      /^addressCoApplicant\d+(permanentCity|permanentState|permanentCountry|currentCity|currentState|currentCountry)$/;

    return dynamicPattern.test(field.name);
  };

  useEffect(() => {
    if (!isReferenceCollateralStep) return;
    if (typeof summaryReferenceCollateralEditTab === "number") {
      setReferenceCollateralActiveTab(summaryReferenceCollateralEditTab);
      return;
    }
    if (currentVerticalStepName === "Collateral Details") {
      setReferenceCollateralActiveTab(1);
    } else if (currentVerticalStepName === "Reference Details") {
      setReferenceCollateralActiveTab(0);
    }
  }, [
    currentVerticalStepName,
    isReferenceCollateralStep,
    summaryReferenceCollateralEditTab,
  ]);

  const isReferencePincodeResolved = (fieldName: string) => {
    const match = String(fieldName || "").match(/^addressReference(\d+)Pincode$/i);
    if (!match) return false;

    const referenceNumber = match[1];
    const codeData =
      referenceNumber === "2" ? reference2CodeData : reference1CodeData;
    const currentPincode =
      formikRef?.current?.values?.[`addressReference${referenceNumber}Pincode`];

    return Boolean(
      codeData &&
        String(currentPincode || "").length === 6 &&
        getFirstNonEmptyValue(
          codeData?.pinCodeId,
          codeData?.pincodeId,
          codeData?.pinCode,
          codeData?.pincode,
          codeData?.cityId,
          codeData?.city,
          codeData?.cityName
        )
    );
  };

  const isCollateralPincodeResolved = (fieldName: string) => {
    const match = String(fieldName || "").match(/^collateral(\d*)Pincode$/i);
    if (!match) return false;

    const collateralNumber = Number(match[1] || 1);
    const codeData = collateralCodeData[collateralNumber];
    const currentPincode =
      formikRef?.current?.values?.[fieldName] ||
      formikRef?.current?.values?.[`collateral${collateralNumber}Pincode`] ||
      formikRef?.current?.values?.collateralPincode;

    return Boolean(
      codeData &&
        String(currentPincode || "").length === 6 &&
        getFirstNonEmptyValue(
          codeData?.pinCodeId,
          codeData?.pincodeId,
          codeData?.pinCode,
          codeData?.pincode,
          codeData?.cityId,
          codeData?.city,
          codeData?.cityName
        )
    );
  };

  // Ref to store timeout ID for cleanup
  const zipCodeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [isPinCodeLoading, setIsPinCodeLoading] = useState(false);
  // console.log(isCurrentSameAsPermanent, "isCurrentSameAsPermanent")
  const handleInvokPinCodeApi = async (
    zipCode: string,
    stateCode: string,
    fieldType?: string,
    coAppNum?: string
  ) => {
    try {
      const resp = await eligibilityCheckServices.getPinCode(zipCode);
      if (resp.status === 200) {
        // Read fresh values from Redux store to avoid using stale closure values
        const currentState = store.getState();
        const currentActiveHorizontalIndex = currentState.stepper.activeHorizontalIndex;
        const currentActiveVerticalIndex = currentState.stepper.activeVerticalIndex[currentActiveHorizontalIndex] || 0;
        if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 5) {
          const latestState = store.getState();
          const collapseVal =
            latestState.stepper.loanDetailCoApplicantCollapseValue;
          if (/^CoApplicant\d+$/.test(collapseVal)) {
            // Always read the latest state from Redux store to handle concurrent updates
            // This ensures we always have the most recent state even when API calls happen in quick succession
            const latestZipCodeData =
              latestState.stepper.coApplicantZipCodeData || {};

            // Create a proper copy of the state to avoid mutations
            // Use spread operator for shallow copy, then deep copy nested objects
            var oldPinCodeData: any = {};
            Object.keys(latestZipCodeData).forEach((key) => {
              if (
                latestZipCodeData[key] &&
                typeof latestZipCodeData[key] === "object"
              ) {
                oldPinCodeData[key] = {
                  current:
                    latestZipCodeData[key].current &&
                    typeof latestZipCodeData[key].current === "object"
                      ? { ...latestZipCodeData[key].current }
                      : latestZipCodeData[key].current,
                  permanent:
                    latestZipCodeData[key].permanent &&
                    typeof latestZipCodeData[key].permanent === "object"
                      ? { ...latestZipCodeData[key].permanent }
                      : latestZipCodeData[key].permanent,
                };
              } else {
                oldPinCodeData[key] = latestZipCodeData[key];
              }
            });

            let coAppKey = collapseVal;

            // Ensure coAppKey exists in the data structure
            if (!oldPinCodeData[coAppKey]) {
              oldPinCodeData[coAppKey] = {
                current: null,
                permanent: null,
              };
            }

            // Get existing data for this co-applicant, preserving both current and permanent
            const existingCoAppData = oldPinCodeData[coAppKey] || {};

            // Preserve existing values - these are already deep copied above
            const preservedCurrent =
              existingCoAppData.current !== undefined
                ? existingCoAppData.current
                : null;

            const preservedPermanent =
              existingCoAppData.permanent !== undefined
                ? existingCoAppData.permanent
                : null;

            // Prepare the new data object with API response
            const newPinCodeData = {
              ...resp.data.data?.[0],
              stateCode: stateCode,
            };

            const coAppNumValue = collapseVal.split("CoApplicant")[1];
            const currentSameAsPermanent =
              formikRef?.current?.values?.[
                `addressCoApplicant${coAppNumValue}currentsameAsPermanent`
              ];

            if (isSameAsPermanentChecked(currentSameAsPermanent)) {
              // If same as permanent is checked, update both with same data
              oldPinCodeData[coAppKey] = {
                current: { ...newPinCodeData },
                permanent: { ...newPinCodeData },
              };
            } else {
              // Update only the targeted field type, preserving the opposite field
              if (fieldType === "permanent") {
                oldPinCodeData[coAppKey] = {
                  current: preservedCurrent, // Preserve existing current data
                  permanent: { ...newPinCodeData }, // Update permanent with new data
                };
              } else if (fieldType === "current") {
                oldPinCodeData[coAppKey] = {
                  current: { ...newPinCodeData }, // Update current with new data
                  permanent: preservedPermanent, // Preserve existing permanent data
                };
              } else {
                // If fieldType is not specified, preserve both existing values
                oldPinCodeData[coAppKey] = {
                  current: preservedCurrent,
                  permanent: preservedPermanent,
                };
              }
            }

            // Dispatch the updated state
            dispatch(setCoApplicantZipCodeData(oldPinCodeData));
          }
        }

        if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 1) {
          if (isSameAsPermanentChecked(isCurrentSameAsPermanent)) {
            // console.log("permanentCodeData")
            // Create separate copies for permanent and current to avoid reference sharing
            // lookupPincode records which pincode these ids belong to (see the address save).
            const permanentData = { ...resp.data.data?.[0], stateCode: stateCode, lookupPincode: zipCode };
            setPermanentCodeData(permanentData);
            setCurrentCodeData(permanentData);
          } else {
            switch (fieldType) {
              case "permanent":
                // Update permanent only, preserve current address with its existing stateCode
                const permanentData = { ...resp.data.data?.[0], stateCode: stateCode, lookupPincode: zipCode };
                setPermanentCodeData(permanentData);
                // currentCodeData remains unchanged - don't touch it
                break;
              case "current":
                // Update current only, preserve permanent address with its existing stateCode
                const currentData = { ...resp.data.data?.[0], stateCode: stateCode, lookupPincode: zipCode };
                setCurrentCodeData(currentData);
                // permanentCodeData remains unchanged - don't touch it
                break;
              case "employment":
                if (coAppNum && formikRef?.current) {
                  formikRef.current.setFieldValue(
                    `employmentCoApplicant${coAppNum}city`,
                    resp.data?.data?.[0]?.cityName || "",
                    false
                  );
                  formikRef.current.setFieldValue(
                    `employmentCoApplicant${coAppNum}state`,
                    resp.data?.data?.[0]?.stateName || "",
                    false
                  );
	                  formikRef.current.setFieldValue(
	                    `employmentCoApplicant${coAppNum}companyCountry`,
	                    resp.data?.data?.[0]?.countryName || "",
	                    false
	                  );
	                  [
	                    `employmentCoApplicant${coAppNum}city`,
	                    `employmentCoApplicant${coAppNum}state`,
	                    `employmentCoApplicant${coAppNum}companyCountry`,
	                  ].forEach((fieldName) =>
	                    formikRef.current?.setFieldError(fieldName, undefined)
	                  );
	                }
	                break;
              default:
                // No action needed for other fieldType values
                break;
            }
          }
        }
        if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 2) {
          // Update company address pincode data state
          if (resp.data?.data?.[0]) {
            const companyData = { ...resp.data.data?.[0], stateCode: stateCode };
            setCompanyCodeData(companyData);
          } else {
            // Clear company code data if no data found
            setCompanyCodeData(null);
          }
        }
        if (currentActiveHorizontalIndex == 3 && currentActiveVerticalIndex == 3) {
          const referenceData = resp.data?.data?.[0]
            ? { ...resp.data.data?.[0], stateCode: stateCode }
            : null;
          if (fieldType === "reference1") {
            setReference1CodeData(referenceData);
          } else if (fieldType === "reference2") {
            setReference2CodeData(referenceData);
          }
        }
        if (fieldType === "reference1" || fieldType === "reference2") {
          const referenceNumber = fieldType === "reference2" ? 2 : 1;
          const referenceData = resp.data?.data?.[0]
            ? {
                ...resp.data.data?.[0],
                cityId: resp.data.data?.[0]?.city ?? resp.data.data?.[0]?.cityId,
                stateCode: stateCode,
              }
            : null;

          if (referenceNumber === 1) {
            setReference1CodeData(referenceData);
          } else {
            setReference2CodeData(referenceData);
          }

          const referenceCity =
            resp.data?.data?.[0]?.cityName ||
            resp.data?.data?.[0]?.city ||
            "";
          const referenceState =
            resp.data?.data?.[0]?.stateName ||
            resp.data?.data?.[0]?.state ||
            resp.data?.data?.[0]?.stateCode ||
            stateCode ||
            "";
          const referenceCountry = resp.data?.data?.[0]?.countryName || "";

          if (formikRef?.current) {
            formikRef.current.setFieldValue(
              `addressReference${referenceNumber}City`,
              referenceCity,
              false
            );
            formikRef.current.setFieldValue(
              `addressReference${referenceNumber}State`,
              referenceState,
              false
            );
            formikRef.current.setFieldValue(
              `addressReference${referenceNumber}Country`,
              referenceCountry,
              false
            );
            dispatch(
              updateFormData({
                [`addressReference${referenceNumber}City`]: referenceCity,
                [`addressReference${referenceNumber}State`]: referenceState,
                [`addressReference${referenceNumber}Country`]: referenceCountry,
              })
            );
          }
        }
        if (/^collateral\d*$/i.test(String(fieldType || ""))) {
          const collateralNumber = getCollateralFieldNumber(String(fieldType || ""));
          const collateralData = resp.data?.data?.[0]
            ? {
                ...resp.data.data?.[0],
                cityId: resp.data.data?.[0]?.city ?? resp.data.data?.[0]?.cityId,
                stateCode,
              }
            : null;

          setCollateralCodeData((prev) => ({
            ...prev,
            [collateralNumber]: collateralData,
          }));

          const collateralCity =
            resp.data?.data?.[0]?.cityName ||
            resp.data?.data?.[0]?.city ||
            "";
          const collateralState =
            resp.data?.data?.[0]?.stateName ||
            resp.data?.data?.[0]?.state ||
            resp.data?.data?.[0]?.stateCode ||
            stateCode ||
            "";
          const collateralCountry = resp.data?.data?.[0]?.countryName || "";

          setCollateralAddressValues(collateralNumber, {
            city: collateralCity,
            state: collateralState,
            country: collateralCountry,
          });
        }
      }
    } catch (error: any) {
      // Clear company code data on error if we're in company address section
      const currentState = store.getState();
      const currentActiveHorizontalIndex = currentState.stepper.activeHorizontalIndex;
      const currentActiveVerticalIndex = currentState.stepper.activeVerticalIndex[currentActiveHorizontalIndex] || 0;
      if (currentActiveHorizontalIndex == 1 && currentActiveVerticalIndex == 2) {
        setCompanyCodeData(null);
      }
      if (currentActiveHorizontalIndex == 3 && currentActiveVerticalIndex == 3) {
        if (fieldType === "reference1") {
          setReference1CodeData(null);
        } else if (fieldType === "reference2") {
          setReference2CodeData(null);
        }
      }
      if (/^collateral\d*$/i.test(String(fieldType || ""))) {
        const collateralNumber = getCollateralFieldNumber(String(fieldType || ""));
        setCollateralCodeData((prev) => {
          const next = { ...prev };
          delete next[collateralNumber];
          return next;
        });
      }
    } finally {
      setTimeout(() => {
        setZipCodeLoading(false);
      }, 1000);
    }
  };

  const lastUniversityQueryRef = useRef("");
  const lastInstituteQueryRef = useRef("");
  const lastCourseQueryRef = useRef("");

  // Debounced function to handle zip code API calls
  const debouncedZipCodeCall = useCallback(
    async (pincode: string, coAppNum?: string, fieldType?: string) => {
      if (pincode && String(pincode).length === 6) {
        setZipCodeLoading(true);
        try {
          const resp = await eligibilityCheckServices.getZipCode(pincode);
          if (resp.status === 200) {
            if (resp?.data?.data.length > 0) {
              const zipCodeData: any = resp?.data?.data?.[0] || {};
              const { cityName, countryName, stateName, stateCode, city }: any =
                zipCodeData;

              // Determine if this is a permanent address field
              const isPermanentField = fieldType === "permanent";
              const isCurrentField = fieldType === "current";
              const isEmploymentField = fieldType === "employment";
              const isReferenceField = fieldType === "reference1" || fieldType === "reference2";
              const isCollateralField = /^collateral\d*$/i.test(String(fieldType || ""));

              // Safety check - if fieldType is not specified, don't update any fields to avoid confusion
              if (!fieldType) {
                console.warn(
                  "handleInvokZipCode called without fieldType, skipping field updates"
                );
                return;
              }

              if (isReferenceField) {
                const referenceNumber = fieldType === "reference2" ? 2 : 1;
                const pinCodeResp = await eligibilityCheckServices.getPinCode(pincode);
                const pinCodeData = pinCodeResp?.data?.data?.[0] || {};
                const referenceData = {
                  ...zipCodeData,
                  ...pinCodeData,
                  cityId: pinCodeData?.city ?? pinCodeData?.cityId,
                  stateCode,
                };
                const referenceCity = cityName || "";
                const referenceState = stateName || "";
                const referenceCountry = countryName || "";

                if (referenceNumber === 1) {
                  setReference1CodeData(referenceData);
                } else {
                  setReference2CodeData(referenceData);
                }

                formikRef?.current?.setFieldValue(
                  `addressReference${referenceNumber}City`,
                  referenceCity,
                  false
                );
                formikRef?.current?.setFieldValue(
                  `addressReference${referenceNumber}State`,
                  referenceState,
                  false
                );
                formikRef?.current?.setFieldValue(
                  `addressReference${referenceNumber}Country`,
                  referenceCountry,
                  false
                );
                dispatch(
                  updateFormData({
                    [`addressReference${referenceNumber}City`]: referenceCity,
                    [`addressReference${referenceNumber}State`]: referenceState,
                    [`addressReference${referenceNumber}Country`]: referenceCountry,
                  })
                );
                return;
              }

              if (isCollateralField) {
                const collateralNumber = getCollateralFieldNumber(String(fieldType || ""));
                const pinCodeResp = await eligibilityCheckServices.getPinCode(pincode);
                const pinCodeData = pinCodeResp?.data?.data?.[0] || {};
                const collateralData = {
                  ...zipCodeData,
                  ...pinCodeData,
                  cityId: pinCodeData?.city ?? pinCodeData?.cityId,
                  stateCode,
                };
                const collateralCity = cityName || "";
                const collateralState = stateName || "";
                const collateralCountry = countryName || "";

                setCollateralCodeData((prev) => ({
                  ...prev,
                  [collateralNumber]: collateralData,
                }));

                setCollateralAddressValues(collateralNumber, {
                  city: collateralCity,
                  state: collateralState,
                  country: collateralCountry,
                });
                return;
              }

              handleInvokPinCodeApi(pincode, stateCode, fieldType, coAppNum);

              if (coAppNum) {
                const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
                const isSameAs = formikRef?.current?.values?.[sameAsKey];

                if (isPermanentField) {
                  // Update permanent fields when permanent pincode is entered
                  formikRef?.current?.setFieldValue(
                    `addressCoApplicant${coAppNum}permanentCity`,
                    cityName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    `addressCoApplicant${coAppNum}permanentState`,
                    stateName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    `addressCoApplicant${coAppNum}permanentCountry`,
                    countryName || ""
                  );
                  // Only update current fields if same as permanent is checked
                  if (isSameAsPermanentChecked(isSameAs)) {
                    handleInvokCityApi(stateCode);
                    formikRef?.current?.setFieldValue(
                      `addressCoApplicant${coAppNum}currentCity`,
                      cityName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      `addressCoApplicant${coAppNum}currentState`,
                      stateName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      `addressCoApplicant${coAppNum}currentCountry`,
                      countryName || ""
                    );
                  }
                } else if (isCurrentField) {
                  // Update current fields when current pincode is entered
                  handleInvokCityApi(stateCode);
                  formikRef?.current?.setFieldValue(
                    `addressCoApplicant${coAppNum}currentCity`,
                    cityName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    `addressCoApplicant${coAppNum}currentState`,
                    stateName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    `addressCoApplicant${coAppNum}currentCountry`,
                    countryName || ""
                  );
                  // Only update permanent fields if same as current is checked
                  if (isSameAsPermanentChecked(isSameAs)) {
                    formikRef?.current?.setFieldValue(
                      `addressCoApplicant${coAppNum}permanentCity`,
                      cityName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      `addressCoApplicant${coAppNum}permanentState`,
                      stateName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      `addressCoApplicant${coAppNum}permanentCountry`,
                      countryName || ""
                    );
                  }
                } else if (isEmploymentField) {
                  formikRef?.current?.setFieldValue(
                    `employmentCoApplicant${coAppNum}city`,
                    cityName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    `employmentCoApplicant${coAppNum}state`,
                    stateName || ""
                  );
	                  formikRef?.current?.setFieldValue(
	                    `employmentCoApplicant${coAppNum}companyCountry`,
	                    countryName || ""
	                  );
	                  [
	                    `employmentCoApplicant${coAppNum}city`,
	                    `employmentCoApplicant${coAppNum}state`,
	                    `employmentCoApplicant${coAppNum}companyCountry`,
	                  ].forEach((fieldName) =>
	                    formikRef.current?.setFieldError(fieldName, undefined)
	                  );
	                  dispatch(
	                    updateFormData({
                      [`employmentCoApplicant${coAppNum}city`]: cityName || "",
                      [`employmentCoApplicant${coAppNum}state`]: stateName || "",
                      [`employmentCoApplicant${coAppNum}companyCountry`]:
                        countryName || "",
                    })
                  );
                }
              } else {
                const isSameAs =
                  formikRef?.current?.values?.currentsameAsPermanent;

                if (isPermanentField) {
                  // Update permanent fields when permanent pincode is entered
                  formikRef?.current?.setFieldValue(
                    "permanentCity",
                    cityName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    "permanentState",
                    stateName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    "permanentCountry",
                    countryName || ""
                  );
                  // Only update current fields if same as permanent is checked
                  if (isSameAsPermanentChecked(isSameAs)) {
                    handleInvokCityApi(stateCode);
                    formikRef?.current?.setFieldValue(
                      "currentCity",
                      cityName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      "currentState",
                      stateName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      "currentCountry",
                      countryName || ""
                    );
                  }
                } else if (isCurrentField) {
                  // Update current fields when current pincode is entered
                  handleInvokCityApi(stateCode);
                  formikRef?.current?.setFieldValue(
                    "currentCity",
                    cityName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    "currentState",
                    stateName || ""
                  );
                  formikRef?.current?.setFieldValue(
                    "currentCountry",
                    countryName || ""
                  );
                  // Only update permanent fields if same as current is checked
                  if (isSameAsPermanentChecked(isSameAs)) {
                    formikRef?.current?.setFieldValue(
                      "permanentCity",
                      cityName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      "permanentState",
                      stateName || ""
                    );
                    formikRef?.current?.setFieldValue(
                      "permanentCountry",
                      countryName || ""
                    );
                  }
                }
              }
            } else {
              const isPermanentField = fieldType === "permanent";
              const isCurrentField = fieldType === "current";
              const isEmploymentField = fieldType === "employment";
              if (coAppNum) {
                if (isPermanentField) {
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}permanentCity`, "");
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}permanentState`, "");
                } else if (isCurrentField) {
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}currentCity`, "");
                  formikRef?.current?.setFieldValue(`addressCoApplicant${coAppNum}currentState`, "");
                } else if (isEmploymentField) {
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}city`, "");
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}state`, "");
                  formikRef?.current?.setFieldValue(`employmentCoApplicant${coAppNum}companyCountry`, "");
                }
              } else if (fieldType === "reference1" || fieldType === "reference2") {
                const referenceNumber = fieldType === "reference2" ? 2 : 1;
                if (referenceNumber === 1) {
                  setReference1CodeData(null);
                } else {
                  setReference2CodeData(null);
                }
                formikRef?.current?.setFieldValue(`addressReference${referenceNumber}City`, "");
                formikRef?.current?.setFieldValue(`addressReference${referenceNumber}State`, "");
                formikRef?.current?.setFieldValue(`addressReference${referenceNumber}Country`, "");
              } else if (/^collateral\d+$/i.test(String(fieldType || ""))) {
                const collateralNumber = getCollateralFieldNumber(String(fieldType || ""));
                setCollateralCodeData((prev) => {
                  const next = { ...prev };
                  delete next[collateralNumber];
                  return next;
                });
                formikRef?.current?.setFieldValue(`collateral${collateralNumber}City`, "");
                formikRef?.current?.setFieldValue(`collateral${collateralNumber}State`, "");
                formikRef?.current?.setFieldValue(`collateral${collateralNumber}Country`, "");
              } else {
                if (isPermanentField) {
                  formikRef?.current?.setFieldValue("permanentCity", "");
                  formikRef?.current?.setFieldValue("permanentState", "");
                } else if (isCurrentField) {
                  formikRef?.current?.setFieldValue("currentCity", "");
                  formikRef?.current?.setFieldValue("currentState", "");
                }
              }

              dispatch(
                setStatusPopup({
                  status: "error",
                  message: "Pincode not found. Please enter a valid pincode.",
                })
              );
            }
          }
        } catch (error: any) {
          console.log("error", error);
        } finally {
          setZipCodeLoading(false);
        }
      }
      // }, 500);
    },
    [
      loanDetailCoApplicantCollapseValue,
      coApplicantZipCodeData,
      formData,
      permanentCodeData,
      currentCodeData,
      isCurrentSameAsPermanent,
      activeHorizontalIndex,
      activeVerticalIndex
    ]
  );

  const debouncedCall = useMemo(
    () =>
      debounce((key: string, value: string) => {
        if (key === "university") fetchUniversities(value);
        if (key === "institute") fetchInstitutes(value);
        if (key === "courseName" || key === "course" || key === "cource") {
          fetchCourses(value);
        }
      }, 1000),
    [formValues.countryId, formData?.country?.value, formValues.universityId, formValues?.instituteId, dropdownData]
  );
  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (zipCodeTimeoutRef.current) {
        clearTimeout(zipCodeTimeoutRef.current);
      }
    };
  }, []);

  const handleInvokZipCode = (
    pincode: string,
    coAppNum?: string,
    fieldType?: string
  ) => {
    // Only call API if pincode is exactly 6 digits
    if (pincode && pincode.length === 6) {
      debouncedZipCodeCall(pincode, coAppNum, fieldType);
    }
  };
  // console.log(permanentCodeData, currentCodeData, isCurrentSameAsPermanent, "permanentCodeData")
  useEffect(() => {
    if (isCurrentSameAsPermanent == true && activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      setPermanentCodeData(null);
      setCurrentCodeData(null);
      handleInvokZipCode(
        aadhaarVerifiedDetails?.pincode,
        undefined,
        "permanent"
      );
    } else {
      if (!formikRef?.current?.values?.pincode &&
        aadhaarVerifiedDetails?.pincode &&
        activeHorizontalIndex === 1 &&
        (activeVerticalIndex === 1 ||
          activeVerticalIndex === 2 ||
          activeVerticalIndex === 5)
      ) {
        handleInvokZipCode(
          aadhaarVerifiedDetails?.pincode,
          undefined,
          "permanent"
        );
      }
    }
  }, [
    aadhaarVerifiedDetails?.pincode,
    activeHorizontalIndex,
    activeVerticalIndex,
    formikRef?.current?.values?.pincode,
    isCurrentSameAsPermanent
  ]);

  // Ref to track last processed employment pincode
  const lastEmploymentPincodeRef = useRef<string>("");

  useEffect(() => {
    if (
      activeHorizontalIndex == 1 &&
      (activeVerticalIndex == 1 ||
        activeVerticalIndex == 2)
    ) {
      const currentPincode = formikRef?.current?.values?.employmentCompanyPincode;
      if (currentPincode && currentPincode !== lastEmploymentPincodeRef.current) {
        lastEmploymentPincodeRef.current = currentPincode;
        handleInvokZipCode(currentPincode);
      }
    }
  }, [formikRef?.current?.values?.employmentCompanyPincode, activeHorizontalIndex, activeVerticalIndex]);

  // For each co-applicant, if Aadhaar details have pincode, trigger handleInvokZipCode with co-applicant number
  useEffect(() => {
    if (!aadhaarVerifiedDetailsCoApplicant) return;
    Object.entries(aadhaarVerifiedDetailsCoApplicant).forEach(
      ([coAppKey, detailsRaw]) => {
        const match = coAppKey.match(/CoApplicant(\d+)/);
        if (!match) return;
        const num = match[1];
        const details = detailsRaw as any;
        if (details?.pincode) {
          handleInvokZipCode(details.pincode, num, "permanent");
        }
      }
    );
  }, [aadhaarVerifiedDetailsCoApplicant]);

  // Ref to store timeout ID for cleanup
  const companyZipCodeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Debounced function to handle zip code API calls
  const debouncedCompanyZipCodeCall = useCallback((pincode: string) => {
    // Clear existing timeout
    if (companyZipCodeTimeoutRef.current) {
      clearTimeout(companyZipCodeTimeoutRef.current);
    }

    // Clear loading state when user starts typing again
    setZipCodeLoading(false);

    // Set new timeout
    companyZipCodeTimeoutRef.current = setTimeout(async () => {
      if (pincode && pincode.length === 6) {
        setZipCodeLoading(true);

        try {
          const resp = await eligibilityCheckServices.getZipCode(pincode);
          if (resp.status === 200) {
            if (resp?.data?.data.length > 0) {
              const { cityName, countryName, stateName, stateCode }: any =
                resp?.data?.data?.[0];

              handleInvokPinCodeApi(pincode, stateCode);
              // handleInvokStateApi(stateCode);
              handleInvokCityApi(stateCode);
              formikRef?.current?.setFieldValue(
                "employmentCompanyCity",
                cityName || ""
              );
              formikRef?.current?.setFieldValue(
                "employmentCompanyState",
                stateName || ""
              );
              formikRef?.current?.setFieldValue(
                "employmentCompanyCountry",
                countryName || ""
              );
            } else {
              // Clear company code data if pincode not found
              setCompanyCodeData(null);
              formikRef?.current?.setFieldValue("employmentCompanyCity", "");
              formikRef?.current?.setFieldValue("employmentCompanyState", "");
              formikRef?.current?.setFieldValue("employmentCompanyCountry", "");

              dispatch(
                setStatusPopup({
                  status: "error",
                  message: "Pincode not found. Please enter a valid pincode.",
                })
              );
            }
          }
        } catch (error: any) {
          console.log("error", error);
        } finally {
          setZipCodeLoading(false);
        }
      }
    }, 500); // 500ms delay
  }, []);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (companyZipCodeTimeoutRef.current) {
        clearTimeout(companyZipCodeTimeoutRef.current);
      }
    };
  }, []);

  const handleInvokCompanyZipCode = (pincode: string) => {
    // Only call API if pincode is exactly 6 digits
    if (pincode && pincode.length === 6) {
      debouncedCompanyZipCodeCall(pincode);
    }
  };

  const lastReferencePincodeRef = useRef<string>("");

  useEffect(() => {
    if (!isReferenceCollateralStep || referenceCollateralActiveTab !== 0) return;
    const values = formikRef?.current?.values || formData || {};
    const pincodeFieldName = `addressReference${activeReferenceSection}Pincode`;
    const pincode = values?.[pincodeFieldName];
    const cacheKey = `reference${activeReferenceSection}:${pincode || ""}`;
    if (
      String(pincode || "").length === 6 &&
      lastReferencePincodeRef.current !== cacheKey
    ) {
      lastReferencePincodeRef.current = cacheKey;
      handleInvokZipCode(
        String(pincode),
        undefined,
        `reference${activeReferenceSection}`
      );
    }
  }, [
    activeReferenceSection,
    formData,
    isReferenceCollateralStep,
    referenceCollateralActiveTab,
  ]);

  const lastCollateralPincodeRef = useRef<string>("");

  useEffect(() => {
    if (!isReferenceCollateralStep || referenceCollateralActiveTab !== 1) return;
    const values = formikRef?.current?.values || formData || {};
    const pincodeFieldName = getCollateralAddressFieldName(
      activeCollateralSection,
      "Pincode"
    );
    const pincode = values?.[pincodeFieldName];
    const cacheKey = `collateral${activeCollateralSection}:${pincode || ""}`;
    if (
      String(pincode || "").length === 6 &&
      lastCollateralPincodeRef.current !== cacheKey
    ) {
      lastCollateralPincodeRef.current = cacheKey;
      handleInvokZipCode(
        String(pincode),
        undefined,
        `collateral${activeCollateralSection}`
      );
    }
  }, [
    activeCollateralSection,
    formData,
    getCollateralAddressFieldName,
    isReferenceCollateralStep,
    referenceCollateralActiveTab,
  ]);

  const renderField = (field: any) => {
     const isSummaryEligibilityStep0 =
      pageType === "SUMMARY" &&
      activeHorizontalIndex === 0 &&
      activeVerticalIndex === 0;
    const isAcademicDetailsCourseField = /^course\d+(Type|Cgpa|Percentage|Year)$/i.test(
      field?.name || ""
    );
    const summaryEligibilityThreeColFields = new Set([
      "product",
      "applicantType",
      "studentDetailsFirstName",
      "studentDetailsLastName",
      "firstName",
      "lastName",
      "phone_number",
      "email",
      "studentDetailsPhone_number",
      "studentDetailEmail",
    ]);
    const smForSummaryEligibility = (baseSm: number) =>
      isSummaryEligibilityStep0 && summaryEligibilityThreeColFields.has(field.name)
        ? 3
        : baseSm;
    const clearFieldErrorWhenFilled = (
      form: any,
      fieldName: string,
      value: any
    ) => {
      if (isAddressYearField(fieldName)) {
        const fieldValue = String(value ?? "").trim();
        if (fieldValue !== "" && Number(fieldValue) <= 150) {
          form.setFieldError(fieldName, undefined);
        }
        return;
      }
      if (
        /^(basic|address|employment)CoApplicant\d+/i.test(fieldName) &&
        String(value ?? "").trim() !== ""
      ) {
        form.setFieldError(fieldName, undefined);
      }
    };
    switch (field.type) {
      case "number":
      case "text":
        if (formikRef?.current?.values?.employmentType !== "Others" && field.name === "employmentYear") {
          const yearField = (
            <Field name="employmentYear">
              {({ field: f, meta, form }: any) => (
                <InputField
                  {...f}
                  fullWidth
                  type="text"
                  placeholder="Total Years"
                  variant="outlined"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  inputProps={{ min: 0, max: 60, maxLength: 2 }}
                  error={!!meta.touched && !!meta.error}
                  helperText={meta.touched && meta.error ? meta.error : ""}
                  autoComplete="new-password"
                  onKeyDown={(e: any) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e: any) => {
                    let v = String(e?.target?.value ?? "");
                    v = v.replace(/\D/g, "");
                    if (v.length > 2) v = v.slice(0, 2);

                    if (v === "") {
                      form.setFieldError("employmentYear", "");
                      form.setFieldValue("employmentYear", ""); // Use setFieldValue for consistency
                      handleFilledFieldsCount("employmentYear", "");
                      return;
                    }

                    const n = parseInt(v, 10);
                    if (!Number.isNaN(n) && n > 60) {
                      const prev = !f.value ? "60" : String(f.value);
                      form.setFieldTouched("employmentYear", true, false);
                      form.setFieldError("employmentYear", "Year cannot be greater than 60");
                      form.setFieldValue("employmentYear", prev, false);
                      handleFilledFieldsCount("employmentYear", prev);
                      return;
                    }

                    if (meta.error === "Year cannot be greater than 60") {
                      form.setFieldError("employmentYear", "");
                    }

                    // NEW LOGIC: If years set to 60, force month to 0
                    if (n === 60) {
                      form.setFieldValue("employmentMonth", "0", false);
                      handleFilledFieldsCount("employmentMonth", "0");
                    }

                    form.setFieldValue("employmentYear", v, false);
                    handleFilledFieldsCount("employmentYear", v);
                  }}
                />
              )}
            </Field>
          );

          const monthField = (
            <Field name="employmentMonth">
              {({ field: f, meta, form }: any) => (
                <InputField
                  {...f}
                  fullWidth
                  type="text"
                  placeholder="Total Months"
                  variant="outlined"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  inputProps={{ min: 0, max: 12, maxLength: 2 }}
                  error={!!meta.touched && !!meta.error}
                  helperText={meta.touched && meta.error ? meta.error : ""}
                  autoComplete="new-password"
                  onKeyDown={(e: any) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e: any) => {
                    let v = String(e?.target?.value ?? "");
                    v = v.replace(/\D/g, "");
                    if (v.length > 2) v = v.slice(0, 2);

                    const currentYear = parseInt(form.values.employmentYear, 10);

                    if (v === "") {
                      form.setFieldError("employmentMonth", "");
                      form.setFieldValue("employmentMonth", "", false);
                      handleFilledFieldsCount("employmentMonth", "");
                      return;
                    }

                    const n = parseInt(v, 10);

                    // LOGIC: If years are 60, force month to 0 and show error if they try to change it
                    if (currentYear === 60 && n > 0) {
                      form.setFieldTouched("employmentMonth", true, false);
                      form.setFieldError("employmentMonth", "Month must be 0 if Year is 60");
                      form.setFieldValue("employmentMonth", "0", false);
                      return;
                    }

                    if (!Number.isNaN(n) && n > 12) {
                      const prev = !f.value ? "12" : String(f.value);
                      form.setFieldTouched("employmentMonth", true, false);
                      form.setFieldError("employmentMonth", "Month cannot be greater than 12");
                      form.setFieldValue("employmentMonth", prev, false);
                      return;
                    }

                    if (meta.error === "Month cannot be greater than 12" || meta.error === "Month must be 0 if Year is 60") {
                      form.setFieldError("employmentMonth", "");
                    }

                    form.setFieldValue("employmentMonth", v, false);
                    handleFilledFieldsCount("employmentMonth", v);
                  }}
                />
              )}
            </Field>
          );

          if (pageType === "SUMMARY") {
            return (
              <Grid item xs={12} key={field.id} sx={{ mt: 1 }}>
                <Box sx={{ bgcolor: "#EAF7F9", p: 1.5, borderRadius: "6px" }}>
                  <Box mb={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        width: 18,
                        height: 18,
                        borderRadius: "4px",
                        bgcolor: "#00B3B51A",
                        color: "#00B3B5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <WorkOutlineIcon sx={{ fontSize: 14 }} />
                    </Box>
                    <Typography sx={{ color: "#2F2A3C", fontSize: "13px", fontWeight: 700 }}>
                      Help us with your work experience <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      {yearField}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {monthField}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            );
          }

          return (
            <Grid item xs={12} key={field.id} sx={{ mt: 1 }}>
              <Box sx={{ bgcolor: "#EAF7F9", p: 1.5, borderRadius: "6px" }}>
                <Box mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      borderRadius: "4px",
                      bgcolor: "#00B3B51A",
                      color: "#00B3B5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <WorkOutlineIcon sx={{ fontSize: 14 }} />
                  </Box>
                  <Typography style={{ color: '#2F2A3C', fontSize: '13px', fontWeight: 700 }}>
                    Help us with your work experience <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  {/* YEAR FIELD */}
                  <Grid item xs={12} sm={6}>
                    {yearField}
                  </Grid>

                  {/* MONTH FIELD */}
                  <Grid item xs={12} sm={6}>
                    {monthField}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
        }

        // return null for employmentMonth so it doesn't render a second time
        if (field.name === "employmentMonth") {
          return null;
        }
        // Handle main applicant First/Last Name only if value exists and as per bugs in sheet have not change anything in api
        if (
          field.name === "studentDetailsFirstName" ||
          field.name === "studentDetailsLastName" ||
          field.name === "firstName" ||
          field.name === "lastName"
        ) {
          let valueExists = false;
          let valueExistsone = false;
          if (field.name === "studentDetailsFirstName" || field.name === "studentDetailsLastName") {
            valueExists =
              formikRef.current?.values?.[field.name] ||
              formData?.[field.name];
          }
          if (field.name === "firstName" || field.name === "lastName") {
            valueExistsone =
              formikRef.current?.values?.[field.name] ||
              formData?.[field.name];
          }
          if (valueExists || valueExistsone) {
            return (
              <Grid
                item
                xs={pageType === "SUMMARY" ? 3 : 12}
                sm={pageType === "SUMMARY" ? 3 : smForSummaryEligibility(6)}
                key={field.id}
              >
                <Box>
                  <label className="text-lable" style={{ display: "block" }}>
                    {field.label}{" "}
                    {field.required && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <Field name={field.name}>
                    {({ field: f, meta }: any) => (
                      <InputField
                        {...f}
                        fullWidth
                        placeholder={field.placeholder || `Enter ${field.label}`}
                        variant="outlined"
                        inputmode="text"
                        disabled={
                          isApiLoading ||
                          Boolean(valueExists) ||
                          (Boolean(valueExistsone) && isAuthenticated) ||
                          (pageType === "SUMMARY" &&
                            [
                              "firstName",
                              "lastName",
                              "studentDetailsFirstName",
                              "studentDetailsLastName",
                            ].includes(field.name))
                        }
                        error={!!meta.touched && !!meta.error}
                        helperText={meta.touched && meta.error ? meta.error : ""}
                        autoComplete="new-password"
                        inputProps={{ autoComplete: "new-password" }}
                        onInput={(e: any) => {
                          if (valueExists) return;
                          if (
                            pageType === "SUMMARY" &&
                            [
                              "firstName",
                              "lastName",
                              "studentDetailsFirstName",
                              "studentDetailsLastName",
                            ].includes(field.name)
                          ) {
                            return;
                          }
                          e.target.value = e.target.value;
                          handleFilledFieldsCount(field.name, e.target.value);

                          if (
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 5 &&
                            formikRef?.current?.values
                          ) {
                            dispatch(
                              updateFormData({
                                [field.name]: e.target.value,
                              })
                            );
                          }
                        }}
                        onBlur={(e: any) => {
                          if (
                            pageType === "SUMMARY" &&
                            [
                              "firstName",
                              "lastName",
                              "studentDetailsFirstName",
                              "studentDetailsLastName",
                            ].includes(field.name)
                          ) {
                            return;
                          }
                          let value = e.target.value || "";
                          value = value.trim().replace(/\s{2,}/g, " ");
                          e.target.value = value;

                          if (formikRef?.current) {
                            formikRef.current.setFieldValue(field.name, value, true);
                          }

                          handleFilledFieldsCount(field.name, value);

                          if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                            dispatch(
                              updateFormData({
                                [field.name]: value,
                              })
                            );
                          }
                        }}
                      />
                    )}
                  </Field>
                </Box>
              </Grid>
            );
          }
        }
        // PAN field logic for co-applicants
        if (field.name.match(/^basicCoApplicant\d+PanNumber$/)) {
          const coApplicantPanMatch = field.name.match(
            /^basicCoApplicant(\d+)PanNumber$/
          );
          const idx = coApplicantPanMatch
            ? String(Number(coApplicantPanMatch[1]) - 1)
            : null;

          // Verified logic (check both Redux and Formik)
          let isPanVerified = false;
          let lastVerifiedPan = "";
          if (idx !== null) {
            const formikPanVerified = isTruthyFormFlag(
              formikRef.current?.values[
                `basicCoApplicant${Number(idx) + 1}IsPanVerified`
              ]
            );
            const reduxPanVerified = isTruthyFormFlag(
              coApplicantVerification[idx]?.panVerified
            );
            const lastPan =
              coApplicantVerification[idx]?.lastPanNumber ||
              formikRef.current?.values[field.name];
            isPanVerified =
              (formikPanVerified || reduxPanVerified) &&
              formikRef.current?.values[field.name] === lastPan;
            lastVerifiedPan = lastPan;
          }

          // Duplicate PAN validation (include main applicant PAN)
          const allPanFields = Object.keys(
            formikRef.current?.values || {}
          ).filter((key) => key.match(/^basicCoApplicant\d+PanNumber$/));
          const currentPanValue = formikRef.current?.values[field.name];
          // Get main applicant PAN from Redux formData, formik, and panNumber
          let mainApplicantPan = formData?.pan;
          if (
            !mainApplicantPan ||
            mainApplicantPan === "" ||
            mainApplicantPan === "yes" ||
            mainApplicantPan === "no"
          ) {
            // fallback to Formik value if Redux is blank or not a PAN
            const formikPan = formikRef.current?.values?.pan;
            if (
              formikPan &&
              formikPan !== "" &&
              formikPan !== "yes" &&
              formikPan !== "no"
            ) {
              mainApplicantPan = formikPan;
            } else if (
              panNumber &&
              panNumber !== "" &&
              /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panNumber)
            ) {
              // fallback to panNumber from Redux if it's a valid PAN
              mainApplicantPan = panNumber;
            } else {
              mainApplicantPan = undefined;
            }
          }
          const duplicatePan =
            allPanFields
              .filter((key) => key !== field.name)
              .map((key) => formikRef.current?.values[key])
              .includes(currentPanValue) ||
            (mainApplicantPan &&
              currentPanValue &&
              mainApplicantPan?.toUpperCase() ===
              currentPanValue?.toUpperCase());
          return (
            <Grid
              item
              xs={12}
              sm={
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                    : pageType === "SUMMARY" ? 3 : 6
              }
              key={field.id}
            >
              <Box>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Field name={field.name}>
                  {({ field: f, meta, form }: any) => (
                    <InputField
                      {...f}
                      fullWidth
                      placeholder={field.placeholder || "Enter PAN Number"}
                      variant="outlined"
                      inputmode="text"
                      // disabled={isApiLoading || isPanVerified}
                      autoComplete="new-password"
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      error={
                        (!!meta.touched && !!meta.error) ||
                        (duplicatePan && !!currentPanValue)
                      }
                      helperText={
                        meta.touched && meta.error
                          ? meta.error
                          : duplicatePan && !!currentPanValue
                            ? "This PAN is already used in another field."
                            : ""
                      }
                      onChange={(e) => {
                        let inputValue = e.target.value?.toUpperCase();
                        if (inputValue.length > 10) {
                          inputValue = inputValue.slice(0, 10);
                        }
                        form.setFieldValue(field.name, inputValue);
                        clearFieldErrorWhenFilled(form, field.name, inputValue);
                        // Reset verification if value changes
                        if (inputValue !== lastVerifiedPan) {
                          if (idx !== null) {
                            dispatch(
                              setCoApplicantVerification({
                                index: idx,
                                data: {
                                  panVerified: false,
                                },
                              })
                            );
                          }
                        } else {
                          if (idx !== null) {
                            dispatch(
                              setCoApplicantVerification({
                                index: idx,
                                data: {
                                  panVerified: true,
                                },
                              })
                            );
                          }
                        }
                      }}
                      onInput={(e: any) => {
                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === "string" &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, "");
                        }
                        let panval = e.target.value?.toUpperCase();
                        handleFilledFieldsCount(field.name, panval);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          // Persist all form values to Redux for refresh survival
                          if (formikRef?.current?.values) {
                            // dispatch(
                            //   updateFormData({
                            //     ...formikRef.current.values,
                            //     [field.name]: e.target.value,
                            //   })
                            // );
                            dispatch(
                              updateFormData({
                                [field.name]: panval,
                              })
                            );
                          }
                        }
                      }}
                      inputProps={{
                        ...(coApplicantPanMatch ? { maxLength: 10 } : {}),
                      }}
                      InputProps={{
                        readOnly: isApiLoading || isPanVerified,
                        style: { textTransform: "uppercase" },
                        endAdornment: (
                          <Button
                            sx={{
                              backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                              color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                              "&:hover": {
                                backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                                color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: isPanVerified && !duplicatePan ? "transparent" : "#FEC10D",
                                color: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                                WebkitTextFillColor: isPanVerified && !duplicatePan ? "#28C76F" : "#000000",
                                opacity: 1
                              },
                              "& img": {
                                opacity: 1,
                                filter: "brightness(1)",
                              },
                              textTransform: "none",
                              fontSize: isPanVerified && !duplicatePan ? "16px" : "10px",
                              fontWeight: isPanVerified && !duplicatePan ? 400 : 700,
                              px: "15px",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              boxShadow: "none",
                              height: '100%',
                              mr: 0.5,
                            }}
	                            onClick={isApiLoading || isPanVerified ? undefined : async () => {
	                              if (isPanVerified || duplicatePan) return;
	                              const coApplicantNumber = Number(idx) + 1;
	                              const coApplicantEmailVerifiedForPan =
	                                isTruthyFormFlag(
	                                  form.values[
	                                    `basicCoApplicant${coApplicantNumber}IsEmailVerified`
	                                  ]
	                                );
	                              const coApplicantMobileVerifiedForPan =
	                                isTruthyFormFlag(
	                                  form.values[
	                                    `basicCoApplicant${coApplicantNumber}IsMobileVerified`
	                                  ]
	                                );
                              if (
                                !coApplicantEmailVerifiedForPan ||
                                !coApplicantMobileVerifiedForPan
                              ) {
                                setSnackbar({
                                  open: true,
                                  message: "Please verify email and mobile",
                                  severity: "error",
                                });
                                return;
                              }
                              setCoApplicantPanLoading((prev) => ({
                                ...prev,
                                [field.name]: true,
                              }));

                              try {
                                const panNumber = form.values[field.name];
                                const firstName =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1
                                  }FirstName`
                                  ] || "";
                                const lastName =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1}LastName`
                                  ] || "";
                                const name = `${firstName} ${lastName}`.trim();
                                const dob =
                                  form.values[
                                  `basicCoApplicant${Number(idx) + 1}dob`
                                  ] || "";
                                if (!dob) {
                                  setSnackbar({
                                    open: true,
                                    message:
                                      "Please provide your Date of Birth before proceeding with PAN verification.",
                                    severity: "error",
                                  });
                                  return;
                                }
                                const piiPublicKey =
                                  await fetchSanitizedPiiPublicKey();
                                if (!piiPublicKey) return;

                                const payload = await encryptData(
                                  {
                                    panNumber,
                                    fullName: name.trim(),
                                    dob: dob
                                      ? new Date(dob).toLocaleDateString(
                                        "en-GB"
                                      )
                                      : "",
                                    trackingId: trackingId,
                                    applicantType: `Co-Applicant ${Number(idx) + 1}`,
                                  },
                                  ["panNumber"],
                                  piiPublicKey
                                );
                                const resp =
                                  await applicantDetailsServices.verifyPan(payload);
                                if (resp.status === 200) {

                                  trackCustomerJourneyEvent(
                                    `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                    decrypt(userProfile?.id) ?? "",
                                    trackingId,
                                    {
                                      label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                      category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                      action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${Number(idx) + 1}BASIC_PANVERI_PAGE10`,
                                      page: `ProvisionalOff_Loan Details_COAPP(${Number(idx) + 1}) PAN Verification`,
                                    }
                                  );


                                  // Check for invalid date of birth in PAN API response
                                  if (
                                    resp.data?.data?.dateOfBirth === "invalid" && dob // only if dob is provided
                                  ) {
                                    setSnackbar({
                                      open: true,
                                      message: "DOB mismatch. Please ensure the Date of Birth matches the one linked to this PAN.",
                                      severity: "error",
                                    });
                                  } else {
                                    const isAadhaarSeeded =
                                      String(
                                        resp?.data?.data?.aadhaarSeedingStatus || ""
                                      ).toLowerCase() === "y";
                                    dispatch(
                                      setCoApplicantVerification({
                                        index: idx ?? "",
                                        data: {
                                          panVerified: true,
                                          lastPanNumber: panNumber,
                                          aadhaarSeedingStatus: isAadhaarSeeded,
                                        },
                                      })
                                    );
                                    formikRef.current?.setFieldValue(
                                      field.name,
                                      panNumber
                                    );
                                    dispatch(
                                      updateFormData({
                                        [`basicCoApplicant${Number(idx) + 1}IsPanVerified`]: true
                                      })
                                    );
                                    setSnackbar({
                                      open: true,
                                      message:
                                        "Yay! The co-applicant's PAN has been successfully verified.",
                                      severity: "success",
                                    });
                                  }
                                } else if (resp.status === 400) {
                                  setSnackbar({
                                    open: true,
                                    message:
                                      "Uh-oh! We are experiencing some technical issues fetching the co-applicant’s PAN details. Please try again later.",
                                    severity: "error",
                                  });
                                } else {
                                  setSnackbar({
                                    open: true,
                                    message:
                                      "Please provide your Date of Birth before proceeding with PAN verification.",
                                    severity: "error",
                                  });
                                }
                              } catch (err: any) {
                                setSnackbar({
                                  open: true,
                                  message: "Uh-oh! PAN verification failed. Please check the details and try again.",
                                  severity: "error",
                                });
                              } finally {
                                setCoApplicantPanLoading((prev) => ({
                                  ...prev,
                                  [field.name]: false,
                                }));
                              }
                            }}
                            disabled={
                              isPanVerified ||
                              duplicatePan ||
                              coApplicantPanLoading[field.name]
                            }
                          >
                            {coApplicantPanLoading[field.name] ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : (
                              <>
                                {isPanVerified && !duplicatePan ? (
                                  <>
                                    <img
                                      src={greenCheckVerified}
                                      alt="Verified"
                                      style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                    <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="inherit">Verify</Typography>
                                    <img
                                      src={arrowRightVerify}
                                      alt="Verified"
                                      style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </Button>
                        ),
                      }}
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }
        // Name fields: block numbers for First Name, Last Name, Co-applicant First/Last Name
        const isNameField =
          field.name === "firstName" ||
          field.name === "lastName" ||
          field.name === "studentDetailsFirstName" ||
          field.name === "studentDetailsLastName" ||
          /^basicCoApplicant\d+FirstName$/.test(field.name) ||
          /^basicCoApplicant\d+LastName$/.test(field.name);
        const isSummaryLockedStudentName =
          pageType === "SUMMARY" &&
          [
            "firstName",
            "lastName",
            "studentDetailsFirstName",
            "studentDetailsLastName",
          ].includes(field.name);

        if (isNameField) {
          return (
            <Grid
              item
              xs={12}
               sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3
                  ? 4
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                    ? 12
                     : pageType === "SUMMARY" ? 3 : 6
              )}
              key={field.id}
            >
              <Box>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                <Field name={field.name}>
                  {({ field: f, meta }: any) => (
                    <InputField
                      {...f}
                      fullWidth
                      placeholder={field.placeholder || `Enter ${field.label}`}
                      variant="outlined"
                      inputmode="text"
                      disabled={
                        isApiLoading ||
                        isSummaryLockedStudentName ||
                        isCoApplicantFieldLockedByCoOwner(coOwnerLockSavedValues, field.name)
                      }
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error ? meta.error : ""}
                      autoComplete="new-password"
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      onInput={(e: any) => {
                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === "string" &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, "");
                        }
                        // Only allow alphabets and spaces
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        );
                        handleFilledFieldsCount(field.name, e.target.value);
                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          if (formikRef?.current?.values) {
                            dispatch(
                              updateFormData({
                                [field.name]: e.target.value,
                              })
                            );
                          }
                        }
                      }}
                      onBlur={(e: any) => {
                        let value = e.target.value || "";
                        value = value.trim().replace(/\s{2,}/g, " ");
                        e.target.value = value;

                        if (formikRef?.current) {
                          formikRef.current.setFieldValue(field.name, value, true);
                        }

                        handleFilledFieldsCount(field.name, value);

                        if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }}
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }

        // logic for comma separated values
        const isCurrencyFieldName = (fieldName: string): boolean => {
          const exactCurrencyFields = [
            "expenseVasExpense",
            "fundOwnSources",
          ];
          if (
            exactCurrencyFields.includes(fieldName) ||
            /^collateral\d*Value$/i.test(fieldName) ||
            /^collateral\d+noOfUnits$/i.test(fieldName)
          ) {
            return true;
          }

          const keywords = [
            "amount",
            "price",
            "fees",
            "cost",
            "loan",
            "charge",
            "balance",
            "total",
            "expenses",
            "obligation",
            "income",
          ];
          return keywords.some((keyword) =>
            fieldName.toLowerCase().includes(keyword)
          );
        };
        if (isCurrencyFieldName(field.name)) {
          const formatNumberIndian = (value: string | number) => {
            if (value) {
              const num = Number(value?.toString().replace(/,/g, ""));
              if (isNaN(num)) return value?.toString();

              return new Intl.NumberFormat("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(num);
            }
          };

          const unformatNumber = (formattedValue: string): string => {
            // Allows decimal points but removes all commas
            return formattedValue.replace(/,/g, "");
          };

          const fieldLabel = field.label || field.name;

          return (
            <Grid
              item
              xs={12}
              sm={
                activeHorizontalIndex === 1 && activeVerticalIndex === 5
                  ? 12
                  : activeHorizontalIndex === 0 && activeVerticalIndex === 2
                  ? 6
                  : activeHorizontalIndex === 1 && activeVerticalIndex === 2
                    ? (pageType === "SUMMARY" ? 3 : 6)
                    : isFundsAndExpensesStep ? 12: 3 // for summary and other steps, make currency fields smaller from 12 to 3
              }
              sx={{ mt: (activeHorizontalIndex === 1 && activeVerticalIndex === 4) && !isXsOrSm ? '2px' : '0px' }}
              key={field.id}
            >
              <Box>
                {/* Label (Standard Form Label) */}
                <label className="text-lable" style={{ display: "block" }}>
                  {fieldLabel}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>

                {/* Input Field with Currency Formatting Logic */}
                <Field name={field.name}>
                  {({ field: f, meta, form }: any) => (
                    <InputField
                      {...f}
                      type="text" // Set the input type to 'text' to allow comma characters to be displayed
                      inputmode="numeric"
                      pattern="[0-9]*"
                      // disabled={isApiLoading}
                      autoComplete="new-password"
                      // Ensure cleared values render as empty string for currency fields
                      value={formatNumberIndian(f.value) ?? ""}
                      onKeyDown={(e) => {
                        // Block leading space: allow spaces only after first character
                        if (e.key === " ") {
                          const target = e.target as HTMLInputElement;
                          const start = target.selectionStart ?? 0;
                          if (start === 0) {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\D/g, "");
                        let displayValue = e.target.value;
                        let storeValue = unformatNumber(displayValue);

                        // only allow numbers (and single decimal point)
                        if (
                          storeValue === "" ||
                          /^\d*(\.\d*)?$/.test(storeValue)
                        ) {
                          // Enforce max 15 digits before decimal
                          const [intPart, decPart] = storeValue.split(".");
                          let limitedInt =
                            f?.name === "employmentMonthlyObligation" ||
                            /^employmentCoApplicant\d+monthlyObligation$/i.test(
                              f?.name || ""
                            )
                              ? intPart.slice(0, 14)
                              : intPart.slice(0, 15);
                          let limitedValue =
                            decPart !== undefined
                              ? `${limitedInt}.${decPart}`
                              : limitedInt;
                          clearFieldErrorWhenFilled(
                            form,
                            field.name,
                            limitedValue
                          );
                          f.onChange({
                            target: {
                              name: f.name,
                              value: limitedValue,
                            },
                          } as React.ChangeEvent<HTMLInputElement>);
                          const totalValueField =
                            getCollateralTotalValueFieldName(f.name);
                          if (totalValueField) {
                            const collateralNumber = getCollateralFieldNumber(
                              f.name
                            );
                            const unitPriceField = `collateral${collateralNumber}unitPrice`;
                            const noOfUnitsField = `collateral${collateralNumber}noOfUnits`;
	                            const unitPrice =
	                              f.name === unitPriceField
	                                ? toNumberValue(limitedValue)
	                                : toNumberValue(form.values?.[unitPriceField]);
	                            const noOfUnits =
	                              f.name === noOfUnitsField
	                                ? toNumberValue(limitedValue)
	                                : toNumberValue(form.values?.[noOfUnitsField]);
	                            const hasUnitPrice =
	                              f.name === unitPriceField
	                                ? hasNumericInputValue(limitedValue)
	                                : hasNumericInputValue(form.values?.[unitPriceField]);
	                            const hasNoOfUnits =
	                              f.name === noOfUnitsField
	                                ? hasNumericInputValue(limitedValue)
	                                : hasNumericInputValue(form.values?.[noOfUnitsField]);
	                            const totalValue =
	                              hasUnitPrice && hasNoOfUnits
	                                ? String(unitPrice * noOfUnits)
	                                : "";
                            form.setFieldValue(
                              totalValueField,
                              totalValue,
                              false
                            );
                            dispatch(
                              updateFormData({
                                [f.name]: limitedValue,
                                [totalValueField]: totalValue,
                              })
                            );
                          }
                          handleFilledFieldsCount(field.name, limitedValue);
                        }
                      }}
                      fullWidth
                      placeholder={`Enter ${fieldLabel}`}
                      variant="outlined"
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error}
                      InputProps={{
                        maxLength: 18, // allow for commas and decimal
                      }}
                      disabled={
                        isApiLoading ||
                        field?.disabled ||
                        field.name.startsWith("coreTotalMarks") ||
                        field.name.startsWith("languageTotalMarks") ||
                        /^collateral\d+totalValue$/i.test(field.name)
                      }
                    />
                  )}
                </Field>
              </Box>
            </Grid>
          );
        }

        let isEmployeeRequiredField = field.name === "employmentCompanyName"
          || field.name === "employmentCompanyAddress1"
          || field.name === "employmentCompanyAddress2"
          || field.name === "employmentCompanyAddress3"
          || field.name === "employmentLandmark"
          || field.name === "employmentCompanyPincode"
          || field.name === "employmentCompanyCity"
          || field.name === "employmentCompanyState"
          || field.name === "employmentCompanyCountry";
	        const isReferenceNameField =
	          /^basicReference\d+(FirstName|LastName)$/i.test(field.name);
	        const referenceNameMatch = field.name.match(
	          /^basicReference(\d+)(FirstName|LastName)$/i
	        );
	        const isCollateralHolderNameField =
	          /^collateral\d*(FdHolderName|holderName)$/i.test(field.name);
	        const isCollateralAddressTextField =
	          /^collateral\d*addressLine[12]$/i.test(field.name);
	        const isCollateralOwnershipPercentageField =
	          /^coOwnerCollateral\d+(?:_\d+|\d+)?OwnershipPercentage$/i.test(field.name);
	        const toReferenceTitleCase = (value: string) =>
	          value
	            .toLowerCase()
	            .replace(/\b\w/g, (char) => char.toUpperCase());
	        const validateReferenceNamePair = () => {
	          if (!referenceNameMatch) return;
	          const currentRefNo = referenceNameMatch[1];
	          const otherRefNo = currentRefNo === "1" ? "2" : "1";
	          [
	            `basicReference${currentRefNo}FirstName`,
	            `basicReference${currentRefNo}LastName`,
	            `basicReference${otherRefNo}FirstName`,
	            `basicReference${otherRefNo}LastName`,
	          ].forEach((name) => {
	            formikRef.current?.setFieldTouched(name, true, false);
	            formikRef.current?.validateField(name);
	          });
	        };

        return (
          <Grid
            item
            xs={12}
            sm={smForSummaryEligibility(
              (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
                (activeHorizontalIndex === 1 && activeVerticalIndex === 4) ||
                (activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 3 &&
                  !isAcademicDetailsCourseField)
                ? 12
                : isAcademicDetailsCourseField
                  ? 3
                  : pageType === 'SUMMARY'
                    ? isFundsAndExpensesStep
                      ? 12
                      : 3
                    : 6
            )}
            sx={{
              mt:
                activeHorizontalIndex === 1 &&
                activeVerticalIndex === 4 &&
                !isXsOrSm
                  ? '2px'
                  : '0px',
            }}
            key={field.id}
          >
            <Box>
              <label className="text-lable" style={{ display: 'block' }}>
                {field.label}{' '}
                {(field.required || isEmployeeRequiredField) && (
                  <span style={{ color: 'red' }}>*</span>
                )}
              </label>
              <Field name={field.name}>
                {({ field: f, meta }: any) => {
                  const pinOrDerivedLock =
                    handleDisablePermanentPincodeBasedFields(field);
                  const { disabled: _omitFormikDisabled, ...formikFieldInput } =
                    f;
                  return (
                    <InputField
                      {...formikFieldInput}
                      fullWidth
                      type={
                        field?.name.match(/^course\d+Percentage$/) ||
                        field?.name.match(/^coreExamScore(_\d+)?$/) ||
                        field?.name.match(/^languageExamScore(_\d+)?$/)
                          ? 'text'
                          : field.type
                      }
                      inputmode="numeric"
                      pattern="[0-9]*"
	                      disabled={isApiLoading || pinOrDerivedLock || field?.disabled}
                      autoComplete="new-password"
                      inputProps={{
                        min: 0,
	                        ...(isReferenceNameField ? { maxLength: 25 } : {}),
	                        ...(isCollateralHolderNameField || isCollateralAddressTextField ? { maxLength: 50 } : {}),
                      }}
                      onCopy={
                        isReferenceNameField
                          ? (event: any) => event.preventDefault()
                          : undefined
                      }
                      onPaste={
                        isReferenceNameField
                          ? (event: any) => event.preventDefault()
                          : undefined
                      }
                      onCut={
                        isReferenceNameField
                          ? (event: any) => event.preventDefault()
                          : undefined
                      }
                      onWheel={(e: any) => {
                        // Prevent mouse wheel from changing number input values
                        if (field.type === 'number') {
                          e.target.blur();
                        }
                      }}
                      onKeyDown={(e) => {
                        if (
                          field.type === 'number' &&
                          ['e', 'E', '+', '-'].includes(e.key)
                        ) {
                          e.preventDefault(); // Block scientific notation and sign keys
                        }
                        // Disallow leading space: only allow space after first character
                        if (e.key === ' ') {
                          const target = e.target as HTMLInputElement;
                          if (
                            !target.value ||
                            (target.selectionStart === 0 &&
                              target.selectionEnd === 0)
                          ) {
                            e.preventDefault();
                          }
                        }
                      }}
                      placeholder={
                        field.name.includes('YearsInCurrentAddress')
                          ? 'How long have you been living here (in years)'
                          : field.name.includes('YearsInCurrentCity')
                            ? 'How long have you lived in this city (in years)'
                            : field.name === 'pincode'
                              ? 'Enter Area Pincode'
                              : field.placeholder || `Enter ${field.label}`
                      }
                      variant="outlined"
                      error={!!meta.touched && !!meta.error}
                      helperText={
                        (field.name === 'permanentPincode' ||
                          field.name === 'employmentCompanyPincode' ||
                          /^addressCoApplicant\d+permanentPincode$/.test(
                            field.name
                          ) ||
                          /^addressCoApplicant\d+currentPincode$/.test(
                            field.name
                          ) ||
                          (/^addressReference\d+Pincode$/i.test(field.name)
                            ? !isReferencePincodeResolved(field.name)
                            : /^collateral\d*Pincode$/i.test(field.name)
                              ? !isCollateralPincodeResolved(field.name)
                            : false)) &&
                        zipCodeLoading
                          ? 'Validating pincode...'
                          : meta.touched && meta.error
                      }
                      onInput={(e: any) => {
                        if (field.name === 'totalCost') {
                          // Use setTimeout to ensure Formik has the latest value of totalCost before validating the dependent field
                          setTimeout(() => {
                            formikRef.current?.validateField('loanAmount');
                          }, 0);
                        }

                        // Trim leading spaces from pasted/typed input but allow internal spaces
                        if (
                          typeof e.target.value === 'string' &&
                          /^\s/.test(e.target.value)
                        ) {
                          e.target.value = e.target.value.replace(/^\s+/, '');
                        }

                        if (field.type === 'number') {
                          const sanitized = e.target.value.replace(
                            /[eE+\-]/g,
                            ''
                          );
                          if (sanitized !== e.target.value) {
                            e.target.value = sanitized; // Strip unsupported characters from pasted input
                          }
                        }
                        // Only enforce 6-digit numeric for fields containing 'pincode'
                        if (field.name.toLowerCase().includes('pincode')) {
                          e.target.value = e.target.value
                            .replace(/\D/g, '')
                            .slice(0, 6);
                        }

                        // Restrict employmentMonth to numeric input only and max 2 digits
                        if (
                          field.name.toLowerCase().includes('employmentmonth')
                        ) {
                          let monthValue = e.target.value.replace(/\D/g, '');
                          // Limit to 2 digits
                          e.target.value = monthValue.slice(0, 2);
                        }

                        let value = e.target.value;
	                        if (isReferenceNameField || isCollateralHolderNameField) {
	                          value = toReferenceTitleCase(value);
	                          e.target.value = value;
	                          formikRef.current?.setFieldValue(
	                            field.name,
	                            value,
	                            false
	                          );
	                        }
	                        if (isReferenceNameField) {
	                          formikRef.current?.setFieldTouched(field.name, true, false);
	                          setTimeout(() => {
	                            validateReferenceNamePair();
	                          }, 0);
	                        }
	                        if (isCollateralOwnershipPercentageField) {
	                          value = value
	                            .replace(/[^0-9.]/g, "")
	                            .replace(/(\..*)\./g, "$1");
	                          const [whole, decimal] = value.split(".");
	                          value =
	                            decimal !== undefined
	                              ? `${whole}.${decimal.slice(0, 2)}`
	                              : whole;
	                          e.target.value = value;
	                          formikRef.current?.setFieldValue(field.name, value, false);
	                        }
                        clearFieldErrorWhenFilled(
                          formikRef.current,
                          field.name,
                          value
                        );

                        if (
                          field.name.match(/^course\d+Percentage$/) ||
                          field.name.match(/^coreExamScore(_\d+)?$/) ||
                          field?.name.match(/^languageExamScore(_\d+)?$/)
                        ) {
                          let v = e.target.value;
                          v = v.replace(/^0/, '');
                          // remove + - e E
                          v = v.replace(/[eE+\-]/g, '');
                          v = v.replace(/[^0-9.]/g, '');
                          // remove commas
                          v = v.replace(/,/g, '');

                          // split by dot
                          const parts = v.split('.');

                          if (parts.length === 1) {
                            // only integers, no dot
                            v = parts[0];
                          } else if (parts.length === 2) {
                            const [i, d] = parts;

                            // ✔ allow trailing dot (like "99.")
                            if (d === '') {
                              v = i + '.';
                            } else {
                              // ✔ allow max 2 decimals
                              v = i + '.' + d.slice(0, 2);
                            }
                          } else {
                            // more than one dot → keep only first two parts
                            v = parts[0] + '.' + parts[1].slice(0, 2);
                          }

                          e.target.value = v;
                          if (
                            v &&
                            /^course\d+Percentage$/i.test(field.name)
                          ) {
                            formikRef.current?.setFieldValue(
                              field.name,
                              v,
                              false
                            );
                            formikRef.current?.setFieldError(
                              field.name,
                              undefined
                            );
                          }
                          // Clear error immediately when exam score field has a value
                          if (
                            v &&
                            (field.name.match(/^coreExamScore(_\d+)?$/) ||
                              field.name.match(/^languageExamScore(_\d+)?$/))
                          ) {
                            formikRef.current?.setFieldError(
                              field.name,
                              undefined
                            );
                          }
                        }

                        // If user tries to enter more than 6 digits, do not call any API handlers
                        if (field.name.toLowerCase().includes('pincode')) {
                          if (value.length > 6) {
                            return;
                          }
                          if (value.length < 6) {
                            setZipCodeLoading(false);
                            const referencePincodeMatch = field.name.match(
                              /^addressReference(\d+)Pincode$/i
                            );
                            if (referencePincodeMatch?.[1] === "1") {
                              setReference1CodeData(null);
                            } else if (referencePincodeMatch?.[1] === "2") {
                              setReference2CodeData(null);
                            }
                            const collateralPincodeMatch = field.name.match(
                              /^collateral(\d*)Pincode$/i
                            );
                            if (collateralPincodeMatch) {
                              const collateralNumber = Number(
                                collateralPincodeMatch[1] || 1
                              );
                              setCollateralCodeData((prev) => {
                                const next = { ...prev };
                                delete next[collateralNumber];
                                return next;
                              });
                            }
                          }
                        }

                        // For main applicant permanent pincode
                        if (field.name === 'permanentPincode') {
                          if (value && value.length === 6) {
                            handleInvokZipCode(value, undefined, 'permanent');
                          }
                        }
                        // For main applicant current pincode
                        else if (field.name === 'currentPincode') {
                          if (value && value.length === 6) {
                            handleInvokZipCode(value, undefined, 'current');
                          }
                          // Do not update permanentPincode when currentPincode changes
                        }
                        // For co-applicant permanent pincode
                        else if (
                          /^addressCoApplicant\d+permanentPincode$/.test(
                            field.name
                          )
                        ) {
                          const match = field.name.match(
                            /^addressCoApplicant(\d+)permanentPincode$/
                          );
                          const coAppNum = match ? match[1] : undefined;
                          if (value && value.length === 6) {
                            handleInvokZipCode(value, coAppNum, 'permanent');
                          }
                        }
                        // For co-applicant current pincode
                        else if (
                          /^addressCoApplicant\d+currentPincode$/.test(
                            field.name
                          )
                        ) {
                          const match = field.name.match(
                            /^addressCoApplicant(\d+)currentPincode$/
                          );
                          const coAppNum = match ? match[1] : undefined;
                          if (value && value.length === 6) {
                            handleInvokZipCode(value, coAppNum, 'current');
                          }
                          // Only update permanent pincode if the 'same as' checkbox is checked
                          // if (coAppNum) {
                          //   const sameAsKey = `addressCoApplicant${coAppNum}currentsameAsPermanent`;
                          //   const isSameAs =
                          //     formikRef?.current?.values?.[sameAsKey];
                          //   if (isSameAs) {
                          //     formikRef?.current?.setFieldValue(
                          //       `addressCoApplicant${coAppNum}permanentPincode`,
                          //       value,
                          //       false
                          //     );
                          //     // Also clear city, state, and country when pincode changes
                          //     formikRef?.current?.setFieldValue(
                          //       `addressCoApplicant${coAppNum}permanentCity`,
                          //       "",
                          //       false
                          //     );
                          //     formikRef?.current?.setFieldValue(
                          //       `addressCoApplicant${coAppNum}permanentState`,
                          //       "",
                          //       false
                          //     );
                          //     formikRef?.current?.setFieldValue(
                          //       `addressCoApplicant${coAppNum}permanentCountry`,
                          //       "",
                          //       false
                          //     );
                          //   }
                          // }
                        }
                        // For co-applicant employment/company pincode
                        else if (
                          /^employmentCoApplicant\d+pincode$/i.test(
                            field.name
                          )
                        ) {
                          const match = field.name.match(
                            /^employmentCoApplicant(\d+)pincode$/i
                          );
                          const coAppNum = match ? match[1] : undefined;
                          if (value && String(value).length === 6) {
                            handleInvokZipCode(value, coAppNum, 'employment');
                          }
                        }
                        // For reference address pincode
                        else if (
                          /^addressReference(\d+)Pincode$/i.test(field.name)
                        ) {
                          const match = field.name.match(
                            /^addressReference(\d+)Pincode$/i
                          );
                          const referenceNum = match ? match[1] : undefined;
                          if (value && value.length === 6) {
                            handleInvokZipCode(
                              value,
                              undefined,
                              referenceNum
                                ? `reference${referenceNum}`
                                : undefined
                            );
                          }
                        }
                        else if (/^collateral(\d*)Pincode$/i.test(field.name)) {
                          const match = field.name.match(/^collateral(\d*)Pincode$/i);
                          const collateralNum = match ? match[1] || "1" : undefined;
                          if (value && value.length === 6 && collateralNum) {
                            handleInvokZipCode(
                              value,
                              undefined,
                              `collateral${collateralNum}`
                            );
                          }
                        }
                        if (field.name === 'employmentCompanyPincode') {
                          handleInvokCompanyZipCode(value);
                        }
                        handleFilledFieldsCount(field.name, value);

                        if (
                          activeHorizontalIndex === 1 &&
                          activeVerticalIndex === 5
                        ) {
                          // Persist all form values to Redux for refresh survival
                          if (formikRef?.current?.values) {
                            dispatch(
                              updateFormData({
                                [field.name]: value,
                              })
                            );
                          }
                        }
                        // setting empty data on input changes
                        if (
                          field.name === 'fatherName' ||
                          field.name === 'motherName'
                        ) {
                          dispatch(
                            setVerificationMessage({
                              index: '',
                              applicantType: '',
                              field: '',
                              status: '',
                              message: '',
                            })
                          );
                        }
                      }}
                      InputProps={{
                        readOnly: pinOrDerivedLock,
                        endAdornment:
                          (field.name === 'permanentPincode' ||
                            field.name === 'employmentCompanyPincode' ||
                            /^addressCoApplicant\d+permanentPincode$/.test(
                              field.name
                            ) ||
                            /^addressCoApplicant\d+currentPincode$/.test(
                              field.name
                            ) ||
                            /^collateral\d*Pincode$/i.test(field.name) ||
                            /^employmentCoApplicant\d+pincode$/i.test(
                              field.name
                            )) &&
                          zipCodeLoading ? (
                            <CircularProgress size={20} />
                          ) : undefined,
                      }}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "phone":
        // Co-applicant phone field check
        const coApplicantPhoneMatch = field.name.match(
          /^basicCoApplicant(\d+)PhoneNumber$/
        );
	        const isReferencePhoneField = /^basicReference\d+PhoneNumber$/i.test(
	          field.name
	        );
	        const validateReferenceMobileFields = (form: any) => {
	          if (!isReferencePhoneField) return;
	          ["basicReference1PhoneNumber", "basicReference2PhoneNumber"].forEach(
	            (name) => {
	              form.setFieldTouched(name, true, false);
	              form.validateField(name);
	            }
	          );
	        };
        const isCollateralPhoneField = /^coOwnerCollateral(?:\d+(?:_?\d+)?)?PhoneNumber$/i.test(
          field.name
        );
        const isInvalidReferenceCollateralPhone = (value: any) =>
          (isReferencePhoneField || isCollateralPhoneField) &&
          /^00/.test(String(value || "").replace(/\D/g, ""));
        const disableApplicantMobileField =
          !coApplicantPhoneMatch &&
          !isReferencePhoneField &&
          !isCollateralPhoneField &&
          (field.name === "phone_number" ||
            field.name === "studentDetailsPhone_number") &&
          ((activeHorizontalIndex === 0 && activeVerticalIndex === 0) ||
            (activeHorizontalIndex === 1 && activeVerticalIndex === 0));
        let isMobileVerifiedField = false;
        let lastVerifiedMobile = "";
        if (coApplicantPhoneMatch) {
          const idx = String(Number(coApplicantPhoneMatch[1]) - 1); // 0-based index
          const formikMobileVerified =
            formikRef.current?.values[
            `basicCoApplicant${Number(idx) + 1}IsMobileVerified`
            ];
          const reduxMobileVerified =
            coApplicantVerification[idx]?.mobileVerified;
          const lastMobile =
            coApplicantVerification[idx]?.lastVerifiedMobileNumber ||
            formikRef.current?.values[field.name];
          isMobileVerifiedField =
            (formikMobileVerified || reduxMobileVerified) &&
            formikRef.current?.values[field.name] === lastMobile;
          lastVerifiedMobile = lastMobile;
        } else {
          const applicantMobileVerifiedFlag =
            isMobileVerified === true ||
            isMobileVerified === "true" ||
            formData?.isMobileVerified === true ||
            formData?.isMobileVerified === "true" ||
            formikRef.current?.values?.isMobileVerified === true ||
            formikRef.current?.values?.isMobileVerified === "true";
          const hasLastVerifiedMobile = Boolean(lastVerifiedPhoneNumber);
          const currentMobileValue = formikRef.current?.values[field.name];
          isMobileVerifiedField =
            applicantMobileVerifiedFlag &&
            (
              !hasLastVerifiedMobile ||
              currentMobileValue === lastVerifiedPhoneNumber ||
              pageType === "SUMMARY"
            );
          lastVerifiedMobile = lastVerifiedPhoneNumber;
        }

        // Get all phone field names
        const allPhoneFields = Object.keys(
          formikRef.current?.values || {}
        ).filter(
          (key) =>
            key === "phone_number" ||
            key.match(/^basicCoApplicant\d+PhoneNumber$/)
        );
        // Check for duplicate phone
        const currentPhoneValue = formikRef.current?.values[field.name];
        const invalidReferenceCollateralPhone =
          isInvalidReferenceCollateralPhone(currentPhoneValue);
        // Allow main applicant and student details to match
        const allowedPhonePairs = [
          ["phone_number", "studentDetailsPhone_number"],
          ["studentDetailsPhone_number", "phone_number"],
        ];
        const duplicatePhone = isCollateralPhoneField
          ? false
          : allPhoneFields
              .filter((key) => key !== field.name)
              .filter((key) => {
                // If current field and key are allowed pair, skip duplicate check
                return !allowedPhonePairs.some(
                  ([a, b]) =>
                    (field.name === a && key === b) ||
                    (field.name === b && key === a)
                );
              })
              .map((key) => formikRef.current?.values[key])
              .includes(currentPhoneValue);
        return (
          <Grid
            item
            xs={12}
             sm={smForSummaryEligibility(
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                  ? 12
                  : pageType === "SUMMARY" ? 3 : 6
            )}
            key={field.id}
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <label className="text-lable" style={{ display: "block" }}>
                  {field.label}{" "}
                  {field.required && <span style={{ color: "red" }}>*</span>}
                </label>
                {/* {field.label && /(mobile|phone|contact)/i.test(field.label) ? (
                  <Tooltip
                    title={MobileNumberTooltipContent}
                    placement="top-start"
                    arrow
                  >
                    <IconButtonMui
                      size="small"
                      sx={{
                        ml: "5px",
                        padding: 0,
                        "&:hover": {
                          background: "transparent",
                        },
                      }}
                      aria-label="Salesperson contact details"
                    >
                      <InfoOutlinedIcon
                        sx={{
                          fontSize: "14px",
                          color: "#a5a3ae",
                          cursor: "pointer",
                        }}
                      />
                    </IconButtonMui>
                  </Tooltip>
                ) : (
                  <></>
                )} */}
              </Box>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    disabled={
                      field?.disabled ||
                      isCoApplicantFieldLockedByCoOwner(coOwnerLockSavedValues, field.name) ||
                      false
                    }
                    // type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder={
                      field.placeholder ||
                      (isReferencePhoneField
                        ? "Enter Reference Mobile Number"
                        : isXsOrSm
                          ? "Enter Aadhaar Linked Mobile Number..."
                          : "Enter Aadhaar Linked Mobile Number and Verify")
                    }
                    variant="outlined"
                    error={
                      (!!meta.touched && !!meta.error) ||
                      (duplicatePhone && !!currentPhoneValue) ||
                      invalidReferenceCollateralPhone
                    }
                    helperText={
                      meta.touched && meta.error
                        ? meta.error
                        : invalidReferenceCollateralPhone
                          ? "Invalid mobile number."
                        : duplicatePhone && !!currentPhoneValue
                          ? "This mobile number is already used in another field."
                          : ""
                    }
                    autoComplete="new-password"
                    // disabled={
                    //   isApiLoading ||
                    //   (isAuthenticated &&
                    //     ((activeHorizontalIndex === 1 &&
                    //       activeVerticalIndex === 0) ||
                    //       (activeHorizontalIndex === 0 &&
                    //         activeVerticalIndex === 0 &&
                    //         !!f.value &&
                    //         (formData?.isMobileVerified ||
                    //           formikRef?.current?.values?.isMobileVerified))))
                    // }
                    onKeyDown={(e) => {
                      // Block leading space: allow spaces only after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        const start = target.selectionStart ?? 0;
                        if (start === 0) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      f.onChange(e);

                      const rawValue = e.target.value;
                      const numericValue = rawValue.replace(/\D/g, "");
	                      if (isInvalidReferenceCollateralPhone(numericValue)) {
	                        form.setFieldTouched(field.name, true, false);
	                        form.setFieldError(field.name, "Invalid mobile number.");
	                      } else if (meta.error === "Invalid mobile number.") {
	                        form.setFieldError(field.name, undefined);
	                      }
	                      clearFieldErrorWhenFilled(form, field.name, numericValue);
	                      if (isReferencePhoneField) {
	                        form.setFieldTouched(field.name, true, false);
	                        form.setFieldValue(field.name, numericValue, false);
	                        setTimeout(() => {
	                          validateReferenceMobileFields(form);
	                        }, 0);
	                      }

	                      const isValidMobile = numericValue.length === 10;

                      // Always reset verification if not a valid 10-digit number
                      if (
                        !isValidMobile ||
                        numericValue !== lastVerifiedMobile
                      ) {
                        if (coApplicantPhoneMatch) {
                          const idx = String(
                            Number(coApplicantPhoneMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: { mobileVerified: false },
                            })
                          );
                        } else if (!isReferencePhoneField && !isCollateralPhoneField) {
                          dispatch(setIsMobileVerified(false));
                        }
                      }

                      // Only set verified = true when it exactly matches last verified number
                      if (
                        isValidMobile &&
                        numericValue === lastVerifiedMobile
                      ) {
                        if (coApplicantPhoneMatch) {
                          const idx = String(
                            Number(coApplicantPhoneMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: { mobileVerified: true },
                            })
                          );
                        } else if (!isReferencePhoneField && !isCollateralPhoneField) {
                          dispatch(setIsMobileVerified(true));
                        }
                      }
                    }}
                    onInput={(e: any) => {
                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                      if (isInvalidReferenceCollateralPhone(e.target.value)) {
                        form.setFieldTouched(field.name, true, false);
                        form.setFieldError(field.name, "Invalid mobile number.");
                      } else if (meta.error === "Invalid mobile number.") {
                        form.setFieldError(field.name, undefined);
                      }
                      clearFieldErrorWhenFilled(form, field.name, e.target.value);
                      handleFilledFieldsCount(field.name, e.target.value);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: e.target.value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: e.target.value,
                            })
                          );
                        }
                      }
                    }}
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                      readOnly: disableApplicantMobileField || isApiLoading || (
                        isAuthenticated && (
                          (activeHorizontalIndex === 1 && activeVerticalIndex === 0) ||
                          (activeHorizontalIndex === 0 && activeVerticalIndex === 0 && !!f.value && (formData?.isMobileVerified || formikRef?.current?.values?.isMobileVerified)
                          )
                        )
                      ) || (!!coApplicantPhoneMatch && isMobileVerifiedField),
                      autoComplete: "off",
                      endAdornment: coApplicantPhoneMatch || isReferencePhoneField || isCollateralPhoneField ? undefined : disableApplicantMobileField ? (
                        <InputAdornment position="end">
                          {isMobileVerifiedField ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                color: "#28c76f",
                                fontSize: "12px",
                                fontWeight: 500,
                                mr: 0.5,
                              }}
                            >
                              <img
                                src={greenCheckVerified}
                                alt="Verified"
                                style={{
                                  width: 14,
                                  height: 14,
                                  objectFit: "contain",
                                  imageRendering: "-webkit-optimize-contrast",
                                }}
                              />
                              Verified
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mr: 0.5,
                                px: 1,
                                py: 0.35,
                                borderRadius: "4px",
                                bgcolor: "rgba(255, 159, 67, 0.14)",
                                border: "1px solid rgba(255, 159, 67, 0.45)",
                              }}
                            >
                              <Typography
                                component="span"
                                sx={{
                                  color: "#ff9f43",
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  lineHeight: 1.2,
                                }}
                              >
                                Not Verified
                              </Typography>
                            </Box>
                          )}
                        </InputAdornment>
                      ) : (
                        <Button
                          onClick={isApiLoading || (
                            isAuthenticated && (
                              (activeHorizontalIndex === 1 && activeVerticalIndex === 0 && ((formData?.isMobileVerified === "true" || formData?.isMobileVerified === true) || (formikRef?.current?.values?.isMobileVerified === "true" || formikRef?.current?.values?.isMobileVerified === true))) ||
                              (activeHorizontalIndex === 0 && activeVerticalIndex === 0 && !!f.value && ((formData?.isMobileVerified === "true" || formData?.isMobileVerified === true) || (formikRef?.current?.values?.isMobileVerified === "true" || formikRef?.current?.values?.isMobileVerified === true))
                              )
                            )
                          ) ? undefined : async () => {
                            if (
                              isMobileVerifiedField ||
                              duplicatePhone ||
                              !currentPhoneValue
                            )
                              return;
                            try {
                              let name = `${form?.values?.studentDetailsFirstName || form?.values?.firstName || ""} ${form?.values?.studentDetailsLastName || form?.values?.lastName || ""}`.trim();
                              // applicant name
                              const mobileNumber = form.values[field.name];
                              setOtpMobileNumber(mobileNumber);
                              setOtpMobileFieldName(field.name);

                              const coApplicantPhoneMatch = field.name.match(
                                /^basicCoApplicant(\d+)PhoneNumber$/
                              );
                              if (coApplicantPhoneMatch) {
                                dispatch(
                                  setCurrentCoApplicantIdx(
                                    String(Number(coApplicantPhoneMatch[1]) - 1)
                                  )
                                );

                                // this will only work for coapplicant
                                const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantPhoneMatch[1]))}FirstName`;
                                if (form.values[dynamicNameKey]) {
                                  name = form.values[dynamicNameKey];   // co-applicant name
                                }
                              } else {
                                dispatch(setCurrentCoApplicantIdx(null));
                              }

                              const resp =
                                await eligibilityCheckServices.sendOtp({
                                  name,
                                  mobileNumber,
                                });

                              // trackCustomerJourneyEvent(
                              //   `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //   decrypt(userProfile?.id) ?? "",
                              //   trackingId,
                              //   {
                              //       label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //     category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //     action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${String(Number(coApplicantPhoneMatch[1]))}BASIC_MOBILEVERI_PAGE10`,
                              //     page: `ProvisionalOff_Loan Details_COAPP(${String(Number(coApplicantPhoneMatch[1]))}) Mobile Verification`,
                              //   }
                              // );

                              if (resp?.data?.status === "fail") {
                                dispatch(
                                  setStatusPopup({
                                    status: "error",
                                    message: resp.data.message,
                                  })
                                );
                                return;
                              }
                              setOtpKey(resp.data.data.value);
                              setOtpTime(resp.data.data.otpTime);
                              setOpenOtpModal(true);
                            } catch (err: any) {
                              const apiMsg =
                                err?.response?.data?.errors?.[0]?.constraints
                                  ?.matches;
                              dispatch(
                                setStatusPopup({
                                  status: "info",
                                  message: apiMsg,
                                })
                              );
                            }
                          }}
                          disabled={duplicatePhone || !currentPhoneValue}
                          sx={{
                            backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                            color: isMobileVerifiedField ? "#28C76F" : "#000000",
                            "&:hover": {
                              backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                              color: isMobileVerifiedField ? "#28C76F" : "#000000",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: isMobileVerifiedField ? "transparent" : "#FEC10D",
                              color: isMobileVerifiedField ? "#28C76F" : "#000000",
                              WebkitTextFillColor: isMobileVerifiedField ? "#28C76F" : "#000000",
                              opacity: 1,
                            },
                            "& img": {
                              opacity: 1,
                              filter: "brightness(1)",
                            },
                            textTransform: "none",
                            fontSize: isMobileVerifiedField ? "16px" : "10px",
                            fontWeight: isMobileVerifiedField ? 400 : 700,
                            px: "15px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "none",
                            height: '100%',
                            mr: 0.5,
                          }}
                        >
                          {isMobileVerifiedField ? (
                            <>
                              <img
                                src={greenCheckVerified}
                                alt="Verified"
                                style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                              />
                              <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="inherit">Verify</Typography>
                              <img
                                src={arrowRightVerify}
                                alt="Verified"
                                style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                              />
                            </>
                          )}
                        </Button>
                      ),
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "email":
        // Co-applicant email field check
        const coApplicantEmailMatch = field.name.match(
          /^basicCoApplicant(\d+)Email$/
        );
	        const isReferenceEmailField = /^basicReference\d+Email$/i.test(
	          field.name
	        );
	        const validateReferenceEmailFields = (form: any) => {
	          if (!isReferenceEmailField) return;
	          ["basicReference1Email", "basicReference2Email"].forEach((name) => {
	            form.setFieldTouched(name, true, false);
	            form.validateField(name);
	          });
	        };
        const isApplicantStudentEmailField =
          field.name === "email" || field.name === "studentDetailEmail";
        /** Applicant email is not editable on Eligibility consent (0,0) or Student Details (1,0). */
        const disableApplicantEmailField =
          isApplicantStudentEmailField &&
          ((activeHorizontalIndex === 0 && activeVerticalIndex === 0) ||
            (activeHorizontalIndex === 1 && activeVerticalIndex === 0));
        const applicantDisplayEmailNorm = isApplicantStudentEmailField
          ? String(
              formikRef.current?.values?.studentDetailEmail ||
                formikRef.current?.values?.email ||
                ""
            )
              .trim()
              .toLowerCase()
          : "";
        const explicitApplicantEmailFlag = [
          formikRef.current?.values?.isEmailVerified,
          formData?.isEmailVerified,
        ].find(hasNonEmptyFormValue);
        const applicantEmailVerifiedFlags = hasNonEmptyFormValue(
          explicitApplicantEmailFlag
        )
          ? isTruthyFormFlag(explicitApplicantEmailFlag)
          : isTruthyFormFlag(isEmailVerified) ||
            isTruthyFormFlag((formData as any)?.emailAddressVerifiedFlag);
        const applicantLastEmailNorm = String(
          lastVerifiedEmail || (applicantEmailVerifiedFlags ? applicantDisplayEmailNorm : "")
        )
          .trim()
          .toLowerCase();
        const applicantEmailVerifiedFlag = Boolean(
          isApplicantStudentEmailField &&
            !!applicantDisplayEmailNorm &&
            !!applicantLastEmailNorm &&
            applicantDisplayEmailNorm === applicantLastEmailNorm &&
            applicantEmailVerifiedFlags
        );
        let isVerified = false;
        let lastVerified = "";
        if (coApplicantEmailMatch) {
          const idx = String(Number(coApplicantEmailMatch[1]) - 1); // 0-based index
          const formikEmailVerified = isTruthyFormFlag(
            formikRef.current?.values[
              `basicCoApplicant${Number(idx) + 1}IsEmailVerified`
            ]
          );
          const reduxEmailVerified = isTruthyFormFlag(
            coApplicantVerification[idx]?.emailVerified
          );
          const lastEmail = coApplicantVerification[idx]?.lastVerifiedEmail || "";
          isVerified =
            !!lastEmail &&
            (formikEmailVerified || reduxEmailVerified) &&
            String(formikRef.current?.values[field.name] || "").trim().toLowerCase() ===
              String(lastEmail || "").trim().toLowerCase();
          lastVerified = lastEmail;
        } else {
          isVerified = applicantEmailVerifiedFlag;
          lastVerified = lastVerifiedEmail || "";
        }

        // Check duplicate email only between applicant and co-applicant 1
        const currentEmailValue = formikRef.current?.values[field.name];
        // No OTP for an invalid email (e.g. containing + or -)
        const isCurrentEmailInvalid = !isValidJourneyEmail(currentEmailValue);
        const normalizedCurrentEmail = String(currentEmailValue || "")
          .trim()
          .toLowerCase();
        const normalizeEmail = (value: any) =>
          String(value || "")
            .trim()
            .toLowerCase();
        const applicantEmail = normalizeEmail(formikRef.current?.values?.email);
        const coApplicant1Email = normalizeEmail(
          formikRef.current?.values?.basicCoApplicant1Email
        );
        const isApplicantOrCoApplicant1 =
          field.name === "email" || field.name === "basicCoApplicant1Email";
        const isCoApplicant2Onward = /^basicCoApplicant([2-9]\d*)Email$/.test(
          field.name
        );

        let duplicateEmail = false;
        if (!!normalizedCurrentEmail) {
          if (isApplicantOrCoApplicant1) {
            duplicateEmail =
              normalizedCurrentEmail ===
              normalizeEmail(
                formikRef.current?.values[
                field.name === "email" ? "basicCoApplicant1Email" : "email"
                ]
              );
          } else if (isCoApplicant2Onward) {
            duplicateEmail =
              normalizedCurrentEmail === applicantEmail ||
              normalizedCurrentEmail === coApplicant1Email;
          }
        }

        return (
          <Grid
            item
            xs={12}
             sm={smForSummaryEligibility(
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                  ? 12
                  : pageType === "SUMMARY" ? 3 : 6
            )}
            key={field.id}
          >
            <Box>
              <label className="text-lable" style={{ display: "block" }}>
                {field.label}{" "}
                {field.required && <span style={{ color: "red" }}>*</span>}
              </label>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => (
                  <InputField
                    {...f}
                    fullWidth
                    placeholder={
                      field.placeholder || "Enter Email ID and verify"
                    }
                    variant="outlined"
                    inputmode="text"
                    error={
                      ((!!f.value || !!meta.touched) && !!meta.error) ||
                      (duplicateEmail && !!currentEmailValue)
                    }
                    helperText={
                      ((!!f.value || !!meta.touched) && meta.error)
                        ? meta.error
                        : duplicateEmail && !!currentEmailValue
                          ? "This email is already used in another field."
                          : ""
                    }
                    autoComplete="new-password"
                    onKeyDown={(e) => {
                      if (disableApplicantEmailField) {
                        e.preventDefault();
                        return;
                      }
                      // Block leading space: allow spaces only after first character
                      if (e.key === " ") {
                        const target = e.target as HTMLInputElement;
                        const start = target.selectionStart ?? 0;
                        if (start === 0) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      if (disableApplicantEmailField) {
                        return;
                      }
                      const inputValue = e.target.value;

                      // Keep Formik values in sync between applicant email fields
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        form.setFieldValue("email", inputValue, false);
                        form.setFieldValue("studentDetailEmail", inputValue, false);
                      } else {
                        f.onChange(e);
	                      }
	                      clearFieldErrorWhenFilled(form, field.name, inputValue);
	                      if (isReferenceEmailField) {
	                        form.setFieldTouched(field.name, true, false);
	                        setTimeout(() => {
	                          validateReferenceEmailFields(form);
	                        }, 0);
	                      }

	                      // Keep Redux formData in sync with latest typed email
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        dispatch(
                          updateFormData({
                            email: inputValue,
                            studentDetailEmail: inputValue,
                          })
                        );
                      } else {
                        dispatch(
                          updateFormData({
                            [field.name]: inputValue,
                          })
                        );
                      }

                      const normalizedInputEmail = String(inputValue || "")
                        .trim()
                        .toLowerCase();
                      const normalizedLastVerifiedEmail = String(lastVerified || "")
                        .trim()
                        .toLowerCase();

                      // Reset verification if value changes or the email is cleared
                      if (
                        normalizedInputEmail !== normalizedLastVerifiedEmail ||
                        !normalizedInputEmail
                      ) {
                        if (coApplicantEmailMatch) {
                          const idx = String(
                            Number(coApplicantEmailMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: {
                                emailVerified: false,
                              },
                            })
                          );
                        } else {
                          if (!isReferenceEmailField) {
                            dispatch(setIsEmailVerified(false));
                          }
                        }
                      } else {
                        if (coApplicantEmailMatch) {
                          const idx = String(
                            Number(coApplicantEmailMatch[1]) - 1
                          );
                          dispatch(
                            setCoApplicantVerification({
                              index: idx,
                              data: {
                                emailVerified: true,
                              },
                            })
                          );
                        } else {
                          if (!isReferenceEmailField) {
                            dispatch(
                              setIsEmailVerified(
                                  normalizedInputEmail === normalizedLastVerifiedEmail &&
                                  normalizedInputEmail !== "" &&
                                  isTruthyFormFlag(isEmailVerified)
                              )
                            );
                          }
                        }
                      }
                    }}
                    onInput={(e: any) => {
                      if (disableApplicantEmailField) {
                        return;
                      }
                      // Trim leading spaces from pasted/typed input but allow internal spaces
                      if (
                        typeof e.target.value === "string" &&
                        /^\s/.test(e.target.value)
                      ) {
                        e.target.value = e.target.value.replace(/^\s+/, "");
                      }
                      if (field.name === "email" || field.name === "studentDetailEmail") {
                        dispatch(
                          updateFormData({
                            email: e.target.value,
                            studentDetailEmail: e.target.value,
                          })
                        );
                      }
                      handleFilledFieldsCount(field.name, e.target.value);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: e.target.value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: e.target.value,
                            })
                          );
                        }
                      }
                    }}
                    // disabled={
                    //   isApiLoading ||
                    //   (isAuthenticated &&
                    //     ((activeHorizontalIndex === 1 &&
                    //       activeVerticalIndex === 0) ||
                    //       (activeHorizontalIndex === 0 &&
                    //         activeVerticalIndex === 0 &&
                    //         !!f.value &&
                    //         (formData?.isEmailVerified ||
                    //           formikRef?.current?.values?.isEmailVerified))))
                    // }
                    inputProps={{ autoComplete: "off", maxLength: 40 }}
                    InputProps={{
                      readOnly:
                        disableApplicantEmailField ||
                        isApiLoading ||
                        ((field.name === "email" || field.name === "studentDetailEmail") && applicantEmailVerifiedFlag) ||
                        (() => {
                          if (!coApplicantEmailMatch) return false;
                          // An empty email is never locked: the user must be able to fill it
                          if (!String(formikRef.current?.values?.[field.name] || "").trim()) return false;
                          const idx = Number(coApplicantEmailMatch[1]) - 1;
                          const emailVerifiedFlag =
                            isTruthyFormFlag(
                              formikRef.current?.values?.[
                                `basicCoApplicant${idx + 1}IsEmailVerified`
                              ]
                            ) ||
                            Boolean(coApplicantVerification[idx]?.emailVerified);
                          if (!emailVerifiedFlag) return false;
                          const lastEmail =
                            coApplicantVerification[idx]?.lastVerifiedEmail ||
                            formikRef.current?.values?.[field.name] ||
                            "";
                          return (
                            String(formikRef.current?.values?.[field.name] || "")
                              .trim()
                              .toLowerCase() ===
                            String(lastEmail || "").trim().toLowerCase()
                          );
                        })(),
                      endAdornment: (
                        coApplicantEmailMatch || isReferenceEmailField
                          ? null
                          : disableApplicantEmailField ? (
                            <InputAdornment position="end">
                              {isVerified ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    color: "#28c76f",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    mr: 0.5,
                                  }}
                                >
                                  <img
                                    src={greenCheckVerified}
                                    alt="Verified"
                                    style={{
                                      width: 14,
                                      height: 14,
                                      objectFit: "contain",
                                      imageRendering: "-webkit-optimize-contrast",
                                    }}
                                  />
                                  Verified
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mr: 0.5,
                                    px: 1,
                                    py: 0.35,
                                    borderRadius: "4px",
                                    bgcolor: "rgba(255, 159, 67, 0.14)",
                                    border: "1px solid rgba(255, 159, 67, 0.45)",
                                  }}
                                >
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: "#ff9f43",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    Not Verified
                                  </Typography>
                                </Box>
                              )}
                            </InputAdornment>
                          ) : (
                            <Button
                              sx={{
                                backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                color: isVerified ? "#28C76F" : "#000000",
                                "&:hover": {
                                  backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                  color: isVerified ? "#28C76F" : "#000000",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: isVerified ? "transparent" : "#FEC10D",
                                  color: isVerified ? "#28C76F" : "#000000",
                                  WebkitTextFillColor: isVerified ? "#28C76F" : "#000000",
                                  opacity: 1,
                                },
                                "& img": {
                                  opacity: 1,
                                  filter: "brightness(1)",
                                },
                                textTransform: "none",
                                fontSize: isVerified ? "16px" : "10px",
                                fontWeight: isVerified ? 400 : 700,
                                px: "15px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "none",
                                height: "100%",
                                mr: 0.5,
                              }}
                              onClick={isApiLoading ? undefined : async () => {
                                if (
                                  isVerified ||
                                  duplicateEmail ||
                                  !currentEmailValue ||
                                  isCurrentEmailInvalid
                                )
                                  return;
                                try {
                                  let name = `${form?.values?.studentDetailsFirstName || form?.values?.firstName || ""} ${form?.values?.studentDetailsLastName || form?.values?.lastName || ""}`.trim();

                                  const email = form.values[field.name];
                                  setOtpEmail(email);
                                  setOtpEmailFieldName(field.name);

                                  const coApplicantEmailMatch = field.name.match(
                                    /^basicCoApplicant(\d+)Email$/
                                  );
                                  if (coApplicantEmailMatch) {
                                    dispatch(
                                      setCurrentCoApplicantIdx(
                                        String(Number(coApplicantEmailMatch[1]) - 1)
                                      )
                                    );

                                    // this will only work for coapplicant
                                    const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantEmailMatch[1]))}FirstName`;
                                    if (form.values[dynamicNameKey]) {
                                      name = form.values[dynamicNameKey];   // co-applicant name
                                    }
                                  } else {
                                    dispatch(setCurrentCoApplicantIdx(null));
                                  }

                                  const resp =
                                    await eligibilityCheckServices.sendOtp({
                                      name,
                                      email: email.toLowerCase(),
                                    });
                                  if (resp?.data?.status === "fail") {
                                    dispatch(
                                      setStatusPopup({
                                        status: "error",
                                        message: resp.data.message,
                                      })
                                    );
                                    return;
                                  }
                                  setOtpEmailKey(resp.data.data.value);
                                  setOtpEmailTime(resp.data.data.otpTime);
                                  setOpenEmailOtp(true);
                                } catch (err: any) {
                                  const apiMsg =
                                    err?.response?.data?.errors?.[0]?.constraints
                                      ?.isEmail;
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message: apiMsg,
                                    })
                                  );
                                }
                              }}
                              disabled={isVerified || duplicateEmail || !currentEmailValue || isCurrentEmailInvalid}
                            >
                              {isVerified ? (
                                <>
                                  <img
                                    src={greenCheckVerified}
                                    alt="Verified"
                                    style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                  />
                                  <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                </>
                              ) : (
                                <>
                                  <Typography variant="inherit">Verify</Typography>
                                  <img
                                    src={arrowRightVerify}
                                    alt="Verified"
                                    style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                  />
                                </>
                              )}
                            </Button>
                          )
                      ),
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "dropdown":
        if (field.name === "product") {
          return (
            <Grid
              item
              xs={12}
                sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3 ? 4 : pageType === "SUMMARY" ? 3 : 6
    )}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    useEffect(() => {
                      if (!f.value && productOptions.length > 0 && !loadingProducts) {
                        const defaultValue = productOptions[0].value;
                        form.setFieldValue(field.name, defaultValue);
                        dispatch(setSelectedProduct(defaultValue));
                        handleFilledFieldsCount(field.name, defaultValue);
                      }
                    }, [productOptions, loadingProducts, f.value]);

                    return (
                      <SelectOptions
                        label={field.label}
                        value={f.value}
                        onChange={(value: any) => {
                          form.setFieldValue(field.name, value);
                          dispatch(setSelectedProduct(value));
                          handleFilledFieldsCount(field.name, value);
                        }}
                        options={productOptions}
                        placeholder={field.label}
                        isMandatory={field.required || false}
                        disabled={loadingProducts || pageType === "SUMMARY"}
                        error={form.errors[field.name] ? true : false}
                        helperText={form.errors[field.name] || ""}
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }

        if (field.name === "courseCategory") {
          return (
            <Grid
              item
              xs={12}
                sm={smForSummaryEligibility(
                activeHorizontalIndex === 1 && activeVerticalIndex === 3 ? 4 : pageType === "SUMMARY" ? 3 : 6
              )}              
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    const options = getDropdownOptions(field);

                    useEffect(() => {
                      // Only set default if value is empty and options are available
                      if (!f.value && options.length > 0 && !loadingProducts) {
                        const defaultValue = options[0].value;
                        form.setFieldValue(field.name, defaultValue);

                        // Ensure Redux and trackers are updated on initial mount
                        dispatch(updateFormData({ [field.name]: defaultValue }));
                        handleFilledFieldsCount(field.name, defaultValue);
                      }
                    }, [options, loadingProducts, f.value]);

                    // Normalize value: extract .value if it's an object, otherwise use as-is
                    const normalizedValue =
                      (typeof f.value === "object" && f.value !== null && "value" in f.value)
                        ? f.value.value
                        : f.value;

                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          // Normalize incoming value for storage
                          const valToStore = (typeof value === "object" && value !== null && "value" in value)
                            ? value.value
                            : value;

                          form.setFieldValue(field.name, valToStore);

                          // Standard handlers
                          handleDropdownChange(field.name, value, form);
                          handleFilledFieldsCount(field.name, valToStore);

                          // Persist to Redux for refresh survival
                          dispatch(
                            updateFormData({
                              [field.name]: valToStore,
                            })
                          );
                        }}
                        options={options}
                        placeholder={`Select ${field.label}`}
                        isMandatory={field.required || false}
                        disabled={loadingProducts}
                        error={!!form.errors[field.name]}
                        helperText={form.errors[field.name] || ""}
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }

        return (
          <>
            <Grid
              item
              xs={12}
                sm={smForSummaryEligibility(
                (activeHorizontalIndex === 1 && activeVerticalIndex === 5) ||
                  (activeHorizontalIndex === 1 && activeVerticalIndex === 4) ||
                  ((activeHorizontalIndex === 1 &&
                    activeVerticalIndex === 3 &&
                    !isAcademicDetailsCourseField))
                  ? 12
                  : isAcademicDetailsCourseField
                    ? 3
                    : pageType === "SUMMARY"
                      ? 3
                      : 6
              )}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    let options = getDropdownOptions(field);
                    if (isCollateralScalarDropdownField(field.name)) {
                      options = (options || []).map((option: any) => ({
                        ...option,
                        value: normalizeDropdownScalarValue(option?.value),
                        label:
                          typeof option?.label === "string"
                            ? option.label.replace(/^"+|"+$/g, "")
                            : option?.label,
                      }));
                    }

                    // Restrict duplicate course types
                    const keyItem: any = field.name.match(
                      /^basicCoApplicant(\d+)RelationWithStudent$/
                    );

                    if (field.name.includes(keyItem?.[0])) {
                      options = relationshipOptions;
                    }

                    // Populate applicant + co-applicant names for coOwnerCollateral Name fields
                    if (isCoOwnerCollateralNameField(field.name)) {
                      const fv = { ...(formData || {}), ...(form.values || {}) };
                      const mainFirst = fv?.firstName || fv?.studentDetailsFirstName || "";
                      const mainLast = fv?.lastName || fv?.studentDetailsLastName || "";
                      const mainName = [mainFirst, mainLast].filter(Boolean).join(" ");
                      const mainPhone =
                        fv?.phone_number || fv?.studentDetailsPhone_number || "";
                      const nameOptions: Array<{
                        value: string;
                        label: string;
                        phoneNumber?: string;
                      }> = [];
                      if (mainName)
                        nameOptions.push({
                          value: mainName,
                          label: mainName,
                          phoneNumber: mainPhone,
                        });
                      for (let ci = 1; ci <= 10; ci++) {
                        const coFirst = fv?.[`basicCoApplicant${ci}FirstName`];
                        if (!coFirst) continue;
                        const coLast = fv?.[`basicCoApplicant${ci}LastName`] || "";
                        const coName = [coFirst, coLast].filter(Boolean).join(" ");
                        const coPhone =
                          fv?.[`basicCoApplicant${ci}PhoneNumber`] ||
                          fv?.[`basicCoApplicant${ci}Phone_number`] ||
                          fv?.[`basicCoApplicant${ci}Phone`] ||
                          fv?.[`coApplicant${ci}Phone_number`] ||
                          "";
                        nameOptions.push({
                          value: coName,
                          label: coName,
                          phoneNumber: coPhone,
                        });
                      }
                      const currentValue = normalizeSelectionValue(f.value);
                      const currentCollateralNumber = getCollateralFieldNumber(field.name);
                      const selectedCoOwnerNames = (fields || [])
                        .map((coOwnerField: any) => coOwnerField?.name)
                        .filter(
                          (fieldName: string) =>
                            isCoOwnerCollateralNameField(fieldName) &&
                            getCollateralFieldNumber(fieldName) === currentCollateralNumber &&
                            fieldName !== field.name
                        )
                        .map((fieldName: string) =>
                          normalizeSelectionValue(fv?.[fieldName])
                        )
                        .filter(Boolean);
                      options = nameOptions.filter((option) => {
                        const optionValue = normalizeSelectionValue(option.value);
                        return (
                          optionValue === currentValue ||
                          !selectedCoOwnerNames.includes(optionValue)
                        );
                      });
                    }
                    // Filter out "Student" option from employmentType
                    if (field.name === "employmentType") {
                      options = options.filter(
                        (opt: any) => opt.value !== "Student"
                      );
                    }

                    if (
                      field.name.includes("course") &&
                      field.name.includes("Type")
                    ) {
                      // Derive selectedCourseTypes from form.values
                      const selectedCourseTypes = Object.keys(form.values)
                        .filter(
                          (key) => key.includes("course") && key.includes("Type")
                        )
                        .map((key) => form.values[key]?.value || form.values[key])
                        .filter(Boolean);

                      options = options.filter(
                        (opt: any) =>
                          !selectedCourseTypes.includes(opt.value) ||
                          opt.value === f.value?.value ||
                          opt.value === f.value
                      );

                      // 12th / Diploma / Graduation are not offered for Qualification 1 (10th)
                      // (kept only if already saved, so the existing value still shows)
                      if (field.name === "course1Type") {
                        const currentCourseType = f.value?.value || f.value;
                        options = options.filter(
                          (opt: any) =>
                            !["12th", "Diploma", "Graduation"].includes(opt.value) ||
                            opt.value === currentCourseType
                        );
                      }
                    }

                    // Restrict duplicate exam names within the same section (core vs language).
                    // Normalize stored values (string vs { value, label }) so filtering matches options.
                    if (
                      /^coreExamName(_\d+)?$/.test(field?.name ?? "") ||
                      /^languageExamName(_\d+)?$/.test(field?.name ?? "")
                    ) {
                      const normalizeExamNameVal = (val: any): string | null => {
                        if (val == null || val === "") return null;
                        if (
                          typeof val === "object" &&
                          val !== null &&
                          "value" in val
                        ) {
                          const v = (val as { value?: unknown }).value;
                          return v == null || v === "" ? null : String(v);
                        }
                        return String(val);
                      };

                      const isCoreExamNameField = /^coreExamName(_\d+)?$/.test(
                        field?.name ?? ""
                      );
                      const nameKeyPattern = isCoreExamNameField
                        ? /^coreExamName(_\d+)?$/
                        : /^languageExamName(_\d+)?$/;

                      const selectedExamNames: string[] = Object.keys(
                        form?.values ?? {}
                      )
                        .filter((key) => nameKeyPattern.test(key))
                        .map((key) => normalizeExamNameVal(form?.values?.[key]))
                        .filter((v): v is string => Boolean(v));

                      const currentVal = normalizeExamNameVal(f?.value);

                      options = options.filter((opt: any) => {
                        const optVal = String(opt?.value ?? "");
                        return (
                          !selectedExamNames.includes(optVal) ||
                          (currentVal != null && optVal === currentVal)
                        );
                      });
                    }

                    let normalizedValue = f.value;

                    if (
                      (field.name === "permanentAddressType" ||
                        /^addressCoApplicant\d+permanentAddressType$/.test(
                          field.name
                        )) &&
                      !f.value
                    ) {
                      normalizedValue = "Permanent Address";
                    }

                    if (
                      field.name === "currentAddressType" ||
                      /^addressCoApplicant\d+currentAddressType$/.test(field.name)
                    ) {
                      if (f.value !== "Current address") {
                        normalizedValue = "Current address";
                      }
                    }

                    // Default course type values are now handled in useEffect to ensure proper Redux storage

                    // Normalize value for simple dropdowns (like employmentType)
                    normalizedValue = normalizedValue ?? f.value;

                    if (isCollateralScalarDropdownField(field.name)) {
                      normalizedValue = normalizeDropdownScalarValue(f.value);
                    }

                    if (
                      field.name === "employmentType" &&
                      typeof f.value === "object" &&
                      f.value !== null &&
                      "value" in f.value
                    ) {
                      normalizedValue = f.value.value;
                    }

                    // Special handling for salutation fields
                    if (field.name.toLowerCase().includes("salutation")) {
                      // For salutation, f.value should contain the salutation code (value)
                      // If it's an object, extract the value, otherwise use as-is
                      if (
                        typeof f.value === "object" &&
                        f.value !== null &&
                        "value" in f.value
                      ) {
                        normalizedValue = f.value.value;
                      } else {
                        normalizedValue = f.value;
                      }
                    }

                    // Special handling for designation fields
                    if (field.name.toLowerCase().includes("designation")) {
                      // For designation, f.value should contain the designation code (value)
                      // If it's an object, extract the value, otherwise use as-is
                      if (
                        typeof f.value === "object" &&
                        f.value !== null &&
                        "value" in f.value
                      ) {
                        normalizedValue = f.value.value;
                      } else {
                        // Saved data reloads the full name — select by its code
                        normalizedValue =
                          (dropdownData?.designations || []).find(
                            (opt: any) => opt.label === f.value
                          )?.value ?? f.value;
                      }
                    }

                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          // For employmentCompanyCountry, set value with validation, then clear error and validate
                          if (field.name === "employmentCompanyCountry") {
                            form.setFieldValue(field.name, value, true); // validate = true
                            handleFilledFieldsCount(field.name, value);
                            form.setFieldTouched(field.name, true, false);
                            form.setFieldError(field.name, undefined);
                            form.validateField(field.name);
                          } else if (field.name === "employmentType") {
                            // Always store as string for employmentType
                            const normalizedEmploymentType =
                              typeof value === "object" &&
                                value !== null &&
                                "value" in value
                                ? (value as any).value
                                : value;

                            form.setFieldValue(field.name, normalizedEmploymentType);
                            handleFilledFieldsCount(field.name, normalizedEmploymentType);

                            // If employmentType is Others, clear other employment-related fields
                            // But preserve monthlyIncome and monthlyObligation
                            if (normalizedEmploymentType === "Others") {
                              const employmentFieldNamesToClear = fields
                                .filter(
                                  (f: any) =>
                                    (f.name?.toLowerCase().startsWith("employment") ||
                                      f.name?.toLowerCase().startsWith("employmentcompany")) &&
                                    f.name !== "employmentType" &&
                                    f.name !== "employmentisEmployed" &&
                                    f.name !== "employmentMonthlyIncome" &&
                                    f.name !== "employmentMonthlyObligation"
                                )
                                .map((f: any) => f.name);
                              employmentFieldNamesToClear.forEach((fname: string) => {
                                form.setFieldValue(fname, "", false);
                                form.setFieldTouched(fname, false, false);
                                form.setFieldError(fname, undefined);
                                handleFilledFieldsCount(fname, "");
                              });
                            }
                          } else if (
                            field.name.startsWith("coreExamName") ||
                            field.name.startsWith("languageExamName")
                          ) {
                            handleExamDropdownChange(
                              field.name,
                              value,
                              form.setFieldValue
                            );
                            handleFilledFieldsCount(field.name, value);
                            // Explicitly clear errors for exam name and all auto-populated/related fields
                            // without triggering cascade validation on other fields
                            if (value) {
                              form.setFieldError(field.name, undefined);
                              const sfxMatch = field.name.match(/_(\d+)$/);
                              const sfx = sfxMatch ? `_${sfxMatch[1]}` : "";
                              const isCore = field.name.startsWith("coreExamName");
                              const mf = isCore ? `coreTotalMarks${sfx}` : `languageTotalMarks${sfx}`;
                              const scoreField = isCore ? `coreExamScore${sfx}` : `languageExamScore${sfx}`;
                              form.setFieldError(mf, undefined);
                              // Also clear stale range/required errors on the score field
                              // (e.g. "cannot be greater than total marks" from old totalMarks value)
                              form.setFieldError(scoreField, undefined);
                            }
                          } else {
                            // For exam fields, find the full option object to get both ID and name
                            // if (field.name.toLowerCase().includes("exam")) {
                            //   const selectedOption = options.find((opt: any) => opt.value === value);
                            //   if (selectedOption) {
                            //     // Set the form value to just the selected value, but pass full option to handleDropdownChange
                            //     form.setFieldValue(field.name, value.value);
                            //     handleDropdownChange(field.name, selectedOption, form);
                            //   } else {
                            //     form.setFieldValue(field.name, value.value);
                            //     handleDropdownChange(field.name, value, form);
                            //   }
                            // } else

                            if (isCoOwnerCollateralNameField(field.name)) {
                              const selectedName = normalizeSelectionValue(value);
                              const selectedOption = options.find(
                                (option: any) =>
                                  normalizeSelectionValue(option?.value) ===
                                  selectedName
                              );
                              const phoneFieldName =
                                getCoOwnerCollateralPhoneFieldName(field.name);
                              const phoneNumber =
                                selectedOption?.phoneNumber || "";

                              form.setFieldValue(field.name, selectedName);
                              handleDropdownChange(field.name, selectedName, form);
                              handleFilledFieldsCount(field.name, selectedName);

                              if (phoneFieldName) {
                                form.setFieldValue(phoneFieldName, phoneNumber, false);
                                form.setFieldTouched(phoneFieldName, true, false);
                                form.setFieldError(phoneFieldName, undefined);
                                handleFilledFieldsCount(phoneFieldName, phoneNumber);
                                dispatch(
                                  updateFormData({
                                    [field.name]: selectedName,
                                    [phoneFieldName]: phoneNumber,
                                  })
                                );
                              }
                            } else if (field.name.toLowerCase().includes("salutation")) {
                              // For salutation fields, find the full option object to get both code and description
                              const selectedOption = options.find(
                                (opt: any) => opt.value === value
                              );
                              if (selectedOption) {
                                // Set the form value to the salutation code (value)
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                );
                                // Pass full option to handleDropdownChange to store both code and description
                                handleDropdownChange(
                                  field.name,
                                  selectedOption,
                                  form
                                );
                              } else {
                                form.setFieldValue(field.name, value);
                                handleDropdownChange(field.name, value, form);
                              }
                            } else if (
                              field.name.toLowerCase().includes("designation")
                            ) {
                              // For designation fields, store only the value (code) but display label
	                              // The value passed here is already the code from the selected option
	                              form.setFieldValue(field.name, value);
	                              form.setFieldError(field.name, undefined);
	                              handleFilledFieldsCount(field.name, value);
                            } else if (isCollateralScalarDropdownField(field.name)) {
                              const scalarValue = normalizeDropdownScalarValue(value);
                              form.setFieldValue(field.name, scalarValue);
                              handleDropdownChange(field.name, scalarValue, form);
                              handleFilledFieldsCount(field.name, scalarValue);
                              dispatch(updateFormData({ [field.name]: scalarValue }));
                            } else {
                              form.setFieldValue(field.name, value);
                              handleDropdownChange(field.name, value, form);
                            }
                            handleFilledFieldsCount(field.name, value);
                            // Clear this field's error immediately when a value is selected
                            if (value) {
                              form.setFieldError(field.name, undefined);
                            }
                          }

                          if (
                            activeHorizontalIndex === 1 &&
                            activeVerticalIndex === 5
                          ) {
                            // Persist all form values to Redux for refresh survival
                            if (formikRef?.current?.values) {
                              // dispatch(
                              //   updateFormData({
                              //     ...formikRef.current.values,
                              //     [field.name]: value,
                              //   })
                              // );
                              dispatch(
                                updateFormData({
                                  [field.name]: value,
                                })
                              );
                            }
                          }

                          if (field.name == "salutation") {
                            const fatherFirstName = form?.values?.fatherFirstName;
                            const fatherLastName = form?.values?.fatherLastName;
                            const motherFirstName = form?.values?.motherFirstName;
                            const motherLastName = form?.values?.motherLastName;
                            const gender = form?.values?.gender;
                            const aadhaar = form?.values?.aadhaar;
                            const dob = form?.values?.dob;
                            const firstName =
                              form?.values?.firstName ||
                              form?.values?.studentDetailsFirstName;
                            const lastName =
                              form?.values?.lastName ||
                              form?.values?.studentDetailsLastName;
                            const phone_number =
                              form?.values?.phone_number ||
                              form?.values?.studentDetailsPhone_number;
                            const email =
                              form?.values?.email ||
                              form?.values?.studentDetailEmail;
                            const isAadhaarVerified = form?.values?.isAadhaarVerified;
                            const isEmailVerified = form?.values?.isEmailVerified;
                            const isMobileVerified = form?.values?.isMobileVerified;
                            const isPanVerified = form?.values?.isPanVerified;
                            dispatch(
                              updateFormData({
                                [field?.name]: value,
                                fatherFirstName,
                                fatherLastName,
                                motherFirstName,
                                motherLastName,
                                gender,
                                aadhaar,
                                dob,
                                firstName: formikRef?.current?.values?.studentDetailsFirstName || formikRef?.current?.values?.firstName || "",
                                lastName: formikRef?.current?.values?.studentDetailsLastName || formikRef?.current?.values?.lastName || "",
                                phone_number,
                                email,
                                isAadhaarVerified: isAadhaarVerified ?? false,
                                isEmailVerified,
                                isMobileVerified,
                                isPanVerified,
                              })
                            );
                          }
                        }}
                        options={options}
                        placeholder={
                          field.name?.includes("salutation")
                            ? 'Select Salutation'
                            : field.name === "coreScoreReceived" || field.name === "languageScoreReceived"
                              ? 'Select Status'
                              : `Select ${field.label}`
                        }
                        isMandatory={field.required || false}
                        error={!!(form.touched[field.name] && form.errors[field.name])}
                        helperText={form.touched[field.name] && form.errors[field.name] ? String(form.errors[field.name]) : ""}
                        isApplicant={field.name === "employmentType" ? true : false}
                        disabled={field?.disabled || false}
                      // disabled={
                      //   field.name === "permanentAddressType" ||
                      //   field.name === "currentAddressType" ||
                      //   /^addressCoApplicant\d+permanentAddressType$/.test(
                      //     field.name
                      //   ) ||
                      //   /^addressCoApplicant\d+currentAddressType$/.test(
                      //     field.name
                      //   )
                      //     ? true
                      //     : false
                      // }
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>

            {/* This renders the whitespace (empty box) only next to Employment Type */}
            {field.name === 'employmentType' && !isXsOrSm && (
              <Grid item xs={12} sm={6} />
            )}
          </>
        );
      case "radio":
        if (
          pageType === "SUMMARY" &&
          isSummaryEligibilityStep0 &&
          field.name === "applicantType"
        ) {
          return (
            <Grid
              item
              xs={12}
              sm={smForSummaryEligibility(12)}
              key={field.id}
            >
              <Box>
                <Field name={field.name}>
                  {({ field: f, form }: any) => {
                    const applicantTypeOptions = (
                      field.options?.options || []
                    ).map((opt: string) => ({
                      value: String(opt).toLowerCase(),
                      label: opt,
                    }));
                    const normalizedValue =
                      typeof f.value === "string"
                        ? f.value.toLowerCase()
                        : f.value;
                    return (
                      <SelectOptions
                        label={field.label}
                        value={normalizedValue}
                        onChange={(value: any) => {
                          const valToStore =
                            typeof value === "object" &&
                            value !== null &&
                            "value" in value
                              ? value.value
                              : value;
                          handleFilledFieldsCount(field.name, valToStore);
                          handleRadioChange(field.name, valToStore, form);
                        }}
                        options={applicantTypeOptions}
                        placeholder={`Select ${field.label}`}
                        isMandatory={field.required || false}
                        disabled
                        error={!!form.errors[field.name]}
                        helperText={form.errors[field.name] || ""}
                      />
                    );
                  }}
                </Field>
              </Box>
            </Grid>
          );
        }
        return (
          <Grid
            item
            xs={12}
            sm={smForSummaryEligibility(12)}
            key={field.id}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, form }: any) => (
                  <CustomRadioGroup
                    hasBg={
                      activeHorizontalIndex === 0 && activeVerticalIndex === 0
                    }
                    isRequired={true}
                    label={field.label}
                    options={(field.options?.options || []).map(
                      (opt: string) => ({
                        value:
                          activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 0
                            ? opt?.toLowerCase()
                            : opt,
                        label: opt,
                      })
                    )}
	                    value={f.value}
	                    disabled={field?.disabled || false}
	                    onChange={(value) => {
                      handleFilledFieldsCount(field.name, value);
                      handleRadioChange(field.name, value, form);
                      if (
                        activeHorizontalIndex === 1 &&
                        activeVerticalIndex === 5
                      ) {
                        // Persist all form values to Redux for refresh survival
                        if (formikRef?.current?.values) {
                          // dispatch(
                          //   updateFormData({
                          //     ...formikRef.current.values,
                          //     [field.name]: value,
                          //   })
                          // );
                          dispatch(
                            updateFormData({
                              [field.name]: value,
                            })
                          );
                        }
                      }
                    }}
                  />
                )}
              </Field>
            </Box>
          </Grid>
        );
      case "checkbox":
        if (
          pageType === "SUMMARY" &&
          activeHorizontalIndex === 0 &&
          activeVerticalIndex === 0 &&
          (field.name === "terms_conditions" ||
            field.name === "privacy_policy")
        ) {
          return null;
        }
        return (
          <Grid item xs={12} sm={12} key={field.id} sx={{ mb: 0, mt: 0, p: 0 }}>
            <Box sx={{ m: 0, p: 0 }}>
              <Field name={field.name}>
                {({ field: f }: any) => {
                  const safeLabel = DOMPurify.sanitize(field?.label); // sanitize before rendering
                  const hasPurposesAnchor = hasSpecificPurposesAnchor(
                    field?.label
                  );

                  return (
                    <div
                      className="checkbox-wrapper"
                      style={{ margin: 0, padding: 0 }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!f.value}
                            {...f}
                            onChange={(event: any) => {
                              let checked = event.target.checked;
                              if (field.name === "currentsameAsPermanent") {
                                setIsCurrentSameAsPermanent(checked);
                                handleFilledCurrentAddressFields(checked);
                              }
                              const match = field.name.match(
                                /^addressCoApplicant(\d+)currentsameAsPermanent$/
                              );
                              if (match) {
                                if (checked) {
                                  handleInvokZipCode(
                                    String(formikRef?.current?.values?.[`addressCoApplicant${match[1]}permanentPincode`]),
                                    undefined,
                                    "current"
                                  )
                                }
                                handleFilledCurrentAddressFieldsCoApplicant(
                                  match[1],
                                  checked
                                );
                              }
                              handleFilledFieldsCount(field.name, event);
                              f.onChange(event); // ensure Formik state is updated
                            }}
                            sx={{
                              p: 0.5,
                              "&.Mui-checked": {
                                color: "#33C2C4",
                              },
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            component="span"
                            onClick={
                              hasPurposesAnchor
                                ? handlePurposesClick
                                : undefined
                            }
                            sx={{
                              fontFamily: "Jost, sans-serif",
                              fontWeight: 400,
                              fontSize: isXsOrSm ? "12px" : "15px",
                              lineHeight: "22px",
                              textAlign: "left",
                              color: "#4B465C",
                              display: "inline-block",
                              borderRadius: "4px",
                              padding: "2px 0px",
                              cursor: hasPurposesAnchor ? "pointer" : "default",
                              "& a": {
                                color: "#33C2C4",
                                textDecoration: "underline",
                                transition: "color 0.2s ease-in-out",
                                "&:hover": {
                                  color: "#33C2C4",
                                },
                              },
                            }}
                            dangerouslySetInnerHTML={{ __html: safeLabel }} // sanitized HTML
                          />
                        }
                        sx={{ m: 0, alignItems: "flex-start !important" }}
                      />
                    </div>
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "autocomplete":
        // Restrict duplicate course types
        const keyItem: any = field.name.match(
          /^basicCoApplicant(\d+)RelationWithStudent$/
        );
        return (
          <Grid
            item
             xs={pageType === "SUMMARY" ? 3 : 12} 
            sm={
              activeHorizontalIndex === 1 && activeVerticalIndex === 3
                ? 4
                : activeHorizontalIndex === 1 && activeVerticalIndex === 5
                   ? 12  
                  : pageType === "SUMMARY" ? 3 : 6
            }
            key={field.id}
          // sx={{
          //   minWidth:
          //     activeHorizontalIndex === 1 && activeVerticalIndex === 3
          //       ? "100% !important"
          //       : "",
          // }}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, form, meta }: any) => {
                  // For RelationWithStudent, convert stored value to option object for display
                  let displayValue = f.value || "";
                  const options = getDropdownOptions(field);
                  if (
                    field.name.match(/^basicCoApplicant\d+RelationWithStudent$/)
                  ) {
                    const relationOptions = relationshipOptions;
                    // Find the option that matches the stored value
                    const matchedOption = relationOptions.find(
                      (opt: any) => opt.value === f.value
                    );
                    displayValue = matchedOption || "";
                  }

                  // For designation fields, convert stored code to option object for display
                  if (field.name.toLowerCase().includes("designation")) {
                    // Match the stored code, or the full name once saved data reloads
                    const matchedOption = options.find(
                      (opt: any) => opt.value === f.value || opt.label === f.value
                    );
                    displayValue = matchedOption || "";
                  }

                  if (
                    !field.name.match(/^basicCoApplicant\d+RelationWithStudent$/) &&
                    typeof displayValue !== "object" &&
                    displayValue !== ""
                  ) {
                    const matchedOption = options.find((opt: any) => {
                      const optionValue = String(
                        opt?.value ?? opt?.countryId ?? ""
                      ).toLowerCase();
                      const optionLabel = String(opt?.label ?? "").toLowerCase();
                      const currentValue = String(displayValue).toLowerCase();
                      return (
                        optionValue === currentValue || optionLabel === currentValue
                      );
                    });
                    if (matchedOption) {
                      displayValue = matchedOption;
                    }
                  }

                  const fieldNameLower = field.name.toLowerCase();
                  const typedSearchValue =
                    fieldNameLower === "university"
                      ? formValues?.universityName
                      : fieldNameLower === "institute"
                        ? formValues?.instituteName
                        : fieldNameLower === "coursename"
                          ? formValues?.courseName
                          : "";
                  const hasTypedSearchValue =
                    String(typedSearchValue || "").trim().length > 0;

                  return (
                    <AutoCompleteOptions
                      isNotList={
                        fieldNameLower == "university" ||
                        fieldNameLower == "institute" ||
                        fieldNameLower == "coursename"
                      }
                      formikRef={formikRef}
                      label={field.label}
                      fieldProps={{ ...f }}
                      options={
                        field.name.includes(keyItem?.[0])
                          ? relationshipOptions
                          : options
                      }
                      value={displayValue}
                      form={form}
                      onChange={(value: any) => {
                        if (
                          field.name.match(
                            /^basicCoApplicant\d+RelationWithStudent$/
                          )
                        ) {
                          const relationValue = value?.value || value;
                          const relationLabel = value?.label || value;

                          // Set the field value to only the value
                          form.setFieldValue(field.name, relationValue);
                          form.setFieldValue(
                            `${field.name}Name`,
                            relationLabel
                          );

                          // Update Redux with RelationWithStudent value and name
                          const currentFormData = { ...formData };
                          currentFormData[field.name] = relationValue;
                          currentFormData[`${field.name}Name`] = relationLabel;
                          dispatch(updateFormData(currentFormData));

                          handleFilledFieldsCount(field.name, relationValue);
                        } else if (field.name.toLowerCase().includes("designation")) {
                          // Extract value (code) from the selected option
	                          const designationValue = value?.value || value;
	
	                          // Set the field value to only the designation code
	                          form.setFieldValue(field.name, designationValue, false);
	                          form.setFieldTouched(field.name, true, false);
	                          form.setFieldError(field.name, undefined);
	                          dispatch(
	                            updateFormData({
	                              [field.name]: designationValue,
	                            })
	                          );
	                          handleFilledFieldsCount(field.name, designationValue);
                        } else {
                          handleFilledFieldsCount(field.name, value);
                          // For step (0,1) university/institute/courseName: pass shouldValidate=false
                          // to prevent async Yup validation from re-setting errors after we clear them
                          const isEligibilityAutocomplete =
                            activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 1 &&
                            (field.name === "university" ||
                              field.name === "institute" ||
                              field.name === "courseName");
                          handleDropdownChange(
                            field.name,
                            value,
                            form,
                            isEligibilityAutocomplete ? false : undefined
                          );
                          handleFilledFieldsCount(field.name, value);
                          // Clear the field's own error when a value is selected
                          if (value) {
                            form.setFieldError(field.name, undefined);
                          }
                          // When admissionStatus changes to Undecided, clear dependent field errors
                          if (
                            field.name.toLowerCase().includes("admissionstatus") &&
                            (value === "Undecided" || value?.value === "Undecided")
                          ) {
                            form.setFieldError("university", undefined);
                            form.setFieldError("institute", undefined);
                            form.setFieldError("courseName", undefined);
                          }
                        }

                        if (value && Object.keys(value).length > 0) {
                          if (field.name === "country") {
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          }

                          if (field.name === "university") {
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              institutes: [],
                              courses: [],
                            }));
                          }

                          if (field.name === "institute") {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          }
                        }

                        // Clear dropdown options if value is cleared (cross button)
                        if (!value || value == null) {
                          if (
                            field.name === "courseCategory" ||
                            field.name.toLowerCase().includes("study") ||
                            field.name.toLowerCase().includes("admissionstatus")
                          ) {
                            form.setFieldValue("country", "");
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              countries: [],
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "country") {
                            form.setFieldValue("university", "");
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              universities: [],
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "university") {
                            form.setFieldValue("institute", "");
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              institutes: [],
                              courses: [],
                            }));
                          } else if (field.name === "institute") {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            // setDropdownData((prev) => ({
                            //   ...prev,
                            //   institutes: [],
                            // }));
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          } else if (
                            field.name === "courseName" ||
                            field.name === "course"
                          ) {
                            form.setFieldValue("course", "");
                            form.setFieldValue("courseName", "");
                            setDropdownData((prev) => ({
                              ...prev,
                              courses: [],
                            }));
                          } else if (
                            field.name.match(
                              /^basicCoApplicant(\d+)RelationWithStudent$/
                            )
                          ) {
                            // Clear RelationWithStudent name field
                            form.setFieldValue(`${field.name}Name`, "");
                          }
                        }
                      }}
                      onInputChange={(e: any, inputValue: any, reason: any) => {
                        if (reason !== "reset") {
                          if (field.name === "university") {
                            setFormValues((prev) => ({
                              ...prev,
                              universityName: inputValue,
                            }));
                          } else if (field.name === "institute") {
                            setFormValues((prev) => ({
                              ...prev,
                              instituteName: inputValue,
                            }));
                          } else if (
                            field.name === "courseName" ||
                            field.name === "course" ||
                            field.name === "cource"
                          ) {
                            setFormValues((prev) => ({
                              ...prev,
                              courseName: inputValue,
                            }));
                          }
                        }
                        // Call API when typing, but not on selection (reset) or if value already in options
                        if (
                          field.name === "university" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.universities?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              universityName: inputValue,
                            }));
                            // Prevent duplicate calls for same value
                            if (lastUniversityQueryRef.current !== inputValue) {
                              lastUniversityQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (
                          field.name === "institute" &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.institutes?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              instituteName: inputValue,
                            }));
                            if (lastInstituteQueryRef.current !== inputValue) {
                              lastInstituteQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (
                          (field.name === "courseName" ||
                            field.name === "course" ||
                            field.name === "cource") &&
                          inputValue?.length >= 3 &&
                          reason !== "reset"
                        ) {
                          // Check if inputValue matches any existing option (means it's a selection)
                          const isExistingOption = dropdownData.courses?.some(
                            (opt: any) => opt.label === inputValue
                          );

                          if (!isExistingOption) {
                            setFormValues((prev) => ({
                              ...prev,
                              courseName: inputValue,
                            }));
                            if (lastCourseQueryRef.current !== inputValue) {
                              lastCourseQueryRef.current = inputValue;
                              debouncedCall(field.name, inputValue);
                            }
                          }
                        } else if (field.name === "salutation") {
                          setFormValues((prev) => ({
                            ...prev,
                            salutation: inputValue,
                          }));
                        } else if (
                          field.name === "currentPincode" &&
                          inputValue?.length == 6
                        ) {
                          setFormValues((prev) => ({
                            ...prev,
                            salutation: inputValue.label,
                          }));
                        }
                      }}
                      // isMandatory: non-mandatory on (0,1) when admissionStatus is Undecided for University/Institute/Course
                      isMandatory={
                        (() => {
                          const nameLower = field.name.toLowerCase();
                          const applyAdmissionUndecided =
                            activeHorizontalIndex === 0 &&
                            activeVerticalIndex === 1 &&
                            form?.values?.admissionStatus === "Undecided";
                          const isTargetField =
                            nameLower === "university" ||
                            nameLower === "institute" ||
                            nameLower === "coursename";
                          return field.required && !(applyAdmissionUndecided && isTargetField);
                        })()
                      }
                      loading={isDropdownLoading(field)}
                      placeholder={
                        field.name.toLowerCase() === "university"
                          ? "Type 3 Letters of University Name"
                          : field.name.toLowerCase() === "institute"
                            ? "Type 3 Letters of Institute Name"
                            : field.name.toLowerCase() === "coursename"
                              ? "Type 3 Letters of Course Name"
                              : `Select ${field.label}`
                      }
                      noOptionText={
                        fieldNameLower === "university"
                          ? hasTypedSearchValue
                            ? "Select Not In List and Enter the University Name"
                            : "Type 3 Letters of University Name"
                          : fieldNameLower === "institute"
                            ? hasTypedSearchValue
                              ? "Select Not In List and Enter the Institute Name"
                              : "Type 3 Letters of Institute Name"
                            : fieldNameLower === "coursename"
                              ? hasTypedSearchValue
                                ? "Select Not In List and Enter the Course Name"
                                : "Type 3 Letters of Course Name"
                              : "No Options"
                      }
                      error={!!meta?.touched && !!meta?.error}
                      helperText={meta?.touched && meta?.error}
                      disabled={handleDisablePermanentPincodeBasedFields(field)}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      case "date": {
        const isScoreExpectedField = /scoreExpectedOn/i.test(field.name);
        const isLoanDisbursementDateField = /^loanDateOfDisbursement$/i.test(
          field.name
        );
        const minAllowedDate = isLoanDisbursementDateField
          ? dayjs().add(1, "day").startOf("day")
          : isScoreExpectedField
            ? dayjs().startOf("day")
            : dayjs("1900-01-01");
        const maxAllowedDate =
          isScoreExpectedField || isLoanDisbursementDateField
            ? dayjs("9999-12-31")
            : dayjs();
        return (
          <Grid
            item
            xs={12}
            sm={
              (activeHorizontalIndex === 1 && activeVerticalIndex === 3) || (activeHorizontalIndex === 1 && activeVerticalIndex === 4) || (activeHorizontalIndex === 1 && activeVerticalIndex === 5)
                ? pageType === "SUMMARY" ? 12 : 12
                : pageType === "SUMMARY" ? 3 : 6
            }
            key={field.id}
          >
            <Box>
              <Field name={field.name}>
                {({ field: f, meta, form }: any) => {
                  // Disable DOB for a co-applicant if their PAN is verified
                  let disableDate = Boolean(field?.disabled);
                  const coApplicantDobMatch = field.name.match(/^basicCoApplicant(\d+)dob$/);
                  if (coApplicantDobMatch) {
                    const idx = String(Number(coApplicantDobMatch[1]) - 1);
                    const panVerifiedFlag =
                      formikRef.current?.values?.[
                        `basicCoApplicant${Number(idx) + 1}IsPanVerified`
                      ];
                    // API/Formik may send "false"/"true" strings; only treat strict truthy flags as verified.
                    disableDate =
                      Boolean(field?.disabled) ||
                      isTruthyFormFlag(panVerifiedFlag);
                  }

                  // Disable main applicant DOB if main PAN is verified
                  if (field.name === "dob" && isPanVerified) {
                    disableDate = true;
                  }
                  const dateValue = useMemo(
                    () => (f.value ? dayjs(f.value) : null),
                    [f.value]
                  );
                  return (
                    <BasicDatePicker
                      label={field.label==="Language Score Expected On"?"Score Expected On":field.label}
                      required={field.required}
                      value={dateValue}
                      onChange={(date) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : "";

                        handleFilledFieldsCount(field.name, formattedDate);

                        // prevent validation on each change
                        form.setFieldValue(field.name, formattedDate, false);
                        // Clear stale required/type errors when user selects a date
                        if (formattedDate) {
                          form.setFieldError(field.name, undefined);
                        }
                        const value = form.values[field.name];
                        dispatch(updateFormData({ [field.name]: formattedDate }));
                      }}
                      onBlur={() => {
                        // dispatch only once on blur (much faster)
                        const value = form.values[field.name];
                        dispatch(updateFormData({ [field.name]: value }));
                      }}
                      error={!!meta.touched && !!meta.error}
                      helperText={meta.touched && meta.error}
                      width="100%"
                      readOnly={false}
                      minDate={minAllowedDate}
                      maxDate={maxAllowedDate}
                      disabled={disableDate}
                      disableTyping={isLoanDisbursementDateField}
                    />
                  );
                }}
              </Field>
            </Box>
          </Grid>
        );
      }
      case "hidden":
        return (
          <Field name={field.name}>
            {({ field: f }: any) => (
              <input
                type="hidden"
                name={f.name}
                autoComplete="new-password"
                value={f.value || ""}
                onChange={f.onChange}
                onBlur={f.onBlur}
              />
            )}
          </Field>
        );
      default:
        return null;
    }
  };

  // useEffect(() => {
  //   // For each course score type, if initial value is CGPA, set cgpaModes in Redux to true
  //   const allFields = fields;
  //   allFields.forEach((field) => {
  //     const match = field.name.match(/^course(\d+)ScoreType$/);
  //     if (match) {
  //       const courseNum = match[1];
  //       // Check initial value (from initialValues or formData)
  //       const initial =
  //         (formData && formData[field.name]) ||
  //         initialValues[field.name] ||
  //         "CGPA";
  //       if (initial === "CGPA") {
  //         dispatch(setCgpaMode({ courseNum, mode: true }));
  //       } else {
  //         dispatch(setCgpaMode({ courseNum, mode: false }));
  //       }
  //     }
  //   });
  //   // Only run on mount or when fields/extraCourses change
  // }, [fields, extraCourses, activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    // dispatch(setHasPan(""));

    const formDataPan = String(formData?.pan ?? "").toUpperCase();
    const isValidFormDataPan = /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formDataPan);
    const formDataMobile = String(
      formData?.phone_number ?? formData?.studentDetailsPhone_number ?? ""
    ).trim();
    const formDataEmail = String(
      formData?.email ?? formData?.studentDetailEmail ?? ""
    )
      .trim()
      .toLowerCase();
    const isFormDataMobileVerified =
      formData?.isMobileVerified === true || formData?.isMobileVerified === "true";
    const isFormDataPanVerified =
      formData?.isPanVerified === true || formData?.isPanVerified === "true";
    const isFormDataEmailVerified =
      isTruthyFormFlag(formData?.isEmailVerified) ||
      isTruthyFormFlag((formData as any)?.emailAddressVerifiedFlag);

    // Keep verification anchors in sync after save/rehydration so UI does not fall back to "Verify".
    if (isValidFormDataPan && isFormDataPanVerified) {
      dispatch(setLastPanNumber(formDataPan));
      dispatch(setIsPanVerified(true));
    }
    if (formDataMobile && isFormDataMobileVerified) {
      dispatch(setLastVerifiedPhoneNumber(formDataMobile));
      dispatch(setIsMobileVerified(true));
    }
    if (formDataEmail && isFormDataEmailVerified) {
      dispatch(setLastVerifiedEmail(formDataEmail));
      dispatch(setIsEmailVerified(true));
    }

    if (formData.pan) {
      if (formData.pan == "yes" || formData.pan == "no") {
        dispatch(setHasPan(formData?.pan));
        if (formData.pan === "no") {
          setPanNumberValue("");
          dispatch(setPanNumber(""));
          dispatch(setIsPanVerified(false));
          formikRef.current?.setFieldValue("isPanVerified", false, false);
        }
        // if (formData.pan == "yes" && panNumber == reduxLastPanNumber) {
        //   dispatch(setAadhaarMandatory(true));
        // }
      } else if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData?.pan?.toUpperCase())) {
        dispatch(setHasPan("yes"));
        dispatch(setPanNumber(formData?.pan?.toUpperCase()));
        dispatch(setAadhaarMandatory(formData?.isPanVerified));
        dispatch(setIsPanVerified(isLoadTesting ? true : Boolean(formData?.isPanVerified)));
      }
    } else if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan?.toUpperCase())) {
      // If PAN is a valid PAN number, treat as 'yes' and set PAN number
      dispatch(setHasPan("yes"));
      dispatch(setPanNumber(formData.pan?.toUpperCase()));
      setPanNumberValue(formData.pan?.toUpperCase());
      dispatch(setIsPanVerified(isLoadTesting ? true : formData.isPanVerified));
      dispatch(setShowAadhaar(formData.isAadhaarVerified));
      dispatch(setAadhaarMandatory(formData.isAadhaarVerified));

      if (formData.aadhaar) {
        formikRef?.current?.setFieldValue("aadhaar", formData.aadhaar);
        dispatch(setAadhaarApplicationNo(formData.aadhaar));
      }
      // Handle per-coapplicant Aadhaar application numbers if present in formData
      Object.keys(formData).forEach((key) => {
        const aadhaarMatch = key.match(/^basicCoApplicant(\d+)AadhaarNumber$/);
        if (aadhaarMatch && formData[key]) {
          const coAppKey = aadhaarMatch[1];
          dispatch(
            setAadhaarApplicationNoCoApplicant({
              coAppKey,
              applicationNo: formData[key],
            })
          );
        }
        // Handle per-coapplicant isDocumentVerifiedCoApplicant if present in formData
        const verifiedMatch = key.match(
          /^basicCoApplicant(\d+)AadhaarVerified$/
        );
        if (verifiedMatch && formData[key] !== undefined) {
          const coAppKey = verifiedMatch[1];
          dispatch(
            setIsDocumentVerifiedCoApplicant({
              coAppKey,
              value: isLoadTesting ? true : Boolean(formData[key]),
            })
          );
        }
      });
      // dispatch(setIsDocumentVerified(formData?.aadhaar ? true : false));
      // dispatch(setAadhaarMandatory(formData?.aadhaar ? true : false));
    }

    // aadhaar key is removed from getdata api so using isAadhaarVerified to check aadhaar verification
    if (formData.aadhaar || formData.isAadhaarVerified) {
      dispatch(setIsDocumentVerified(true));
    }
    if (hasPan === "no") {
      dispatch(setAadhaarMandatory(true));
    }
  }, [formData, hasPan]);



  const [panNumberValue, setPanNumberValue] = useState("");
  const [isPanLoading, setIsPanLoading] = useState(false);

  useEffect(() => {
    const getApplicationNo = async () => {
      // For main applicant
      const applicationNo = localStorage.getItem("applicationNo");
      if (applicationNo) {
        dispatch(setAadhaarApplicationNo(applicationNo));
      }

      // For co-applicants: look for keys like "applicationNo_CoApplicant1", "applicationNo_CoApplicant2", etc.
      Object.keys(localStorage).forEach((key) => {
        const match = key.match(/^applicationNo_CoApplicant(\d+)$/);
        if (match) {
          const coAppKey = match[1];
          const coAppApplicationNo = localStorage.getItem(key);
          if (coAppApplicationNo) {
            dispatch(
              setAadhaarApplicationNoCoApplicant({
                coAppKey,
                applicationNo: coAppApplicationNo,
              })
            );
          }
        }
      });
    };
    getApplicationNo();
  }, [formikRef]);

  useEffect(() => {
    if (panNumber) {
      // dispatch(setIsPanVerified(true));
      // dispatch(setAadhaarMandatory(true));
      setPanNumberValue(panNumber);
    }
  }, [panNumber]);

  // useEffect(() => {
  //   if (hasPan === "yes") {
  //     if (panNumber === reduxLastPanNumber && panNumber !== "") {
  //       dispatch(setIsPanVerified(true));
  //     } else {
  //       dispatch(setIsPanVerified(false));
  //     }
  //   }
  // }, [panNumber, reduxLastPanNumber, hasPan]);
  // PAN and Aadhaar related fields
  const renderPanAadhaarFields = (
    values: any,
    shouldDisableFields: boolean,
    setFieldValue: any
  ) => {
    if (pageType === "SUMMARY") {
      const rawPanForDisplay = panNumberValue || values?.pan || "";
      const panValue =
        String(rawPanForDisplay).toLowerCase() === "yes" ||
        String(rawPanForDisplay).toLowerCase() === "no"
          ? ""
          : String(rawPanForDisplay).toUpperCase();
      const studentEmailValue =
        values?.studentDetailEmail ||
        values?.email ||
        formData?.studentDetailEmail ||
        formData?.email ||
        "";
      const aadhaarValue =
        values?.aadhaar || aadhaarApplicationNo || formData?.aadhaar || "";
      const normalizedSummaryStudentEmail = String(studentEmailValue || "")
        .trim()
        .toLowerCase();
      const explicitSummaryEmailFlag = [
        values?.isEmailVerified,
        formData?.isEmailVerified,
      ].find(hasNonEmptyFormValue);
      const summaryEmailVerifiedFlags = hasNonEmptyFormValue(
        explicitSummaryEmailFlag
      )
        ? isTruthyFormFlag(explicitSummaryEmailFlag)
        : isTruthyFormFlag(isEmailVerified) ||
          isTruthyFormFlag((formData as any)?.emailAddressVerifiedFlag);
      const normLastVerifiedEmail = String(
        lastVerifiedEmail || (summaryEmailVerifiedFlags ? normalizedSummaryStudentEmail : "")
      )
        .trim()
        .toLowerCase();
      // Require current email === OTP anchor so stale API flags alone cannot show "Verified".
      const isEmailVerifiedInSummary = Boolean(
        !!normalizedSummaryStudentEmail &&
          !!normLastVerifiedEmail &&
          normalizedSummaryStudentEmail === normLastVerifiedEmail &&
          summaryEmailVerifiedFlags
      );

      const duplicateSummaryApplicantStudentEmail =
        !!normalizedSummaryStudentEmail &&
        normalizedSummaryStudentEmail ===
          String(formikRef.current?.values?.basicCoApplicant1Email || "")
            .trim()
            .toLowerCase();

      const isPanVerifiedInSummary = Boolean(
        hasPan !== "no" &&
        panValue &&
        (isTruthyFormFlag(isPanVerified) ||
          isTruthyFormFlag(values?.isPanVerified) ||
          isTruthyFormFlag(formData?.isPanVerified))
      );
      const isAadhaarVerifiedInSummary = Boolean(
        isDocumentVerified || values?.isAadhaarVerified || formData?.isAadhaarVerified
      );
      const isSummaryStudentDetailsSection =
        pageType === "SUMMARY" &&
        activeHorizontalIndex === 1 && activeVerticalIndex === 0;
      const showEmailField =
        Boolean(studentEmailValue) && !isSummaryStudentDetailsSection;
      const panStrForVisibility = String(values?.pan || "").trim();
      const panIsYesNoToken =
        panStrForVisibility.toLowerCase() === "yes" ||
        panStrForVisibility.toLowerCase() === "no";
      const showPanInput =
        hasPan !== "no" &&
        (hasPan === "yes" ||
          Boolean(panNumberValue) ||
          (Boolean(panStrForVisibility) && !panIsYesNoToken));
      const hideAadhaarOnSummaryPanStep =
        pageType === "SUMMARY" &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 0;
      const disableApplicantStudentEmailOnSummaryPanBlock =
        (activeHorizontalIndex === 0 && activeVerticalIndex === 0) ||
        (activeHorizontalIndex === 1 && activeVerticalIndex === 0);
      const showAadhaarField =
        !hideAadhaarOnSummaryPanStep &&
        isAadhaarVerifiedInSummary &&
        Boolean(aadhaarValue);

      return (
        <>
          {showEmailField && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography className="text-lable" sx={{ mb: 0.5 }}>
                Student Email ID
              </Typography>
              {isEmailVerifiedInSummary ? (
                <InputField
                  fullWidth
                  value={studentEmailValue}
                  disabled
                  placeholder=""
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "#28c76f",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          <img
                            src={greenCheckVerified}
                            alt="Verified"
                            style={{ width: 14, height: 14 }}
                          />
                          Verified
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                />
              ) : (
                <InputField
                  fullWidth
                  value={studentEmailValue}
                  placeholder="Enter Email ID and verify"
                  autoComplete="new-password"
                  inputProps={{ autoComplete: "off", maxLength: 40 }}
                  error={duplicateSummaryApplicantStudentEmail}
                  helperText={
                    duplicateSummaryApplicantStudentEmail
                      ? "This email is already used in another field."
                      : ""
                  }
                  onChange={(e) => {
                    if (disableApplicantStudentEmailOnSummaryPanBlock) {
                      return;
                    }
                    const inputValue = e.target.value;
                    setFieldValue?.("email", inputValue, false);
                    setFieldValue?.("studentDetailEmail", inputValue, false);
                    dispatch(
                      updateFormData({
                        email: inputValue,
                        studentDetailEmail: inputValue,
                      })
                    );
                    const norm = String(inputValue || "").trim().toLowerCase();
                    const normLast = String(lastVerifiedEmail || "")
                      .trim()
                      .toLowerCase();
                    if (norm !== normLast) {
                      dispatch(setIsEmailVerified(false));
                    }
                  }}
                  InputProps={{
                    readOnly:
                      disableApplicantStudentEmailOnSummaryPanBlock ||
                      isApiLoading,
                    endAdornment: disableApplicantStudentEmailOnSummaryPanBlock ? (
                      <InputAdornment position="end">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mr: 0.5,
                            px: 1,
                            py: 0.35,
                            borderRadius: "4px",
                            bgcolor: "rgba(255, 159, 67, 0.14)",
                            border: "1px solid rgba(255, 159, 67, 0.45)",
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              color: "#ff9f43",
                              fontSize: "11px",
                              fontWeight: 600,
                              lineHeight: 1.2,
                            }}
                          >
                            Not Verified
                          </Typography>
                        </Box>
                      </InputAdornment>
                    ) : (
                      <Button
                        sx={{
                          backgroundColor: isEmailVerifiedInSummary
                            ? "transparent"
                            : "#FEC10D",
                          color: isEmailVerifiedInSummary ? "#28C76F" : "#000000",
                          "&:hover": {
                            backgroundColor: isEmailVerifiedInSummary
                              ? "transparent"
                              : "#FEC10D",
                            color: isEmailVerifiedInSummary ? "#28C76F" : "#000000",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: isEmailVerifiedInSummary
                              ? "transparent"
                              : "#FEC10D",
                            color: isEmailVerifiedInSummary ? "#28C76F" : "#000000",
                            WebkitTextFillColor: isEmailVerifiedInSummary
                              ? "#28C76F"
                              : "#000000",
                            opacity: 1,
                          },
                          "& img": {
                            opacity: 1,
                            filter: "brightness(1)",
                          },
                          textTransform: "none",
                          fontSize: isEmailVerifiedInSummary ? "16px" : "10px",
                          fontWeight: isEmailVerifiedInSummary ? 400 : 700,
                          px: "15px",
                          borderRadius: "4px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: "none",
                          height: "100%",
                          mr: 0.5,
                        }}
                        onClick={
                          isApiLoading
                            ? undefined
                            : async () => {
                                if (
                                  isEmailVerifiedInSummary ||
                                  duplicateSummaryApplicantStudentEmail ||
                                  !normalizedSummaryStudentEmail
                                ) {
                                  return;
                                }
                                try {
                                  let name =
                                    `${values?.studentDetailsFirstName || values?.firstName || ""} ${values?.studentDetailsLastName || values?.lastName || ""}`.trim();
                                  const email = String(
                                    studentEmailValue || ""
                                  ).trim();
                                  setOtpEmail(email);
                                  setOtpEmailFieldName("studentDetailEmail");
                                  dispatch(setCurrentCoApplicantIdx(null));

                                  const resp =
                                    await eligibilityCheckServices.sendOtp({
                                      name,
                                      email: email.toLowerCase(),
                                    });
                                  if (resp?.data?.status === "fail") {
                                    dispatch(
                                      setStatusPopup({
                                        status: "error",
                                        message: resp.data.message,
                                      })
                                    );
                                    return;
                                  }
                                  setOtpEmailKey(resp.data.data.value);
                                  setOtpEmailTime(resp.data.data.otpTime);
                                  setOpenEmailOtp(true);
                                } catch (err: any) {
                                  const apiMsg =
                                    err?.response?.data?.errors?.[0]
                                      ?.constraints?.isEmail;
                                  dispatch(
                                    setStatusPopup({
                                      status: "error",
                                      message: apiMsg,
                                    })
                                  );
                                }
                              }
                        }
                        disabled={
                          isApiLoading ||
                          isEmailVerifiedInSummary ||
                          duplicateSummaryApplicantStudentEmail ||
                          !normalizedSummaryStudentEmail
                        }
                      >
                        <Typography variant="inherit">Verify</Typography>
                        <img
                          src={arrowRightVerify}
                          alt="Verified"
                          style={{
                            height: "15px",
                            objectFit: "contain",
                            imageRendering: "-webkit-optimize-contrast",
                          }}
                        />
                      </Button>
                    ),
                  }}
                />
              )}
            </Grid>
          )}

          {isPanVerifiedInSummary ? (
            <Grid item xs={12} sm={6} md={3}>
              <Typography className="text-lable" sx={{ mb: 0.5 }}>
                PAN Number
              </Typography>
              <InputField
                fullWidth
                value={panValue}
                disabled
                placeholder=""
                autoComplete="new-password"
                inputProps={{ maxLength: 10, style: { textTransform: "uppercase" } }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          color: "#28c76f",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      >
                        <img
                          src={greenCheckVerified}
                          alt="Verified"
                          style={{ width: 14, height: 14 }}
                        />
                        Verified
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={showEmailField ? 3 : 12}
                md={showEmailField ? 3 : 12}
              >
                {!isXsOrSm ? (
                  <label className="text-lable">
                    Do you have PAN? <span style={{ color: "red" }}>*</span>
                  </label>
                ) : (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#4B465C",
                      mb: 0.5,
                    }}
                  >
                    Do you have PAN? <span style={{ color: "red" }}>*</span>
                  </Typography>
                )}
                <RadioGroup
                  row
                  name="has_pan"
                  value={hasPan}
                  onChange={(e) => {
                    const choice = e.target.value;
                    const dobValue = values?.dob;
                    const motherFirstName = values?.motherFirstName;
                    const fatherFirstName = values?.fatherFirstName;
                    const motherLastName = values?.motherLastName;
                    const fatherLastName = values?.fatherLastName;
                    const gender = values?.gender;
                    const aadhaar = values?.aadhaar;
                    const firstName = values?.firstName;
                    const lastName = values?.lastName;

                    dispatch(setHasPan(choice));

                    if (choice === "no") {
                      dispatch(setLastPanNumber(panNumber));
                      setPanNumberValue("");
                      dispatch(setPanNumber(""));
                      setFieldValue?.("pan", "");
                      dispatch(
                        updateFormData({
                          pan: "",
                          dob: dobValue,
                          motherFirstName,
                          motherLastName,
                          fatherFirstName,
                          fatherLastName,
                          gender,
                          aadhaar,
                          firstName,
                          lastName,
                        })
                      );
                      dispatch(setAadhaarMandatory(true));
                      dispatch(setShowAadhaar(true));
                    } else {
	                const restored =
                    isPanVerified &&
	                  reduxLastPanNumber &&
	                  /^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(reduxLastPanNumber)
	                    ? reduxLastPanNumber.toUpperCase()
                          : "";
                      setPanNumberValue(restored);
                      dispatch(setPanNumber(restored));
                      setFieldValue?.("pan", restored);
                      dispatch(
                        updateFormData({
                          pan: restored,
                          dob: dobValue,
                          motherFirstName,
                          motherLastName,
                          fatherFirstName,
                          fatherLastName,
                          gender,
                          aadhaar,
                          firstName,
                          lastName,
                        })
                      );
                      if (!urlParams.get("document_verified")) {
                        dispatch(
                          setAadhaarMandatory(
                            panNumber == reduxLastPanNumber &&
                              panNumber != "" &&
                              isPanVerified
                          )
                        );
                        dispatch(
                          setShowAadhaar(
                            panNumber == reduxLastPanNumber &&
                              panNumber !== "" &&
                              isPanVerified
                          )
                        );
                      }
                    }
                    dispatch(
                      setVerificationMessage({
                        index: "",
                        applicantType: "",
                        field: "",
                        status: "",
                        message: "",
                      })
                    );
                  }}
                  sx={{ flexDirection: "row" }}
                >
                  <FormControlLabel
                    value="yes"
                    control={<RadioButton />}
                    label="Yes"
                    classes={{ label: "text-lable" }}
                  />
                  <FormControlLabel
                    value="no"
                    control={<RadioButton />}
                    label="No"
                    classes={{ label: "text-lable" }}
                  />
                </RadioGroup>
              </Grid>
              {showPanInput && (
                <Grid item xs={12} sm={6} md={3}>
                  <Typography className="text-lable" sx={{ mb: 0.5 }}>
                    PAN Number
                  </Typography>
                  <InputField
                    fullWidth
                    value={panValue}
                    disabled={isApiLoading}
                    autoComplete="new-password"
                    inputProps={{ maxLength: 10, style: { textTransform: "uppercase" } }}
                    onChange={(e) => {
                      let newPan = e.target.value?.toUpperCase() || "";
                      if (newPan.length > 10) {
                        newPan = newPan.slice(0, 10);
                      }
                      setPanNumberValue(newPan);
                      dispatch(setPanNumber(newPan));
                      setFieldValue && setFieldValue("pan", newPan);
                      dispatch(setIsPanVerified(false));
                      dispatch(
                        setVerificationMessage({
                          applicantType: "applicant",
                          field: "pan",
                          status: "",
                          message: "",
                        })
                      );
                    }}
                    InputProps={{
                      readOnly: isApiLoading || isPanVerifiedInSummary,
                      endAdornment: (
                        <Button
                          sx={{
                            backgroundColor: "#FEC10D",
                            color: "#000000",
                            "&:hover": {
                              backgroundColor: "#FEC10D",
                              color: "#000000",
                            },
                            textTransform: "none",
                            fontSize: "10px",
                            fontWeight: 700,
                            px: "15px",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "none",
                            height: "100%",
                            mr: 0.5,
                          }}
                          onClick={isApiLoading ? undefined : async () => {
                            const applicantEmailVerifiedForPan =
                              isTruthyFormFlag(values?.isEmailVerified) ||
                              isTruthyFormFlag(formData?.isEmailVerified);
                            const applicantMobileVerifiedForPan =
                              isTruthyFormFlag(values?.isMobileVerified) ||
                              isTruthyFormFlag(formData?.isMobileVerified);
                            if (
                              !applicantEmailVerifiedForPan ||
                              !applicantMobileVerifiedForPan
                            ) {
                              dispatch(
                                setVerificationMessage({
                                  applicantType: "applicant",
                                  field: "pan",
                                  status: "error",
                                  message: "Please verify email and mobile",
                                })
                              );
                              return;
                            }
                            try {
                              setIsPanLoading(true);
                              if (!values?.dob) {
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "error",
                                    message:
                                      "Please provide your Date of Birth before proceeding with PAN verification.",
                                  })
                                );
                                return;
                              }
                              if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panValue)) {
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "error",
                                    message: "Please enter a valid PAN number.",
                                  })
                                );
                                return;
                              }

                              const piiPublicKey = await fetchSanitizedPiiPublicKey();
                              if (!piiPublicKey) return;

                              const payload = await encryptData(
                                {
                                  panNumber: panValue,
                                  fullName: `${values.firstName || ""} ${values.lastName || ""}`.trim(),
                                  dob: values.dob
                                    ? new Date(values.dob).toLocaleDateString("en-GB")
                                    : "",
                                  trackingId: trackingId,
                                  applicantType: "Applicant",
                                },
                                ["panNumber"],
                                piiPublicKey
                              );

	                              const resp = await applicantDetailsServices.verifyPan(payload);
		                              if (
                                    resp.status === 200 &&
                                    resp?.data?.data?.dateOfBirth?.toLowerCase() === "invalid"
                                  ) {
                                    const panMismatchMessage =
                                      "DOB mismatch. Please ensure the Date of Birth matches the one linked to this PAN.";
			                                dispatch(setIsPanVerified(false));
			                                setFieldValue &&
			                                  setFieldValue("isPanVerified", false);
			                                dispatch(
			                                  setVerificationMessage({
		                                    applicantType: "applicant",
		                                    field: "pan",
		                                    status: "error",
		                                    message: panMismatchMessage,
		                                  })
		                                );
                                      setSnackbar({
                                        open: true,
                                        message: panMismatchMessage,
                                        severity: "error",
                                      });
                                      return;
		                              } else if (resp.status === 200) {
	                                dispatch(setPanNumber(panValue));
	                                dispatch(setIsPanVerified(true));
                                dispatch(setLastPanNumber(panValue));
                                setFieldValue && setFieldValue("pan", panValue);
                                setFieldValue &&
                                  setFieldValue("isPanVerified", true);
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "success",
                                    message: "Yay! Your PAN has been verified successfully.",
                                  })
                                );
                              } else {
                                dispatch(
                                  setVerificationMessage({
                                    applicantType: "applicant",
                                    field: "pan",
                                    status: "error",
                                    message:
                                      "Uh-oh! PAN verification failed. Please check the details and try again.",
                                  })
                                );
                              }
                            } catch {
                              dispatch(
                                setVerificationMessage({
                                  applicantType: "applicant",
                                  field: "pan",
                                  status: "error",
                                  message:
                                    "Uh-oh! PAN verification failed. Please check the details and try again.",
                                })
                              );
                            } finally {
                              setIsPanLoading(false);
                            }
                          }}
                          disabled={isApiLoading || isPanLoading || !panValue}
                        >
                          {isPanLoading ? (
                            <CircularProgress size={16} color="inherit" />
                          ) : (
                            <>
                              <Typography variant="inherit">Verify</Typography>
                              <img
                                src={arrowRightVerify}
                                alt="Verify"
                                style={{
                                  height: "15px",
                                  objectFit: "contain",
                                  imageRendering: "-webkit-optimize-contrast",
                                }}
                              />
                            </>
                          )}
                        </Button>
                      ),
                    }}
                  />
                  {verificationMessage?.message &&
                    verificationMessage?.field === "pan" && (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          mt: 0.5,
                          color:
                            verificationMessage?.status === "success"
                              ? "success.main"
                              : "error.main",
                        }}
                      >
                        {verificationMessage?.message}
                      </Typography>
                    )}
                </Grid>
              )}
            </>
          )}

          {showAadhaarField && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography className="text-lable" sx={{ mb: 0.5 }}>
                Aadhaar Number
              </Typography>
              <InputField
                fullWidth
                value={aadhaarValue}
                disabled
                placeholder=""
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          color: isAadhaarVerifiedInSummary ? "#28c76f" : "#4B465C",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      >
                        {isAadhaarVerifiedInSummary && (
                          <img
                            src={greenCheckVerified}
                            alt="Verified"
                            style={{ width: 14, height: 14 }}
                          />
                        )}
                        {isAadhaarVerifiedInSummary ? "Verified" : "Not Verified"}
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
        </>
      );
    }

    return (
      <>
      <Grid container className="inner-form-box" ml={2} mt={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <img src={idIcon} alt="icon" style={{ width: 20, height: 20 }} />

            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#4B465C",
              }}
            >
              Verify your PAN now to speed up the process
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          {!isXsOrSm ? (
            <label className="text-lable">Do you have PAN? <span style={{ color: "red" }}>*</span></label>
          ) : (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#4B465C",
                mt: 2,
              }}
            >
              Do you have PAN? <span style={{ color: "red" }}>*</span>
            </Typography>
          )}

          <RadioGroup
            row
            name="has_pan"
            value={hasPan}
            onChange={(e) => {
              const choice = e.target.value;
              // Preserve dob value in Redux formData when toggling PAN radio
              const dobValue = values?.dob;
              const motherFirstName = values?.motherFirstName;
              const fatherFirstName = values?.fatherFirstName;
              const motherLastName = values?.motherLastName;
              const fatherLastName = values?.fatherLastName;
              const gender = values?.gender;
              const aadhaar = values?.aadhaar;
              const firstName = values?.firstName;
              const lastName = values?.lastName;

              dispatch(setHasPan(choice));

              if (choice === "no") {
                dispatch(setLastPanNumber(panNumber));
                setPanNumberValue("");
                dispatch(setPanNumber(""));
                setFieldValue?.("pan", "");
                dispatch(
                  updateFormData({
                    pan: "",
                    dob: dobValue,
                    motherFirstName,
                    motherLastName,
                    fatherFirstName,
                    fatherLastName,
                    gender,
                    aadhaar,
                    firstName,
                    lastName,
                  })
                );
                dispatch(setAadhaarMandatory(true));
                dispatch(setShowAadhaar(true));
	              } else {
	                const restored =
                    isPanVerified &&
	                  reduxLastPanNumber &&
	                  /^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(reduxLastPanNumber)
	                    ? reduxLastPanNumber.toUpperCase()
                    : "";
                setPanNumberValue(restored);
                dispatch(setPanNumber(restored));
                setFieldValue?.("pan", restored);
                dispatch(
                  updateFormData({
                    pan: restored,
                    dob: dobValue,
                    motherFirstName,
                    motherLastName,
                    fatherFirstName,
                    fatherLastName,
                    gender,
                    aadhaar,
                    firstName,
                    lastName,
                  })
                );

                if (!urlParams.get("document_verified")) {
                  dispatch(
                    setAadhaarMandatory(
                      panNumber == reduxLastPanNumber &&
                        panNumber != "" &&
                        isPanVerified
                    )
                  );
                  dispatch(
                    setShowAadhaar(
                      panNumber == reduxLastPanNumber &&
                        panNumber !== "" &&
                        isPanVerified
                    )
                  );
                }
              }

              dispatch(
                setVerificationMessage({
                  index: "",
                  applicantType: "",
                  field: "",
                  status: "",
                  message: "",
                })
              );
            }}
            sx={{ flexDirection: "row" }}
          >
            <FormControlLabel
              value="yes"
              control={<RadioButton />}
              label="Yes"
              classes={{ label: "text-lable" }}
            // disabled={true}
            />
            <FormControlLabel
              value="no"
              control={<RadioButton />}
              label="No"
              classes={{ label: "text-lable" }}
              disabled={isPanVerified}
            />
          </RadioGroup>
        </Grid>

        {(() => {
          const panVis = String(values?.pan || "").trim();
          const panVisIsYesNo =
            panVis.toLowerCase() === "yes" || panVis.toLowerCase() === "no";
          return (
            hasPan === "yes" ||
            Boolean(panNumberValue) ||
            (Boolean(panVis) && !panVisIsYesNo)
          );
        })() && (
          <>
            <Grid item xs={12} sm={8} md={8}>
              <FormGrid
                fields={[
                  {
                    label: "PAN Number",
                    component: (
                      <InputField
                        fullWidth
                        value={panNumberValue?.toUpperCase()}
                        // disabled={isApiLoading || isPanVerified}
                        inputProps={{ maxLength: 10 }}
                        autoComplete="new-password"
                        onKeyDown={(e) => {
                          // Block leading space: allow spaces only after first character
                          if (e.key === " ") {
                            const target = e.target as HTMLInputElement;
                            const start = target.selectionStart ?? 0;
                            if (start === 0) {
                              e.preventDefault();
                            }
                          }
                        }}
                        onChange={(e) => {
                          let newPan = e.target.value?.toUpperCase();
                          // Preserve dob value in Redux formData when toggling PAN radio
                          const dobValue = values?.dob;
                          if (newPan.length > 10) {
                            newPan = newPan.slice(0, 10);
                          }
                          setPanNumberValue(newPan);
                          dispatch(setPanNumber(newPan));
                          setFieldValue && setFieldValue("pan", newPan);
                          // Mark as touched and force validation on every change for immediate error display
                          if (formikRef.current?.setFieldTouched) {
                            formikRef.current.setFieldTouched(
                              "pan",
                              true,
                              false
                            );
                          }
                          // Use setTimeout to ensure Formik state is updated before validation
                          if (formikRef.current?.validateField) {
                            setTimeout(() => {
                              formikRef.current?.validateField("pan");
                            }, 0);
                          }
                          // Always run filled fields/verification logic for any 10-char input
                          handleFilledFieldsCount("pan", newPan);
                          if (newPan === "") {
                            dispatch(setIsPanVerified(false));
                          } else {
                            if (newPan === reduxLastPanNumber) {
                              dispatch(setIsPanVerified(true));
                            } else {
                              dispatch(setIsPanVerified(false));
                            }
                          }

                          // setting empty data on input value changes
                          dispatch(
                            setVerificationMessage({
                              index: "",
                              applicantType: "",
                              field: "",
                              status: "",
                              message: "",
                            })
                          );
                        }}
                        error={
                          !!formikRef.current?.touched?.pan &&
                          !!panNumberValue &&
                          !!formikRef.current?.errors?.pan
                        }
                        helperText={
                          formikRef.current?.touched?.pan &&
                            !!panNumberValue &&
                            typeof formikRef.current?.errors?.pan === "string"
                            ? formikRef.current?.errors?.pan
                            : undefined
                        }
                        variant="outlined"
                        InputProps={{
                          readOnly: isApiLoading || isPanVerified,
                          style: { textTransform: "uppercase" },
                          endAdornment: (
                            <Button
                              sx={{
                                backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                color: isPanVerified ? "#28C76F" : "#000000",
                                "&:hover": {
                                  backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                  color: isPanVerified ? "#28C76F" : "#000000",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: isPanVerified ? "transparent" : "#FEC10D",
                                  color: isPanVerified ? "#28C76F" : "#000000",
                                  WebkitTextFillColor: isPanVerified ? "#28C76F" : "#000000",
                                  opacity: 1,
                                },
                                "& img": {
                                  opacity: 1,
                                  filter: "brightness(1)",
                                },
                                textTransform: "none",
                                fontSize: isPanVerified ? "16px" : "10px",
                                fontWeight: isPanVerified ? 400 : 700,
                                px: "15px",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "none",
                                height: '100%',
                                mr: 0.5,
	                              }}
	                              onClick={isApiLoading || isPanVerified ? undefined : async () => {
	                                const applicantEmailVerifiedForPan =
	                                  isTruthyFormFlag(values?.isEmailVerified) ||
	                                  isTruthyFormFlag(formData?.isEmailVerified);
	                                const applicantMobileVerifiedForPan =
	                                  isTruthyFormFlag(values?.isMobileVerified) ||
	                                  isTruthyFormFlag(formData?.isMobileVerified);
                                if (
                                  !applicantEmailVerifiedForPan ||
                                  !applicantMobileVerifiedForPan
                                ) {
                                  dispatch(
                                    setVerificationMessage({
                                      applicantType: "applicant",
                                      field: "pan",
                                      status: "error",
                                      message: "Please verify email and mobile",
                                    })
                                  );
                                  return;
                                }
                                try {
                                  setIsPanLoading(true);
                                  if (!values.dob) {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please provide your Date of Birth before proceeding with PAN verification.",
                                      })
                                    );
                                    return;
                                  }


                                  const piiPublicKey =
                                    await fetchSanitizedPiiPublicKey();
                                  if (!piiPublicKey) return;

                                  const payload = await encryptData(
                                    {
                                      panNumber: panNumberValue,
                                      fullName: `${values.firstName || ""} ${values.lastName || ""
                                        }`.trim(),
                                      dob: values.dob
                                        ? new Date(
                                          values.dob
                                        ).toLocaleDateString("en-GB")
                                        : "",
                                      trackingId: trackingId,
                                      applicantType: "Applicant",
                                    },
                                    ["panNumber"],
                                    piiPublicKey
                                  );

	                                  const resp =
	                                    await applicantDetailsServices.verifyPan(payload);
		                                  if (
		                                    resp.status === 200 &&
		                                    resp?.data?.data?.dateOfBirth?.toLowerCase() === "invalid"
		                                  ) {
                                      const panMismatchMessage =
                                        "DOB mismatch. Please ensure the Date of Birth matches the one linked to this PAN.";
		                                    dispatch(setIsPanVerified(false));
		                                    setFieldValue("isPanVerified", false);
		                                    dispatch(
		                                      setVerificationMessage({
	                                        // index: "",
	                                        applicantType: "applicant",
	                                        field: "pan",
	                                        status: "error",
	                                        message: panMismatchMessage,
	                                      })
	                                    );
                                      setSnackbar({
                                        open: true,
                                        message: panMismatchMessage,
                                        severity: "error",
                                      });
                                      return;
	                                  } else if (
	                                    resp.status === 200 &&
                                      resp.data?.data?.dateOfBirth?.toLowerCase() === "invalid" &&
	                                    resp.data?.data?.panStatus?.toLowerCase() === "invalid"
	                                  ) {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message: "Please provide your Date of Birth before proceeding with PAN verification.",
                                      })
                                    );
                                  } else if (resp.status === 200) {
                                    const isAadhaarSeeded =
                                      String(
                                        resp?.data?.data
                                          ?.aadhaarSeedingStatus || ""
                                      ).toLowerCase() === "y";
                                    dispatch(
                                      updateFormData({
                                        pan: panNumber,
                                        dob: values.dob,
                                      })
                                    );
                                    dispatch(
                                      setAadhaarSeedingStatus(isAadhaarSeeded)
                                    );
                                    setPanNumberValue(panNumber);
                                    setFieldValue("pan", panNumberValue);
                                    dispatch(setPanNumber(panNumberValue));
                                    dispatch(setIsPanVerified(true));
                                    dispatch(setLastPanNumber(panNumberValue));
                                    dispatch(
                                      setAadhaarMandatory(
                                        resp.data.data.adharMandatory
                                      )
                                    );
                                    dispatch(
                                      setShowAadhaar(
                                        resp.data.data.adharMandatory
                                      )
                                    );

                                    trackCustomerJourneyEvent(
                                      `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                      decrypt(userProfile?.id) ?? "",
                                      trackingId,
                                      {
                                        label: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        category: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        action: `${handleGAProvisionalOfferStatments}_STDUENTDET_PANVERIF_PAGE5`,
                                        page: "ProvisionalOff_Student Details_PAN Verification",
                                      }
                                    );

                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "success",
                                        message:
                                          "Yay! Your PAN has been verified successfully.",
                                      })
                                    );

                                    // Add this line:
                                    handleFilledFieldsCount("pan", panNumber);
                                  } else if (resp.status === 400) {
                                    dispatch(
                                      setVerificationMessage({
                                        index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message:
                                          "Uh-oh! We are experiencing some technical issues fetching PAN details. Please try again later.",
                                      })
                                    );
                                  } else {
                                    dispatch(
                                      setVerificationMessage({
                                        // index: "",
                                        applicantType: "applicant",
                                        field: "pan",
                                        status: "error",
                                        message:
                                          "Please provide your Date of Birth before proceeding with PAN verification.",
                                      })
                                    );
                                  }
                                } catch (err: any) {
                                  dispatch(
                                    setVerificationMessage({
                                      // index: "",
                                      applicantType: "applicant",
                                      field: "pan",
                                      status: "error",
                                      message: err?.response?.data?.errors?.[0]?.property === "dob" ?
                                        "DOB mismatch. Please ensure the Date of Birth matches the one linked to this PAN."
                                        : err?.response?.data?.message,
                                    })
                                  );
                                } finally {
                                  setIsPanLoading(false);
                                }
                              }}
                              disabled={isPanLoading || isPanVerified}
                            >
                              {isPanLoading
                                ? <CircularProgress size={16} />
                                : isPanVerified ? (
                                  <>
                                    <img
                                      src={greenCheckVerified}
                                      alt="Verified"
                                      style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                    <Typography variant="inherit" sx={{ fontSize: '12px' }}>Verified</Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="inherit">Verify</Typography>
                                    <img
                                      src={arrowRightVerify}
                                      alt="Verified"
                                      style={{ height: '15px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                    />
                                  </>
                                )
                              }
                            </Button>
                          ),
                        }}
                      />
                    ),
                  },
                ]}
              />
            </Grid>

            {/* displaying PAN activity related messages */}
            <Grid item xs={12} mt={1}>
              {verificationMessage?.message &&
                verificationMessage?.field === "pan" && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color:
                        verificationMessage?.status === "success"
                          ? "success.main"
                          : "error.main",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {verificationMessage?.message}
                  </Typography>
                )}
            </Grid>
          </>
        )}
      </Grid>

      {/* Aadhaar Section */}
      {(adharMandatory || showAadhaar) && (
        <Grid container className="inner-form-box" ml={2} mt={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <img src={idIcon} alt="icon" style={{ width: 20, height: 20 }} />

              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#4B465C",
                }}
              >
                Verify Aadhaar Number
              </Typography>
            </Box>

            <label className="text-lable" style={{ marginBottom: "10px" }}>
              Verify your Aadhaar through Digilocker to keep your application
              going smoothly
            </label>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            {isAadharLoading ? (
              <Skeleton
                variant="rectangular"
                width={120}
                height={40}
                sx={{ borderRadius: 2, mb: 1 }}
              />
            ) : (
              <IconButton
                sx={{
                  backgroundColor: isDocumentVerified ? "#33c2c4" : undefined,
                  color: isDocumentVerified ? "#33c2c4" : "#000",
                  border: isDocumentVerified ? "1px solid #33c2c4" : "",
                  "&.Mui-disabled": {
                    backgroundColor: "white !important",
                    color: isDocumentVerified ? "#33c2c4" : "#000",
                  },
                }}
                onClick={async () => {
                  setIsEaadhaarOnVerifyNow(true);
                  setIsAadharLoading(true);
                  // setting empty data on button click
                  dispatch(
                    setVerificationMessage({
                      index: "",
                      applicantType: "",
                      field: "",
                      status: "",
                      message: "",
                    })
                  );
                  try {

                    trackCustomerJourneyEvent(
                      `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                      decrypt(userProfile?.id) ?? "",
                      trackingId,
                      {
                        label: `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                        category: `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                        action: `${handleGAProvisionalOfferStatments}_STDUENTDET_AADHAARVERIF_PAGE5`,
                        page: "ProvisionalOff_Student Details_Aadhaar Verification",
                      }
                    );

                    const aadhaarPayload: any = {
                      applicantEmail: values.email,
                      applicantName: `${values.firstName || ""} ${values.lastName || ""
                        }`.trim(),
                      applicantMobile: values.phone_number,
                      redirectUrl: `${window.location.origin}/assisted-portal`,
                      landingPageNotRequired: true,
                      trackingId: trackingId,
                      typeOfApplicant: "Applicant",
                    };
                    if (hasPan === "yes") {
                      aadhaarPayload.applicantPan = panNumber;
                      // aadhaarPayload.uiStream = "DIGILOCKER_AADHAAR_PAN";
                    }
                    // if (hasPan === "no") {
                    //   aadhaarPayload.uiStream = "DIGILOCKER_AADHAAR";
                    // }

                    const resp =
                      await applicantDetailsServices.aadhaarApplication(
                        aadhaarPayload
                      );
                    if (
                      resp.data?.status === "success" &&
                      resp.data.data?.link
                    ) {



                      let link = resp.data.data.link;
                      const applicationNo = resp.data.data.applicationNo;
                      localStorage.setItem("applicationNo", applicationNo);
                      dispatch(setAadhaarApplicationNo(applicationNo));
                      dispatch(
                        setLastVerifiedPhoneNumber(lastVerifiedPhoneNumber)
                      );
                      dispatch(setLastVerifiedEmail(lastVerifiedEmail));
                      if (!/^https?:\/\//i.test(link)) {
                        link = "https://" + link;
                      }
                      window.location.replace(link);
                    } else {
                      dispatch(
                        setStatusPopup({
                          status: "info",
                          message: resp.data?.message,
                        })
                      );
                    }
                  } catch (err: any) {
                    dispatch(
                      setStatusPopup({
                        status: "error",
                        message: err?.response?.data?.message,
                      })
                    );
                  } finally {
                    setIsAadharLoading(false);
                  }
                }}
                disabled={isDocumentVerified}
              >
                {isDocumentVerified && (
                  <img src={VerifiedIcon} alt="arrow-narrow-right" />
                )}
                {`${isDocumentVerified ? "Verified" : "Verify Via Digilocker"}`}

                {!isDocumentVerified && (
                  <img src={RightBlackArrow} alt="right-arrow" />
                )}
              </IconButton>
            )}
          </Grid>

          {/* displaying Aadhar activity related messages */}
          <Grid item xs={12} mt={1}>
            {verificationMessage?.message &&
              verificationMessage?.field === "aadhar" && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 500,
                    color:
                      verificationMessage?.status === "success"
                        ? "success.main"
                        : "error.main",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  {verificationMessage?.message}
                </Typography>
              )}
          </Grid>

          {/* <IconButton
            sx={{
              backgroundColor: isDocumentVerified ? "#33c2c4" : undefined, // green when disabled
              color: "#fff",
              opacity: isDocumentVerified ? 1 : undefined,
              "&.Mui-disabled": {
                backgroundColor: "#33c2c4 !important", // green for disabled
                color: "#000",
                opacity: 0.6,
              },
            }}
            onClick={async () => {
              try {
                const resp = await applicantDetailsServices.aadhaarApplication({
                  applicantEmail: values.email,
                  applicantName: `${values.firstName || ""} ${
                    values.lastName || ""
                  }`.trim(),
                  applicantMobile: values.phone_number,
                  primaryApplicant: 0,
                  redirectUrl: `${window.location.origin}/application/apply-now`,
                  // redirectLink: "https://customerportal-sit2.avanse.com/",
                });
                if (resp.data?.status === "success" && resp.data.data?.link) {
                  let link = resp.data.data.link;
                  const applicationNo = resp.data.data.applicationNo;
                  localStorage.setItem("applicationNo", applicationNo);
                  dispatch(setAadhaarApplicationNo(applicationNo));
                  dispatch(setLastVerifiedPhoneNumber(lastVerifiedPhoneNumber));
                  dispatch(setLastVerifiedEmail(lastVerifiedEmail));

                  // Prepend protocol if missing
                  if (!/^https?:\/\//i.test(link)) {
                    link = "https://" + link;
                  }
                  window.location.replace(link);
                } else {
                  setSnackbar({
                    open: true,
                    message: resp.data?.message,
                    severity: "error",
                  });
                }
              } catch (err: any) {
                setSnackbar({
                  open: true,
                  message: err?.response?.data?.message,
                  severity: "error",
                });
              }
            }}
            disabled={isDocumentVerified}
          >
            {isDocumentVerified && (
                <img src={VerifiedIcon} alt="arrow-narrow-right" />
              )}
              {`${isDocumentVerified ? "Verified" : "Verify Via Digilocker"}`}

              {!isDocumentVerified && (
                <img src={RightBlackArrow} alt="right-arrow" />
              )}
          </IconButton> */}
        </Grid>
      )}
    </>
    );
  };

  // Current Address fields
  const currFields = fields.filter(
    (f) => f.required && f.name?.toLowerCase().startsWith("current")
  );
  // Employment Address fields
  const employmentFields = fields.filter(
    (f) =>
      f.required &&
      f.name?.toLowerCase().includes("employment") &&
      !f.name?.toLowerCase().includes("employmentcompany")
  );

  // Company Address fields
  const companyFields = fields.filter(
    (f) =>
      f.required &&
      f.name?.toLowerCase().includes("employmentcompany") &&
      f.name !== "employmentCompanyName"
  );

  // Core and Language fields from Entrance Exam
  const coreFields = fields.filter((f) => f.name.startsWith("core"));
  const languageFields = fields.filter((f) => f.name.startsWith("language"));

  const otherFields = fields.filter(
    (f) =>
      f.required &&
      !f.name?.toLowerCase().startsWith("current") &&
      !f.name?.toLowerCase().includes("employmentcompany") &&
      f.name !== "employmentCompanyName"
  );

  const getFilledCount = (fieldSubset: any[], values: any) => {
    if (!Array.isArray(fieldSubset)) return 0;
    return fieldSubset.filter((field: any) => {
      if (!field?.name) return false;

      // Exclude checkboxes for step 1, form 1
      if (
        field.type === "checkbox" &&
        activeHorizontalIndex === 1 &&
        activeVerticalIndex === 0
      ) {
        return false;
      }

      const val = values?.[field.name];

      // Handle checkboxes separately
      if (field.type === "checkbox") {
        // Accept both boolean true and string 'true' as checked
        return val === true || val === "true";
      }

      // For arrays (like multi-select), check length
      if (Array.isArray(val)) {
        return val.length > 0;
      }

      // For normal text/number fields
      return val !== undefined && val !== null && val !== "";
    }).length;
  };

  const getFilledCountWithPanAadhaar = (fieldSubset: any[], values: any) => {
    let count = getFilledCount(fieldSubset, values);
    // Aadhaar logic (count if document_verified is true)
    // if (
    //   activeHorizontalIndex === 1 &&
    //   activeVerticalIndex === 0 &&
    //   isDocumentVerified
    // ) {
    //   count += 1;
    // }
    return count;
  };

  /**
   * useEffect hook to automatically populate form fields with Aadhaar verified details.
   *
   * This effect runs whenever the aadhaarVerifiedDetails object changes and maps
   * the verified Aadhaar data to corresponding formik form fields. It handles
   * address information, personal details, and demographic data.
   *
   * The effect performs the following mappings:
   * - Country, pincode, state, and city from address data
   * - Address lines (house, street, locality, landmark)
   * - Date of birth (with date format conversion from DD-MM-YYYY to YYYY-MM-DD)
   * - Gender (converts "M" to "male", "F" to "female")
   * - Father's name from careOf field
   *
   * @dependencies
   * - formikRef: Reference to the formik form instance
   * - aadhaarVerifiedDetails: Object containing verified Aadhaar information
   *
   * @sideEffects
   * - Updates multiple formik field values using setFieldValue
   * - Modifies form state without user interaction
   *
   * @note
   * - Date format conversion: Splits DD-MM-YYYY, reverses to YYYY-MM-DD
   * - Gender mapping: "M" → "male", "F" → "female"
   * - Address concatenation: Combines street, locality, and landmark
   *
   * @since 1.0.0
   * @author DynamicForm Component
   */

  // const fatherName = removeSalutation(
  //   aadhaarVerifiedDetails?.careOf || formikRef?.current?.values?.fatherName
  // );
  const fatherName = aadhaarVerifiedDetails?.careOf || formikRef?.current?.values?.fatherName;

  // Function to check and uncheck address checkbox
  const checkAndUncheckAddressCheckbox = useCallback(() => {
    const values = formikRef?.current?.values;
    if (!values) return;

    // Helper function to normalize values for comparison
    const normalizeValue = (val: any) => {
      if (val === null || val === undefined || val === '') return '';
      return String(val).trim();
    };

    // Helper function to check if at least one address field is filled
    const hasAddressData = (prefix = '', addressType = 'permanent') => {
      const owner = normalizeValue(values[`${prefix}${addressType}OwnershipStatus`]);
      const yearsInCurrentAddress = normalizeValue(values[`${prefix}${addressType}YearsInCurrentAddress`]);
      const YearsInCurrentCity = normalizeValue(values[`${prefix}${addressType}YearsInCurrentCity`]);
      const line1 = normalizeValue(values[`${prefix}${addressType}AddressLine1`]);
      const line2 = normalizeValue(values[`${prefix}${addressType}AddressLine2`]);
      const line3 = normalizeValue(values[`${prefix}${addressType}AddressLine3`]);
      const pincode = normalizeValue(values[`${prefix}${addressType}Pincode`]);
      const city = normalizeValue(values[`${prefix}${addressType}City`]);
      const state = normalizeValue(values[`${prefix}${addressType}State`]);
      const country = normalizeValue(values[`${prefix}${addressType}Country`]);

      return owner || yearsInCurrentAddress || YearsInCurrentCity || line1 || line2 || line3 || pincode || city || state || country;
    };

    // Helper function to compare addresses
    const areAddressesDifferent = (prefix = '') => {
      const hasPermanentData = hasAddressData(prefix, 'permanent');
      const hasCurrentData = hasAddressData(prefix, 'current');
      if (!hasPermanentData || !hasCurrentData) {
        return false;
      }
      const permanentOwnershipStatus = normalizeValue(values[`${prefix}permanentOwnershipStatus`]);
      const permanentYearsInCurrentAddress = normalizeValue(values[`${prefix}permanentYearsInCurrentAddress`]);
      const permanentYearsInCurrentCity = normalizeValue(values[`${prefix}permanentYearsInCurrentCity`]);
      const permanentAddressLine1 = normalizeValue(values[`${prefix}permanentAddressLine1`]);
      const permanentAddressLine2 = normalizeValue(values[`${prefix}permanentAddressLine2`]);
      const permanentAddressLine3 = normalizeValue(values[`${prefix}permanentAddressLine3`]);
      const permanentPincode = normalizeValue(values[`${prefix}permanentPincode`]);
      const permanentCity = normalizeValue(values[`${prefix}permanentCity`]);
      const permanentState = normalizeValue(values[`${prefix}permanentState`]);
      const permanentCountry = normalizeValue(values[`${prefix}permanentCountry`]);

      const currentOwnershipStatus = normalizeValue(values[`${prefix}currentOwnershipStatus`]);
      const currentYearsInCurrentAddress = normalizeValue(values[`${prefix}currentYearsInCurrentAddress`]);
      const currentYearsInCurrentCity = normalizeValue(values[`${prefix}currentYearsInCurrentCity`]);
      const currentAddressLine1 = normalizeValue(values[`${prefix}currentAddressLine1`]);
      const currentAddressLine2 = normalizeValue(values[`${prefix}currentAddressLine2`]);
      const currentAddressLine3 = normalizeValue(values[`${prefix}currentAddressLine3`]);
      const currentPincode = normalizeValue(values[`${prefix}currentPincode`]);
      const currentCity = normalizeValue(values[`${prefix}currentCity`]);
      const currentState = normalizeValue(values[`${prefix}currentState`]);
      const currentCountry = normalizeValue(values[`${prefix}currentCountry`]);

      return (
        permanentOwnershipStatus !== currentOwnershipStatus ||
        permanentYearsInCurrentAddress !== currentYearsInCurrentAddress ||
        permanentYearsInCurrentCity !== currentYearsInCurrentCity ||
        permanentAddressLine1 !== currentAddressLine1 ||
        permanentAddressLine2 !== currentAddressLine2 ||
        permanentAddressLine3 !== currentAddressLine3 ||
        permanentPincode !== currentPincode ||
        permanentCity !== currentCity ||
        permanentState !== currentState ||
        permanentCountry !== currentCountry
      );
    };

    // Check for main applicant
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 1) {
      if (isSameAsPermanentChecked(values.currentsameAsPermanent) && areAddressesDifferent('')) {
        formikRef?.current?.setFieldValue('currentsameAsPermanent', false);
        setIsCurrentSameAsPermanent(false);
      }
      if (
        hasAddressData('', 'permanent') &&
        hasAddressData('', 'current') &&
        !areAddressesDifferent('')
      ) {
        formikRef?.current?.setFieldValue('currentsameAsPermanent', true);
        setIsCurrentSameAsPermanent(true);
      }
    }

    // Check for co-applicants
    if (activeHorizontalIndex === 1 && activeVerticalIndex === 5) {
      Object.keys(values).forEach((key) => {
        const coAppMatch = key.match(/^addressCoApplicant(\d+)currentsameAsPermanent$/);
        if (coAppMatch) {
          const coAppNum = coAppMatch[1];
          const prefix = `addressCoApplicant${coAppNum}`;

          if (isSameAsPermanentChecked(values[key]) && areAddressesDifferent(prefix)) {
            formikRef?.current?.setFieldValue(key, false);
          }
        }
      });
    }
  }, [activeHorizontalIndex, activeVerticalIndex]);

  useEffect(() => {
    if (
      activeHorizontalIndex === 1 &&
      (activeVerticalIndex === 0 || activeVerticalIndex === 1)
    ) {
      formikRef?.current?.setFieldValue(
        "permanentCountry",
        formikRef?.current?.values?.permanentCountry ||
        aadhaarVerifiedDetails?.country
      );
      formikRef?.current?.setFieldValue(
        "permanentPincode",
        formikRef?.current?.values?.permanentPincode ||
        aadhaarVerifiedDetails?.pincode
      );
      formikRef?.current?.setFieldValue(
        "permanentState",
        formikRef?.current?.values?.permanentState ||
        aadhaarVerifiedDetails?.state
      );

      const conCatAddress: string = [
        handleUnwanted(aadhaarVerifiedDetails?.house),
        handleUnwanted(aadhaarVerifiedDetails?.street),
        handleUnwanted(aadhaarVerifiedDetails?.landmark),
        handleUnwanted(aadhaarVerifiedDetails?.locality),
        //aadhaarVerifiedDetails?.vtc,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      let chunkSize: boolean = conCatAddress.length > 50; // Condition applied here

      // Check if user has manually entered any address data (from formik values OR from formData/Redux)
      const hasManualPermanentAddress = (
        (formikRef?.current?.values?.permanentAddressLine1 && formikRef?.current?.values?.permanentAddressLine1.trim() !== "") ||
        (formikRef?.current?.values?.permanentAddressLine2 && formikRef?.current?.values?.permanentAddressLine2.trim() !== "") ||
        (formikRef?.current?.values?.permanentAddressLine3 && formikRef?.current?.values?.permanentAddressLine3.trim() !== "") ||
        (formData?.permanentAddressLine1 && formData?.permanentAddressLine1.trim() !== "") ||
        (formData?.permanentAddressLine2 && formData?.permanentAddressLine2.trim() !== "") ||
        (formData?.permanentAddressLine3 && formData?.permanentAddressLine3.trim() !== "")
      );

      if (hasManualPermanentAddress) {
        // User has entered data, preserve it
        // Don't overwrite with Aadhaar data
      } else if (chunkSize) {
        const addressLines = splitAddressByWords(conCatAddress);
        const addr1: string = addressLines[0] || "";
        const addr2: string = addressLines[1] || "";
        const addr3: string = addressLines[2] || "";
        formikRef?.current?.setFieldValue("permanentAddressLine1", addr1);
        formikRef?.current?.setFieldValue("permanentAddressLine2", addr2);
        formikRef?.current?.setFieldValue("permanentAddressLine3", addr3);
      } else {

        formikRef?.current?.setFieldValue(
          "permanentAddressLine1",
          aadhaarVerifiedDetails?.house || ""
        );
        formikRef?.current?.setFieldValue(
          "permanentAddressLine2",
          `${aadhaarVerifiedDetails?.street || ""} ${aadhaarVerifiedDetails?.landmark || ""
            }`.trim()
        );
        formikRef?.current?.setFieldValue(
          "permanentAddressLine3",
          `${aadhaarVerifiedDetails?.locality || ""}`.trim()
        );
      }

      formikRef?.current?.setFieldValue(
        "permanentCity",
        formikRef?.current?.values?.permanentCity ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.vtc) ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.district)
      );

      formikRef?.current?.setFieldValue(
        "currentCountry",
        formikRef?.current?.values?.currentCountry ||
        aadhaarVerifiedDetails?.country
      );
      formikRef?.current?.setFieldValue(
        "currentPincode",
        formikRef?.current?.values?.currentPincode ||
        aadhaarVerifiedDetails?.pincode
      );
      formikRef?.current?.setFieldValue(
        "currentState",
        formikRef?.current?.values?.currentState ||
        aadhaarVerifiedDetails?.state
      );

      const conCatCurrentAddress: string = [
        handleUnwanted(aadhaarVerifiedDetails?.house),
        handleUnwanted(aadhaarVerifiedDetails?.street),
        handleUnwanted(aadhaarVerifiedDetails?.landmark),
        handleUnwanted(aadhaarVerifiedDetails?.locality),
        //aadhaarVerifiedDetails?.vtc,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      let chunkSize2: boolean = conCatCurrentAddress.length > 50; // Condition applied here

      // Check if user has manually entered any address data (from formik values OR from formData/Redux)
      const hasManualCurrentAddress = (
        (formikRef?.current?.values?.currentAddressLine1 && formikRef?.current?.values?.currentAddressLine1.trim() !== "") ||
        (formikRef?.current?.values?.currentAddressLine2 && formikRef?.current?.values?.currentAddressLine2.trim() !== "") ||
        (formikRef?.current?.values?.currentAddressLine3 && formikRef?.current?.values?.currentAddressLine3.trim() !== "") ||
        (formData?.currentAddressLine1 && formData?.currentAddressLine1.trim() !== "") ||
        (formData?.currentAddressLine2 && formData?.currentAddressLine2.trim() !== "") ||
        (formData?.currentAddressLine3 && formData?.currentAddressLine3.trim() !== "")
      );

      if (hasManualCurrentAddress) {
        // User has entered data, preserve it
        // Don't overwrite with Aadhaar data
      } else if (chunkSize2) {
        // const currentAddr1: string = conCatCurrentAddress.slice(0, 50);
        // const currentAddr2: string = conCatCurrentAddress.slice(50, 100);
        // const currentAddr3: string = conCatCurrentAddress.slice(100, 150);
        const addressLines = splitAddressByWords(conCatCurrentAddress);
        const currentAddr1: string = addressLines[0] || "";
        const currentAddr2: string = addressLines[1] || "";
        const currentAddr3: string = addressLines[2] || "";
        formikRef?.current?.setFieldValue(
          "currentAddressLine1",
          currentAddr1 || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine2",
          currentAddr2 || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine3",
          currentAddr3 || ""
        );
      } else {
        formikRef?.current?.setFieldValue(
          "currentAddressLine1",
          aadhaarVerifiedDetails?.house || ""
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine2",
          `${aadhaarVerifiedDetails?.street || ""} ${aadhaarVerifiedDetails?.landmark || ""
            }`.trim()
        );
        formikRef?.current?.setFieldValue(
          "currentAddressLine3",
          `${aadhaarVerifiedDetails?.locality || ""}`.trim()
        );
      }

      formikRef?.current?.setFieldValue(
        "currentCity",
        formikRef?.current?.values?.currentCity ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.vtc) ||
        normalizeAadhaarAddressPart(aadhaarVerifiedDetails?.district)
      );

      const dobValue =
        formikRef?.current?.values?.dob ||
        (aadhaarVerifiedDetails?.dob
          ? aadhaarVerifiedDetails.dob.split("-")?.reverse()?.join("-")
          : "");

      formikRef?.current?.setFieldValue("dob", dobValue);
      const genderValue =
        formikRef?.current?.values?.gender ||
        (aadhaarVerifiedDetails?.gender === "M"
          ? "male"
          : aadhaarVerifiedDetails?.gender === "F"
            ? "female"
            : "");

      formikRef?.current?.setFieldValue("gender", genderValue);
      formikRef?.current?.setFieldValue("fatherName", formikRef?.current?.values?.fatherName || fatherName);
    }
  }, [
    formikRef,
    aadhaarVerifiedDetails,
    fatherName,
    activeHorizontalIndex,
    activeVerticalIndex,
    formikRef?.current?.values?.currentPincode
  ]);

  // Per-co-applicant: prepopulate address and personal fields from Aadhaar verification details
  useEffect(() => {
    if (!aadhaarVerifiedDetailsCoApplicant) return;
    Object.entries(aadhaarVerifiedDetailsCoApplicant).forEach(
      ([coAppKey, detailsRaw]) => {
        // coAppKey is like 'CoApplicant1', extract number
        const match = coAppKey.match(/CoApplicant(\d+)/);
        if (!match) return;
        const num = match[1];
        const details = detailsRaw as any;
        if (!details) return;
        // Address fields

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentCountry`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentCountry`
          ] || details?.country
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentPincode`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentPincode`
          ] || details?.pincode
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentState`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentState`
          ] || details?.state
        );

        const conCatPermanentAddress: string = [
          handleUnwanted(details?.house),
          handleUnwanted(details?.street),
          handleUnwanted(details?.landmark),
          handleUnwanted(details?.locality),
          //details?.vtc,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();

        let chunkSize: boolean = conCatPermanentAddress.length > 50; // Condition applied here
        if (chunkSize) {
          // const permanentAddr1: string = conCatPermanentAddress.slice(0, 50);
          // const permanentAddr2: string = conCatPermanentAddress.slice(50, 100);
          // const permanentAddr3: string = conCatPermanentAddress.slice(100, 150);
          const addressLines = splitAddressByWords(conCatPermanentAddress);
          const permanentAddr1: string = addressLines[0] || "";
          const permanentAddr2: string = addressLines[1] || "";
          const permanentAddr3: string = addressLines[2] || "";
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine1`,
            permanentAddr1 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine2`,
            permanentAddr2 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine3`,
            permanentAddr3 || ""
          );
        } else {
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine1`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine1`
            ] || details?.house
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine2`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine2`
            ] || `${details?.street} ${details?.landmark}`
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}permanentAddressLine3`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}permanentAddressLine3`
            ] || `${details?.locality}`
          );
        }

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}permanentCity`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}permanentCity`
          ] ||
          normalizeAadhaarAddressPart(details?.vtc) ||
          normalizeAadhaarAddressPart(details?.district)
        );

        // Current address fields
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentCountry`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentCountry`
          ] || details?.country
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentPincode`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentPincode`
          ] || details?.pincode
        );
        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentState`,
          formikRef?.current?.values?.[
          `addressCoApplicant${num}currentState`
          ] || details?.state
        );

        const conCatCurrentAddress: string = [
          handleUnwanted(details?.house),
          handleUnwanted(details?.street),
          handleUnwanted(details?.landmark),
          handleUnwanted(details?.locality),
          //details?.vtc,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();

        let chunkSize2: boolean = conCatCurrentAddress.length > 50; // Condition applied here

        if (chunkSize2) {
          // const currentAddr1: string = conCatCurrentAddress.slice(0, 50);
          // const currentAddr2: string = conCatCurrentAddress.slice(50, 100);
          // const currentAddr3: string = conCatCurrentAddress.slice(100, 150);
          const addressLines = splitAddressByWords(conCatCurrentAddress);
          const currentAddr1: string = addressLines[0] || "";
          const currentAddr2: string = addressLines[1] || "";
          const currentAddr3: string = addressLines[2] || "";
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine1`,
            currentAddr1 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine2`,
            currentAddr2 || ""
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine3`,
            currentAddr3 || ""
          );
        } else {
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine1`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine1`
            ] || details?.house
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine2`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine2`
            ] || `${details?.street} ${details?.landmark}`
          );
          formikRef?.current?.setFieldValue(
            `addressCoApplicant${num}currentAddressLine3`,
            formikRef?.current?.values?.[
            `addressCoApplicant${num}currentAddressLine3`
            ] || `${details?.locality}`
          );
        }

        formikRef?.current?.setFieldValue(
          `addressCoApplicant${num}currentCity`,
          formikRef?.current?.values?.[`addressCoApplicant${num}currentCity`] ||
          normalizeAadhaarAddressPart(details?.vtc) ||
          normalizeAadhaarAddressPart(details?.district)
        );

        // DOB and gender
        const dobValue =
          formikRef?.current?.values?.[`basicCoApplicant${num}dob`] ||
          (details?.dob ? details.dob.split("-").reverse().join("-") : "");
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}dob`,
          dobValue
        );
        const genderValue =
          formikRef?.current?.values?.[`basicCoApplicant${num}gender`] ||
          (details?.gender === "M"
            ? "male"
            : details?.gender === "F"
              ? "female"
              : "");
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}gender`,
          genderValue
        );
        formikRef?.current?.setFieldValue(
          `basicCoApplicant${num}fatherName`,
          formikRef?.current?.values?.[`basicCoApplicant${num}fatherName`] ||
          removeSalutation(details?.careOf)
        );
      }
    );
  }, [aadhaarVerifiedDetailsCoApplicant]);

  /**
   * Groups all co-applicant fields by their index.
   *
   * This function scans the provided fields array and identifies fields that belong to co-applicants
   * by matching the field name pattern "coApplicant{index}". It then groups these fields by their index,
   * sorts the groups in ascending order, and returns an array of objects containing a label and the grouped fields.
   *
   * @param {Array} fields - The array of form fields to group.
   * @returns {Array} Array of objects, each with a label ("Co-Applicant {index}") and the corresponding fields.
   */
  function getCoApplicantGroups(fields: any) {
    // Find all unique co-applicant prefixes (e.g. coApplicant1, coApplicant2, ...)
    const coApplicantRegex = /^coApplicant(\d+)/;
    const groups: any = {};

    fields.forEach((field: any) => {
      const match: any = field.name.match(coApplicantRegex);
      if (match) {
        const idx = match[1];
        if (!groups[idx]) groups[idx] = [];
        groups[idx].push(field);
      }
    });

    // Sort by index
    return Object.keys(groups)
      .sort((a, b) => Number(a) - Number(b))
      .map((idx) => ({
        label: `Co-Applicant ${idx}`,
        fields: groups[idx],
      }));
  }

  /**
   * Checks if all co-applicants are verified.
   *
   * This function uses getCoApplicantGroups to group co-applicant fields, then iterates over each group.
   * For each co-applicant that has a name filled, it checks the Redux verification state for PAN, email, and mobile.
   * Returns true only if all present co-applicants have all three fields verified.
   *
   * @param {Object} values - The current form values.
   * @returns {boolean} True if all co-applicants are verified, false otherwise.
   */
  function areAllCoApplicantsVerified(values: any) {
    // const groups = getCoApplicantGroups(fields);
    const groups = getCoApplicantGroups(fields);

    return groups.every((group) => {
      const coIdx: any = group.label.split(" ").pop();
      const reduxIdx = String(Number(coIdx) - 1); // zero-based index as string
      const verification = coApplicantVerification[reduxIdx];

      // Only check if co-applicant has a name (i.e., is filled)
      const nameField: any = group.fields.find((fld: any) =>
        fld.name.toLowerCase().endsWith("name")
      );
      const hasName = nameField && values[nameField.name];
      if (!hasName) return true; // skip empty co-applicant
      return (
        verification?.panVerified &&
        // verification?.emailVerified &&
        verification?.mobileVerified
      );
    });
  }

  const getSectionSubtitle = (step: number, form: number) => {
    if (step === 0) {
      if (form === 0) return "Verification Related Details";
      if (form === 1) return "Course Related Details";
      if (form === 2) return "Loan Related Details";
    }
    if (step === 1) {
      if (form === 0) return "Student Related Details";
      if (form === 1) return "Student Permanent Address Related Details";
      if (form === 2) return "Employment Related Details";
      if (form === 3) return "Academic Related Details";
      if (form === 4) return "Entrance Exam Related Details";
      if (form === 5) return "Loan Related Details";
    }
    return "Details";
  };

  function getEntranceExamCompletion(
    values: any,
    fields: any[],
    otherFields: any[],
    getFilledCountWithPanAadhaar: any
  ) {
    const coreExam = values.coreExamApplied;
    const languageExam = values.languageExamApplied;

    // Dynamically get radio fields for denominator
    const radioFields = fields.filter(
      (f) => f.name === "coreExamApplied" || f.name === "languageExamApplied"
    );
    const radioFieldNames = radioFields.map((f) => f.name);

    // Both "No"
    if (coreExam === "No" && languageExam === "No") {
      const filled = radioFieldNames.filter((name) => values[name]).length;
      return `${filled} / ${radioFieldNames.length}`;
    }

    // Only core "No"
    if (coreExam === "No" && languageExam === "Yes") {
      // Exclude languageExamScore/TotalMarks fields if their ScoreReceived is No
      const languageFieldObjs = fields.filter(
        (f) => f.name.startsWith("language") && f.name !== "languageExamApplied"
      );
      const filteredLanguageFields = languageFieldObjs.filter((f) => {
        if (
          /^languageExamScore(_\d+)?$/.test(f.name) ||
          /^languageTotalMarks(_\d+)?$/.test(f.name)
        ) {
          const match = f.name.match(
            /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "languageScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `languageScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        return true;
      });
      const filled =
        radioFieldNames.filter((name) => values[name]).length +
        filteredLanguageFields.filter(
          (f) => values[f.name] !== undefined && values[f.name] !== ""
        ).length;
      return `${filled} / ${filteredLanguageFields.length + 2}`;
    }

    // Only language "No"
    if (coreExam === "Yes" && languageExam === "No") {
      // Exclude coreExamScore/TotalMarks fields if their ScoreReceived is No
      const coreFieldObjs = fields.filter(
        (f) => f.name.startsWith("core") && f.name !== "coreExamApplied"
      );
      const filteredCoreFields = coreFieldObjs.filter((f) => {
        if (
          /^coreExamScore(_\d+)?$/.test(f.name) ||
          /^coreTotalMarks(_\d+)?$/.test(f.name)
        ) {
          const match = f.name.match(
            /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "coreScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `coreScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        return true;
      });
      const filled =
        radioFieldNames.filter((name) => values[name]).length +
        filteredCoreFields.filter(
          (f) => values[f.name] !== undefined && values[f.name] !== ""
        ).length;
      return `${filled} / ${filteredCoreFields.length + 2}`;
    }

    // Both "Yes" (default)
    // Exclude exam score and total marks fields from otherFields if Score Received is 'No'
    const filteredOtherFields = otherFields.filter((f) => {
      // For core
      if (
        /^coreExamScore(_\d+)?$/.test(f.name) ||
        /^coreTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding coreScoreReceived field (dynamic)
        const match = f.name.match(
          /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "coreScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `coreScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
      }
      // For language
      if (
        /^languageExamScore(_\d+)?$/.test(f.name) ||
        /^languageTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding languageScoreReceived field (dynamic)
        const match = f.name.match(
          /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "languageScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `languageScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
      }
      return true;
    });

    return `${getFilledCountWithPanAadhaar(filteredOtherFields, values)} / ${filteredOtherFields.length
      }`;
  }

  const isEntranceExamContinueDisabled = (values: any) => {
    const coreExam = values.coreExamApplied;
    const languageExam = values.languageExamApplied;

    // If any scoreReceived is "No" and its corresponding scoreExpectedOn is empty, disable Continue
    const allScoreReceivedFields = fields.filter(
      (f) => /^(core|language)ScoreReceived(_\d+)?$/.test(f.name)
    );
    const hasMissingExpectedDate = allScoreReceivedFields.some((f) => {
      if (values[f.name] !== "No") return false;
      const suffix = f.name.match(/(_\d+)$/)?.[1] ?? "";
      const expectedOnField = f.name.startsWith("core")
        ? `coreScoreExpectedOn${suffix}`
        : `languageScoreExpectedOn${suffix}`;
      return !values[expectedOnField];
    });
    if (hasMissingExpectedDate) return true;

    // Dynamically get core and language fields
    const coreFields = fields
      .filter((f) => f.name.startsWith("core") && f.name !== "coreExamApplied")
      .map((f) => f.name);
    const languageFields = fields
      .filter(
        (f) => f.name.startsWith("language") && f.name !== "languageExamApplied"
      )
      .map((f) => f.name);
    // Both "No"
    if (coreExam === "No" && languageExam === "No") {
      return !coreExam || !languageExam;
    }
    // Only core "No"
    if (coreExam === "No" && languageExam === "Yes") {
      // Exclude languageExamScore/TotalMarks fields if their ScoreReceived is No (dynamic)
      const filteredLanguageFields = languageFields.filter((fieldName) => {
        if (
          /^languageExamScore(_\d+)?$/.test(fieldName) ||
          /^languageTotalMarks(_\d+)?$/.test(fieldName)
        ) {
          const match = fieldName.match(
            /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "languageScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `languageScoreReceived_${idx}`;
          }
          if (
            /^languageExamID(_\d+)?$/.test(fieldName) ||
            /^languageExamId(_\d+)?$/.test(fieldName)
          ) {
            return false;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        return true;
      });
      const allFilled = filteredLanguageFields.every(
        (f) => values[f] !== undefined && values[f] !== ""
      );
      return !coreExam || !languageExam || !allFilled;
    }
    // Only language "No"
    if (coreExam === "Yes" && languageExam === "No") {
      // Exclude coreExamScore/TotalMarks fields if their ScoreReceived is No (dynamic)
      const filteredCoreFields = coreFields.filter((fieldName) => {
        if (
          /^coreExamScore(_\d+)?$/.test(fieldName) ||
          /^coreTotalMarks(_\d+)?$/.test(fieldName)
        ) {
          const match = fieldName.match(
            /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
          );
          let scoreReceivedKey = "coreScoreReceived";
          if (match) {
            const idx = match[1] || match[2];
            scoreReceivedKey = `coreScoreReceived_${idx}`;
          }
          if (values[scoreReceivedKey] === "No") {
            return false;
          }
        }
        if (
          /^coreExamID(_\d+)?$/.test(fieldName) ||
          /^coreExamId(_\d+)?$/.test(fieldName)
        ) {
          return false;
        }
        return true;
      });
      const allFilled = filteredCoreFields.every(
        (f) => values[f] !== undefined && values[f] !== ""
      );
      return !coreExam || !languageExam || !allFilled;
    }
    // Both "Yes"
    // Exclude exam score and total marks fields from otherFields if Score Received is 'No'

    const filteredOtherFields = otherFields.filter((f) => {
      // For core
      if (
        /^coreExamScore(_\d+)?$/.test(f.name) ||
        /^coreTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding coreScoreReceived field (dynamic)
        const match = f.name.match(
          /^coreExamScore_(\d+)$|^coreTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "coreScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `coreScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
        if (
          /^coreExamID(_\d+)?$/.test(f.name) ||
          /^coreExamId(_\d+)?$/.test(f.name)
        ) {
          return false;
        }
      }
      // For language
      if (
        /^languageExamScore(_\d+)?$/.test(f.name) ||
        /^languageTotalMarks(_\d+)?$/.test(f.name)
      ) {
        // Find corresponding languageScoreReceived field (dynamic)
        const match = f.name.match(
          /^languageExamScore_(\d+)$|^languageTotalMarks_(\d+)$/
        );
        let scoreReceivedKey = "languageScoreReceived";
        if (match) {
          const idx = match[1] || match[2];
          scoreReceivedKey = `languageScoreReceived_${idx}`;
        }
        if (values[scoreReceivedKey] === "No") {
          return false;
        }
        if (
          /^languageExamID(_\d+)?$/.test(f.name) ||
          /^languageExamId(_\d+)?$/.test(f.name)
        ) {
          return false;
        }
      }
      return true;
    });
    return (
      getFilledCountWithPanAadhaar(filteredOtherFields, values) !==
      filteredOtherFields.length
    );
  };

  function getEmploymentCompletion(
    values: any,
    fields: any[],
    getFilledCountWithPanAadhaar: any
  ) {
    // if the main question is not answered, completion is 0
    if (!values.employmentisEmployed) {
      return `0 / ${fields.length}`;
    }

    // Find all employment-related fields except the main radio
    const employmentRadio = fields.find(
      (f) => f.name === "employmentisEmployed"
    );

    // Define companyFields as per selector
    const companyFields = fields.filter(
      (f) =>
        f.required &&
        f.name?.toLowerCase().includes("employmentcompany") &&
        f.name !== "employmentCompanyName"
    );

    // Employment fields: start with employment or employmentCompany, not the radio, and not in companyFields
    const employmentFieldsBase = fields.filter(
      (f) =>
        f.name !== "employmentisEmployed" &&
        (f.name.startsWith("employment") ||
          f.name.startsWith("employmentCompany")) &&
        !companyFields.some((cf) => cf.name === f.name)
    );

    // When employmentType is "Others", only count required employment fields and exclude the Year field
    const employmentFields =
      values?.employmentType === "Others"
        ? employmentFieldsBase.filter(
          (f) =>
            f.required &&
            f.name !== "employmentYear" &&
            f.name !== "employmentMonth" &&
            f.name !== "employmentDesignation"
        )
        : employmentFieldsBase;

    // If "No" is selected, only the required radio fields are required
    if (values.employmentisEmployed === "No") {
      // Find all required employment radio fields (usually just employmentisEmployed, but could be more)
      const requiredEmploymentRadios = fields.filter(
        (f) =>
          f.required &&
          f.type === "radio" &&
          (f.name?.toLowerCase().startsWith("employment") ||
            f.name?.toLowerCase().startsWith("employmentcompany"))
      );
      const filledRadios = requiredEmploymentRadios.filter(
        (f) => values[f.name] !== undefined && values[f.name] !== ""
      ).length;
      return `${filledRadios} / ${requiredEmploymentRadios.length}`;
    }

    // If "Yes" is selected, count all employment fields (including radio)
    const allFields = [employmentRadio, ...employmentFields].filter(Boolean);
    const filled = getFilledCountWithPanAadhaar(allFields, values);
    return `${filled} / ${allFields.length}`;
  }

  useEffect(() => {
    const handlers: Array<{
      el: HTMLInputElement;
      onFocus: () => void;
    }> = [];

    autoCompleteOffFields.forEach((field) => {
      const el = document.querySelector<HTMLInputElement>(
        `[name="${field}"]`
      );

      if (!el) return;

      el.setAttribute("autocomplete", "new-password");
      el.readOnly = true;

      const onFocus = () => {
        el.readOnly = false;
      };

      el.addEventListener("focus", onFocus);
      handlers.push({ el, onFocus });
    });

    // Cleanup on unmount
    return () => {
      handlers.forEach(({ el, onFocus }) => {
        el.removeEventListener("focus", onFocus);
      });
    };
  }, []);

  /** Inline field errors only after Save/Continue is clicked — not on first paint or while typing. */
  const [showFieldErrorsAfterSaveAttempt, setShowFieldErrorsAfterSaveAttempt] =
    useState(false);

  useEffect(() => {
    setShowFieldErrorsAfterSaveAttempt(false);
  }, [activeHorizontalIndex, activeVerticalIndex, pageType]);

  return (
    <Box sx={{ width: "100%" }}>
      {activeVerticalIndex === 3 && activeHorizontalIndex == 0 ? (
        !isCheckingOffer ? (
          <EligibilityConfirmation
            firstName={formData.firstName}
            provisionalOffer={breData}
            onNext={moveToNextStep}
          />
        ) : null
      ) : (
        <>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={
              activeHorizontalIndex === 1 &&
              (activeVerticalIndex === 0 || activeVerticalIndex === 1)
            }
            validateOnChange={showFieldErrorsAfterSaveAttempt}
            validateOnBlur={showFieldErrorsAfterSaveAttempt}
          >
            {({
              isSubmitting,
              errors,
              touched,
              values,
              setFieldValue,
              setTouched,
              setErrors,
              validateForm,
              submitForm,
              ...otherFormikProps
            }) => {
              // if (values.employmentCompanyPincode) {
              //   debouncedCompanyZipCodeCall(values.employmentCompanyPincode);
              // }

              // Exclude employment/company fields from errors if "No" is selected for employment

              const employmentAndCompanyFields = fields
                .filter(
                  (f) =>
                    f.required &&
                    (f.name?.toLowerCase().startsWith("employment") ||
                      f.name?.toLowerCase().startsWith("employmentcompany")) &&
                    f.name !== "employmentisEmployed"
                )
                .map((f) => f.name);

              const employmentNotWorking =
                values.employmentisEmployed === "No" ||
                values.employmentisEmployed === false ||
                String(values?.employmentisEmployed ?? "").toLowerCase() ===
                  "no";

              const isExcludedField = (name: string) => {
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  employmentNotWorking &&
                  employmentAndCompanyFields.includes(name)
                ) {
                  return true;
                }
                // When employmentType is Others, skip validation for employmentYear
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  values?.employmentType === "Others" &&
                  (name === "employmentYear" ||
                    name === "employmentMonth" ||
                    name === "employmentDesignation")
                ) {
                  return true;
                }
                // Exclude University/Institute/Course validation errors on step (0,1) when admissionStatus is Undecided (both dropdown and not-in-list mode)
                if (activeHorizontalIndex === 0 && activeVerticalIndex === 1) {
                  const applyAdmissionUndecided = values?.admissionStatus === "Undecided";
                  const uniExcluded = (name === "university") && applyAdmissionUndecided;
                  const instExcluded = (name === "institute") && applyAdmissionUndecided;
                  const courseExcluded = (name === "courseName") && applyAdmissionUndecided;
                  if (uniExcluded || instExcluded || courseExcluded) {
                    return true;
                  }
                }
                // Entrance Exam Details (1,4): exclude hidden score/marks/date fields
                // based on the ScoreReceived ("Received Your Results?") value
                if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
                  // Static fields
                  const coreScoreReceived = values?.coreScoreReceived;
                  const languageScoreReceived = values?.languageScoreReceived;
                  if (
                    coreScoreReceived === "No" &&
                    (name === "coreExamScore" || name === "coreTotalMarks")
                  ) return true;
                  if (
                    coreScoreReceived !== "No" &&
                    name === "coreScoreExpectedOn"
                  ) return true;
                  if (
                    languageScoreReceived === "No" &&
                    (name === "languageExamScore" || name === "languageTotalMarks")
                  ) return true;
                  if (
                    languageScoreReceived !== "No" &&
                    name === "languageScoreExpectedOn"
                  ) return true;
                  // Dynamic fields (suffixed with _N)
                  const dynMatch = name.match(/^(core|language)(.+)_(\d+)$/);
                  if (dynMatch) {
                    const prefix = dynMatch[1];
                    const fieldPart = dynMatch[2];
                    const suffix = dynMatch[3];
                    const dynScoreReceived = values?.[`${prefix}ScoreReceived_${suffix}`];
                    if (
                      dynScoreReceived === "No" &&
                      (fieldPart === "ExamScore" || fieldPart === "TotalMarks")
                    ) return true;
                    if (
                      dynScoreReceived !== "No" &&
                      fieldPart === "ScoreExpectedOn"
                    ) return true;
                  }
                }
                return [
                  "employmentisEmployed",
                  "coreExamApplied",
                  "languageExamApplied",
                ].includes(name);
              };

              const currentStepFieldNames = getReferenceCollateralActiveFields(
                values || {}
              )
                .map((f: any) => f?.name)
                .filter((name: string | undefined): name is string => Boolean(name));
              const activeReferenceCollateralFields =
                getReferenceCollateralActiveFields(values || {});
              const activeReferenceCollateralRequiredFields =
                activeReferenceCollateralFields.filter((field: any) =>
                  isReferenceCollateralStep ? field?.required !== false : true
                );

              /** Normalize Yup / manual message to a display string. */
              const toErrorString = (e: unknown): string =>
                typeof e === "string"
                  ? e
                  : e != null && typeof e === "object" && "message" in (e as any)
                    ? String((e as { message?: unknown }).message ?? "")
                    : String(e ?? "");

              /** True when a required field still has no usable value (covers types Yup may skip). */
              const isRequiredFieldValueMissing = (f: any, val: any): boolean => {
                const t = f?.type;
                if (t === "checkbox") return val !== true;
                if (val === null || val === undefined) return true;
                if (t === "number") {
                  return val === "" || (typeof val === "number" && Number.isNaN(val));
                }
                if (t === "date") {
                  return val === "" || val == null;
                }
                if (typeof val === "string") return val.trim() === "";
                if (typeof val === "object") {
                  const inner =
                    (val as { value?: unknown }).value ??
                    (val as { label?: unknown }).label;
                  if (inner == null) return true;
                  return String(inner).trim() === "";
                }
                return false;
              };

              /** Same set as validationSchemas `EMPLOYMENT_WHEN_EMPLOYED_NOT_OTHERS_REQUIRED` — UI can show * via isEmployeeRequiredField while `required` is false. */
              const EMPLOYMENT_MANUAL_REQUIRED_WHEN_EMPLOYED = new Set([
                "employmentCompanyName",
                "employmentCompanyAddress1",
                "employmentCompanyAddress2",
                "employmentCompanyAddress3",
                "employmentLandmark",
                "employmentCompanyPincode",
                "employmentCompanyCity",
                "employmentCompanyState",
                "employmentCompanyCountry",
                "employmentDesignation",
              ]);

              const employedYesForManualValidation =
                values?.employmentisEmployed === "Yes" ||
                values?.employmentisEmployed === true ||
                String(values?.employmentisEmployed ?? "").toLowerCase() ===
                  "yes";

              /** Align with validationSchemas entrance step — JSON often has required:false while UI shows *. */
              const entranceAnswerYes = (v: unknown) =>
                v === "Yes" ||
                v === true ||
                String(v ?? "").toLowerCase() === "yes";

              const scoreReceivedForEntranceRow = (
                vals: Record<string, unknown>,
                prefix: "coreScoreReceived" | "languageScoreReceived",
                suffix: string
              ) => {
                const key = `${prefix}${suffix}`;
                const direct = vals[key];
                if (direct !== undefined && direct !== null && direct !== "") {
                  return direct;
                }
                if (suffix === "_0") {
                  const base = vals[prefix];
                  if (base !== undefined && base !== null && base !== "") {
                    return base;
                  }
                }
                return direct;
              };

              const isFieldRequired = (f: any) => {
                if (
                  f?.required === true ||
                  f?.required === "true" ||
                  String(f?.required ?? "").toLowerCase() === "yes"
                ) {
                  return true;
                }
                if (
                  activeHorizontalIndex === 1 &&
                  activeVerticalIndex === 2 &&
                  employedYesForManualValidation &&
                  values?.employmentType !== "Others" &&
                  EMPLOYMENT_MANUAL_REQUIRED_WHEN_EMPLOYED.has(f?.name)
                ) {
                  return true;
                }
                if (activeHorizontalIndex === 1 && activeVerticalIndex === 4) {
                  const n = f?.name || "";
                  if (/^coreTotalMarks(_\d+)?$/.test(n)) {
                    if (entranceAnswerYes(values?.coreExamApplied)) return true;
                  }
                  if (/^languageTotalMarks(_\d+)?$/.test(n)) {
                    if (entranceAnswerYes(values?.languageExamApplied)) {
                      return true;
                    }
                  }
                  if (/^coreExamScore(_\d+)?$/.test(n)) {
                    const sfx = n.match(/(_\d+)$/)?.[0] ?? "";
                    const recv = scoreReceivedForEntranceRow(
                      values as Record<string, unknown>,
                      "coreScoreReceived",
                      sfx
                    );
                    if (
                      entranceAnswerYes(values?.coreExamApplied) &&
                      entranceAnswerYes(recv)
                    ) {
                      return true;
                    }
                  }
                  if (/^languageExamScore(_\d+)?$/.test(n)) {
                    const sfx = n.match(/(_\d+)$/)?.[0] ?? "";
                    const recv = scoreReceivedForEntranceRow(
                      values as Record<string, unknown>,
                      "languageScoreReceived",
                      sfx
                    );
                    if (
                      entranceAnswerYes(values?.languageExamApplied) &&
                      entranceAnswerYes(recv)
                    ) {
                      return true;
                    }
                  }
                }
                return false;
              };

              const currentStepErrors = Object.keys(errors).filter(
                (key) =>
                  currentStepFieldNames.includes(key) && !isExcludedField(key)
              );
              // Remove errors for employment/company fields from Formik errors if "No" is selected
              if (
                activeHorizontalIndex === 1 &&
                activeVerticalIndex === 2 &&
                employmentNotWorking
              ) {
                employmentAndCompanyFields.forEach((field) => {
                  if (errors[field]) {
                    delete errors[field];
                  }
                });
              }
              // Remove errors for University/Institute/Course on step (0,1) when admissionStatus is Undecided only if NOT in notInList (when "not in list" is selected, show required value error)
              if (activeHorizontalIndex === 0 && activeVerticalIndex === 1) {
                // console.log(errors, values?.admissionStatus)
                const applyAdmissionUndecided = values?.admissionStatus === "Undecided";
                if (applyAdmissionUndecided) {
                  if (errors["country"]) delete errors["country"];
                  if (!notInList?.includes("University Name") && errors["university"]) delete errors["university"];
                  if (!notInList?.includes("Institute Name") && errors["institute"]) delete errors["institute"];
                  if (!notInList?.includes("Course Name") && errors["courseName"]) delete errors["courseName"];
                }
              }
              return (
                <Form autoComplete="off">
                  
                  {pageType == "FORM" && (
                    <Box sx={{ mb: 2, mt: 2 }}>
                      <SectionHeader
                        icon={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 40,
                              height: 40,
                              borderRadius: "8px",
                              bgcolor: "#e5feffff",
                            }}
                          >
                            <img
                              src={
                                activeHorizontalIndex === 0 // activeHorizontalIndex === 0
                                  ? activeVerticalIndex === 0
                                    ? idIcon
                                    : activeVerticalIndex === 1
                                      ? booksIcon
                                      : loanIcon
                                  : activeVerticalIndex === 0 // activeHorizontalIndex === 1
                                    ? idIcon
                                    : activeVerticalIndex === 1
                                      ? locationIcon
                                      : activeVerticalIndex === 2
                                        ? idIcon
                                        : academicIcon
                              }
                              alt="icon"
                              style={{
                                width: 28,
                                height: 28,
                              }}
                            />
                          </Box>
                        }
                        title={
                          horizontalSteps[activeHorizontalIndex]?.verticalSteps[
                            activeVerticalIndex
                          ]?.stepLabel === "Address Details"
                            ? "Permanent Address"
                            : horizontalSteps[activeHorizontalIndex]
                              ?.verticalSteps[activeVerticalIndex]?.stepLabel ||
                              horizontalSteps[activeHorizontalIndex]
                                ?.verticalSteps[activeVerticalIndex]?.verticalStepName
                        }
                        subtitle={getSectionSubtitle(
                          activeHorizontalIndex,
                          activeVerticalIndex
                        )}
                        completion={
                          activeHorizontalIndex === 1 && activeVerticalIndex === 4
                            ? getEntranceExamCompletion(
                              values,
                              fields,
                              otherFields,
                              getFilledCountWithPanAadhaar
                            )
                            : activeHorizontalIndex === 1 &&
                              activeVerticalIndex === 2
                              ? `${getEmploymentCompletion(
                                values,
                                fields,
                                getFilledCountWithPanAadhaar
                              )}`
                              : `${getFilledCountWithPanAadhaar(
                                otherFields.filter((f) => {
                                  const isUniversity = f.name === "university";
                                  const isInstitute = f.name === "institute";
                                  const isCourseName = f.name === "courseName";
                                  const applyAdmissionUndecided =
                                    activeHorizontalIndex === 0 &&
                                    activeVerticalIndex === 1 &&
                                    values?.admissionStatus === "Undecided";
                                  const exclude = applyAdmissionUndecided &&
                                    (isUniversity || isInstitute || isCourseName);
                                  return !exclude;
                                }),
                                values
                              )} / ${otherFields.filter((f) => {
                                const isUniversity = f.name === "university";
                                const isInstitute = f.name === "institute";
                                const isCourseName = f.name === "courseName";
                                const applyAdmissionUndecided =
                                  activeHorizontalIndex === 0 &&
                                  activeVerticalIndex === 1 &&
                                  values?.admissionStatus === "Undecided";
                                const exclude = applyAdmissionUndecided &&
                                  (isUniversity || isInstitute || isCourseName);
                                return !exclude;
                              }).length
                              }`
                        }
                      />
                    </Box>
                  )}
                  {pageType === "SUMMARY" &&
                    !(activeHorizontalIndex === 1 && activeVerticalIndex === 5) && (
                    <Box sx={{ mb: 2, mt: 2 }}>
                      <SummarySectionHeader
                        title={
                            horizontalSteps[activeHorizontalIndex]?.verticalSteps[
                            activeVerticalIndex
                          ]?.stepLabel === "Address Details"
                            ? "Permanent Address"
                            : isReferenceCollateralStep &&
                              typeof summaryReferenceCollateralEditTab === "number"
                              ? summaryReferenceCollateralEditTab === 1
                                ? "Collateral Details"
                                : "Reference Details"
                              : horizontalSteps[activeHorizontalIndex]
                                ?.verticalSteps[activeVerticalIndex]?.stepLabel ||
                                horizontalSteps[activeHorizontalIndex]
                                  ?.verticalSteps[activeVerticalIndex]?.verticalStepName
                        }
                      />
                    </Box>
                    )}
                  {/* Form Fields */}
                  <Grid container spacing={2}>
                    {activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 2 ? (
                      <>
                        {/* Always render the "Are you employed?" radio field */}
                        {fields
                          .filter((f) => f.name === "employmentisEmployed")
                          .map((field) => renderField(field))}

                        {/* If "Yes" is selected, render the rest of the employment fields */}
                        {values.employmentisEmployed === "Yes" &&
                          (() => {
                            let hasInsertedCompanyHeader = false;
                            // When employmentType is "Others", show only required fields in this section
                            const allEmploymentFields = fields.filter(
                              (f) => f.name !== "employmentisEmployed"
                            );
                            const shouldShowOnlyRequired =
                              values?.employmentType === "Others";
                             const fieldsToRenderBase = shouldShowOnlyRequired
                              ? allEmploymentFields.filter(
                                (f) =>
                                  f.required &&
                                  f.name !== "employmentYear" &&
                                  f.name !== "employmentMonth" &&
                                  f.name !== "employmentDesignation"
                              )
                              : allEmploymentFields;
                              // SUMMARY: show "Help us with your work experience" below Monthly Income
                            let fieldsToRender = fieldsToRenderBase;
                            if (pageType === "SUMMARY") {
                              const yearField = fieldsToRenderBase.find(
                                (f) => f.name === "employmentYear"
                              );
                              const withoutWorkExp = fieldsToRenderBase.filter(
                                (f) =>
                                  f.name !== "employmentYear" &&
                                  f.name !== "employmentMonth"
                              );
                              if (
                                yearField &&
                                values?.employmentType !== "Others"
                              ) {
                                const incomeIdx = withoutWorkExp.findIndex(
                                  (f) => f.name === "employmentMonthlyIncome"
                                );
                                fieldsToRender =
                                  incomeIdx >= 0
                                    ? [
                                      ...withoutWorkExp.slice(0, incomeIdx + 1),
                                      yearField,
                                      ...withoutWorkExp.slice(incomeIdx + 1),
                                    ]
                                    : [...withoutWorkExp, yearField];
                              } else {
                                fieldsToRender = withoutWorkExp;
                              }
                            }
                            return fieldsToRender.map((field) => {
                              const elements: React.ReactNode[] = [];

                              // Insert header before the *first* company field
                              if (
                                !hasInsertedCompanyHeader &&
                                field.name
                                  ?.toLowerCase()
                                  .includes("employmentcompany") &&
                                field.name !== "employmentCompanyName"
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="company-section-header"
                                  >
                                    <Box sx={{ mt: 3, mb: 1 }}>
                                       {pageType === "SUMMARY" ? (
                                        <SummarySectionHeader title="Company Address" />
                                      ) : (
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Company Address"
                                          subtitle="Company Address Related Details"
                                          completion={`${companyFields.length > 0
                                            ? `${getFilledCount(
                                              companyFields,
                                              values
                                            )} / ${companyFields.length}`
                                            : ""
                                            }`}
                                        />
                                      )}
                                    </Box>
                                  </Grid>
                                );
                                hasInsertedCompanyHeader = true;
                              }

                              if (
                                pageType === "SUMMARY" &&
                                field.name === "employmentMonthlyObligation"
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="employment-obligation-row-break"
                                    sx={{ p: "0 !important" }}
                                  />
                                );
                              }

                              elements.push(renderField(field));
                              return elements;
                            });
                          })()}
                      </>
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 4 ? (
                      <>
                        {/* Entrance Exam Details Sections */}
                        <Grid container ml={2} mt={2}>
                          {/* Render Core Entrance Exam Section */}
                          <EntranceExamDetailsSection
                            fields={fields.filter((f: any) =>
                              f.name.startsWith("core")
                            )}
                            sectionPrefix="core"
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            renderField={renderField}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            formikRef={formikRef}
                            dropdownData={dropdownData}
                            trackingId={trackingId}
                          />

                          {/* Render Language Entrance Exam Section */}
                          <EntranceExamDetailsSection
                            fields={fields.filter((f: any) =>
                              f.name.startsWith("language")
                            )}
                            sectionPrefix="language"
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            renderField={renderField}
                            horizontalSteps={horizontalSteps}
                            activeHorizontalIndex={activeHorizontalIndex}
                            activeVerticalIndex={activeVerticalIndex}
                            formikRef={formikRef}
                            dropdownData={dropdownData}
                            trackingId={trackingId}
                          />
                        </Grid>
                      </>
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 3 ? (
                      (() => {
                        return (
                          <>
                            {/* Render Course Details Section */}
                            <CourseDetailsSection
                              fields={fields}
                              horizontalSteps={horizontalSteps}
                              activeHorizontalIndex={activeHorizontalIndex}
                              activeVerticalIndex={activeVerticalIndex}
                              renderField={renderField}
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={otherFormikProps.handleChange}
                              formikRef={formikRef}
                              trackingId={trackingId}
                            />
                          </>
                        );
                      })()
                    ) : activeHorizontalIndex === 1 &&
                      activeVerticalIndex === 5 ? (
                      <>
                        {/* Render CoApplicant Details Section */}
                        <CoApplicantDetailsSection
                          fields={fields}
                          horizontalSteps={horizontalSteps}
                          activeHorizontalIndex={activeHorizontalIndex}
                          activeVerticalIndex={activeVerticalIndex}
                          pageType={pageType}
                          selectedCoApplicantKey={
                            loanDetailCoApplicantCollapseValue
                          }
                          getCoApplicantGroups={getCoApplicantGroups}
                          renderField={renderField}
                          values={values}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          handleChange={otherFormikProps.handleChange}
                          formikRef={formikRef}
                          pinCodeData={{ permanent: permanentCodeData, current: currentCodeData }}
                          dropdownData={dropdownData}
                          handleInvokZipCode={handleInvokZipCode}
                          relationshipOptionsList={relationshipOptions}
                          salutationOptionsList={
                            dropdownData?.salutations || []
                          }
                          tabIndex={tabIndex}
                          setTabIndex={setTabIndex}
                          zipCodeLoading={zipCodeLoading}
                          checkIsLeadApiInvoked={checkIsLeadApiInvoked}
                          handleLeadCreationFlow={handleLeadCreationFlow}
                          getLeadPayload={getLeadPayload}
                        />
                      </>
                    ) : isApplicantAdditionalDetailsStep ? (
                      (() => {
                        return (
                          <>
                            {/* Render Applicant Additional Details Section */}
                            <ApplicationAdditionalDetails
                              fields={fields}
                              horizontalSteps={horizontalSteps}
                              activeHorizontalIndex={activeHorizontalIndex}
                              activeVerticalIndex={activeVerticalIndex}
                              renderField={renderField}
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={otherFormikProps.handleChange}
                              formikRef={formikRef}
                              nationalityOptions={nationalityMasterOptions}
                              dropdownData={dropdownData}
                            />
                          </>
                        );
                      })()
                    ) : isFundsAndExpensesStep ? (
                      (() => {
                        return (
                          <>
                            {/* Render Fund & Expense Details Section */}
                            <FundExpenseDetails
                              fields={fields}
                              renderField={renderField}
                              formikRef={formikRef}
                              values={values}
                            />
                          </>
                        );
                      })()
                    ) : isReferenceCollateralStep ? (
                      (() => {
                        return (
                          <>
                            {/* Render Reference & Collateral Details Section */}
                            <ReferenceCollateralDetails
                              fields={referenceCollateralFields}
                              horizontalSteps={horizontalSteps}
                              renderField={renderField}
                              formikRef={formikRef}
                              values={values}
                              isSaving={isSubmittingToAPI}
                              pageType={pageType}
                              hideTabs={
                                pageType === "SUMMARY" &&
                                typeof summaryReferenceCollateralEditTab === "number"
                              }
                              activeTab={referenceCollateralActiveTab}
                              onActiveTabChange={setReferenceCollateralActiveTab}
                              activeReferenceNumber={activeReferenceSection}
                              onActiveReferenceChange={setActiveReferenceSection}
                              activeCollateralNumber={activeCollateralSection}
                              onActiveCollateralChange={setActiveCollateralSection}
                              onCollateralOptionsChange={setCollateralMasterOptions}
                            />
                          </>
                        );
                      })()
                    ) : (
                      <>
                        {(() => {
                          // Fields excluding pan and aadhaar
                          const baseFields = fields.filter(
                            (field) =>
                              field.name !== "pan" && field.name !== "aadhaar"
                          );
                          const filteredFields = baseFields;

                          // Find index of first dob-related field
                          const dobIndex = filteredFields.findIndex(
                            (field) =>
                              field.name?.toLowerCase().includes("dob") ||
                              field.label?.toLowerCase().includes("dob") ||
                              field.label?.toLowerCase().includes("date of birth")
                          );
                          const panInsertionIndex =
                            dobIndex + 1;

                          if (dobIndex === -1) {
                            let hasInsertedCurrHeader = false; // <-- track insertion

                            return filteredFields.map((field) => {
                              const elements: React.ReactNode[] = [];

                              // Insert header before the *first* field with prefix "current"
                              if (
                                !hasInsertedCurrHeader &&
                                field.name?.toLowerCase().startsWith("current")
                              ) {
                                elements.push(
                                  <Grid
                                    item
                                    xs={12}
                                    key="current-section-header"
                                  >
                                    <Box
                                      sx={{ mt: 3, mb: 1 }}
                                      key="current-section-header"
                                    >
                                         {pageType === "SUMMARY" ? (
                                        <SummarySectionHeader title="Current Address" />
                                      ) : (
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Current Address"
                                          subtitle="Student Current Address Related Details "
                                          completion={`${getFilledCount(
                                            currFields,
                                            values
                                          )} / ${currFields.length}`}
                                        />
                                      )}
                                    </Box>
                                  </Grid>
                                );
                                hasInsertedCurrHeader = true;
                              }

                              elements.push(renderField(field));
                              return elements;
                            });
                          }

                          // Before PAN/Aadhaar insertion point
                          const beforeDob = filteredFields.slice(
                            0,
                            panInsertionIndex
                          );

                          // After PAN/Aadhaar insertion point
                          const afterDob = filteredFields.slice(
                            panInsertionIndex
                          );

                          let hasInsertedCurrHeader = false;

                          return (
                            <>
                              {/* Fields before dob */}
                              {beforeDob.map((field) => {
                                const elements: React.ReactNode[] = [];

                                if (
                                  !hasInsertedCurrHeader &&
                                  field.name
                                    ?.toLowerCase()
                                    .startsWith("current")
                                ) {
                                  elements.push(
                                    <Grid
                                      item
                                      xs={12}
                                      key="current-section-header"
                                    >
                                      <Box
                                        sx={{ mt: 3, mb: 1 }}
                                        key="current-section-header"
                                      >
                                         {pageType === "SUMMARY" ? (
                                          <SummarySectionHeader title="Current Address" />
                                        ) : (
                                          <SectionHeader
                                            icon={
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  width: 40,
                                                  height: 40,
                                                  borderRadius: "8px",
                                                  bgcolor: "#e5feffff",
                                                }}
                                              >
                                                <img
                                                  src={locationIcon}
                                                  alt="icon"
                                                  style={{
                                                    width: 28,
                                                    height: 28,
                                                  }}
                                                />
                                              </Box>
                                            }
                                            title="Current Address"
                                            subtitle="Student Current Address Related Details "
                                            completion={`${getFilledCount(
                                              currFields,
                                              values
                                            )} / ${currFields.length}`}
                                          />
                                        )}
                                      </Box>
                                    </Grid>
                                  );
                                  hasInsertedCurrHeader = true;
                                }

                                elements.push(renderField(field));
                                return elements;
                              })}
                              {/* For Pan and Aadhaar Section */}
                              {isPanStep &&
                                renderPanAadhaarFields(
                                  values,
                                  shouldDisableFields,
                                  setFieldValue
                                )}
                              {/* Fields after dob */}
                              {afterDob.map((field) => {
                                const elements: React.ReactNode[] = [];

                                // Insert header before the *first* field with prefix "current"
                                if (
                                  !hasInsertedCurrHeader &&
                                  field.name
                                    ?.toLowerCase()
                                    .startsWith("current")
                                ) {
                                  elements.push(
                                    <Box
                                      sx={{ mt: 3, mb: 1 }}
                                      key="current-section-header"
                                    >
                                       {pageType === "SUMMARY" ? (
                                        <SummarySectionHeader title="Current Address" />
                                      ) : (
                                        <SectionHeader
                                          icon={
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 40,
                                                borderRadius: "8px",
                                                bgcolor: "#e5feffff",
                                              }}
                                            >
                                              <img
                                                src={locationIcon}
                                                alt="icon"
                                                style={{
                                                  width: 28,
                                                  height: 28,
                                                }}
                                              />
                                            </Box>
                                          }
                                          title="Current Address"
                                          subtitle="Student Current Address Related Details "
                                          completion={`${getFilledCount(
                                            currFields,
                                            values
                                          )} / ${currFields.length}`}
                                        />
                                      )}
                                    </Box>
                                  );
                                  hasInsertedCurrHeader = true;
                                }

                                elements.push(renderField(field));
                                return elements;
                              })}
                            </>
                          );
                        })()}
                      </>
                    )}
                  </Grid>

                   {/* Actions Back & Continue (hidden on SUMMARY view) */}
                  {pageType !== "SUMMARY" && (
                    <Box mt={2}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        {/* Show Back button only if not on first form and not on step 3 */}
                        {((activeHorizontalIndex === 0 &&
                          activeVerticalIndex > 0 &&
                          activeVerticalIndex < 3) ||
                          (activeHorizontalIndex === 1 &&
                            activeVerticalIndex > 0)) && isPreviousButton === true && !isXsOrSm ? (
                          <Box sx={{ width: { xs: "100%", sm: 134 }, mb: isXsOrSm ? 2 : "0", mr: !isXsOrSm ? 2 : "0", }}>
                            <OutlinedPrimaryButton
                              width={isXsOrSm ? "100%" : "134px"}
                              type="button"
                              fullWidth
                              variant="outlined"
                              onClick={() => {
                                dispatch(prevVerticalStep());
                                window.scrollTo({ top: 0, behavior: "smooth" });
                              }}
                              disabled={isSubmitting || isSubmittingToAPI}
                            >
                              <ArrowBackIcon sx={{ mr: !isXsOrSm ? 1 : 0 }} />

                              {"Previous"}
                            </OutlinedPrimaryButton>
                          </Box>
                        ) : null}
                        {/* Continue Button */}
                        {(activeHorizontalIndex !== 1 ||
                          activeVerticalIndex !== 5) && (
                            <Box sx={{ width: { xs: "100%", sm: 220 } }}>
                              <PrimaryButton
                                type="button"
                                fullWidth         
                                disabled={
                                  zipCodeLoading ||
                                  isSubmitting ||
                                  isSubmittingToAPI ||
                                  !isTruthyFormFlag(isMobileVerified) ||
                                  !isTruthyFormFlag(isEmailVerified) ||
                                  (isReferenceCollateralStep
                                    ? getFilledCountWithPanAadhaar(
                                        activeReferenceCollateralRequiredFields,
                                        values
                                      ) !==
                                      activeReferenceCollateralRequiredFields.length
                                    :
                                  (activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 2 &&
                                    values.employmentisEmployed === "No"
                                    ? !values.employmentisEmployed
                                    : activeHorizontalIndex === 1 &&
                                      activeVerticalIndex === 2
                                      ? (() => {
                                        // For Employment step when "Yes", ensure displayed fields are filled.
                                        const allEmploymentFields = fields.filter(
                                          (f) => f.name !== "employmentisEmployed"
                                        );
                                        const shouldShowOnlyRequired = values?.employmentType === "Others";
                                        const fieldsToCheck = shouldShowOnlyRequired
                                          ? allEmploymentFields.filter(
                                            (f) =>
                                              f.required &&
                                              f.name !== "employmentYear" &&
                                              f.name !== "employmentMonth" &&
                                              f.name !== "employmentDesignation"
                                          )
                                          : allEmploymentFields;
                                        return (
                                          getFilledCountWithPanAadhaar(fieldsToCheck, values) !==
                                          fieldsToCheck.length
                                        );
                                      })()
                                      : activeHorizontalIndex === 1 &&
                                        activeVerticalIndex === 4
                                        ? isEntranceExamContinueDisabled(values)
                                        : (() => {
                                          const filteredOtherFields = otherFields.filter((f) => {
                                            const isUniversity = f.name === "university";
                                            const isInstitute = f.name === "institute";
                                            const isCourseName = f.name === "courseName";
                                            const applyAdmissionUndecided =
                                              activeHorizontalIndex === 0 &&
                                              activeVerticalIndex === 1 &&
                                              values?.admissionStatus === "Undecided";
                                            const exclude = applyAdmissionUndecided &&
                                              (isUniversity || isInstitute || isCourseName);
                                            return !exclude;
                                          });
                                          return (
                                            getFilledCountWithPanAadhaar(
                                              filteredOtherFields,
                                              values
                                            ) !== filteredOtherFields.length
                                          );
                                        })())) ||
                                  (activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 2 &&
                                    values.employmentisEmployed === "No"
                                    ? false
                                    : getFilledCount(currFields, values) !==
                                    currFields.length ||
                                    getFilledCount(companyFields, values) !==
                                    companyFields.length) ||
                                  !areAllCoApplicantsVerified(values) ||
                                  (isLoadTesting
                                    ? false
                                    : activeHorizontalIndex === 1 &&
                                    activeVerticalIndex === 0 &&
                                    (formikRef.current?.values
                                      .isAadhaarVerified === false ||
                                      formikRef.current?.values
                                        .isAadhaarVerified === ""))
                                }
                                onClick={async () => {
                                  const yupRaw = await validateForm();
                                  console.log("=== SAVE CLICK DEBUG ===");
                                  console.log("Step:", activeHorizontalIndex, activeVerticalIndex);
                                  console.log("Raw Yup errors:", yupRaw);
                                  console.log("coreScoreReceived:", values?.coreScoreReceived, "languageScoreReceived:", values?.languageScoreReceived);
                                  console.log("currentStepFieldNames:", currentStepFieldNames);
                                  // Log isExcludedField for every error key
                                  Object.keys(yupRaw).forEach((k) => {
                                    console.log(`  Field "${k}": inStep=${currentStepFieldNames.includes(k)}, excluded=${isExcludedField(k)}, error=${(yupRaw as any)[k]}`);
                                  });
                                  const merged: Record<string, string> = {};
                                  Object.keys(yupRaw).forEach((k) => {
                                    if (
                                      !currentStepFieldNames.includes(k) ||
                                      isExcludedField(k)
                                    ) {
                                      return;
                                    }
                                    const v = (yupRaw as Record<string, unknown>)[k];
                                    if (v == null || v === "") return;
                                    merged[k] = Array.isArray(v)
                                      ? toErrorString(v[0])
                                      : toErrorString(v);
                                  });

                                  fields.forEach((f: any) => {
                                    if (
                                      !f?.name ||
                                      !currentStepFieldNames.includes(f.name)
                                    ) {
                                      return;
                                    }
                                    if (isExcludedField(f.name)) return;
                                    if (!isFieldRequired(f)) return;
                                    if (merged[f.name]) return;
                                    const val = values[f.name];
                                    // if (isRequiredFieldValueMissing(f, val)) {
                                    //   merged[f.name] =
                                    //     `${f.label || f.name} is required`;
                                    // }
                                  });

                                  const stepErrors = Object.keys(merged).filter(
                                    (key) =>
                                      currentStepFieldNames.includes(key) &&
                                      !isExcludedField(key)
                                  );

                                  if (stepErrors.length > 0) {
                                    setShowFieldErrorsAfterSaveAttempt(true);
                                    const stepScoped: Record<string, string> = {};
                                    stepErrors.forEach((k) => {
                                      stepScoped[k] = merged[k];
                                    });
                                    setErrors(stepScoped);
                                    console.log("Errors on current step:", stepScoped);

                                    const touchedFromErrors: Record<
                                      string,
                                      boolean
                                    > = {
                                      ...(touched as Record<string, boolean>),
                                    };
                                    stepErrors.forEach((k) => {
                                      touchedFromErrors[k] = true;
                                    });
                                    setTouched(touchedFromErrors, false);

                                    setSnackbar({
                                      open: true,
                                      message:
                                        "Some fields are missing or invalid. Update them and save again.",
                                      severity: "error",
                                    });
                                  } else {
                                    setErrors({});
                                    submitForm();
                                  }
                                }}
                              >
                                {isSubmittingToAPI ? (
                                  <CircularProgress size={16} />
                                ) : isXsOrSm ? (
                                  "Save & Continue"
                                ) : (
                                  "Continue"
                                )}
                              </PrimaryButton>
                            </Box>
                          )}
                        {((activeHorizontalIndex === 0 &&
                          activeVerticalIndex > 0 &&
                          activeVerticalIndex < 3) ||
                          (activeHorizontalIndex === 1 &&
                            activeVerticalIndex > 0)) && isXsOrSm && isPreviousButton === true ? (
                          <Box sx={{ width: { xs: "100%", sm: 134 }, mb: isXsOrSm ? 2 : "0", mr: !isXsOrSm ? 2 : "0", mt: 2 }}>
                            <OutlinedPrimaryButton
                              width={isXsOrSm ? "100%" : "134px"}
                              type="button"
                              fullWidth
                              variant="outlined"
                              onClick={() => dispatch(prevVerticalStep())}
                              disabled={isSubmitting || isSubmittingToAPI}
                            >
                              <ArrowBackIcon sx={{ mr: !isXsOrSm ? 1 : 0 }} />

                              {"Previous"}
                            </OutlinedPrimaryButton>
                          </Box>
                        ) : null}
                      </Box>
                    </Box>
                  )}
                  
                </Form>
              );
            }}
          </Formik>
        </>
      )}

      <LoaderBackdrop
        open={
          isAadharLoading ||
          Object.values(isAadharCoApplicantLoading).some(Boolean)
        }
      />

      {/* Mobile OTP Modal */}
      <ModalPopup
        isOpen={openOtpModal}
        onClose={() => {
          setOpenOtpModal(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{ maxWidth: isAuthenticated && (otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/) ? true : !isTruthyFormFlag(isEmailVerified)) ? "600px" : "450px" }}
      >
        <OtpInputForm
          mobileMasked={otpMobileNumber.replace(/.(?=.{4})/g, "x")}
          onOtpSubmit={async (otp) => {
            try {
              const coApplicantPhoneMatch = otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/);

              // Determine the userType string
              let currentUserType = "Applicant"; // Default
              if (coApplicantPhoneMatch) {
                const coAppIndex = coApplicantPhoneMatch[1]; // This is '1', '2', etc.
                currentUserType = `Co-Applicant ${coAppIndex}`;
              }

              const verifyResp = await eligibilityCheckServices.verifyOtp({
                type: "mobile",
                mobileNumber: otpMobileNumber,
                key: otpKey,
                mobileOtp: otp,
                mobileOtpCrtdAt: otpTime,
                userType: currentUserType,
                ...(isAuthenticated && {
                  trackingId: trackingId,
                }),
              });
              if (verifyResp?.data?.status === "success") {

                if (activeHorizontalIndex === 0) {

                  trackCustomerJourneyEvent(
                    `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      category: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      action: `${handleGAEligibilityStatments}_VERIFYYOURSELF_MOBILE_PAGE1`,
                      page: "EligibiityCheck_Verify Yourself and Provide Consent_Mobile",
                    }
                  );

                } else if (activeHorizontalIndex === 1) {
                  const coApplicantPhoneMatchForOtp = otpMobileFieldName.match(
                    /^basicCoApplicant(\d+)PhoneNumber$/
                  );
                  const coAppNum = coApplicantPhoneMatchForOtp
                    ? String(Number(coApplicantPhoneMatchForOtp[1]))
                    : "0";
                  trackCustomerJourneyEvent(
                    `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                    decrypt(userProfile?.id) ?? "",
                    trackingId,
                    {
                      label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_COAPP${coAppNum}BASIC_MOBILEVERI_PAGE10`,
                      page: `ProvisionalOff_Loan Details_COAPP(${coAppNum}) Mobile Verification`,
                    }
                  );
                }
                setSnackbar({
                  open: true,
                  message: verifyResp?.data?.message,
                  severity: "success",
                });
                setOpenOtpModal(false);

                // Check which field is being verified
                const coApplicantPhoneMatch = otpMobileFieldName.match(
                  /^basicCoApplicant(\d+)PhoneNumber$/
                );
                if (coApplicantPhoneMatch) {
                  const idx = String(Number(coApplicantPhoneMatch[1]) - 1);
                  dispatch(
                    setCoApplicantVerification({
                      index: idx,
                      data: {
                        mobileVerified: true,
                        lastVerifiedMobileNumber: otpMobileNumber,
                      },
                    })
                  );
                  // Map value to Formik field
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      otpMobileFieldName,
                      otpMobileNumber
                    );
                  }
                } else {
                  dispatch(setIsMobileVerified(true));
                  dispatch(setLastVerifiedPhoneNumber(otpMobileNumber));
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      "phone_number",
                      otpMobileNumber
                    );
                  }
                }
              } else {
                dispatch(
                  setStatusPopup({
                    status: "error",
                    message: verifyResp?.data?.message,
                  })
                );
              }
            } catch (err: any) {
              setErrorMsg(
                // err?.response?.data?.message ||
                'Oops! Looks like you have entered the wrong OTP. Please try again or click "Resend OTP" to get a new one.'
              );
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          onResendOtp={async () => {
            let name = `${formikRef?.current?.values?.studentDetailsFirstName || ""} ${formikRef?.current?.values?.studentDetailsLastName || ""}`.trim();
            const coApplicantPhoneMatch = otpMobileFieldName.match(
              /^basicCoApplicant(\d+)PhoneNumber$/
            );
            if (coApplicantPhoneMatch) {
              // this will only work for coapplicant
              const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantPhoneMatch[1]))}FirstName`;
              name = formData[dynamicNameKey];   // co-applicant name
            }

            const resp = await eligibilityCheckServices.sendOtp({
              name: name,
              mobileNumber: otpMobileNumber,
            });
            setOtpKey(resp.data.data.value);
            setOtpTime(resp.data.data.otpTime);
            setErrorMsg(
              "A new OTP has been sent to your registered mobile number."
            );
          }}
          showConsentMessage={
            isAuthenticated ?
              otpMobileFieldName.match(/^basicCoApplicant(\d+)PhoneNumber$/)
                ? true // Always true for Co-applicants on Mobile
                : !customerConsentTime// For Applicant: only true if consent not yet given AND email not yet verified
              : false
          }
        />
      </ModalPopup>

      {/* Email OTP Modal */}
      <ModalPopup
        isOpen={openEmailOtp}
        onClose={() => {
          setOpenEmailOtp(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{ maxWidth: isAuthenticated && (otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/) ? false : !isTruthyFormFlag(isMobileVerified)) ? "600px" : "450px" }}
      >
        <OtpInputForm
          emailMasked={
            otpEmail.length > 3
              ? otpEmail.slice(0, 3) +
              otpEmail.slice(3).replace(/.(?=.{4})/g, "x")
              : otpEmail.replace(/.(?=.{4})/g, "x")
          }
          onOtpSubmit={async (otp) => {
            try {
              const coApplicantEmailMatch = otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/);

              // Determine the userType string
              let currentUserType = "Applicant"; // Default
              if (coApplicantEmailMatch) {
                const coAppIndex = coApplicantEmailMatch[1]; // This is '1', '2', etc.
                currentUserType = `Co-Applicant ${coAppIndex}`;
              }
              const verifyResp = await eligibilityCheckServices.verifyOtp({
                type: "email",
                email: otpEmail,
                key: otpEmailKey,
                emailOtp: otp,
                emailOtpCrtdAt: otpEmailTime,
                userType: currentUserType,
                ...(isAuthenticated && {
                  trackingId: trackingId,
                }),
              });

              if (verifyResp?.data?.status === "success") {
                const isProvisionalStudentDetailsEmail =
                  activeHorizontalIndex === 1 && activeVerticalIndex === 0;
                const emailVerifyGaPrefix = isProvisionalStudentDetailsEmail
                  ? handleGAProvisionalOfferStatments
                  : handleGAEligibilityStatments;
                const emailVerifyGaEvent = isProvisionalStudentDetailsEmail
                  ? `${emailVerifyGaPrefix}_STDUENTDET_EMAIL_PAGE5`
                  : `${emailVerifyGaPrefix}_VERIFYYOURSELF_EMAIL_PAGE1`;
                const emailVerifyGaPage = isProvisionalStudentDetailsEmail
                  ? "ProvisionalOff_Student Details_Email"
                  : "EligibiityCheck_Verify Yourself and Provide Consent_Email";

                trackCustomerJourneyEvent(
                  emailVerifyGaEvent,
                  decrypt(userProfile?.id) ?? "",
                  trackingId,
                  {
                    label: emailVerifyGaEvent,
                    category: emailVerifyGaEvent,
                    action: emailVerifyGaEvent,
                    page: emailVerifyGaPage,
                  }
                );


                setSnackbar({
                  open: true,
                  message: verifyResp?.data?.message,
                  severity: "success",
                });
                setOpenEmailOtp(false);

                // Check which field is being verified
                const coApplicantEmailMatch = otpEmailFieldName.match(
                  /^basicCoApplicant(\d+)Email$/
                );
                if (coApplicantEmailMatch) {
                  const idx = String(Number(coApplicantEmailMatch[1]) - 1);
                  dispatch(
                    setCoApplicantVerification({
                      index: idx,
                      data: {
                        emailVerified: true,
                        lastVerifiedEmail: otpEmail,
                      },
                    })
                  );
                  if (formikRef.current) {
                    formikRef.current.setFieldValue(
                      otpEmailFieldName,
                      otpEmail
                    );
                  }
                } else {
                  dispatch(setIsEmailVerified(true));
                  dispatch(setLastVerifiedEmail(otpEmail));
                  if (formikRef.current) {
                    formikRef.current.setFieldValue("email", otpEmail);
                    formikRef.current.setFieldValue("studentDetailEmail", otpEmail);
                    formikRef.current.setFieldValue("isEmailVerified", true, false);
                  }
                  dispatch(
                    updateFormData({
                      email: otpEmail,
                      studentDetailEmail: otpEmail,
                      isEmailVerified: true,
                    })
                  );
                }
              } else {
                dispatch(
                  setStatusPopup({
                    status: "error",
                    message: verifyResp?.data?.message,
                  })
                );
              }
            } catch (err: any) {
              setErrorMsg(
                // err?.response?.data?.message ||
                'Oops! Looks like you have entered the wrong OTP. Please try again or click "Resend OTP" to get a new one.'
              );
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          onResendOtp={async () => {
            let name = `${formikRef?.current?.values?.studentDetailsFirstName || ""} ${formikRef?.current?.values?.studentDetailsLastName || ""}`.trim();

            const coApplicantEmailMatch = otpEmailFieldName.match(
              /^basicCoApplicant(\d+)Email$/
            );
            if (coApplicantEmailMatch) {
              // this will only work for coapplicant
              const dynamicNameKey = `basicCoApplicant${String(Number(coApplicantEmailMatch[1]))}FirstName`;
              name = formData[dynamicNameKey];   // co-applicant name
            }

            const resp = await eligibilityCheckServices.sendOtp({
              name: name,
              email: otpEmail.toLowerCase(),
            });
            setOtpEmailKey(resp.data.data.value);
            setOtpEmailTime(resp.data.data.otpTime);
            setErrorMsg("A new OTP has been sent to your registered email ID.");
          }}
          showConsentMessage={
            isAuthenticated
              ? otpEmailFieldName.match(/^basicCoApplicant(\d+)Email$/)
                ? false // Always false for Co-applicants on Email
                : !customerConsentTime// For Applicant: only true if consent not yet given AND mobile not yet verified
              : false
          }
        />
      </ModalPopup>

      {/* Co-Applicant Modal */}
      <ModalPopup
        isOpen={openCoApplicantModal}
        onClose={() => setOpenCoApplicantModal(false)}
        title="Co-Applicant Selected"
      >
        <Typography sx={{ mt: 2 }}>
          Please enter the applicant's details.
        </Typography>
      </ModalPopup>

      {/* Purposes Anchor Modal */}
      <ModalPopup
        isOpen={openAnchorModal}
        onClose={() => setOpenAnchorModal(false)}
        title=""
      >
        {purposeItems.length > 0 ? (
          <Box component="ul" sx={{ pl: 3, mt: 1, mb: 0 }}>
            {purposeItems.map((item, idx) => (
              <Box component="li" key={idx} sx={{ mb: 1.25 }}>
                <Typography sx={{ m: 0 }}>{item}</Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography sx={{ mt: 2, whiteSpace: "pre-line" }}>
            {anchorModalContent}
          </Typography>
        )}
      </ModalPopup>

      {/* Alert  */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {/* Loader Backdrop for BRE checkOffer API */}
      <OfferCheckLoader
        open={isCheckingOffer}
        content="We are checking your eligibility"
      />
    </Box>
  );
};

export default React.memo(DynamicForm);
